/*! jQuery v3.5.1 | (c) JS Foundation and other contributors | jquery.org/license */ ;(function (
    e,
    t
) {
    'use strict'
    typeof module == 'object' && typeof module.exports == 'object'
        ? (module.exports = e.document
              ? t(e, !0)
              : function (e2) {
                    if (!e2.document)
                        throw new Error(
                            'jQuery requires a window with a document'
                        )
                    return t(e2)
                })
        : t(e)
})(typeof window < 'u' ? window : this, function (C, e) {
    'use strict'
    var t = [],
        r = Object.getPrototypeOf,
        s = t.slice,
        g = t.flat
            ? function (e2) {
                  return t.flat.call(e2)
              }
            : function (e2) {
                  return t.concat.apply([], e2)
              },
        u = t.push,
        i = t.indexOf,
        n = {},
        o = n.toString,
        v = n.hasOwnProperty,
        a = v.toString,
        l = a.call(Object),
        y = {},
        m = function (e2) {
            return typeof e2 == 'function' && typeof e2.nodeType != 'number'
        },
        x = function (e2) {
            return e2 != null && e2 === e2.window
        },
        E = C.document,
        c = { type: !0, src: !0, nonce: !0, noModule: !0 }
    function b(e2, t2, n2) {
        var r2,
            i2,
            o2 = (n2 = n2 || E).createElement('script')
        if (((o2.text = e2), t2))
            for (r2 in c)
                (i2 = t2[r2] || (t2.getAttribute && t2.getAttribute(r2))) &&
                    o2.setAttribute(r2, i2)
        n2.head.appendChild(o2).parentNode.removeChild(o2)
    }
    function w(e2) {
        return e2 == null
            ? e2 + ''
            : typeof e2 == 'object' || typeof e2 == 'function'
            ? n[o.call(e2)] || 'object'
            : typeof e2
    }
    var f = '3.5.1',
        S = function (e2, t2) {
            return new S.fn.init(e2, t2)
        }
    function p(e2) {
        var t2 = !!e2 && 'length' in e2 && e2.length,
            n2 = w(e2)
        return (
            !m(e2) &&
            !x(e2) &&
            (n2 === 'array' ||
                t2 === 0 ||
                (typeof t2 == 'number' && 0 < t2 && t2 - 1 in e2))
        )
    }
    ;(S.fn = S.prototype =
        {
            jquery: f,
            constructor: S,
            length: 0,
            toArray: function () {
                return s.call(this)
            },
            get: function (e2) {
                return e2 == null
                    ? s.call(this)
                    : e2 < 0
                    ? this[e2 + this.length]
                    : this[e2]
            },
            pushStack: function (e2) {
                var t2 = S.merge(this.constructor(), e2)
                return (t2.prevObject = this), t2
            },
            each: function (e2) {
                return S.each(this, e2)
            },
            map: function (n2) {
                return this.pushStack(
                    S.map(this, function (e2, t2) {
                        return n2.call(e2, t2, e2)
                    })
                )
            },
            slice: function () {
                return this.pushStack(s.apply(this, arguments))
            },
            first: function () {
                return this.eq(0)
            },
            last: function () {
                return this.eq(-1)
            },
            even: function () {
                return this.pushStack(
                    S.grep(this, function (e2, t2) {
                        return (t2 + 1) % 2
                    })
                )
            },
            odd: function () {
                return this.pushStack(
                    S.grep(this, function (e2, t2) {
                        return t2 % 2
                    })
                )
            },
            eq: function (e2) {
                var t2 = this.length,
                    n2 = +e2 + (e2 < 0 ? t2 : 0)
                return this.pushStack(0 <= n2 && n2 < t2 ? [this[n2]] : [])
            },
            end: function () {
                return this.prevObject || this.constructor()
            },
            push: u,
            sort: t.sort,
            splice: t.splice,
        }),
        (S.extend = S.fn.extend =
            function () {
                var e2,
                    t2,
                    n2,
                    r2,
                    i2,
                    o2,
                    a2 = arguments[0] || {},
                    s2 = 1,
                    u2 = arguments.length,
                    l2 = !1
                for (
                    typeof a2 == 'boolean' &&
                        ((l2 = a2), (a2 = arguments[s2] || {}), s2++),
                        typeof a2 == 'object' || m(a2) || (a2 = {}),
                        s2 === u2 && ((a2 = this), s2--);
                    s2 < u2;
                    s2++
                )
                    if ((e2 = arguments[s2]) != null)
                        for (t2 in e2)
                            (r2 = e2[t2]),
                                t2 !== '__proto__' &&
                                    a2 !== r2 &&
                                    (l2 &&
                                    r2 &&
                                    (S.isPlainObject(r2) ||
                                        (i2 = Array.isArray(r2)))
                                        ? ((n2 = a2[t2]),
                                          (o2 =
                                              i2 && !Array.isArray(n2)
                                                  ? []
                                                  : i2 || S.isPlainObject(n2)
                                                  ? n2
                                                  : {}),
                                          (i2 = !1),
                                          (a2[t2] = S.extend(l2, o2, r2)))
                                        : r2 !== void 0 && (a2[t2] = r2))
                return a2
            }),
        S.extend({
            expando: 'jQuery' + (f + Math.random()).replace(/\D/g, ''),
            isReady: !0,
            error: function (e2) {
                throw new Error(e2)
            },
            noop: function () {},
            isPlainObject: function (e2) {
                var t2, n2
                return (
                    !(!e2 || o.call(e2) !== '[object Object]') &&
                    (!(t2 = r(e2)) ||
                        (typeof (n2 =
                            v.call(t2, 'constructor') && t2.constructor) ==
                            'function' &&
                            a.call(n2) === l))
                )
            },
            isEmptyObject: function (e2) {
                var t2
                for (t2 in e2) return !1
                return !0
            },
            globalEval: function (e2, t2, n2) {
                b(e2, { nonce: t2 && t2.nonce }, n2)
            },
            each: function (e2, t2) {
                var n2,
                    r2 = 0
                if (p(e2))
                    for (
                        n2 = e2.length;
                        r2 < n2 && t2.call(e2[r2], r2, e2[r2]) !== !1;
                        r2++
                    );
                else
                    for (r2 in e2) if (t2.call(e2[r2], r2, e2[r2]) === !1) break
                return e2
            },
            makeArray: function (e2, t2) {
                var n2 = t2 || []
                return (
                    e2 != null &&
                        (p(Object(e2))
                            ? S.merge(n2, typeof e2 == 'string' ? [e2] : e2)
                            : u.call(n2, e2)),
                    n2
                )
            },
            inArray: function (e2, t2, n2) {
                return t2 == null ? -1 : i.call(t2, e2, n2)
            },
            merge: function (e2, t2) {
                for (var n2 = +t2.length, r2 = 0, i2 = e2.length; r2 < n2; r2++)
                    e2[i2++] = t2[r2]
                return (e2.length = i2), e2
            },
            grep: function (e2, t2, n2) {
                for (
                    var r2 = [], i2 = 0, o2 = e2.length, a2 = !n2;
                    i2 < o2;
                    i2++
                )
                    !t2(e2[i2], i2) !== a2 && r2.push(e2[i2])
                return r2
            },
            map: function (e2, t2, n2) {
                var r2,
                    i2,
                    o2 = 0,
                    a2 = []
                if (p(e2))
                    for (r2 = e2.length; o2 < r2; o2++)
                        (i2 = t2(e2[o2], o2, n2)) != null && a2.push(i2)
                else
                    for (o2 in e2)
                        (i2 = t2(e2[o2], o2, n2)) != null && a2.push(i2)
                return g(a2)
            },
            guid: 1,
            support: y,
        }),
        typeof Symbol == 'function' &&
            (S.fn[Symbol.iterator] = t[Symbol.iterator]),
        S.each(
            'Boolean Number String Function Array Date RegExp Object Error Symbol'.split(
                ' '
            ),
            function (e2, t2) {
                n['[object ' + t2 + ']'] = t2.toLowerCase()
            }
        )
    var d = (function (n2) {
        var e2,
            d2,
            b2,
            o2,
            i2,
            h2,
            f2,
            g2,
            w2,
            u2,
            l2,
            T2,
            C2,
            a2,
            E2,
            v2,
            s2,
            c2,
            y2,
            S2 = 'sizzle' + 1 * new Date(),
            p2 = n2.document,
            k2 = 0,
            r2 = 0,
            m2 = ue2(),
            x2 = ue2(),
            A2 = ue2(),
            N2 = ue2(),
            D2 = function (e3, t3) {
                return e3 === t3 && (l2 = !0), 0
            },
            j2 = {}.hasOwnProperty,
            t2 = [],
            q2 = t2.pop,
            L2 = t2.push,
            H2 = t2.push,
            O2 = t2.slice,
            P2 = function (e3, t3) {
                for (var n3 = 0, r3 = e3.length; n3 < r3; n3++)
                    if (e3[n3] === t3) return n3
                return -1
            },
            R2 =
                'checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped',
            M2 = '[\\x20\\t\\r\\n\\f]',
            I2 =
                '(?:\\\\[\\da-fA-F]{1,6}' +
                M2 +
                '?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+',
            W2 =
                '\\[' +
                M2 +
                '*(' +
                I2 +
                ')(?:' +
                M2 +
                '*([*^$|!~]?=)' +
                M2 +
                `*(?:'((?:\\\\.|[^\\\\'])*)'|"((?:\\\\.|[^\\\\"])*)"|(` +
                I2 +
                '))|)' +
                M2 +
                '*\\]',
            F2 =
                ':(' +
                I2 +
                `)(?:\\((('((?:\\\\.|[^\\\\'])*)'|"((?:\\\\.|[^\\\\"])*)")|((?:\\\\.|[^\\\\()[\\]]|` +
                W2 +
                ')*)|.*)\\)|)',
            B2 = new RegExp(M2 + '+', 'g'),
            $3 = new RegExp(
                '^' + M2 + '+|((?:^|[^\\\\])(?:\\\\.)*)' + M2 + '+$',
                'g'
            ),
            _2 = new RegExp('^' + M2 + '*,' + M2 + '*'),
            z2 = new RegExp('^' + M2 + '*([>+~]|' + M2 + ')' + M2 + '*'),
            U2 = new RegExp(M2 + '|>'),
            X2 = new RegExp(F2),
            V2 = new RegExp('^' + I2 + '$'),
            G2 = {
                ID: new RegExp('^#(' + I2 + ')'),
                CLASS: new RegExp('^\\.(' + I2 + ')'),
                TAG: new RegExp('^(' + I2 + '|[*])'),
                ATTR: new RegExp('^' + W2),
                PSEUDO: new RegExp('^' + F2),
                CHILD: new RegExp(
                    '^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(' +
                        M2 +
                        '*(even|odd|(([+-]|)(\\d*)n|)' +
                        M2 +
                        '*(?:([+-]|)' +
                        M2 +
                        '*(\\d+)|))' +
                        M2 +
                        '*\\)|)',
                    'i'
                ),
                bool: new RegExp('^(?:' + R2 + ')$', 'i'),
                needsContext: new RegExp(
                    '^' +
                        M2 +
                        '*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(' +
                        M2 +
                        '*((?:-\\d)?\\d*)' +
                        M2 +
                        '*\\)|)(?=[^-]|$)',
                    'i'
                ),
            },
            Y2 = /HTML$/i,
            Q2 = /^(?:input|select|textarea|button)$/i,
            J2 = /^h\d$/i,
            K2 = /^[^{]+\{\s*\[native \w/,
            Z2 = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
            ee2 = /[+~]/,
            te2 = new RegExp(
                '\\\\[\\da-fA-F]{1,6}' + M2 + '?|\\\\([^\\r\\n\\f])',
                'g'
            ),
            ne2 = function (e3, t3) {
                var n3 = '0x' + e3.slice(1) - 65536
                return (
                    t3 ||
                    (n3 < 0
                        ? String.fromCharCode(n3 + 65536)
                        : String.fromCharCode(
                              (n3 >> 10) | 55296,
                              (1023 & n3) | 56320
                          ))
                )
            },
            re2 = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
            ie2 = function (e3, t3) {
                return t3
                    ? e3 === '\0'
                        ? '\uFFFD'
                        : e3.slice(0, -1) +
                          '\\' +
                          e3.charCodeAt(e3.length - 1).toString(16) +
                          ' '
                    : '\\' + e3
            },
            oe2 = function () {
                T2()
            },
            ae2 = be2(
                function (e3) {
                    return (
                        e3.disabled === !0 &&
                        e3.nodeName.toLowerCase() === 'fieldset'
                    )
                },
                { dir: 'parentNode', next: 'legend' }
            )
        try {
            H2.apply((t2 = O2.call(p2.childNodes)), p2.childNodes),
                t2[p2.childNodes.length].nodeType
        } catch {
            H2 = {
                apply: t2.length
                    ? function (e4, t3) {
                          L2.apply(e4, O2.call(t3))
                      }
                    : function (e4, t3) {
                          for (
                              var n3 = e4.length, r3 = 0;
                              (e4[n3++] = t3[r3++]);

                          );
                          e4.length = n3 - 1
                      },
            }
        }
        function se2(t3, e3, n3, r3) {
            var i3,
                o3,
                a3,
                s3,
                u3,
                l3,
                c3,
                f3 = e3 && e3.ownerDocument,
                p3 = e3 ? e3.nodeType : 9
            if (
                ((n3 = n3 || []),
                typeof t3 != 'string' ||
                    !t3 ||
                    (p3 !== 1 && p3 !== 9 && p3 !== 11))
            )
                return n3
            if (!r3 && (T2(e3), (e3 = e3 || C2), E2)) {
                if (p3 !== 11 && (u3 = Z2.exec(t3)))
                    if ((i3 = u3[1])) {
                        if (p3 === 9) {
                            if (!(a3 = e3.getElementById(i3))) return n3
                            if (a3.id === i3) return n3.push(a3), n3
                        } else if (
                            f3 &&
                            (a3 = f3.getElementById(i3)) &&
                            y2(e3, a3) &&
                            a3.id === i3
                        )
                            return n3.push(a3), n3
                    } else {
                        if (u3[2])
                            return H2.apply(n3, e3.getElementsByTagName(t3)), n3
                        if (
                            (i3 = u3[3]) &&
                            d2.getElementsByClassName &&
                            e3.getElementsByClassName
                        )
                            return (
                                H2.apply(n3, e3.getElementsByClassName(i3)), n3
                            )
                    }
                if (
                    d2.qsa &&
                    !N2[t3 + ' '] &&
                    (!v2 || !v2.test(t3)) &&
                    (p3 !== 1 || e3.nodeName.toLowerCase() !== 'object')
                ) {
                    if (
                        ((c3 = t3),
                        (f3 = e3),
                        p3 === 1 && (U2.test(t3) || z2.test(t3)))
                    ) {
                        for (
                            ((f3 =
                                (ee2.test(t3) && ye2(e3.parentNode)) || e3) ===
                                e3 &&
                                d2.scope) ||
                                ((s3 = e3.getAttribute('id'))
                                    ? (s3 = s3.replace(re2, ie2))
                                    : e3.setAttribute('id', (s3 = S2))),
                                o3 = (l3 = h2(t3)).length;
                            o3--;

                        )
                            l3[o3] =
                                (s3 ? '#' + s3 : ':scope') + ' ' + xe2(l3[o3])
                        c3 = l3.join(',')
                    }
                    try {
                        return H2.apply(n3, f3.querySelectorAll(c3)), n3
                    } catch {
                        N2(t3, !0)
                    } finally {
                        s3 === S2 && e3.removeAttribute('id')
                    }
                }
            }
            return g2(t3.replace($3, '$1'), e3, n3, r3)
        }
        function ue2() {
            var r3 = []
            return function e3(t3, n3) {
                return (
                    r3.push(t3 + ' ') > b2.cacheLength && delete e3[r3.shift()],
                    (e3[t3 + ' '] = n3)
                )
            }
        }
        function le2(e3) {
            return (e3[S2] = !0), e3
        }
        function ce2(e3) {
            var t3 = C2.createElement('fieldset')
            try {
                return !!e3(t3)
            } catch {
                return !1
            } finally {
                t3.parentNode && t3.parentNode.removeChild(t3), (t3 = null)
            }
        }
        function fe2(e3, t3) {
            for (var n3 = e3.split('|'), r3 = n3.length; r3--; )
                b2.attrHandle[n3[r3]] = t3
        }
        function pe2(e3, t3) {
            var n3 = t3 && e3,
                r3 =
                    n3 &&
                    e3.nodeType === 1 &&
                    t3.nodeType === 1 &&
                    e3.sourceIndex - t3.sourceIndex
            if (r3) return r3
            if (n3) {
                for (; (n3 = n3.nextSibling); ) if (n3 === t3) return -1
            }
            return e3 ? 1 : -1
        }
        function de2(t3) {
            return function (e3) {
                return e3.nodeName.toLowerCase() === 'input' && e3.type === t3
            }
        }
        function he2(n3) {
            return function (e3) {
                var t3 = e3.nodeName.toLowerCase()
                return (t3 === 'input' || t3 === 'button') && e3.type === n3
            }
        }
        function ge2(t3) {
            return function (e3) {
                return 'form' in e3
                    ? e3.parentNode && e3.disabled === !1
                        ? 'label' in e3
                            ? 'label' in e3.parentNode
                                ? e3.parentNode.disabled === t3
                                : e3.disabled === t3
                            : e3.isDisabled === t3 ||
                              (e3.isDisabled !== !t3 && ae2(e3) === t3)
                        : e3.disabled === t3
                    : 'label' in e3 && e3.disabled === t3
            }
        }
        function ve2(a3) {
            return le2(function (o3) {
                return (
                    (o3 = +o3),
                    le2(function (e3, t3) {
                        for (
                            var n3, r3 = a3([], e3.length, o3), i3 = r3.length;
                            i3--;

                        )
                            e3[(n3 = r3[i3])] && (e3[n3] = !(t3[n3] = e3[n3]))
                    })
                )
            })
        }
        function ye2(e3) {
            return e3 && typeof e3.getElementsByTagName < 'u' && e3
        }
        for (e2 in ((d2 = se2.support = {}),
        (i2 = se2.isXML =
            function (e3) {
                var t3 = e3.namespaceURI,
                    n3 = (e3.ownerDocument || e3).documentElement
                return !Y2.test(t3 || (n3 && n3.nodeName) || 'HTML')
            }),
        (T2 = se2.setDocument =
            function (e3) {
                var t3,
                    n3,
                    r3 = e3 ? e3.ownerDocument || e3 : p2
                return (
                    r3 != C2 &&
                        r3.nodeType === 9 &&
                        r3.documentElement &&
                        ((a2 = (C2 = r3).documentElement),
                        (E2 = !i2(C2)),
                        p2 != C2 &&
                            (n3 = C2.defaultView) &&
                            n3.top !== n3 &&
                            (n3.addEventListener
                                ? n3.addEventListener('unload', oe2, !1)
                                : n3.attachEvent &&
                                  n3.attachEvent('onunload', oe2)),
                        (d2.scope = ce2(function (e4) {
                            return (
                                a2
                                    .appendChild(e4)
                                    .appendChild(C2.createElement('div')),
                                typeof e4.querySelectorAll < 'u' &&
                                    !e4.querySelectorAll(':scope fieldset div')
                                        .length
                            )
                        })),
                        (d2.attributes = ce2(function (e4) {
                            return (
                                (e4.className = 'i'),
                                !e4.getAttribute('className')
                            )
                        })),
                        (d2.getElementsByTagName = ce2(function (e4) {
                            return (
                                e4.appendChild(C2.createComment('')),
                                !e4.getElementsByTagName('*').length
                            )
                        })),
                        (d2.getElementsByClassName = K2.test(
                            C2.getElementsByClassName
                        )),
                        (d2.getById = ce2(function (e4) {
                            return (
                                (a2.appendChild(e4).id = S2),
                                !C2.getElementsByName ||
                                    !C2.getElementsByName(S2).length
                            )
                        })),
                        d2.getById
                            ? ((b2.filter.ID = function (e4) {
                                  var t4 = e4.replace(te2, ne2)
                                  return function (e5) {
                                      return e5.getAttribute('id') === t4
                                  }
                              }),
                              (b2.find.ID = function (e4, t4) {
                                  if (typeof t4.getElementById < 'u' && E2) {
                                      var n4 = t4.getElementById(e4)
                                      return n4 ? [n4] : []
                                  }
                              }))
                            : ((b2.filter.ID = function (e4) {
                                  var n4 = e4.replace(te2, ne2)
                                  return function (e5) {
                                      var t4 =
                                          typeof e5.getAttributeNode < 'u' &&
                                          e5.getAttributeNode('id')
                                      return t4 && t4.value === n4
                                  }
                              }),
                              (b2.find.ID = function (e4, t4) {
                                  if (typeof t4.getElementById < 'u' && E2) {
                                      var n4,
                                          r4,
                                          i3,
                                          o3 = t4.getElementById(e4)
                                      if (o3) {
                                          if (
                                              (n4 =
                                                  o3.getAttributeNode('id')) &&
                                              n4.value === e4
                                          )
                                              return [o3]
                                          for (
                                              i3 = t4.getElementsByName(e4),
                                                  r4 = 0;
                                              (o3 = i3[r4++]);

                                          )
                                              if (
                                                  (n4 =
                                                      o3.getAttributeNode(
                                                          'id'
                                                      )) &&
                                                  n4.value === e4
                                              )
                                                  return [o3]
                                      }
                                      return []
                                  }
                              })),
                        (b2.find.TAG = d2.getElementsByTagName
                            ? function (e4, t4) {
                                  return typeof t4.getElementsByTagName < 'u'
                                      ? t4.getElementsByTagName(e4)
                                      : d2.qsa
                                      ? t4.querySelectorAll(e4)
                                      : void 0
                              }
                            : function (e4, t4) {
                                  var n4,
                                      r4 = [],
                                      i3 = 0,
                                      o3 = t4.getElementsByTagName(e4)
                                  if (e4 === '*') {
                                      for (; (n4 = o3[i3++]); )
                                          n4.nodeType === 1 && r4.push(n4)
                                      return r4
                                  }
                                  return o3
                              }),
                        (b2.find.CLASS =
                            d2.getElementsByClassName &&
                            function (e4, t4) {
                                if (
                                    typeof t4.getElementsByClassName < 'u' &&
                                    E2
                                )
                                    return t4.getElementsByClassName(e4)
                            }),
                        (s2 = []),
                        (v2 = []),
                        (d2.qsa = K2.test(C2.querySelectorAll)) &&
                            (ce2(function (e4) {
                                var t4
                                ;(a2.appendChild(e4).innerHTML =
                                    "<a id='" +
                                    S2 +
                                    "'></a><select id='" +
                                    S2 +
                                    "-\r\\' msallowcapture=''><option selected=''></option></select>"),
                                    e4.querySelectorAll("[msallowcapture^='']")
                                        .length &&
                                        v2.push('[*^$]=' + M2 + `*(?:''|"")`),
                                    e4.querySelectorAll('[selected]').length ||
                                        v2.push(
                                            '\\[' + M2 + '*(?:value|' + R2 + ')'
                                        ),
                                    e4.querySelectorAll('[id~=' + S2 + '-]')
                                        .length || v2.push('~='),
                                    (t4 =
                                        C2.createElement('input')).setAttribute(
                                        'name',
                                        ''
                                    ),
                                    e4.appendChild(t4),
                                    e4.querySelectorAll("[name='']").length ||
                                        v2.push(
                                            '\\[' +
                                                M2 +
                                                '*name' +
                                                M2 +
                                                '*=' +
                                                M2 +
                                                `*(?:''|"")`
                                        ),
                                    e4.querySelectorAll(':checked').length ||
                                        v2.push(':checked'),
                                    e4.querySelectorAll('a#' + S2 + '+*')
                                        .length || v2.push('.#.+[+~]'),
                                    e4.querySelectorAll('\\\f'),
                                    v2.push('[\\r\\n\\f]')
                            }),
                            ce2(function (e4) {
                                e4.innerHTML =
                                    "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>"
                                var t4 = C2.createElement('input')
                                t4.setAttribute('type', 'hidden'),
                                    e4
                                        .appendChild(t4)
                                        .setAttribute('name', 'D'),
                                    e4.querySelectorAll('[name=d]').length &&
                                        v2.push('name' + M2 + '*[*^$|!~]?='),
                                    e4.querySelectorAll(':enabled').length !==
                                        2 && v2.push(':enabled', ':disabled'),
                                    (a2.appendChild(e4).disabled = !0),
                                    e4.querySelectorAll(':disabled').length !==
                                        2 && v2.push(':enabled', ':disabled'),
                                    e4.querySelectorAll('*,:x'),
                                    v2.push(',.*:')
                            })),
                        (d2.matchesSelector = K2.test(
                            (c2 =
                                a2.matches ||
                                a2.webkitMatchesSelector ||
                                a2.mozMatchesSelector ||
                                a2.oMatchesSelector ||
                                a2.msMatchesSelector)
                        )) &&
                            ce2(function (e4) {
                                ;(d2.disconnectedMatch = c2.call(e4, '*')),
                                    c2.call(e4, "[s!='']:x"),
                                    s2.push('!=', F2)
                            }),
                        (v2 = v2.length && new RegExp(v2.join('|'))),
                        (s2 = s2.length && new RegExp(s2.join('|'))),
                        (t3 = K2.test(a2.compareDocumentPosition)),
                        (y2 =
                            t3 || K2.test(a2.contains)
                                ? function (e4, t4) {
                                      var n4 =
                                              e4.nodeType === 9
                                                  ? e4.documentElement
                                                  : e4,
                                          r4 = t4 && t4.parentNode
                                      return (
                                          e4 === r4 ||
                                          !(
                                              !r4 ||
                                              r4.nodeType !== 1 ||
                                              !(n4.contains
                                                  ? n4.contains(r4)
                                                  : e4.compareDocumentPosition &&
                                                    16 &
                                                        e4.compareDocumentPosition(
                                                            r4
                                                        ))
                                          )
                                      )
                                  }
                                : function (e4, t4) {
                                      if (t4) {
                                          for (; (t4 = t4.parentNode); )
                                              if (t4 === e4) return !0
                                      }
                                      return !1
                                  }),
                        (D2 = t3
                            ? function (e4, t4) {
                                  if (e4 === t4) return (l2 = !0), 0
                                  var n4 =
                                      !e4.compareDocumentPosition -
                                      !t4.compareDocumentPosition
                                  return (
                                      n4 ||
                                      (1 &
                                          (n4 =
                                              (e4.ownerDocument || e4) ==
                                              (t4.ownerDocument || t4)
                                                  ? e4.compareDocumentPosition(
                                                        t4
                                                    )
                                                  : 1) ||
                                      (!d2.sortDetached &&
                                          t4.compareDocumentPosition(e4) === n4)
                                          ? e4 == C2 ||
                                            (e4.ownerDocument == p2 &&
                                                y2(p2, e4))
                                              ? -1
                                              : t4 == C2 ||
                                                (t4.ownerDocument == p2 &&
                                                    y2(p2, t4))
                                              ? 1
                                              : u2
                                              ? P2(u2, e4) - P2(u2, t4)
                                              : 0
                                          : 4 & n4
                                          ? -1
                                          : 1)
                                  )
                              }
                            : function (e4, t4) {
                                  if (e4 === t4) return (l2 = !0), 0
                                  var n4,
                                      r4 = 0,
                                      i3 = e4.parentNode,
                                      o3 = t4.parentNode,
                                      a3 = [e4],
                                      s3 = [t4]
                                  if (!i3 || !o3)
                                      return e4 == C2
                                          ? -1
                                          : t4 == C2
                                          ? 1
                                          : i3
                                          ? -1
                                          : o3
                                          ? 1
                                          : u2
                                          ? P2(u2, e4) - P2(u2, t4)
                                          : 0
                                  if (i3 === o3) return pe2(e4, t4)
                                  for (n4 = e4; (n4 = n4.parentNode); )
                                      a3.unshift(n4)
                                  for (n4 = t4; (n4 = n4.parentNode); )
                                      s3.unshift(n4)
                                  for (; a3[r4] === s3[r4]; ) r4++
                                  return r4
                                      ? pe2(a3[r4], s3[r4])
                                      : a3[r4] == p2
                                      ? -1
                                      : s3[r4] == p2
                                      ? 1
                                      : 0
                              })),
                    C2
                )
            }),
        (se2.matches = function (e3, t3) {
            return se2(e3, null, null, t3)
        }),
        (se2.matchesSelector = function (e3, t3) {
            if (
                (T2(e3),
                d2.matchesSelector &&
                    E2 &&
                    !N2[t3 + ' '] &&
                    (!s2 || !s2.test(t3)) &&
                    (!v2 || !v2.test(t3)))
            )
                try {
                    var n3 = c2.call(e3, t3)
                    if (
                        n3 ||
                        d2.disconnectedMatch ||
                        (e3.document && e3.document.nodeType !== 11)
                    )
                        return n3
                } catch {
                    N2(t3, !0)
                }
            return 0 < se2(t3, C2, null, [e3]).length
        }),
        (se2.contains = function (e3, t3) {
            return (e3.ownerDocument || e3) != C2 && T2(e3), y2(e3, t3)
        }),
        (se2.attr = function (e3, t3) {
            ;(e3.ownerDocument || e3) != C2 && T2(e3)
            var n3 = b2.attrHandle[t3.toLowerCase()],
                r3 =
                    n3 && j2.call(b2.attrHandle, t3.toLowerCase())
                        ? n3(e3, t3, !E2)
                        : void 0
            return r3 !== void 0
                ? r3
                : d2.attributes || !E2
                ? e3.getAttribute(t3)
                : (r3 = e3.getAttributeNode(t3)) && r3.specified
                ? r3.value
                : null
        }),
        (se2.escape = function (e3) {
            return (e3 + '').replace(re2, ie2)
        }),
        (se2.error = function (e3) {
            throw new Error('Syntax error, unrecognized expression: ' + e3)
        }),
        (se2.uniqueSort = function (e3) {
            var t3,
                n3 = [],
                r3 = 0,
                i3 = 0
            if (
                ((l2 = !d2.detectDuplicates),
                (u2 = !d2.sortStable && e3.slice(0)),
                e3.sort(D2),
                l2)
            ) {
                for (; (t3 = e3[i3++]); ) t3 === e3[i3] && (r3 = n3.push(i3))
                for (; r3--; ) e3.splice(n3[r3], 1)
            }
            return (u2 = null), e3
        }),
        (o2 = se2.getText =
            function (e3) {
                var t3,
                    n3 = '',
                    r3 = 0,
                    i3 = e3.nodeType
                if (i3) {
                    if (i3 === 1 || i3 === 9 || i3 === 11) {
                        if (typeof e3.textContent == 'string')
                            return e3.textContent
                        for (e3 = e3.firstChild; e3; e3 = e3.nextSibling)
                            n3 += o2(e3)
                    } else if (i3 === 3 || i3 === 4) return e3.nodeValue
                } else for (; (t3 = e3[r3++]); ) n3 += o2(t3)
                return n3
            }),
        ((b2 = se2.selectors =
            {
                cacheLength: 50,
                createPseudo: le2,
                match: G2,
                attrHandle: {},
                find: {},
                relative: {
                    '>': { dir: 'parentNode', first: !0 },
                    ' ': { dir: 'parentNode' },
                    '+': { dir: 'previousSibling', first: !0 },
                    '~': { dir: 'previousSibling' },
                },
                preFilter: {
                    ATTR: function (e3) {
                        return (
                            (e3[1] = e3[1].replace(te2, ne2)),
                            (e3[3] = (e3[3] || e3[4] || e3[5] || '').replace(
                                te2,
                                ne2
                            )),
                            e3[2] === '~=' && (e3[3] = ' ' + e3[3] + ' '),
                            e3.slice(0, 4)
                        )
                    },
                    CHILD: function (e3) {
                        return (
                            (e3[1] = e3[1].toLowerCase()),
                            e3[1].slice(0, 3) === 'nth'
                                ? (e3[3] || se2.error(e3[0]),
                                  (e3[4] = +(e3[4]
                                      ? e3[5] + (e3[6] || 1)
                                      : 2 *
                                        (e3[3] === 'even' || e3[3] === 'odd'))),
                                  (e3[5] = +(e3[7] + e3[8] || e3[3] === 'odd')))
                                : e3[3] && se2.error(e3[0]),
                            e3
                        )
                    },
                    PSEUDO: function (e3) {
                        var t3,
                            n3 = !e3[6] && e3[2]
                        return G2.CHILD.test(e3[0])
                            ? null
                            : (e3[3]
                                  ? (e3[2] = e3[4] || e3[5] || '')
                                  : n3 &&
                                    X2.test(n3) &&
                                    (t3 = h2(n3, !0)) &&
                                    (t3 =
                                        n3.indexOf(')', n3.length - t3) -
                                        n3.length) &&
                                    ((e3[0] = e3[0].slice(0, t3)),
                                    (e3[2] = n3.slice(0, t3))),
                              e3.slice(0, 3))
                    },
                },
                filter: {
                    TAG: function (e3) {
                        var t3 = e3.replace(te2, ne2).toLowerCase()
                        return e3 === '*'
                            ? function () {
                                  return !0
                              }
                            : function (e4) {
                                  return (
                                      e4.nodeName &&
                                      e4.nodeName.toLowerCase() === t3
                                  )
                              }
                    },
                    CLASS: function (e3) {
                        var t3 = m2[e3 + ' ']
                        return (
                            t3 ||
                            ((t3 = new RegExp(
                                '(^|' + M2 + ')' + e3 + '(' + M2 + '|$)'
                            )) &&
                                m2(e3, function (e4) {
                                    return t3.test(
                                        (typeof e4.className == 'string' &&
                                            e4.className) ||
                                            (typeof e4.getAttribute < 'u' &&
                                                e4.getAttribute('class')) ||
                                            ''
                                    )
                                }))
                        )
                    },
                    ATTR: function (n3, r3, i3) {
                        return function (e3) {
                            var t3 = se2.attr(e3, n3)
                            return t3 == null
                                ? r3 === '!='
                                : !r3 ||
                                      ((t3 += ''),
                                      r3 === '='
                                          ? t3 === i3
                                          : r3 === '!='
                                          ? t3 !== i3
                                          : r3 === '^='
                                          ? i3 && t3.indexOf(i3) === 0
                                          : r3 === '*='
                                          ? i3 && -1 < t3.indexOf(i3)
                                          : r3 === '$='
                                          ? i3 && t3.slice(-i3.length) === i3
                                          : r3 === '~='
                                          ? -1 <
                                            (
                                                ' ' +
                                                t3.replace(B2, ' ') +
                                                ' '
                                            ).indexOf(i3)
                                          : r3 === '|=' &&
                                            (t3 === i3 ||
                                                t3.slice(0, i3.length + 1) ===
                                                    i3 + '-'))
                        }
                    },
                    CHILD: function (h3, e3, t3, g3, v3) {
                        var y3 = h3.slice(0, 3) !== 'nth',
                            m3 = h3.slice(-4) !== 'last',
                            x3 = e3 === 'of-type'
                        return g3 === 1 && v3 === 0
                            ? function (e4) {
                                  return !!e4.parentNode
                              }
                            : function (e4, t4, n3) {
                                  var r3,
                                      i3,
                                      o3,
                                      a3,
                                      s3,
                                      u3,
                                      l3 =
                                          y3 !== m3
                                              ? 'nextSibling'
                                              : 'previousSibling',
                                      c3 = e4.parentNode,
                                      f3 = x3 && e4.nodeName.toLowerCase(),
                                      p3 = !n3 && !x3,
                                      d3 = !1
                                  if (c3) {
                                      if (y3) {
                                          for (; l3; ) {
                                              for (a3 = e4; (a3 = a3[l3]); )
                                                  if (
                                                      x3
                                                          ? a3.nodeName.toLowerCase() ===
                                                            f3
                                                          : a3.nodeType === 1
                                                  )
                                                      return !1
                                              u3 = l3 =
                                                  h3 === 'only' &&
                                                  !u3 &&
                                                  'nextSibling'
                                          }
                                          return !0
                                      }
                                      if (
                                          ((u3 = [
                                              m3 ? c3.firstChild : c3.lastChild,
                                          ]),
                                          m3 && p3)
                                      ) {
                                          for (
                                              d3 =
                                                  (s3 =
                                                      (r3 =
                                                          (i3 =
                                                              (o3 =
                                                                  (a3 = c3)[
                                                                      S2
                                                                  ] ||
                                                                  (a3[S2] =
                                                                      {}))[
                                                                  a3.uniqueID
                                                              ] ||
                                                              (o3[a3.uniqueID] =
                                                                  {}))[h3] ||
                                                          [])[0] === k2 &&
                                                      r3[1]) && r3[2],
                                                  a3 = s3 && c3.childNodes[s3];
                                              (a3 =
                                                  (++s3 && a3 && a3[l3]) ||
                                                  (d3 = s3 = 0) ||
                                                  u3.pop());

                                          )
                                              if (
                                                  a3.nodeType === 1 &&
                                                  ++d3 &&
                                                  a3 === e4
                                              ) {
                                                  i3[h3] = [k2, s3, d3]
                                                  break
                                              }
                                      } else if (
                                          (p3 &&
                                              (d3 = s3 =
                                                  (r3 =
                                                      (i3 =
                                                          (o3 =
                                                              (a3 = e4)[S2] ||
                                                              (a3[S2] = {}))[
                                                              a3.uniqueID
                                                          ] ||
                                                          (o3[a3.uniqueID] =
                                                              {}))[h3] ||
                                                      [])[0] === k2 && r3[1]),
                                          d3 === !1)
                                      )
                                          for (
                                              ;
                                              (a3 =
                                                  (++s3 && a3 && a3[l3]) ||
                                                  (d3 = s3 = 0) ||
                                                  u3.pop()) &&
                                              !(
                                                  (x3
                                                      ? a3.nodeName.toLowerCase() ===
                                                        f3
                                                      : a3.nodeType === 1) &&
                                                  ++d3 &&
                                                  (p3 &&
                                                      ((i3 =
                                                          (o3 =
                                                              a3[S2] ||
                                                              (a3[S2] = {}))[
                                                              a3.uniqueID
                                                          ] ||
                                                          (o3[a3.uniqueID] =
                                                              {}))[h3] = [
                                                          k2,
                                                          d3,
                                                      ]),
                                                  a3 === e4)
                                              );

                                          );
                                      return (
                                          (d3 -= v3) === g3 ||
                                          (d3 % g3 == 0 && 0 <= d3 / g3)
                                      )
                                  }
                              }
                    },
                    PSEUDO: function (e3, o3) {
                        var t3,
                            a3 =
                                b2.pseudos[e3] ||
                                b2.setFilters[e3.toLowerCase()] ||
                                se2.error('unsupported pseudo: ' + e3)
                        return a3[S2]
                            ? a3(o3)
                            : 1 < a3.length
                            ? ((t3 = [e3, e3, '', o3]),
                              b2.setFilters.hasOwnProperty(e3.toLowerCase())
                                  ? le2(function (e4, t4) {
                                        for (
                                            var n3,
                                                r3 = a3(e4, o3),
                                                i3 = r3.length;
                                            i3--;

                                        )
                                            e4[(n3 = P2(e4, r3[i3]))] = !(t4[
                                                n3
                                            ] = r3[i3])
                                    })
                                  : function (e4) {
                                        return a3(e4, 0, t3)
                                    })
                            : a3
                    },
                },
                pseudos: {
                    not: le2(function (e3) {
                        var r3 = [],
                            i3 = [],
                            s3 = f2(e3.replace($3, '$1'))
                        return s3[S2]
                            ? le2(function (e4, t3, n3, r4) {
                                  for (
                                      var i4,
                                          o3 = s3(e4, null, r4, []),
                                          a3 = e4.length;
                                      a3--;

                                  )
                                      (i4 = o3[a3]) && (e4[a3] = !(t3[a3] = i4))
                              })
                            : function (e4, t3, n3) {
                                  return (
                                      (r3[0] = e4),
                                      s3(r3, null, n3, i3),
                                      (r3[0] = null),
                                      !i3.pop()
                                  )
                              }
                    }),
                    has: le2(function (t3) {
                        return function (e3) {
                            return 0 < se2(t3, e3).length
                        }
                    }),
                    contains: le2(function (t3) {
                        return (
                            (t3 = t3.replace(te2, ne2)),
                            function (e3) {
                                return (
                                    -1 < (e3.textContent || o2(e3)).indexOf(t3)
                                )
                            }
                        )
                    }),
                    lang: le2(function (n3) {
                        return (
                            V2.test(n3 || '') ||
                                se2.error('unsupported lang: ' + n3),
                            (n3 = n3.replace(te2, ne2).toLowerCase()),
                            function (e3) {
                                var t3
                                do
                                    if (
                                        (t3 = E2
                                            ? e3.lang
                                            : e3.getAttribute('xml:lang') ||
                                              e3.getAttribute('lang'))
                                    )
                                        return (
                                            (t3 = t3.toLowerCase()) === n3 ||
                                            t3.indexOf(n3 + '-') === 0
                                        )
                                while (
                                    (e3 = e3.parentNode) &&
                                    e3.nodeType === 1
                                )
                                return !1
                            }
                        )
                    }),
                    target: function (e3) {
                        var t3 = n2.location && n2.location.hash
                        return t3 && t3.slice(1) === e3.id
                    },
                    root: function (e3) {
                        return e3 === a2
                    },
                    focus: function (e3) {
                        return (
                            e3 === C2.activeElement &&
                            (!C2.hasFocus || C2.hasFocus()) &&
                            !!(e3.type || e3.href || ~e3.tabIndex)
                        )
                    },
                    enabled: ge2(!1),
                    disabled: ge2(!0),
                    checked: function (e3) {
                        var t3 = e3.nodeName.toLowerCase()
                        return (
                            (t3 === 'input' && !!e3.checked) ||
                            (t3 === 'option' && !!e3.selected)
                        )
                    },
                    selected: function (e3) {
                        return (
                            e3.parentNode && e3.parentNode.selectedIndex,
                            e3.selected === !0
                        )
                    },
                    empty: function (e3) {
                        for (e3 = e3.firstChild; e3; e3 = e3.nextSibling)
                            if (e3.nodeType < 6) return !1
                        return !0
                    },
                    parent: function (e3) {
                        return !b2.pseudos.empty(e3)
                    },
                    header: function (e3) {
                        return J2.test(e3.nodeName)
                    },
                    input: function (e3) {
                        return Q2.test(e3.nodeName)
                    },
                    button: function (e3) {
                        var t3 = e3.nodeName.toLowerCase()
                        return (
                            (t3 === 'input' && e3.type === 'button') ||
                            t3 === 'button'
                        )
                    },
                    text: function (e3) {
                        var t3
                        return (
                            e3.nodeName.toLowerCase() === 'input' &&
                            e3.type === 'text' &&
                            ((t3 = e3.getAttribute('type')) == null ||
                                t3.toLowerCase() === 'text')
                        )
                    },
                    first: ve2(function () {
                        return [0]
                    }),
                    last: ve2(function (e3, t3) {
                        return [t3 - 1]
                    }),
                    eq: ve2(function (e3, t3, n3) {
                        return [n3 < 0 ? n3 + t3 : n3]
                    }),
                    even: ve2(function (e3, t3) {
                        for (var n3 = 0; n3 < t3; n3 += 2) e3.push(n3)
                        return e3
                    }),
                    odd: ve2(function (e3, t3) {
                        for (var n3 = 1; n3 < t3; n3 += 2) e3.push(n3)
                        return e3
                    }),
                    lt: ve2(function (e3, t3, n3) {
                        for (
                            var r3 = n3 < 0 ? n3 + t3 : t3 < n3 ? t3 : n3;
                            0 <= --r3;

                        )
                            e3.push(r3)
                        return e3
                    }),
                    gt: ve2(function (e3, t3, n3) {
                        for (var r3 = n3 < 0 ? n3 + t3 : n3; ++r3 < t3; )
                            e3.push(r3)
                        return e3
                    }),
                },
            }).pseudos.nth = b2.pseudos.eq),
        { radio: !0, checkbox: !0, file: !0, password: !0, image: !0 }))
            b2.pseudos[e2] = de2(e2)
        for (e2 in { submit: !0, reset: !0 }) b2.pseudos[e2] = he2(e2)
        function me2() {}
        function xe2(e3) {
            for (var t3 = 0, n3 = e3.length, r3 = ''; t3 < n3; t3++)
                r3 += e3[t3].value
            return r3
        }
        function be2(s3, e3, t3) {
            var u3 = e3.dir,
                l3 = e3.next,
                c3 = l3 || u3,
                f3 = t3 && c3 === 'parentNode',
                p3 = r2++
            return e3.first
                ? function (e4, t4, n3) {
                      for (; (e4 = e4[u3]); )
                          if (e4.nodeType === 1 || f3) return s3(e4, t4, n3)
                      return !1
                  }
                : function (e4, t4, n3) {
                      var r3,
                          i3,
                          o3,
                          a3 = [k2, p3]
                      if (n3) {
                          for (; (e4 = e4[u3]); )
                              if ((e4.nodeType === 1 || f3) && s3(e4, t4, n3))
                                  return !0
                      } else
                          for (; (e4 = e4[u3]); )
                              if (e4.nodeType === 1 || f3)
                                  if (
                                      ((i3 =
                                          (o3 = e4[S2] || (e4[S2] = {}))[
                                              e4.uniqueID
                                          ] || (o3[e4.uniqueID] = {})),
                                      l3 && l3 === e4.nodeName.toLowerCase())
                                  )
                                      e4 = e4[u3] || e4
                                  else {
                                      if (
                                          (r3 = i3[c3]) &&
                                          r3[0] === k2 &&
                                          r3[1] === p3
                                      )
                                          return (a3[2] = r3[2])
                                      if (((i3[c3] = a3)[2] = s3(e4, t4, n3)))
                                          return !0
                                  }
                      return !1
                  }
        }
        function we2(i3) {
            return 1 < i3.length
                ? function (e3, t3, n3) {
                      for (var r3 = i3.length; r3--; )
                          if (!i3[r3](e3, t3, n3)) return !1
                      return !0
                  }
                : i3[0]
        }
        function Te2(e3, t3, n3, r3, i3) {
            for (
                var o3, a3 = [], s3 = 0, u3 = e3.length, l3 = t3 != null;
                s3 < u3;
                s3++
            )
                (o3 = e3[s3]) &&
                    ((n3 && !n3(o3, r3, i3)) ||
                        (a3.push(o3), l3 && t3.push(s3)))
            return a3
        }
        function Ce2(d3, h3, g3, v3, y3, e3) {
            return (
                v3 && !v3[S2] && (v3 = Ce2(v3)),
                y3 && !y3[S2] && (y3 = Ce2(y3, e3)),
                le2(function (e4, t3, n3, r3) {
                    var i3,
                        o3,
                        a3,
                        s3 = [],
                        u3 = [],
                        l3 = t3.length,
                        c3 =
                            e4 ||
                            (function (e5, t4, n4) {
                                for (var r4 = 0, i4 = t4.length; r4 < i4; r4++)
                                    se2(e5, t4[r4], n4)
                                return n4
                            })(h3 || '*', n3.nodeType ? [n3] : n3, []),
                        f3 = !d3 || (!e4 && h3) ? c3 : Te2(c3, s3, d3, n3, r3),
                        p3 = g3 ? (y3 || (e4 ? d3 : l3 || v3) ? [] : t3) : f3
                    if ((g3 && g3(f3, p3, n3, r3), v3))
                        for (
                            i3 = Te2(p3, u3),
                                v3(i3, [], n3, r3),
                                o3 = i3.length;
                            o3--;

                        )
                            (a3 = i3[o3]) && (p3[u3[o3]] = !(f3[u3[o3]] = a3))
                    if (e4) {
                        if (y3 || d3) {
                            if (y3) {
                                for (i3 = [], o3 = p3.length; o3--; )
                                    (a3 = p3[o3]) && i3.push((f3[o3] = a3))
                                y3(null, (p3 = []), i3, r3)
                            }
                            for (o3 = p3.length; o3--; )
                                (a3 = p3[o3]) &&
                                    -1 < (i3 = y3 ? P2(e4, a3) : s3[o3]) &&
                                    (e4[i3] = !(t3[i3] = a3))
                        }
                    } else (p3 = Te2(p3 === t3 ? p3.splice(l3, p3.length) : p3)), y3 ? y3(null, t3, p3, r3) : H2.apply(t3, p3)
                })
            )
        }
        function Ee2(e3) {
            for (
                var i3,
                    t3,
                    n3,
                    r3 = e3.length,
                    o3 = b2.relative[e3[0].type],
                    a3 = o3 || b2.relative[' '],
                    s3 = o3 ? 1 : 0,
                    u3 = be2(
                        function (e4) {
                            return e4 === i3
                        },
                        a3,
                        !0
                    ),
                    l3 = be2(
                        function (e4) {
                            return -1 < P2(i3, e4)
                        },
                        a3,
                        !0
                    ),
                    c3 = [
                        function (e4, t4, n4) {
                            var r4 =
                                (!o3 && (n4 || t4 !== w2)) ||
                                ((i3 = t4).nodeType
                                    ? u3(e4, t4, n4)
                                    : l3(e4, t4, n4))
                            return (i3 = null), r4
                        },
                    ];
                s3 < r3;
                s3++
            )
                if ((t3 = b2.relative[e3[s3].type])) c3 = [be2(we2(c3), t3)]
                else {
                    if (
                        (t3 = b2.filter[e3[s3].type].apply(
                            null,
                            e3[s3].matches
                        ))[S2]
                    ) {
                        for (
                            n3 = ++s3;
                            n3 < r3 && !b2.relative[e3[n3].type];
                            n3++
                        );
                        return Ce2(
                            1 < s3 && we2(c3),
                            1 < s3 &&
                                xe2(
                                    e3
                                        .slice(0, s3 - 1)
                                        .concat({
                                            value:
                                                e3[s3 - 2].type === ' '
                                                    ? '*'
                                                    : '',
                                        })
                                ).replace($3, '$1'),
                            t3,
                            s3 < n3 && Ee2(e3.slice(s3, n3)),
                            n3 < r3 && Ee2((e3 = e3.slice(n3))),
                            n3 < r3 && xe2(e3)
                        )
                    }
                    c3.push(t3)
                }
            return we2(c3)
        }
        return (
            (me2.prototype = b2.filters = b2.pseudos),
            (b2.setFilters = new me2()),
            (h2 = se2.tokenize =
                function (e3, t3) {
                    var n3,
                        r3,
                        i3,
                        o3,
                        a3,
                        s3,
                        u3,
                        l3 = x2[e3 + ' ']
                    if (l3) return t3 ? 0 : l3.slice(0)
                    for (a3 = e3, s3 = [], u3 = b2.preFilter; a3; ) {
                        for (o3 in ((n3 && !(r3 = _2.exec(a3))) ||
                            (r3 && (a3 = a3.slice(r3[0].length) || a3),
                            s3.push((i3 = []))),
                        (n3 = !1),
                        (r3 = z2.exec(a3)) &&
                            ((n3 = r3.shift()),
                            i3.push({
                                value: n3,
                                type: r3[0].replace($3, ' '),
                            }),
                            (a3 = a3.slice(n3.length))),
                        b2.filter))
                            !(r3 = G2[o3].exec(a3)) ||
                                (u3[o3] && !(r3 = u3[o3](r3))) ||
                                ((n3 = r3.shift()),
                                i3.push({ value: n3, type: o3, matches: r3 }),
                                (a3 = a3.slice(n3.length)))
                        if (!n3) break
                    }
                    return t3
                        ? a3.length
                        : a3
                        ? se2.error(e3)
                        : x2(e3, s3).slice(0)
                }),
            (f2 = se2.compile =
                function (e3, t3) {
                    var n3,
                        v3,
                        y3,
                        m3,
                        x3,
                        r3,
                        i3 = [],
                        o3 = [],
                        a3 = A2[e3 + ' ']
                    if (!a3) {
                        for (t3 || (t3 = h2(e3)), n3 = t3.length; n3--; )
                            (a3 = Ee2(t3[n3]))[S2] ? i3.push(a3) : o3.push(a3)
                        ;(a3 = A2(
                            e3,
                            ((v3 = o3),
                            (m3 = 0 < (y3 = i3).length),
                            (x3 = 0 < v3.length),
                            (r3 = function (e4, t4, n4, r4, i4) {
                                var o4,
                                    a4,
                                    s3,
                                    u3 = 0,
                                    l3 = '0',
                                    c3 = e4 && [],
                                    f3 = [],
                                    p3 = w2,
                                    d3 = e4 || (x3 && b2.find.TAG('*', i4)),
                                    h3 = (k2 +=
                                        p3 == null ? 1 : Math.random() || 0.1),
                                    g3 = d3.length
                                for (
                                    i4 && (w2 = t4 == C2 || t4 || i4);
                                    l3 !== g3 && (o4 = d3[l3]) != null;
                                    l3++
                                ) {
                                    if (x3 && o4) {
                                        for (
                                            a4 = 0,
                                                t4 ||
                                                    o4.ownerDocument == C2 ||
                                                    (T2(o4), (n4 = !E2));
                                            (s3 = v3[a4++]);

                                        )
                                            if (s3(o4, t4 || C2, n4)) {
                                                r4.push(o4)
                                                break
                                            }
                                        i4 && (k2 = h3)
                                    }
                                    m3 &&
                                        ((o4 = !s3 && o4) && u3--,
                                        e4 && c3.push(o4))
                                }
                                if (((u3 += l3), m3 && l3 !== u3)) {
                                    for (a4 = 0; (s3 = y3[a4++]); )
                                        s3(c3, f3, t4, n4)
                                    if (e4) {
                                        if (0 < u3)
                                            for (; l3--; )
                                                c3[l3] ||
                                                    f3[l3] ||
                                                    (f3[l3] = q2.call(r4))
                                        f3 = Te2(f3)
                                    }
                                    H2.apply(r4, f3),
                                        i4 &&
                                            !e4 &&
                                            0 < f3.length &&
                                            1 < u3 + y3.length &&
                                            se2.uniqueSort(r4)
                                }
                                return i4 && ((k2 = h3), (w2 = p3)), c3
                            }),
                            m3 ? le2(r3) : r3)
                        )).selector = e3
                    }
                    return a3
                }),
            (g2 = se2.select =
                function (e3, t3, n3, r3) {
                    var i3,
                        o3,
                        a3,
                        s3,
                        u3,
                        l3 = typeof e3 == 'function' && e3,
                        c3 = !r3 && h2((e3 = l3.selector || e3))
                    if (((n3 = n3 || []), c3.length === 1)) {
                        if (
                            2 < (o3 = c3[0] = c3[0].slice(0)).length &&
                            (a3 = o3[0]).type === 'ID' &&
                            t3.nodeType === 9 &&
                            E2 &&
                            b2.relative[o3[1].type]
                        ) {
                            if (
                                !(t3 = (b2.find.ID(
                                    a3.matches[0].replace(te2, ne2),
                                    t3
                                ) || [])[0])
                            )
                                return n3
                            l3 && (t3 = t3.parentNode),
                                (e3 = e3.slice(o3.shift().value.length))
                        }
                        for (
                            i3 = G2.needsContext.test(e3) ? 0 : o3.length;
                            i3-- &&
                            ((a3 = o3[i3]), !b2.relative[(s3 = a3.type)]);

                        )
                            if (
                                (u3 = b2.find[s3]) &&
                                (r3 = u3(
                                    a3.matches[0].replace(te2, ne2),
                                    (ee2.test(o3[0].type) &&
                                        ye2(t3.parentNode)) ||
                                        t3
                                ))
                            ) {
                                if (
                                    (o3.splice(i3, 1),
                                    !(e3 = r3.length && xe2(o3)))
                                )
                                    return H2.apply(n3, r3), n3
                                break
                            }
                    }
                    return (
                        (l3 || f2(e3, c3))(
                            r3,
                            t3,
                            !E2,
                            n3,
                            !t3 || (ee2.test(e3) && ye2(t3.parentNode)) || t3
                        ),
                        n3
                    )
                }),
            (d2.sortStable = S2.split('').sort(D2).join('') === S2),
            (d2.detectDuplicates = !!l2),
            T2(),
            (d2.sortDetached = ce2(function (e3) {
                return (
                    1 & e3.compareDocumentPosition(C2.createElement('fieldset'))
                )
            })),
            ce2(function (e3) {
                return (
                    (e3.innerHTML = "<a href='#'></a>"),
                    e3.firstChild.getAttribute('href') === '#'
                )
            }) ||
                fe2('type|href|height|width', function (e3, t3, n3) {
                    if (!n3)
                        return e3.getAttribute(
                            t3,
                            t3.toLowerCase() === 'type' ? 1 : 2
                        )
                }),
            (d2.attributes &&
                ce2(function (e3) {
                    return (
                        (e3.innerHTML = '<input/>'),
                        e3.firstChild.setAttribute('value', ''),
                        e3.firstChild.getAttribute('value') === ''
                    )
                })) ||
                fe2('value', function (e3, t3, n3) {
                    if (!n3 && e3.nodeName.toLowerCase() === 'input')
                        return e3.defaultValue
                }),
            ce2(function (e3) {
                return e3.getAttribute('disabled') == null
            }) ||
                fe2(R2, function (e3, t3, n3) {
                    var r3
                    if (!n3)
                        return e3[t3] === !0
                            ? t3.toLowerCase()
                            : (r3 = e3.getAttributeNode(t3)) && r3.specified
                            ? r3.value
                            : null
                }),
            se2
        )
    })(C)
    ;(S.find = d),
        (S.expr = d.selectors),
        (S.expr[':'] = S.expr.pseudos),
        (S.uniqueSort = S.unique = d.uniqueSort),
        (S.text = d.getText),
        (S.isXMLDoc = d.isXML),
        (S.contains = d.contains),
        (S.escapeSelector = d.escape)
    var h = function (e2, t2, n2) {
            for (
                var r2 = [], i2 = n2 !== void 0;
                (e2 = e2[t2]) && e2.nodeType !== 9;

            )
                if (e2.nodeType === 1) {
                    if (i2 && S(e2).is(n2)) break
                    r2.push(e2)
                }
            return r2
        },
        T = function (e2, t2) {
            for (var n2 = []; e2; e2 = e2.nextSibling)
                e2.nodeType === 1 && e2 !== t2 && n2.push(e2)
            return n2
        },
        k = S.expr.match.needsContext
    function A(e2, t2) {
        return e2.nodeName && e2.nodeName.toLowerCase() === t2.toLowerCase()
    }
    var N = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i
    function D(e2, n2, r2) {
        return m(n2)
            ? S.grep(e2, function (e3, t2) {
                  return !!n2.call(e3, t2, e3) !== r2
              })
            : n2.nodeType
            ? S.grep(e2, function (e3) {
                  return (e3 === n2) !== r2
              })
            : typeof n2 != 'string'
            ? S.grep(e2, function (e3) {
                  return -1 < i.call(n2, e3) !== r2
              })
            : S.filter(n2, e2, r2)
    }
    ;(S.filter = function (e2, t2, n2) {
        var r2 = t2[0]
        return (
            n2 && (e2 = ':not(' + e2 + ')'),
            t2.length === 1 && r2.nodeType === 1
                ? S.find.matchesSelector(r2, e2)
                    ? [r2]
                    : []
                : S.find.matches(
                      e2,
                      S.grep(t2, function (e3) {
                          return e3.nodeType === 1
                      })
                  )
        )
    }),
        S.fn.extend({
            find: function (e2) {
                var t2,
                    n2,
                    r2 = this.length,
                    i2 = this
                if (typeof e2 != 'string')
                    return this.pushStack(
                        S(e2).filter(function () {
                            for (t2 = 0; t2 < r2; t2++)
                                if (S.contains(i2[t2], this)) return !0
                        })
                    )
                for (n2 = this.pushStack([]), t2 = 0; t2 < r2; t2++)
                    S.find(e2, i2[t2], n2)
                return 1 < r2 ? S.uniqueSort(n2) : n2
            },
            filter: function (e2) {
                return this.pushStack(D(this, e2 || [], !1))
            },
            not: function (e2) {
                return this.pushStack(D(this, e2 || [], !0))
            },
            is: function (e2) {
                return !!D(
                    this,
                    typeof e2 == 'string' && k.test(e2) ? S(e2) : e2 || [],
                    !1
                ).length
            },
        })
    var j,
        q = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/
    ;((S.fn.init = function (e2, t2, n2) {
        var r2, i2
        if (!e2) return this
        if (((n2 = n2 || j), typeof e2 == 'string')) {
            if (
                !(r2 =
                    e2[0] === '<' && e2[e2.length - 1] === '>' && 3 <= e2.length
                        ? [null, e2, null]
                        : q.exec(e2)) ||
                (!r2[1] && t2)
            )
                return !t2 || t2.jquery
                    ? (t2 || n2).find(e2)
                    : this.constructor(t2).find(e2)
            if (r2[1]) {
                if (
                    ((t2 = t2 instanceof S ? t2[0] : t2),
                    S.merge(
                        this,
                        S.parseHTML(
                            r2[1],
                            t2 && t2.nodeType ? t2.ownerDocument || t2 : E,
                            !0
                        )
                    ),
                    N.test(r2[1]) && S.isPlainObject(t2))
                )
                    for (r2 in t2)
                        m(this[r2]) ? this[r2](t2[r2]) : this.attr(r2, t2[r2])
                return this
            }
            return (
                (i2 = E.getElementById(r2[2])) &&
                    ((this[0] = i2), (this.length = 1)),
                this
            )
        }
        return e2.nodeType
            ? ((this[0] = e2), (this.length = 1), this)
            : m(e2)
            ? n2.ready !== void 0
                ? n2.ready(e2)
                : e2(S)
            : S.makeArray(e2, this)
    }).prototype = S.fn),
        (j = S(E))
    var L = /^(?:parents|prev(?:Until|All))/,
        H = { children: !0, contents: !0, next: !0, prev: !0 }
    function O(e2, t2) {
        for (; (e2 = e2[t2]) && e2.nodeType !== 1; );
        return e2
    }
    S.fn.extend({
        has: function (e2) {
            var t2 = S(e2, this),
                n2 = t2.length
            return this.filter(function () {
                for (var e3 = 0; e3 < n2; e3++)
                    if (S.contains(this, t2[e3])) return !0
            })
        },
        closest: function (e2, t2) {
            var n2,
                r2 = 0,
                i2 = this.length,
                o2 = [],
                a2 = typeof e2 != 'string' && S(e2)
            if (!k.test(e2)) {
                for (; r2 < i2; r2++)
                    for (n2 = this[r2]; n2 && n2 !== t2; n2 = n2.parentNode)
                        if (
                            n2.nodeType < 11 &&
                            (a2
                                ? -1 < a2.index(n2)
                                : n2.nodeType === 1 &&
                                  S.find.matchesSelector(n2, e2))
                        ) {
                            o2.push(n2)
                            break
                        }
            }
            return this.pushStack(1 < o2.length ? S.uniqueSort(o2) : o2)
        },
        index: function (e2) {
            return e2
                ? typeof e2 == 'string'
                    ? i.call(S(e2), this[0])
                    : i.call(this, e2.jquery ? e2[0] : e2)
                : this[0] && this[0].parentNode
                ? this.first().prevAll().length
                : -1
        },
        add: function (e2, t2) {
            return this.pushStack(S.uniqueSort(S.merge(this.get(), S(e2, t2))))
        },
        addBack: function (e2) {
            return this.add(
                e2 == null ? this.prevObject : this.prevObject.filter(e2)
            )
        },
    }),
        S.each(
            {
                parent: function (e2) {
                    var t2 = e2.parentNode
                    return t2 && t2.nodeType !== 11 ? t2 : null
                },
                parents: function (e2) {
                    return h(e2, 'parentNode')
                },
                parentsUntil: function (e2, t2, n2) {
                    return h(e2, 'parentNode', n2)
                },
                next: function (e2) {
                    return O(e2, 'nextSibling')
                },
                prev: function (e2) {
                    return O(e2, 'previousSibling')
                },
                nextAll: function (e2) {
                    return h(e2, 'nextSibling')
                },
                prevAll: function (e2) {
                    return h(e2, 'previousSibling')
                },
                nextUntil: function (e2, t2, n2) {
                    return h(e2, 'nextSibling', n2)
                },
                prevUntil: function (e2, t2, n2) {
                    return h(e2, 'previousSibling', n2)
                },
                siblings: function (e2) {
                    return T((e2.parentNode || {}).firstChild, e2)
                },
                children: function (e2) {
                    return T(e2.firstChild)
                },
                contents: function (e2) {
                    return e2.contentDocument != null && r(e2.contentDocument)
                        ? e2.contentDocument
                        : (A(e2, 'template') && (e2 = e2.content || e2),
                          S.merge([], e2.childNodes))
                },
            },
            function (r2, i2) {
                S.fn[r2] = function (e2, t2) {
                    var n2 = S.map(this, i2, e2)
                    return (
                        r2.slice(-5) !== 'Until' && (t2 = e2),
                        t2 && typeof t2 == 'string' && (n2 = S.filter(t2, n2)),
                        1 < this.length &&
                            (H[r2] || S.uniqueSort(n2),
                            L.test(r2) && n2.reverse()),
                        this.pushStack(n2)
                    )
                }
            }
        )
    var P = /[^\x20\t\r\n\f]+/g
    function R(e2) {
        return e2
    }
    function M(e2) {
        throw e2
    }
    function I(e2, t2, n2, r2) {
        var i2
        try {
            e2 && m((i2 = e2.promise))
                ? i2.call(e2).done(t2).fail(n2)
                : e2 && m((i2 = e2.then))
                ? i2.call(e2, t2, n2)
                : t2.apply(void 0, [e2].slice(r2))
        } catch (e3) {
            n2.apply(void 0, [e3])
        }
    }
    ;(S.Callbacks = function (r2) {
        var e2, n2
        r2 =
            typeof r2 == 'string'
                ? ((e2 = r2),
                  (n2 = {}),
                  S.each(e2.match(P) || [], function (e3, t3) {
                      n2[t3] = !0
                  }),
                  n2)
                : S.extend({}, r2)
        var i2,
            t2,
            o2,
            a2,
            s2 = [],
            u2 = [],
            l2 = -1,
            c2 = function () {
                for (a2 = a2 || r2.once, o2 = i2 = !0; u2.length; l2 = -1)
                    for (t2 = u2.shift(); ++l2 < s2.length; )
                        s2[l2].apply(t2[0], t2[1]) === !1 &&
                            r2.stopOnFalse &&
                            ((l2 = s2.length), (t2 = !1))
                r2.memory || (t2 = !1), (i2 = !1), a2 && (s2 = t2 ? [] : '')
            },
            f2 = {
                add: function () {
                    return (
                        s2 &&
                            (t2 && !i2 && ((l2 = s2.length - 1), u2.push(t2)),
                            (function n3(e3) {
                                S.each(e3, function (e4, t3) {
                                    m(t3)
                                        ? (r2.unique && f2.has(t3)) ||
                                          s2.push(t3)
                                        : t3 &&
                                          t3.length &&
                                          w(t3) !== 'string' &&
                                          n3(t3)
                                })
                            })(arguments),
                            t2 && !i2 && c2()),
                        this
                    )
                },
                remove: function () {
                    return (
                        S.each(arguments, function (e3, t3) {
                            for (var n3; -1 < (n3 = S.inArray(t3, s2, n3)); )
                                s2.splice(n3, 1), n3 <= l2 && l2--
                        }),
                        this
                    )
                },
                has: function (e3) {
                    return e3 ? -1 < S.inArray(e3, s2) : 0 < s2.length
                },
                empty: function () {
                    return s2 && (s2 = []), this
                },
                disable: function () {
                    return (a2 = u2 = []), (s2 = t2 = ''), this
                },
                disabled: function () {
                    return !s2
                },
                lock: function () {
                    return (a2 = u2 = []), t2 || i2 || (s2 = t2 = ''), this
                },
                locked: function () {
                    return !!a2
                },
                fireWith: function (e3, t3) {
                    return (
                        a2 ||
                            ((t3 = [
                                e3,
                                (t3 = t3 || []).slice ? t3.slice() : t3,
                            ]),
                            u2.push(t3),
                            i2 || c2()),
                        this
                    )
                },
                fire: function () {
                    return f2.fireWith(this, arguments), this
                },
                fired: function () {
                    return !!o2
                },
            }
        return f2
    }),
        S.extend({
            Deferred: function (e2) {
                var o2 = [
                        [
                            'notify',
                            'progress',
                            S.Callbacks('memory'),
                            S.Callbacks('memory'),
                            2,
                        ],
                        [
                            'resolve',
                            'done',
                            S.Callbacks('once memory'),
                            S.Callbacks('once memory'),
                            0,
                            'resolved',
                        ],
                        [
                            'reject',
                            'fail',
                            S.Callbacks('once memory'),
                            S.Callbacks('once memory'),
                            1,
                            'rejected',
                        ],
                    ],
                    i2 = 'pending',
                    a2 = {
                        state: function () {
                            return i2
                        },
                        always: function () {
                            return s2.done(arguments).fail(arguments), this
                        },
                        catch: function (e3) {
                            return a2.then(null, e3)
                        },
                        pipe: function () {
                            var i3 = arguments
                            return S.Deferred(function (r2) {
                                S.each(o2, function (e3, t2) {
                                    var n2 = m(i3[t2[4]]) && i3[t2[4]]
                                    s2[t2[1]](function () {
                                        var e4 = n2 && n2.apply(this, arguments)
                                        e4 && m(e4.promise)
                                            ? e4
                                                  .promise()
                                                  .progress(r2.notify)
                                                  .done(r2.resolve)
                                                  .fail(r2.reject)
                                            : r2[t2[0] + 'With'](
                                                  this,
                                                  n2 ? [e4] : arguments
                                              )
                                    })
                                }),
                                    (i3 = null)
                            }).promise()
                        },
                        then: function (t2, n2, r2) {
                            var u2 = 0
                            function l2(i3, o3, a3, s3) {
                                return function () {
                                    var n3 = this,
                                        r3 = arguments,
                                        e3 = function () {
                                            var e4, t4
                                            if (!(i3 < u2)) {
                                                if (
                                                    (e4 = a3.apply(n3, r3)) ===
                                                    o3.promise()
                                                )
                                                    throw new TypeError(
                                                        'Thenable self-resolution'
                                                    )
                                                ;(t4 =
                                                    e4 &&
                                                    (typeof e4 == 'object' ||
                                                        typeof e4 ==
                                                            'function') &&
                                                    e4.then),
                                                    m(t4)
                                                        ? s3
                                                            ? t4.call(
                                                                  e4,
                                                                  l2(
                                                                      u2,
                                                                      o3,
                                                                      R,
                                                                      s3
                                                                  ),
                                                                  l2(
                                                                      u2,
                                                                      o3,
                                                                      M,
                                                                      s3
                                                                  )
                                                              )
                                                            : (u2++,
                                                              t4.call(
                                                                  e4,
                                                                  l2(
                                                                      u2,
                                                                      o3,
                                                                      R,
                                                                      s3
                                                                  ),
                                                                  l2(
                                                                      u2,
                                                                      o3,
                                                                      M,
                                                                      s3
                                                                  ),
                                                                  l2(
                                                                      u2,
                                                                      o3,
                                                                      R,
                                                                      o3.notifyWith
                                                                  )
                                                              ))
                                                        : (a3 !== R &&
                                                              ((n3 = void 0),
                                                              (r3 = [e4])),
                                                          (
                                                              s3 ||
                                                              o3.resolveWith
                                                          )(n3, r3))
                                            }
                                        },
                                        t3 = s3
                                            ? e3
                                            : function () {
                                                  try {
                                                      e3()
                                                  } catch (e4) {
                                                      S.Deferred
                                                          .exceptionHook &&
                                                          S.Deferred.exceptionHook(
                                                              e4,
                                                              t3.stackTrace
                                                          ),
                                                          u2 <= i3 + 1 &&
                                                              (a3 !== M &&
                                                                  ((n3 =
                                                                      void 0),
                                                                  (r3 = [e4])),
                                                              o3.rejectWith(
                                                                  n3,
                                                                  r3
                                                              ))
                                                  }
                                              }
                                    i3
                                        ? t3()
                                        : (S.Deferred.getStackHook &&
                                              (t3.stackTrace =
                                                  S.Deferred.getStackHook()),
                                          C.setTimeout(t3))
                                }
                            }
                            return S.Deferred(function (e3) {
                                o2[0][3].add(
                                    l2(0, e3, m(r2) ? r2 : R, e3.notifyWith)
                                ),
                                    o2[1][3].add(l2(0, e3, m(t2) ? t2 : R)),
                                    o2[2][3].add(l2(0, e3, m(n2) ? n2 : M))
                            }).promise()
                        },
                        promise: function (e3) {
                            return e3 != null ? S.extend(e3, a2) : a2
                        },
                    },
                    s2 = {}
                return (
                    S.each(o2, function (e3, t2) {
                        var n2 = t2[2],
                            r2 = t2[5]
                        ;(a2[t2[1]] = n2.add),
                            r2 &&
                                n2.add(
                                    function () {
                                        i2 = r2
                                    },
                                    o2[3 - e3][2].disable,
                                    o2[3 - e3][3].disable,
                                    o2[0][2].lock,
                                    o2[0][3].lock
                                ),
                            n2.add(t2[3].fire),
                            (s2[t2[0]] = function () {
                                return (
                                    s2[t2[0] + 'With'](
                                        this === s2 ? void 0 : this,
                                        arguments
                                    ),
                                    this
                                )
                            }),
                            (s2[t2[0] + 'With'] = n2.fireWith)
                    }),
                    a2.promise(s2),
                    e2 && e2.call(s2, s2),
                    s2
                )
            },
            when: function (e2) {
                var n2 = arguments.length,
                    t2 = n2,
                    r2 = Array(t2),
                    i2 = s.call(arguments),
                    o2 = S.Deferred(),
                    a2 = function (t3) {
                        return function (e3) {
                            ;(r2[t3] = this),
                                (i2[t3] =
                                    1 < arguments.length
                                        ? s.call(arguments)
                                        : e3),
                                --n2 || o2.resolveWith(r2, i2)
                        }
                    }
                if (
                    n2 <= 1 &&
                    (I(e2, o2.done(a2(t2)).resolve, o2.reject, !n2),
                    o2.state() === 'pending' || m(i2[t2] && i2[t2].then))
                )
                    return o2.then()
                for (; t2--; ) I(i2[t2], a2(t2), o2.reject)
                return o2.promise()
            },
        })
    var W = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/
    ;(S.Deferred.exceptionHook = function (e2, t2) {
        C.console &&
            C.console.warn &&
            e2 &&
            W.test(e2.name) &&
            C.console.warn(
                'jQuery.Deferred exception: ' + e2.message,
                e2.stack,
                t2
            )
    }),
        (S.readyException = function (e2) {
            C.setTimeout(function () {
                throw e2
            })
        })
    var F = S.Deferred()
    function B() {
        E.removeEventListener('DOMContentLoaded', B),
            C.removeEventListener('load', B),
            S.ready()
    }
    ;(S.fn.ready = function (e2) {
        return (
            F.then(e2).catch(function (e3) {
                S.readyException(e3)
            }),
            this
        )
    }),
        S.extend({
            isReady: !1,
            readyWait: 1,
            ready: function (e2) {
                ;(e2 === !0 ? --S.readyWait : S.isReady) ||
                    ((S.isReady = !0) !== e2 && 0 < --S.readyWait) ||
                    F.resolveWith(E, [S])
            },
        }),
        (S.ready.then = F.then),
        E.readyState === 'complete' ||
        (E.readyState !== 'loading' && !E.documentElement.doScroll)
            ? C.setTimeout(S.ready)
            : (E.addEventListener('DOMContentLoaded', B),
              C.addEventListener('load', B))
    var $2 = function (e2, t2, n2, r2, i2, o2, a2) {
            var s2 = 0,
                u2 = e2.length,
                l2 = n2 == null
            if (w(n2) === 'object')
                for (s2 in ((i2 = !0), n2)) $2(e2, t2, s2, n2[s2], !0, o2, a2)
            else if (
                r2 !== void 0 &&
                ((i2 = !0),
                m(r2) || (a2 = !0),
                l2 &&
                    (a2
                        ? (t2.call(e2, r2), (t2 = null))
                        : ((l2 = t2),
                          (t2 = function (e3, t3, n3) {
                              return l2.call(S(e3), n3)
                          }))),
                t2)
            )
                for (; s2 < u2; s2++)
                    t2(
                        e2[s2],
                        n2,
                        a2 ? r2 : r2.call(e2[s2], s2, t2(e2[s2], n2))
                    )
            return i2 ? e2 : l2 ? t2.call(e2) : u2 ? t2(e2[0], n2) : o2
        },
        _ = /^-ms-/,
        z = /-([a-z])/g
    function U(e2, t2) {
        return t2.toUpperCase()
    }
    function X(e2) {
        return e2.replace(_, 'ms-').replace(z, U)
    }
    var V = function (e2) {
        return e2.nodeType === 1 || e2.nodeType === 9 || !+e2.nodeType
    }
    function G() {
        this.expando = S.expando + G.uid++
    }
    ;(G.uid = 1),
        (G.prototype = {
            cache: function (e2) {
                var t2 = e2[this.expando]
                return (
                    t2 ||
                        ((t2 = {}),
                        V(e2) &&
                            (e2.nodeType
                                ? (e2[this.expando] = t2)
                                : Object.defineProperty(e2, this.expando, {
                                      value: t2,
                                      configurable: !0,
                                  }))),
                    t2
                )
            },
            set: function (e2, t2, n2) {
                var r2,
                    i2 = this.cache(e2)
                if (typeof t2 == 'string') i2[X(t2)] = n2
                else for (r2 in t2) i2[X(r2)] = t2[r2]
                return i2
            },
            get: function (e2, t2) {
                return t2 === void 0
                    ? this.cache(e2)
                    : e2[this.expando] && e2[this.expando][X(t2)]
            },
            access: function (e2, t2, n2) {
                return t2 === void 0 ||
                    (t2 && typeof t2 == 'string' && n2 === void 0)
                    ? this.get(e2, t2)
                    : (this.set(e2, t2, n2), n2 !== void 0 ? n2 : t2)
            },
            remove: function (e2, t2) {
                var n2,
                    r2 = e2[this.expando]
                if (r2 !== void 0) {
                    if (t2 !== void 0)
                        for (
                            n2 = (t2 = Array.isArray(t2)
                                ? t2.map(X)
                                : ((t2 = X(t2)) in r2)
                                ? [t2]
                                : t2.match(P) || []).length;
                            n2--;

                        )
                            delete r2[t2[n2]]
                    ;(t2 === void 0 || S.isEmptyObject(r2)) &&
                        (e2.nodeType
                            ? (e2[this.expando] = void 0)
                            : delete e2[this.expando])
                }
            },
            hasData: function (e2) {
                var t2 = e2[this.expando]
                return t2 !== void 0 && !S.isEmptyObject(t2)
            },
        })
    var Y = new G(),
        Q = new G(),
        J = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
        K = /[A-Z]/g
    function Z(e2, t2, n2) {
        var r2, i2
        if (n2 === void 0 && e2.nodeType === 1)
            if (
                ((r2 = 'data-' + t2.replace(K, '-$&').toLowerCase()),
                typeof (n2 = e2.getAttribute(r2)) == 'string')
            ) {
                try {
                    n2 =
                        (i2 = n2) === 'true' ||
                        (i2 !== 'false' &&
                            (i2 === 'null'
                                ? null
                                : i2 === +i2 + ''
                                ? +i2
                                : J.test(i2)
                                ? JSON.parse(i2)
                                : i2))
                } catch {}
                Q.set(e2, t2, n2)
            } else n2 = void 0
        return n2
    }
    S.extend({
        hasData: function (e2) {
            return Q.hasData(e2) || Y.hasData(e2)
        },
        data: function (e2, t2, n2) {
            return Q.access(e2, t2, n2)
        },
        removeData: function (e2, t2) {
            Q.remove(e2, t2)
        },
        _data: function (e2, t2, n2) {
            return Y.access(e2, t2, n2)
        },
        _removeData: function (e2, t2) {
            Y.remove(e2, t2)
        },
    }),
        S.fn.extend({
            data: function (n2, e2) {
                var t2,
                    r2,
                    i2,
                    o2 = this[0],
                    a2 = o2 && o2.attributes
                if (n2 === void 0) {
                    if (
                        this.length &&
                        ((i2 = Q.get(o2)),
                        o2.nodeType === 1 && !Y.get(o2, 'hasDataAttrs'))
                    ) {
                        for (t2 = a2.length; t2--; )
                            a2[t2] &&
                                (r2 = a2[t2].name).indexOf('data-') === 0 &&
                                ((r2 = X(r2.slice(5))), Z(o2, r2, i2[r2]))
                        Y.set(o2, 'hasDataAttrs', !0)
                    }
                    return i2
                }
                return typeof n2 == 'object'
                    ? this.each(function () {
                          Q.set(this, n2)
                      })
                    : $2(
                          this,
                          function (e3) {
                              var t3
                              if (o2 && e3 === void 0)
                                  return (t3 = Q.get(o2, n2)) !== void 0 ||
                                      (t3 = Z(o2, n2)) !== void 0
                                      ? t3
                                      : void 0
                              this.each(function () {
                                  Q.set(this, n2, e3)
                              })
                          },
                          null,
                          e2,
                          1 < arguments.length,
                          null,
                          !0
                      )
            },
            removeData: function (e2) {
                return this.each(function () {
                    Q.remove(this, e2)
                })
            },
        }),
        S.extend({
            queue: function (e2, t2, n2) {
                var r2
                if (e2)
                    return (
                        (t2 = (t2 || 'fx') + 'queue'),
                        (r2 = Y.get(e2, t2)),
                        n2 &&
                            (!r2 || Array.isArray(n2)
                                ? (r2 = Y.access(e2, t2, S.makeArray(n2)))
                                : r2.push(n2)),
                        r2 || []
                    )
            },
            dequeue: function (e2, t2) {
                t2 = t2 || 'fx'
                var n2 = S.queue(e2, t2),
                    r2 = n2.length,
                    i2 = n2.shift(),
                    o2 = S._queueHooks(e2, t2)
                i2 === 'inprogress' && ((i2 = n2.shift()), r2--),
                    i2 &&
                        (t2 === 'fx' && n2.unshift('inprogress'),
                        delete o2.stop,
                        i2.call(
                            e2,
                            function () {
                                S.dequeue(e2, t2)
                            },
                            o2
                        )),
                    !r2 && o2 && o2.empty.fire()
            },
            _queueHooks: function (e2, t2) {
                var n2 = t2 + 'queueHooks'
                return (
                    Y.get(e2, n2) ||
                    Y.access(e2, n2, {
                        empty: S.Callbacks('once memory').add(function () {
                            Y.remove(e2, [t2 + 'queue', n2])
                        }),
                    })
                )
            },
        }),
        S.fn.extend({
            queue: function (t2, n2) {
                var e2 = 2
                return (
                    typeof t2 != 'string' && ((n2 = t2), (t2 = 'fx'), e2--),
                    arguments.length < e2
                        ? S.queue(this[0], t2)
                        : n2 === void 0
                        ? this
                        : this.each(function () {
                              var e3 = S.queue(this, t2, n2)
                              S._queueHooks(this, t2),
                                  t2 === 'fx' &&
                                      e3[0] !== 'inprogress' &&
                                      S.dequeue(this, t2)
                          })
                )
            },
            dequeue: function (e2) {
                return this.each(function () {
                    S.dequeue(this, e2)
                })
            },
            clearQueue: function (e2) {
                return this.queue(e2 || 'fx', [])
            },
            promise: function (e2, t2) {
                var n2,
                    r2 = 1,
                    i2 = S.Deferred(),
                    o2 = this,
                    a2 = this.length,
                    s2 = function () {
                        --r2 || i2.resolveWith(o2, [o2])
                    }
                for (
                    typeof e2 != 'string' && ((t2 = e2), (e2 = void 0)),
                        e2 = e2 || 'fx';
                    a2--;

                )
                    (n2 = Y.get(o2[a2], e2 + 'queueHooks')) &&
                        n2.empty &&
                        (r2++, n2.empty.add(s2))
                return s2(), i2.promise(t2)
            },
        })
    var ee = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
        te = new RegExp('^(?:([+-])=|)(' + ee + ')([a-z%]*)$', 'i'),
        ne = ['Top', 'Right', 'Bottom', 'Left'],
        re = E.documentElement,
        ie = function (e2) {
            return S.contains(e2.ownerDocument, e2)
        },
        oe = { composed: !0 }
    re.getRootNode &&
        (ie = function (e2) {
            return (
                S.contains(e2.ownerDocument, e2) ||
                e2.getRootNode(oe) === e2.ownerDocument
            )
        })
    var ae = function (e2, t2) {
        return (
            (e2 = t2 || e2).style.display === 'none' ||
            (e2.style.display === '' &&
                ie(e2) &&
                S.css(e2, 'display') === 'none')
        )
    }
    function se(e2, t2, n2, r2) {
        var i2,
            o2,
            a2 = 20,
            s2 = r2
                ? function () {
                      return r2.cur()
                  }
                : function () {
                      return S.css(e2, t2, '')
                  },
            u2 = s2(),
            l2 = (n2 && n2[3]) || (S.cssNumber[t2] ? '' : 'px'),
            c2 =
                e2.nodeType &&
                (S.cssNumber[t2] || (l2 !== 'px' && +u2)) &&
                te.exec(S.css(e2, t2))
        if (c2 && c2[3] !== l2) {
            for (u2 /= 2, l2 = l2 || c2[3], c2 = +u2 || 1; a2--; )
                S.style(e2, t2, c2 + l2),
                    (1 - o2) * (1 - (o2 = s2() / u2 || 0.5)) <= 0 && (a2 = 0),
                    (c2 /= o2)
            ;(c2 *= 2), S.style(e2, t2, c2 + l2), (n2 = n2 || [])
        }
        return (
            n2 &&
                ((c2 = +c2 || +u2 || 0),
                (i2 = n2[1] ? c2 + (n2[1] + 1) * n2[2] : +n2[2]),
                r2 && ((r2.unit = l2), (r2.start = c2), (r2.end = i2))),
            i2
        )
    }
    var ue = {}
    function le(e2, t2) {
        for (
            var n2, r2, i2, o2, a2, s2, u2, l2 = [], c2 = 0, f2 = e2.length;
            c2 < f2;
            c2++
        )
            (r2 = e2[c2]).style &&
                ((n2 = r2.style.display),
                t2
                    ? (n2 === 'none' &&
                          ((l2[c2] = Y.get(r2, 'display') || null),
                          l2[c2] || (r2.style.display = '')),
                      r2.style.display === '' &&
                          ae(r2) &&
                          (l2[c2] =
                              ((u2 = a2 = o2 = void 0),
                              (a2 = (i2 = r2).ownerDocument),
                              (s2 = i2.nodeName),
                              (u2 = ue[s2]) ||
                                  ((o2 = a2.body.appendChild(
                                      a2.createElement(s2)
                                  )),
                                  (u2 = S.css(o2, 'display')),
                                  o2.parentNode.removeChild(o2),
                                  u2 === 'none' && (u2 = 'block'),
                                  (ue[s2] = u2)))))
                    : n2 !== 'none' &&
                      ((l2[c2] = 'none'), Y.set(r2, 'display', n2)))
        for (c2 = 0; c2 < f2; c2++)
            l2[c2] != null && (e2[c2].style.display = l2[c2])
        return e2
    }
    S.fn.extend({
        show: function () {
            return le(this, !0)
        },
        hide: function () {
            return le(this)
        },
        toggle: function (e2) {
            return typeof e2 == 'boolean'
                ? e2
                    ? this.show()
                    : this.hide()
                : this.each(function () {
                      ae(this) ? S(this).show() : S(this).hide()
                  })
        },
    })
    var ce,
        fe,
        pe = /^(?:checkbox|radio)$/i,
        de = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i,
        he = /^$|^module$|\/(?:java|ecma)script/i
    ;(ce = E.createDocumentFragment().appendChild(E.createElement('div'))),
        (fe = E.createElement('input')).setAttribute('type', 'radio'),
        fe.setAttribute('checked', 'checked'),
        fe.setAttribute('name', 't'),
        ce.appendChild(fe),
        (y.checkClone = ce.cloneNode(!0).cloneNode(!0).lastChild.checked),
        (ce.innerHTML = '<textarea>x</textarea>'),
        (y.noCloneChecked = !!ce.cloneNode(!0).lastChild.defaultValue),
        (ce.innerHTML = '<option></option>'),
        (y.option = !!ce.lastChild)
    var ge = {
        thead: [1, '<table>', '</table>'],
        col: [2, '<table><colgroup>', '</colgroup></table>'],
        tr: [2, '<table><tbody>', '</tbody></table>'],
        td: [3, '<table><tbody><tr>', '</tr></tbody></table>'],
        _default: [0, '', ''],
    }
    function ve(e2, t2) {
        var n2
        return (
            (n2 =
                typeof e2.getElementsByTagName < 'u'
                    ? e2.getElementsByTagName(t2 || '*')
                    : typeof e2.querySelectorAll < 'u'
                    ? e2.querySelectorAll(t2 || '*')
                    : []),
            t2 === void 0 || (t2 && A(e2, t2)) ? S.merge([e2], n2) : n2
        )
    }
    function ye(e2, t2) {
        for (var n2 = 0, r2 = e2.length; n2 < r2; n2++)
            Y.set(e2[n2], 'globalEval', !t2 || Y.get(t2[n2], 'globalEval'))
    }
    ;(ge.tbody = ge.tfoot = ge.colgroup = ge.caption = ge.thead),
        (ge.th = ge.td),
        y.option ||
            (ge.optgroup = ge.option =
                [1, "<select multiple='multiple'>", '</select>'])
    var me = /<|&#?\w+;/
    function xe(e2, t2, n2, r2, i2) {
        for (
            var o2,
                a2,
                s2,
                u2,
                l2,
                c2,
                f2 = t2.createDocumentFragment(),
                p2 = [],
                d2 = 0,
                h2 = e2.length;
            d2 < h2;
            d2++
        )
            if ((o2 = e2[d2]) || o2 === 0)
                if (w(o2) === 'object') S.merge(p2, o2.nodeType ? [o2] : o2)
                else if (me.test(o2)) {
                    for (
                        a2 = a2 || f2.appendChild(t2.createElement('div')),
                            s2 = (de.exec(o2) || ['', ''])[1].toLowerCase(),
                            u2 = ge[s2] || ge._default,
                            a2.innerHTML = u2[1] + S.htmlPrefilter(o2) + u2[2],
                            c2 = u2[0];
                        c2--;

                    )
                        a2 = a2.lastChild
                    S.merge(p2, a2.childNodes),
                        ((a2 = f2.firstChild).textContent = '')
                } else p2.push(t2.createTextNode(o2))
        for (f2.textContent = '', d2 = 0; (o2 = p2[d2++]); )
            if (r2 && -1 < S.inArray(o2, r2)) i2 && i2.push(o2)
            else if (
                ((l2 = ie(o2)),
                (a2 = ve(f2.appendChild(o2), 'script')),
                l2 && ye(a2),
                n2)
            )
                for (c2 = 0; (o2 = a2[c2++]); )
                    he.test(o2.type || '') && n2.push(o2)
        return f2
    }
    var be = /^key/,
        we = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
        Te = /^([^.]*)(?:\.(.+)|)/
    function Ce() {
        return !0
    }
    function Ee() {
        return !1
    }
    function Se(e2, t2) {
        return (
            (e2 ===
                (function () {
                    try {
                        return E.activeElement
                    } catch {}
                })()) ==
            (t2 === 'focus')
        )
    }
    function ke(e2, t2, n2, r2, i2, o2) {
        var a2, s2
        if (typeof t2 == 'object') {
            for (s2 in (typeof n2 != 'string' &&
                ((r2 = r2 || n2), (n2 = void 0)),
            t2))
                ke(e2, s2, n2, r2, t2[s2], o2)
            return e2
        }
        if (
            (r2 == null && i2 == null
                ? ((i2 = n2), (r2 = n2 = void 0))
                : i2 == null &&
                  (typeof n2 == 'string'
                      ? ((i2 = r2), (r2 = void 0))
                      : ((i2 = r2), (r2 = n2), (n2 = void 0))),
            i2 === !1)
        )
            i2 = Ee
        else if (!i2) return e2
        return (
            o2 === 1 &&
                ((a2 = i2),
                ((i2 = function (e3) {
                    return S().off(e3), a2.apply(this, arguments)
                }).guid = a2.guid || (a2.guid = S.guid++))),
            e2.each(function () {
                S.event.add(this, t2, i2, r2, n2)
            })
        )
    }
    function Ae(e2, i2, o2) {
        o2
            ? (Y.set(e2, i2, !1),
              S.event.add(e2, i2, {
                  namespace: !1,
                  handler: function (e3) {
                      var t2,
                          n2,
                          r2 = Y.get(this, i2)
                      if (1 & e3.isTrigger && this[i2]) {
                          if (r2.length)
                              (S.event.special[i2] || {}).delegateType &&
                                  e3.stopPropagation()
                          else if (
                              ((r2 = s.call(arguments)),
                              Y.set(this, i2, r2),
                              (t2 = o2(this, i2)),
                              this[i2](),
                              r2 !== (n2 = Y.get(this, i2)) || t2
                                  ? Y.set(this, i2, !1)
                                  : (n2 = {}),
                              r2 !== n2)
                          )
                              return (
                                  e3.stopImmediatePropagation(),
                                  e3.preventDefault(),
                                  n2.value
                              )
                      } else
                          r2.length &&
                              (Y.set(this, i2, {
                                  value: S.event.trigger(
                                      S.extend(r2[0], S.Event.prototype),
                                      r2.slice(1),
                                      this
                                  ),
                              }),
                              e3.stopImmediatePropagation())
                  },
              }))
            : Y.get(e2, i2) === void 0 && S.event.add(e2, i2, Ce)
    }
    ;(S.event = {
        global: {},
        add: function (t2, e2, n2, r2, i2) {
            var o2,
                a2,
                s2,
                u2,
                l2,
                c2,
                f2,
                p2,
                d2,
                h2,
                g2,
                v2 = Y.get(t2)
            if (V(t2))
                for (
                    n2.handler &&
                        ((n2 = (o2 = n2).handler), (i2 = o2.selector)),
                        i2 && S.find.matchesSelector(re, i2),
                        n2.guid || (n2.guid = S.guid++),
                        (u2 = v2.events) ||
                            (u2 = v2.events = Object.create(null)),
                        (a2 = v2.handle) ||
                            (a2 = v2.handle =
                                function (e3) {
                                    return typeof S < 'u' &&
                                        S.event.triggered !== e3.type
                                        ? S.event.dispatch.apply(t2, arguments)
                                        : void 0
                                }),
                        l2 = (e2 = (e2 || '').match(P) || ['']).length;
                    l2--;

                )
                    (d2 = g2 = (s2 = Te.exec(e2[l2]) || [])[1]),
                        (h2 = (s2[2] || '').split('.').sort()),
                        d2 &&
                            ((f2 = S.event.special[d2] || {}),
                            (d2 = (i2 ? f2.delegateType : f2.bindType) || d2),
                            (f2 = S.event.special[d2] || {}),
                            (c2 = S.extend(
                                {
                                    type: d2,
                                    origType: g2,
                                    data: r2,
                                    handler: n2,
                                    guid: n2.guid,
                                    selector: i2,
                                    needsContext:
                                        i2 &&
                                        S.expr.match.needsContext.test(i2),
                                    namespace: h2.join('.'),
                                },
                                o2
                            )),
                            (p2 = u2[d2]) ||
                                (((p2 = u2[d2] = []).delegateCount = 0),
                                (f2.setup &&
                                    f2.setup.call(t2, r2, h2, a2) !== !1) ||
                                    (t2.addEventListener &&
                                        t2.addEventListener(d2, a2))),
                            f2.add &&
                                (f2.add.call(t2, c2),
                                c2.handler.guid || (c2.handler.guid = n2.guid)),
                            i2
                                ? p2.splice(p2.delegateCount++, 0, c2)
                                : p2.push(c2),
                            (S.event.global[d2] = !0))
        },
        remove: function (e2, t2, n2, r2, i2) {
            var o2,
                a2,
                s2,
                u2,
                l2,
                c2,
                f2,
                p2,
                d2,
                h2,
                g2,
                v2 = Y.hasData(e2) && Y.get(e2)
            if (v2 && (u2 = v2.events)) {
                for (l2 = (t2 = (t2 || '').match(P) || ['']).length; l2--; )
                    if (
                        ((d2 = g2 = (s2 = Te.exec(t2[l2]) || [])[1]),
                        (h2 = (s2[2] || '').split('.').sort()),
                        d2)
                    ) {
                        for (
                            f2 = S.event.special[d2] || {},
                                p2 =
                                    u2[
                                        (d2 =
                                            (r2
                                                ? f2.delegateType
                                                : f2.bindType) || d2)
                                    ] || [],
                                s2 =
                                    s2[2] &&
                                    new RegExp(
                                        '(^|\\.)' +
                                            h2.join('\\.(?:.*\\.|)') +
                                            '(\\.|$)'
                                    ),
                                a2 = o2 = p2.length;
                            o2--;

                        )
                            (c2 = p2[o2]),
                                (!i2 && g2 !== c2.origType) ||
                                    (n2 && n2.guid !== c2.guid) ||
                                    (s2 && !s2.test(c2.namespace)) ||
                                    (r2 &&
                                        r2 !== c2.selector &&
                                        (r2 !== '**' || !c2.selector)) ||
                                    (p2.splice(o2, 1),
                                    c2.selector && p2.delegateCount--,
                                    f2.remove && f2.remove.call(e2, c2))
                        a2 &&
                            !p2.length &&
                            ((f2.teardown &&
                                f2.teardown.call(e2, h2, v2.handle) !== !1) ||
                                S.removeEvent(e2, d2, v2.handle),
                            delete u2[d2])
                    } else
                        for (d2 in u2)
                            S.event.remove(e2, d2 + t2[l2], n2, r2, !0)
                S.isEmptyObject(u2) && Y.remove(e2, 'handle events')
            }
        },
        dispatch: function (e2) {
            var t2,
                n2,
                r2,
                i2,
                o2,
                a2,
                s2 = new Array(arguments.length),
                u2 = S.event.fix(e2),
                l2 =
                    (Y.get(this, 'events') || Object.create(null))[u2.type] ||
                    [],
                c2 = S.event.special[u2.type] || {}
            for (s2[0] = u2, t2 = 1; t2 < arguments.length; t2++)
                s2[t2] = arguments[t2]
            if (
                ((u2.delegateTarget = this),
                !c2.preDispatch || c2.preDispatch.call(this, u2) !== !1)
            ) {
                for (
                    a2 = S.event.handlers.call(this, u2, l2), t2 = 0;
                    (i2 = a2[t2++]) && !u2.isPropagationStopped();

                )
                    for (
                        u2.currentTarget = i2.elem, n2 = 0;
                        (o2 = i2.handlers[n2++]) &&
                        !u2.isImmediatePropagationStopped();

                    )
                        (u2.rnamespace &&
                            o2.namespace !== !1 &&
                            !u2.rnamespace.test(o2.namespace)) ||
                            ((u2.handleObj = o2),
                            (u2.data = o2.data),
                            (r2 = (
                                (S.event.special[o2.origType] || {}).handle ||
                                o2.handler
                            ).apply(i2.elem, s2)) !== void 0 &&
                                (u2.result = r2) === !1 &&
                                (u2.preventDefault(), u2.stopPropagation()))
                return (
                    c2.postDispatch && c2.postDispatch.call(this, u2), u2.result
                )
            }
        },
        handlers: function (e2, t2) {
            var n2,
                r2,
                i2,
                o2,
                a2,
                s2 = [],
                u2 = t2.delegateCount,
                l2 = e2.target
            if (u2 && l2.nodeType && !(e2.type === 'click' && 1 <= e2.button)) {
                for (; l2 !== this; l2 = l2.parentNode || this)
                    if (
                        l2.nodeType === 1 &&
                        (e2.type !== 'click' || l2.disabled !== !0)
                    ) {
                        for (o2 = [], a2 = {}, n2 = 0; n2 < u2; n2++)
                            a2[(i2 = (r2 = t2[n2]).selector + ' ')] ===
                                void 0 &&
                                (a2[i2] = r2.needsContext
                                    ? -1 < S(i2, this).index(l2)
                                    : S.find(i2, this, null, [l2]).length),
                                a2[i2] && o2.push(r2)
                        o2.length && s2.push({ elem: l2, handlers: o2 })
                    }
            }
            return (
                (l2 = this),
                u2 < t2.length && s2.push({ elem: l2, handlers: t2.slice(u2) }),
                s2
            )
        },
        addProp: function (t2, e2) {
            Object.defineProperty(S.Event.prototype, t2, {
                enumerable: !0,
                configurable: !0,
                get: m(e2)
                    ? function () {
                          if (this.originalEvent) return e2(this.originalEvent)
                      }
                    : function () {
                          if (this.originalEvent) return this.originalEvent[t2]
                      },
                set: function (e3) {
                    Object.defineProperty(this, t2, {
                        enumerable: !0,
                        configurable: !0,
                        writable: !0,
                        value: e3,
                    })
                },
            })
        },
        fix: function (e2) {
            return e2[S.expando] ? e2 : new S.Event(e2)
        },
        special: {
            load: { noBubble: !0 },
            click: {
                setup: function (e2) {
                    var t2 = this || e2
                    return (
                        pe.test(t2.type) &&
                            t2.click &&
                            A(t2, 'input') &&
                            Ae(t2, 'click', Ce),
                        !1
                    )
                },
                trigger: function (e2) {
                    var t2 = this || e2
                    return (
                        pe.test(t2.type) &&
                            t2.click &&
                            A(t2, 'input') &&
                            Ae(t2, 'click'),
                        !0
                    )
                },
                _default: function (e2) {
                    var t2 = e2.target
                    return (
                        (pe.test(t2.type) &&
                            t2.click &&
                            A(t2, 'input') &&
                            Y.get(t2, 'click')) ||
                        A(t2, 'a')
                    )
                },
            },
            beforeunload: {
                postDispatch: function (e2) {
                    e2.result !== void 0 &&
                        e2.originalEvent &&
                        (e2.originalEvent.returnValue = e2.result)
                },
            },
        },
    }),
        (S.removeEvent = function (e2, t2, n2) {
            e2.removeEventListener && e2.removeEventListener(t2, n2)
        }),
        (S.Event = function (e2, t2) {
            if (!(this instanceof S.Event)) return new S.Event(e2, t2)
            e2 && e2.type
                ? ((this.originalEvent = e2),
                  (this.type = e2.type),
                  (this.isDefaultPrevented =
                      e2.defaultPrevented ||
                      (e2.defaultPrevented === void 0 && e2.returnValue === !1)
                          ? Ce
                          : Ee),
                  (this.target =
                      e2.target && e2.target.nodeType === 3
                          ? e2.target.parentNode
                          : e2.target),
                  (this.currentTarget = e2.currentTarget),
                  (this.relatedTarget = e2.relatedTarget))
                : (this.type = e2),
                t2 && S.extend(this, t2),
                (this.timeStamp = (e2 && e2.timeStamp) || Date.now()),
                (this[S.expando] = !0)
        }),
        (S.Event.prototype = {
            constructor: S.Event,
            isDefaultPrevented: Ee,
            isPropagationStopped: Ee,
            isImmediatePropagationStopped: Ee,
            isSimulated: !1,
            preventDefault: function () {
                var e2 = this.originalEvent
                ;(this.isDefaultPrevented = Ce),
                    e2 && !this.isSimulated && e2.preventDefault()
            },
            stopPropagation: function () {
                var e2 = this.originalEvent
                ;(this.isPropagationStopped = Ce),
                    e2 && !this.isSimulated && e2.stopPropagation()
            },
            stopImmediatePropagation: function () {
                var e2 = this.originalEvent
                ;(this.isImmediatePropagationStopped = Ce),
                    e2 && !this.isSimulated && e2.stopImmediatePropagation(),
                    this.stopPropagation()
            },
        }),
        S.each(
            {
                altKey: !0,
                bubbles: !0,
                cancelable: !0,
                changedTouches: !0,
                ctrlKey: !0,
                detail: !0,
                eventPhase: !0,
                metaKey: !0,
                pageX: !0,
                pageY: !0,
                shiftKey: !0,
                view: !0,
                char: !0,
                code: !0,
                charCode: !0,
                key: !0,
                keyCode: !0,
                button: !0,
                buttons: !0,
                clientX: !0,
                clientY: !0,
                offsetX: !0,
                offsetY: !0,
                pointerId: !0,
                pointerType: !0,
                screenX: !0,
                screenY: !0,
                targetTouches: !0,
                toElement: !0,
                touches: !0,
                which: function (e2) {
                    var t2 = e2.button
                    return e2.which == null && be.test(e2.type)
                        ? e2.charCode != null
                            ? e2.charCode
                            : e2.keyCode
                        : !e2.which && t2 !== void 0 && we.test(e2.type)
                        ? 1 & t2
                            ? 1
                            : 2 & t2
                            ? 3
                            : 4 & t2
                            ? 2
                            : 0
                        : e2.which
                },
            },
            S.event.addProp
        ),
        S.each({ focus: 'focusin', blur: 'focusout' }, function (e2, t2) {
            S.event.special[e2] = {
                setup: function () {
                    return Ae(this, e2, Se), !1
                },
                trigger: function () {
                    return Ae(this, e2), !0
                },
                delegateType: t2,
            }
        }),
        S.each(
            {
                mouseenter: 'mouseover',
                mouseleave: 'mouseout',
                pointerenter: 'pointerover',
                pointerleave: 'pointerout',
            },
            function (e2, i2) {
                S.event.special[e2] = {
                    delegateType: i2,
                    bindType: i2,
                    handle: function (e3) {
                        var t2,
                            n2 = e3.relatedTarget,
                            r2 = e3.handleObj
                        return (
                            (n2 && (n2 === this || S.contains(this, n2))) ||
                                ((e3.type = r2.origType),
                                (t2 = r2.handler.apply(this, arguments)),
                                (e3.type = i2)),
                            t2
                        )
                    },
                }
            }
        ),
        S.fn.extend({
            on: function (e2, t2, n2, r2) {
                return ke(this, e2, t2, n2, r2)
            },
            one: function (e2, t2, n2, r2) {
                return ke(this, e2, t2, n2, r2, 1)
            },
            off: function (e2, t2, n2) {
                var r2, i2
                if (e2 && e2.preventDefault && e2.handleObj)
                    return (
                        (r2 = e2.handleObj),
                        S(e2.delegateTarget).off(
                            r2.namespace
                                ? r2.origType + '.' + r2.namespace
                                : r2.origType,
                            r2.selector,
                            r2.handler
                        ),
                        this
                    )
                if (typeof e2 == 'object') {
                    for (i2 in e2) this.off(i2, t2, e2[i2])
                    return this
                }
                return (
                    (t2 !== !1 && typeof t2 != 'function') ||
                        ((n2 = t2), (t2 = void 0)),
                    n2 === !1 && (n2 = Ee),
                    this.each(function () {
                        S.event.remove(this, e2, n2, t2)
                    })
                )
            },
        })
    var Ne = /<script|<style|<link/i,
        De = /checked\s*(?:[^=]|=\s*.checked.)/i,
        je = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g
    function qe(e2, t2) {
        return (
            (A(e2, 'table') &&
                A(t2.nodeType !== 11 ? t2 : t2.firstChild, 'tr') &&
                S(e2).children('tbody')[0]) ||
            e2
        )
    }
    function Le(e2) {
        return (
            (e2.type = (e2.getAttribute('type') !== null) + '/' + e2.type), e2
        )
    }
    function He(e2) {
        return (
            (e2.type || '').slice(0, 5) === 'true/'
                ? (e2.type = e2.type.slice(5))
                : e2.removeAttribute('type'),
            e2
        )
    }
    function Oe(e2, t2) {
        var n2, r2, i2, o2, a2, s2
        if (t2.nodeType === 1) {
            if (Y.hasData(e2) && (s2 = Y.get(e2).events))
                for (i2 in (Y.remove(t2, 'handle events'), s2))
                    for (n2 = 0, r2 = s2[i2].length; n2 < r2; n2++)
                        S.event.add(t2, i2, s2[i2][n2])
            Q.hasData(e2) &&
                ((o2 = Q.access(e2)), (a2 = S.extend({}, o2)), Q.set(t2, a2))
        }
    }
    function Pe(n2, r2, i2, o2) {
        r2 = g(r2)
        var e2,
            t2,
            a2,
            s2,
            u2,
            l2,
            c2 = 0,
            f2 = n2.length,
            p2 = f2 - 1,
            d2 = r2[0],
            h2 = m(d2)
        if (
            h2 ||
            (1 < f2 && typeof d2 == 'string' && !y.checkClone && De.test(d2))
        )
            return n2.each(function (e3) {
                var t3 = n2.eq(e3)
                h2 && (r2[0] = d2.call(this, e3, t3.html())), Pe(t3, r2, i2, o2)
            })
        if (
            f2 &&
            ((t2 = (e2 = xe(r2, n2[0].ownerDocument, !1, n2, o2)).firstChild),
            e2.childNodes.length === 1 && (e2 = t2),
            t2 || o2)
        ) {
            for (s2 = (a2 = S.map(ve(e2, 'script'), Le)).length; c2 < f2; c2++)
                (u2 = e2),
                    c2 !== p2 &&
                        ((u2 = S.clone(u2, !0, !0)),
                        s2 && S.merge(a2, ve(u2, 'script'))),
                    i2.call(n2[c2], u2, c2)
            if (s2)
                for (
                    l2 = a2[a2.length - 1].ownerDocument, S.map(a2, He), c2 = 0;
                    c2 < s2;
                    c2++
                )
                    (u2 = a2[c2]),
                        he.test(u2.type || '') &&
                            !Y.access(u2, 'globalEval') &&
                            S.contains(l2, u2) &&
                            (u2.src &&
                            (u2.type || '').toLowerCase() !== 'module'
                                ? S._evalUrl &&
                                  !u2.noModule &&
                                  S._evalUrl(
                                      u2.src,
                                      {
                                          nonce:
                                              u2.nonce ||
                                              u2.getAttribute('nonce'),
                                      },
                                      l2
                                  )
                                : b(u2.textContent.replace(je, ''), u2, l2))
        }
        return n2
    }
    function Re(e2, t2, n2) {
        for (
            var r2, i2 = t2 ? S.filter(t2, e2) : e2, o2 = 0;
            (r2 = i2[o2]) != null;
            o2++
        )
            n2 || r2.nodeType !== 1 || S.cleanData(ve(r2)),
                r2.parentNode &&
                    (n2 && ie(r2) && ye(ve(r2, 'script')),
                    r2.parentNode.removeChild(r2))
        return e2
    }
    S.extend({
        htmlPrefilter: function (e2) {
            return e2
        },
        clone: function (e2, t2, n2) {
            var r2,
                i2,
                o2,
                a2,
                s2,
                u2,
                l2,
                c2 = e2.cloneNode(!0),
                f2 = ie(e2)
            if (
                !(
                    y.noCloneChecked ||
                    (e2.nodeType !== 1 && e2.nodeType !== 11) ||
                    S.isXMLDoc(e2)
                )
            )
                for (
                    a2 = ve(c2), r2 = 0, i2 = (o2 = ve(e2)).length;
                    r2 < i2;
                    r2++
                )
                    (s2 = o2[r2]),
                        (u2 = a2[r2]),
                        (l2 = u2.nodeName.toLowerCase()) === 'input' &&
                        pe.test(s2.type)
                            ? (u2.checked = s2.checked)
                            : (l2 !== 'input' && l2 !== 'textarea') ||
                              (u2.defaultValue = s2.defaultValue)
            if (t2)
                if (n2)
                    for (
                        o2 = o2 || ve(e2),
                            a2 = a2 || ve(c2),
                            r2 = 0,
                            i2 = o2.length;
                        r2 < i2;
                        r2++
                    )
                        Oe(o2[r2], a2[r2])
                else Oe(e2, c2)
            return (
                0 < (a2 = ve(c2, 'script')).length &&
                    ye(a2, !f2 && ve(e2, 'script')),
                c2
            )
        },
        cleanData: function (e2) {
            for (
                var t2, n2, r2, i2 = S.event.special, o2 = 0;
                (n2 = e2[o2]) !== void 0;
                o2++
            )
                if (V(n2)) {
                    if ((t2 = n2[Y.expando])) {
                        if (t2.events)
                            for (r2 in t2.events)
                                i2[r2]
                                    ? S.event.remove(n2, r2)
                                    : S.removeEvent(n2, r2, t2.handle)
                        n2[Y.expando] = void 0
                    }
                    n2[Q.expando] && (n2[Q.expando] = void 0)
                }
        },
    }),
        S.fn.extend({
            detach: function (e2) {
                return Re(this, e2, !0)
            },
            remove: function (e2) {
                return Re(this, e2)
            },
            text: function (e2) {
                return $2(
                    this,
                    function (e3) {
                        return e3 === void 0
                            ? S.text(this)
                            : this.empty().each(function () {
                                  ;(this.nodeType !== 1 &&
                                      this.nodeType !== 11 &&
                                      this.nodeType !== 9) ||
                                      (this.textContent = e3)
                              })
                    },
                    null,
                    e2,
                    arguments.length
                )
            },
            append: function () {
                return Pe(this, arguments, function (e2) {
                    ;(this.nodeType !== 1 &&
                        this.nodeType !== 11 &&
                        this.nodeType !== 9) ||
                        qe(this, e2).appendChild(e2)
                })
            },
            prepend: function () {
                return Pe(this, arguments, function (e2) {
                    if (
                        this.nodeType === 1 ||
                        this.nodeType === 11 ||
                        this.nodeType === 9
                    ) {
                        var t2 = qe(this, e2)
                        t2.insertBefore(e2, t2.firstChild)
                    }
                })
            },
            before: function () {
                return Pe(this, arguments, function (e2) {
                    this.parentNode && this.parentNode.insertBefore(e2, this)
                })
            },
            after: function () {
                return Pe(this, arguments, function (e2) {
                    this.parentNode &&
                        this.parentNode.insertBefore(e2, this.nextSibling)
                })
            },
            empty: function () {
                for (var e2, t2 = 0; (e2 = this[t2]) != null; t2++)
                    e2.nodeType === 1 &&
                        (S.cleanData(ve(e2, !1)), (e2.textContent = ''))
                return this
            },
            clone: function (e2, t2) {
                return (
                    (e2 = e2 != null && e2),
                    (t2 = t2 ?? e2),
                    this.map(function () {
                        return S.clone(this, e2, t2)
                    })
                )
            },
            html: function (e2) {
                return $2(
                    this,
                    function (e3) {
                        var t2 = this[0] || {},
                            n2 = 0,
                            r2 = this.length
                        if (e3 === void 0 && t2.nodeType === 1)
                            return t2.innerHTML
                        if (
                            typeof e3 == 'string' &&
                            !Ne.test(e3) &&
                            !ge[(de.exec(e3) || ['', ''])[1].toLowerCase()]
                        ) {
                            e3 = S.htmlPrefilter(e3)
                            try {
                                for (; n2 < r2; n2++)
                                    (t2 = this[n2] || {}).nodeType === 1 &&
                                        (S.cleanData(ve(t2, !1)),
                                        (t2.innerHTML = e3))
                                t2 = 0
                            } catch {}
                        }
                        t2 && this.empty().append(e3)
                    },
                    null,
                    e2,
                    arguments.length
                )
            },
            replaceWith: function () {
                var n2 = []
                return Pe(
                    this,
                    arguments,
                    function (e2) {
                        var t2 = this.parentNode
                        S.inArray(this, n2) < 0 &&
                            (S.cleanData(ve(this)),
                            t2 && t2.replaceChild(e2, this))
                    },
                    n2
                )
            },
        }),
        S.each(
            {
                appendTo: 'append',
                prependTo: 'prepend',
                insertBefore: 'before',
                insertAfter: 'after',
                replaceAll: 'replaceWith',
            },
            function (e2, a2) {
                S.fn[e2] = function (e3) {
                    for (
                        var t2, n2 = [], r2 = S(e3), i2 = r2.length - 1, o2 = 0;
                        o2 <= i2;
                        o2++
                    )
                        (t2 = o2 === i2 ? this : this.clone(!0)),
                            S(r2[o2])[a2](t2),
                            u.apply(n2, t2.get())
                    return this.pushStack(n2)
                }
            }
        )
    var Me = new RegExp('^(' + ee + ')(?!px)[a-z%]+$', 'i'),
        Ie = function (e2) {
            var t2 = e2.ownerDocument.defaultView
            return (t2 && t2.opener) || (t2 = C), t2.getComputedStyle(e2)
        },
        We = function (e2, t2, n2) {
            var r2,
                i2,
                o2 = {}
            for (i2 in t2) (o2[i2] = e2.style[i2]), (e2.style[i2] = t2[i2])
            for (i2 in ((r2 = n2.call(e2)), t2)) e2.style[i2] = o2[i2]
            return r2
        },
        Fe = new RegExp(ne.join('|'), 'i')
    function Be(e2, t2, n2) {
        var r2,
            i2,
            o2,
            a2,
            s2 = e2.style
        return (
            (n2 = n2 || Ie(e2)) &&
                ((a2 = n2.getPropertyValue(t2) || n2[t2]) !== '' ||
                    ie(e2) ||
                    (a2 = S.style(e2, t2)),
                !y.pixelBoxStyles() &&
                    Me.test(a2) &&
                    Fe.test(t2) &&
                    ((r2 = s2.width),
                    (i2 = s2.minWidth),
                    (o2 = s2.maxWidth),
                    (s2.minWidth = s2.maxWidth = s2.width = a2),
                    (a2 = n2.width),
                    (s2.width = r2),
                    (s2.minWidth = i2),
                    (s2.maxWidth = o2))),
            a2 !== void 0 ? a2 + '' : a2
        )
    }
    function $e(e2, t2) {
        return {
            get: function () {
                if (!e2()) return (this.get = t2).apply(this, arguments)
                delete this.get
            },
        }
    }
    ;(function () {
        function e2() {
            if (l2) {
                ;(u2.style.cssText =
                    'position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0'),
                    (l2.style.cssText =
                        'position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%'),
                    re.appendChild(u2).appendChild(l2)
                var e3 = C.getComputedStyle(l2)
                ;(n2 = e3.top !== '1%'),
                    (s2 = t2(e3.marginLeft) === 12),
                    (l2.style.right = '60%'),
                    (o2 = t2(e3.right) === 36),
                    (r2 = t2(e3.width) === 36),
                    (l2.style.position = 'absolute'),
                    (i2 = t2(l2.offsetWidth / 3) === 12),
                    re.removeChild(u2),
                    (l2 = null)
            }
        }
        function t2(e3) {
            return Math.round(parseFloat(e3))
        }
        var n2,
            r2,
            i2,
            o2,
            a2,
            s2,
            u2 = E.createElement('div'),
            l2 = E.createElement('div')
        l2.style &&
            ((l2.style.backgroundClip = 'content-box'),
            (l2.cloneNode(!0).style.backgroundClip = ''),
            (y.clearCloneStyle = l2.style.backgroundClip === 'content-box'),
            S.extend(y, {
                boxSizingReliable: function () {
                    return e2(), r2
                },
                pixelBoxStyles: function () {
                    return e2(), o2
                },
                pixelPosition: function () {
                    return e2(), n2
                },
                reliableMarginLeft: function () {
                    return e2(), s2
                },
                scrollboxSize: function () {
                    return e2(), i2
                },
                reliableTrDimensions: function () {
                    var e3, t3, n3, r3
                    return (
                        a2 == null &&
                            ((e3 = E.createElement('table')),
                            (t3 = E.createElement('tr')),
                            (n3 = E.createElement('div')),
                            (e3.style.cssText =
                                'position:absolute;left:-11111px'),
                            (t3.style.height = '1px'),
                            (n3.style.height = '9px'),
                            re.appendChild(e3).appendChild(t3).appendChild(n3),
                            (r3 = C.getComputedStyle(t3)),
                            (a2 = 3 < parseInt(r3.height)),
                            re.removeChild(e3)),
                        a2
                    )
                },
            }))
    })()
    var _e = ['Webkit', 'Moz', 'ms'],
        ze = E.createElement('div').style,
        Ue = {}
    function Xe(e2) {
        var t2 = S.cssProps[e2] || Ue[e2]
        return (
            t2 ||
            (e2 in ze
                ? e2
                : (Ue[e2] =
                      (function (e3) {
                          for (
                              var t3 = e3[0].toUpperCase() + e3.slice(1),
                                  n2 = _e.length;
                              n2--;

                          )
                              if ((e3 = _e[n2] + t3) in ze) return e3
                      })(e2) || e2))
        )
    }
    var Ve = /^(none|table(?!-c[ea]).+)/,
        Ge = /^--/,
        Ye = { position: 'absolute', visibility: 'hidden', display: 'block' },
        Qe = { letterSpacing: '0', fontWeight: '400' }
    function Je(e2, t2, n2) {
        var r2 = te.exec(t2)
        return r2 ? Math.max(0, r2[2] - (n2 || 0)) + (r2[3] || 'px') : t2
    }
    function Ke(e2, t2, n2, r2, i2, o2) {
        var a2 = t2 === 'width' ? 1 : 0,
            s2 = 0,
            u2 = 0
        if (n2 === (r2 ? 'border' : 'content')) return 0
        for (; a2 < 4; a2 += 2)
            n2 === 'margin' && (u2 += S.css(e2, n2 + ne[a2], !0, i2)),
                r2
                    ? (n2 === 'content' &&
                          (u2 -= S.css(e2, 'padding' + ne[a2], !0, i2)),
                      n2 !== 'margin' &&
                          (u2 -= S.css(
                              e2,
                              'border' + ne[a2] + 'Width',
                              !0,
                              i2
                          )))
                    : ((u2 += S.css(e2, 'padding' + ne[a2], !0, i2)),
                      n2 !== 'padding'
                          ? (u2 += S.css(
                                e2,
                                'border' + ne[a2] + 'Width',
                                !0,
                                i2
                            ))
                          : (s2 += S.css(
                                e2,
                                'border' + ne[a2] + 'Width',
                                !0,
                                i2
                            )))
        return (
            !r2 &&
                0 <= o2 &&
                (u2 +=
                    Math.max(
                        0,
                        Math.ceil(
                            e2['offset' + t2[0].toUpperCase() + t2.slice(1)] -
                                o2 -
                                u2 -
                                s2 -
                                0.5
                        )
                    ) || 0),
            u2
        )
    }
    function Ze(e2, t2, n2) {
        var r2 = Ie(e2),
            i2 =
                (!y.boxSizingReliable() || n2) &&
                S.css(e2, 'boxSizing', !1, r2) === 'border-box',
            o2 = i2,
            a2 = Be(e2, t2, r2),
            s2 = 'offset' + t2[0].toUpperCase() + t2.slice(1)
        if (Me.test(a2)) {
            if (!n2) return a2
            a2 = 'auto'
        }
        return (
            ((!y.boxSizingReliable() && i2) ||
                (!y.reliableTrDimensions() && A(e2, 'tr')) ||
                a2 === 'auto' ||
                (!parseFloat(a2) &&
                    S.css(e2, 'display', !1, r2) === 'inline')) &&
                e2.getClientRects().length &&
                ((i2 = S.css(e2, 'boxSizing', !1, r2) === 'border-box'),
                (o2 = s2 in e2) && (a2 = e2[s2])),
            (a2 = parseFloat(a2) || 0) +
                Ke(e2, t2, n2 || (i2 ? 'border' : 'content'), o2, r2, a2) +
                'px'
        )
    }
    function et(e2, t2, n2, r2, i2) {
        return new et.prototype.init(e2, t2, n2, r2, i2)
    }
    S.extend({
        cssHooks: {
            opacity: {
                get: function (e2, t2) {
                    if (t2) {
                        var n2 = Be(e2, 'opacity')
                        return n2 === '' ? '1' : n2
                    }
                },
            },
        },
        cssNumber: {
            animationIterationCount: !0,
            columnCount: !0,
            fillOpacity: !0,
            flexGrow: !0,
            flexShrink: !0,
            fontWeight: !0,
            gridArea: !0,
            gridColumn: !0,
            gridColumnEnd: !0,
            gridColumnStart: !0,
            gridRow: !0,
            gridRowEnd: !0,
            gridRowStart: !0,
            lineHeight: !0,
            opacity: !0,
            order: !0,
            orphans: !0,
            widows: !0,
            zIndex: !0,
            zoom: !0,
        },
        cssProps: {},
        style: function (e2, t2, n2, r2) {
            if (e2 && e2.nodeType !== 3 && e2.nodeType !== 8 && e2.style) {
                var i2,
                    o2,
                    a2,
                    s2 = X(t2),
                    u2 = Ge.test(t2),
                    l2 = e2.style
                if (
                    (u2 || (t2 = Xe(s2)),
                    (a2 = S.cssHooks[t2] || S.cssHooks[s2]),
                    n2 === void 0)
                )
                    return a2 &&
                        'get' in a2 &&
                        (i2 = a2.get(e2, !1, r2)) !== void 0
                        ? i2
                        : l2[t2]
                ;(o2 = typeof n2) == 'string' &&
                    (i2 = te.exec(n2)) &&
                    i2[1] &&
                    ((n2 = se(e2, t2, i2)), (o2 = 'number')),
                    n2 != null &&
                        n2 == n2 &&
                        (o2 !== 'number' ||
                            u2 ||
                            (n2 +=
                                (i2 && i2[3]) || (S.cssNumber[s2] ? '' : 'px')),
                        y.clearCloneStyle ||
                            n2 !== '' ||
                            t2.indexOf('background') !== 0 ||
                            (l2[t2] = 'inherit'),
                        (a2 &&
                            'set' in a2 &&
                            (n2 = a2.set(e2, n2, r2)) === void 0) ||
                            (u2 ? l2.setProperty(t2, n2) : (l2[t2] = n2)))
            }
        },
        css: function (e2, t2, n2, r2) {
            var i2,
                o2,
                a2,
                s2 = X(t2)
            return (
                Ge.test(t2) || (t2 = Xe(s2)),
                (a2 = S.cssHooks[t2] || S.cssHooks[s2]) &&
                    'get' in a2 &&
                    (i2 = a2.get(e2, !0, n2)),
                i2 === void 0 && (i2 = Be(e2, t2, r2)),
                i2 === 'normal' && t2 in Qe && (i2 = Qe[t2]),
                n2 === '' || n2
                    ? ((o2 = parseFloat(i2)),
                      n2 === !0 || isFinite(o2) ? o2 || 0 : i2)
                    : i2
            )
        },
    }),
        S.each(['height', 'width'], function (e2, u2) {
            S.cssHooks[u2] = {
                get: function (e3, t2, n2) {
                    if (t2)
                        return !Ve.test(S.css(e3, 'display')) ||
                            (e3.getClientRects().length &&
                                e3.getBoundingClientRect().width)
                            ? Ze(e3, u2, n2)
                            : We(e3, Ye, function () {
                                  return Ze(e3, u2, n2)
                              })
                },
                set: function (e3, t2, n2) {
                    var r2,
                        i2 = Ie(e3),
                        o2 = !y.scrollboxSize() && i2.position === 'absolute',
                        a2 =
                            (o2 || n2) &&
                            S.css(e3, 'boxSizing', !1, i2) === 'border-box',
                        s2 = n2 ? Ke(e3, u2, n2, a2, i2) : 0
                    return (
                        a2 &&
                            o2 &&
                            (s2 -= Math.ceil(
                                e3[
                                    'offset' + u2[0].toUpperCase() + u2.slice(1)
                                ] -
                                    parseFloat(i2[u2]) -
                                    Ke(e3, u2, 'border', !1, i2) -
                                    0.5
                            )),
                        s2 &&
                            (r2 = te.exec(t2)) &&
                            (r2[3] || 'px') !== 'px' &&
                            ((e3.style[u2] = t2), (t2 = S.css(e3, u2))),
                        Je(0, t2, s2)
                    )
                },
            }
        }),
        (S.cssHooks.marginLeft = $e(y.reliableMarginLeft, function (e2, t2) {
            if (t2)
                return (
                    (parseFloat(Be(e2, 'marginLeft')) ||
                        e2.getBoundingClientRect().left -
                            We(e2, { marginLeft: 0 }, function () {
                                return e2.getBoundingClientRect().left
                            })) + 'px'
                )
        })),
        S.each({ margin: '', padding: '', border: 'Width' }, function (i2, o2) {
            ;(S.cssHooks[i2 + o2] = {
                expand: function (e2) {
                    for (
                        var t2 = 0,
                            n2 = {},
                            r2 = typeof e2 == 'string' ? e2.split(' ') : [e2];
                        t2 < 4;
                        t2++
                    )
                        n2[i2 + ne[t2] + o2] = r2[t2] || r2[t2 - 2] || r2[0]
                    return n2
                },
            }),
                i2 !== 'margin' && (S.cssHooks[i2 + o2].set = Je)
        }),
        S.fn.extend({
            css: function (e2, t2) {
                return $2(
                    this,
                    function (e3, t3, n2) {
                        var r2,
                            i2,
                            o2 = {},
                            a2 = 0
                        if (Array.isArray(t3)) {
                            for (r2 = Ie(e3), i2 = t3.length; a2 < i2; a2++)
                                o2[t3[a2]] = S.css(e3, t3[a2], !1, r2)
                            return o2
                        }
                        return n2 !== void 0
                            ? S.style(e3, t3, n2)
                            : S.css(e3, t3)
                    },
                    e2,
                    t2,
                    1 < arguments.length
                )
            },
        }),
        (((S.Tween = et).prototype = {
            constructor: et,
            init: function (e2, t2, n2, r2, i2, o2) {
                ;(this.elem = e2),
                    (this.prop = n2),
                    (this.easing = i2 || S.easing._default),
                    (this.options = t2),
                    (this.start = this.now = this.cur()),
                    (this.end = r2),
                    (this.unit = o2 || (S.cssNumber[n2] ? '' : 'px'))
            },
            cur: function () {
                var e2 = et.propHooks[this.prop]
                return e2 && e2.get
                    ? e2.get(this)
                    : et.propHooks._default.get(this)
            },
            run: function (e2) {
                var t2,
                    n2 = et.propHooks[this.prop]
                return (
                    this.options.duration
                        ? (this.pos = t2 =
                              S.easing[this.easing](
                                  e2,
                                  this.options.duration * e2,
                                  0,
                                  1,
                                  this.options.duration
                              ))
                        : (this.pos = t2 = e2),
                    (this.now = (this.end - this.start) * t2 + this.start),
                    this.options.step &&
                        this.options.step.call(this.elem, this.now, this),
                    n2 && n2.set
                        ? n2.set(this)
                        : et.propHooks._default.set(this),
                    this
                )
            },
        }).init.prototype = et.prototype),
        ((et.propHooks = {
            _default: {
                get: function (e2) {
                    var t2
                    return e2.elem.nodeType !== 1 ||
                        (e2.elem[e2.prop] != null &&
                            e2.elem.style[e2.prop] == null)
                        ? e2.elem[e2.prop]
                        : (t2 = S.css(e2.elem, e2.prop, '')) && t2 !== 'auto'
                        ? t2
                        : 0
                },
                set: function (e2) {
                    S.fx.step[e2.prop]
                        ? S.fx.step[e2.prop](e2)
                        : e2.elem.nodeType !== 1 ||
                          (!S.cssHooks[e2.prop] &&
                              e2.elem.style[Xe(e2.prop)] == null)
                        ? (e2.elem[e2.prop] = e2.now)
                        : S.style(e2.elem, e2.prop, e2.now + e2.unit)
                },
            },
        }).scrollTop = et.propHooks.scrollLeft =
            {
                set: function (e2) {
                    e2.elem.nodeType &&
                        e2.elem.parentNode &&
                        (e2.elem[e2.prop] = e2.now)
                },
            }),
        (S.easing = {
            linear: function (e2) {
                return e2
            },
            swing: function (e2) {
                return 0.5 - Math.cos(e2 * Math.PI) / 2
            },
            _default: 'swing',
        }),
        (S.fx = et.prototype.init),
        (S.fx.step = {})
    var tt,
        nt,
        rt,
        it,
        ot = /^(?:toggle|show|hide)$/,
        at = /queueHooks$/
    function st() {
        nt &&
            (E.hidden === !1 && C.requestAnimationFrame
                ? C.requestAnimationFrame(st)
                : C.setTimeout(st, S.fx.interval),
            S.fx.tick())
    }
    function ut() {
        return (
            C.setTimeout(function () {
                tt = void 0
            }),
            (tt = Date.now())
        )
    }
    function lt(e2, t2) {
        var n2,
            r2 = 0,
            i2 = { height: e2 }
        for (t2 = t2 ? 1 : 0; r2 < 4; r2 += 2 - t2)
            i2['margin' + (n2 = ne[r2])] = i2['padding' + n2] = e2
        return t2 && (i2.opacity = i2.width = e2), i2
    }
    function ct(e2, t2, n2) {
        for (
            var r2,
                i2 = (ft.tweeners[t2] || []).concat(ft.tweeners['*']),
                o2 = 0,
                a2 = i2.length;
            o2 < a2;
            o2++
        )
            if ((r2 = i2[o2].call(n2, t2, e2))) return r2
    }
    function ft(o2, e2, t2) {
        var n2,
            a2,
            r2 = 0,
            i2 = ft.prefilters.length,
            s2 = S.Deferred().always(function () {
                delete u2.elem
            }),
            u2 = function () {
                if (a2) return !1
                for (
                    var e3 = tt || ut(),
                        t3 = Math.max(0, l2.startTime + l2.duration - e3),
                        n3 = 1 - (t3 / l2.duration || 0),
                        r3 = 0,
                        i3 = l2.tweens.length;
                    r3 < i3;
                    r3++
                )
                    l2.tweens[r3].run(n3)
                return (
                    s2.notifyWith(o2, [l2, n3, t3]),
                    n3 < 1 && i3
                        ? t3
                        : (i3 || s2.notifyWith(o2, [l2, 1, 0]),
                          s2.resolveWith(o2, [l2]),
                          !1)
                )
            },
            l2 = s2.promise({
                elem: o2,
                props: S.extend({}, e2),
                opts: S.extend(
                    !0,
                    { specialEasing: {}, easing: S.easing._default },
                    t2
                ),
                originalProperties: e2,
                originalOptions: t2,
                startTime: tt || ut(),
                duration: t2.duration,
                tweens: [],
                createTween: function (e3, t3) {
                    var n3 = S.Tween(
                        o2,
                        l2.opts,
                        e3,
                        t3,
                        l2.opts.specialEasing[e3] || l2.opts.easing
                    )
                    return l2.tweens.push(n3), n3
                },
                stop: function (e3) {
                    var t3 = 0,
                        n3 = e3 ? l2.tweens.length : 0
                    if (a2) return this
                    for (a2 = !0; t3 < n3; t3++) l2.tweens[t3].run(1)
                    return (
                        e3
                            ? (s2.notifyWith(o2, [l2, 1, 0]),
                              s2.resolveWith(o2, [l2, e3]))
                            : s2.rejectWith(o2, [l2, e3]),
                        this
                    )
                },
            }),
            c2 = l2.props
        for (
            !(function (e3, t3) {
                var n3, r3, i3, o3, a3
                for (n3 in e3)
                    if (
                        ((i3 = t3[(r3 = X(n3))]),
                        (o3 = e3[n3]),
                        Array.isArray(o3) &&
                            ((i3 = o3[1]), (o3 = e3[n3] = o3[0])),
                        n3 !== r3 && ((e3[r3] = o3), delete e3[n3]),
                        (a3 = S.cssHooks[r3]) && ('expand' in a3))
                    )
                        for (n3 in ((o3 = a3.expand(o3)), delete e3[r3], o3))
                            (n3 in e3) || ((e3[n3] = o3[n3]), (t3[n3] = i3))
                    else t3[r3] = i3
            })(c2, l2.opts.specialEasing);
            r2 < i2;
            r2++
        )
            if ((n2 = ft.prefilters[r2].call(l2, o2, c2, l2.opts)))
                return (
                    m(n2.stop) &&
                        (S._queueHooks(l2.elem, l2.opts.queue).stop =
                            n2.stop.bind(n2)),
                    n2
                )
        return (
            S.map(c2, ct, l2),
            m(l2.opts.start) && l2.opts.start.call(o2, l2),
            l2
                .progress(l2.opts.progress)
                .done(l2.opts.done, l2.opts.complete)
                .fail(l2.opts.fail)
                .always(l2.opts.always),
            S.fx.timer(
                S.extend(u2, { elem: o2, anim: l2, queue: l2.opts.queue })
            ),
            l2
        )
    }
    ;(S.Animation = S.extend(ft, {
        tweeners: {
            '*': [
                function (e2, t2) {
                    var n2 = this.createTween(e2, t2)
                    return se(n2.elem, e2, te.exec(t2), n2), n2
                },
            ],
        },
        tweener: function (e2, t2) {
            m(e2) ? ((t2 = e2), (e2 = ['*'])) : (e2 = e2.match(P))
            for (var n2, r2 = 0, i2 = e2.length; r2 < i2; r2++)
                (n2 = e2[r2]),
                    (ft.tweeners[n2] = ft.tweeners[n2] || []),
                    ft.tweeners[n2].unshift(t2)
        },
        prefilters: [
            function (e2, t2, n2) {
                var r2,
                    i2,
                    o2,
                    a2,
                    s2,
                    u2,
                    l2,
                    c2,
                    f2 = 'width' in t2 || 'height' in t2,
                    p2 = this,
                    d2 = {},
                    h2 = e2.style,
                    g2 = e2.nodeType && ae(e2),
                    v2 = Y.get(e2, 'fxshow')
                for (r2 in (n2.queue ||
                    ((a2 = S._queueHooks(e2, 'fx')).unqueued == null &&
                        ((a2.unqueued = 0),
                        (s2 = a2.empty.fire),
                        (a2.empty.fire = function () {
                            a2.unqueued || s2()
                        })),
                    a2.unqueued++,
                    p2.always(function () {
                        p2.always(function () {
                            a2.unqueued--,
                                S.queue(e2, 'fx').length || a2.empty.fire()
                        })
                    })),
                t2))
                    if (((i2 = t2[r2]), ot.test(i2))) {
                        if (
                            (delete t2[r2],
                            (o2 = o2 || i2 === 'toggle'),
                            i2 === (g2 ? 'hide' : 'show'))
                        ) {
                            if (i2 !== 'show' || !v2 || v2[r2] === void 0)
                                continue
                            g2 = !0
                        }
                        d2[r2] = (v2 && v2[r2]) || S.style(e2, r2)
                    }
                if ((u2 = !S.isEmptyObject(t2)) || !S.isEmptyObject(d2))
                    for (r2 in (f2 &&
                        e2.nodeType === 1 &&
                        ((n2.overflow = [
                            h2.overflow,
                            h2.overflowX,
                            h2.overflowY,
                        ]),
                        (l2 = v2 && v2.display) == null &&
                            (l2 = Y.get(e2, 'display')),
                        (c2 = S.css(e2, 'display')) === 'none' &&
                            (l2
                                ? (c2 = l2)
                                : (le([e2], !0),
                                  (l2 = e2.style.display || l2),
                                  (c2 = S.css(e2, 'display')),
                                  le([e2]))),
                        (c2 === 'inline' ||
                            (c2 === 'inline-block' && l2 != null)) &&
                            S.css(e2, 'float') === 'none' &&
                            (u2 ||
                                (p2.done(function () {
                                    h2.display = l2
                                }),
                                l2 == null &&
                                    ((c2 = h2.display),
                                    (l2 = c2 === 'none' ? '' : c2))),
                            (h2.display = 'inline-block'))),
                    n2.overflow &&
                        ((h2.overflow = 'hidden'),
                        p2.always(function () {
                            ;(h2.overflow = n2.overflow[0]),
                                (h2.overflowX = n2.overflow[1]),
                                (h2.overflowY = n2.overflow[2])
                        })),
                    (u2 = !1),
                    d2))
                        u2 ||
                            (v2
                                ? 'hidden' in v2 && (g2 = v2.hidden)
                                : (v2 = Y.access(e2, 'fxshow', {
                                      display: l2,
                                  })),
                            o2 && (v2.hidden = !g2),
                            g2 && le([e2], !0),
                            p2.done(function () {
                                for (r2 in (g2 || le([e2]),
                                Y.remove(e2, 'fxshow'),
                                d2))
                                    S.style(e2, r2, d2[r2])
                            })),
                            (u2 = ct(g2 ? v2[r2] : 0, r2, p2)),
                            r2 in v2 ||
                                ((v2[r2] = u2.start),
                                g2 && ((u2.end = u2.start), (u2.start = 0)))
            },
        ],
        prefilter: function (e2, t2) {
            t2 ? ft.prefilters.unshift(e2) : ft.prefilters.push(e2)
        },
    })),
        (S.speed = function (e2, t2, n2) {
            var r2 =
                e2 && typeof e2 == 'object'
                    ? S.extend({}, e2)
                    : {
                          complete: n2 || (!n2 && t2) || (m(e2) && e2),
                          duration: e2,
                          easing: (n2 && t2) || (t2 && !m(t2) && t2),
                      }
            return (
                S.fx.off
                    ? (r2.duration = 0)
                    : typeof r2.duration != 'number' &&
                      (r2.duration in S.fx.speeds
                          ? (r2.duration = S.fx.speeds[r2.duration])
                          : (r2.duration = S.fx.speeds._default)),
                (r2.queue != null && r2.queue !== !0) || (r2.queue = 'fx'),
                (r2.old = r2.complete),
                (r2.complete = function () {
                    m(r2.old) && r2.old.call(this),
                        r2.queue && S.dequeue(this, r2.queue)
                }),
                r2
            )
        }),
        S.fn.extend({
            fadeTo: function (e2, t2, n2, r2) {
                return this.filter(ae)
                    .css('opacity', 0)
                    .show()
                    .end()
                    .animate({ opacity: t2 }, e2, n2, r2)
            },
            animate: function (t2, e2, n2, r2) {
                var i2 = S.isEmptyObject(t2),
                    o2 = S.speed(e2, n2, r2),
                    a2 = function () {
                        var e3 = ft(this, S.extend({}, t2), o2)
                        ;(i2 || Y.get(this, 'finish')) && e3.stop(!0)
                    }
                return (
                    (a2.finish = a2),
                    i2 || o2.queue === !1
                        ? this.each(a2)
                        : this.queue(o2.queue, a2)
                )
            },
            stop: function (i2, e2, o2) {
                var a2 = function (e3) {
                    var t2 = e3.stop
                    delete e3.stop, t2(o2)
                }
                return (
                    typeof i2 != 'string' &&
                        ((o2 = e2), (e2 = i2), (i2 = void 0)),
                    e2 && this.queue(i2 || 'fx', []),
                    this.each(function () {
                        var e3 = !0,
                            t2 = i2 != null && i2 + 'queueHooks',
                            n2 = S.timers,
                            r2 = Y.get(this)
                        if (t2) r2[t2] && r2[t2].stop && a2(r2[t2])
                        else
                            for (t2 in r2)
                                r2[t2] &&
                                    r2[t2].stop &&
                                    at.test(t2) &&
                                    a2(r2[t2])
                        for (t2 = n2.length; t2--; )
                            n2[t2].elem !== this ||
                                (i2 != null && n2[t2].queue !== i2) ||
                                (n2[t2].anim.stop(o2),
                                (e3 = !1),
                                n2.splice(t2, 1))
                        ;(!e3 && o2) || S.dequeue(this, i2)
                    })
                )
            },
            finish: function (a2) {
                return (
                    a2 !== !1 && (a2 = a2 || 'fx'),
                    this.each(function () {
                        var e2,
                            t2 = Y.get(this),
                            n2 = t2[a2 + 'queue'],
                            r2 = t2[a2 + 'queueHooks'],
                            i2 = S.timers,
                            o2 = n2 ? n2.length : 0
                        for (
                            t2.finish = !0,
                                S.queue(this, a2, []),
                                r2 && r2.stop && r2.stop.call(this, !0),
                                e2 = i2.length;
                            e2--;

                        )
                            i2[e2].elem === this &&
                                i2[e2].queue === a2 &&
                                (i2[e2].anim.stop(!0), i2.splice(e2, 1))
                        for (e2 = 0; e2 < o2; e2++)
                            n2[e2] && n2[e2].finish && n2[e2].finish.call(this)
                        delete t2.finish
                    })
                )
            },
        }),
        S.each(['toggle', 'show', 'hide'], function (e2, r2) {
            var i2 = S.fn[r2]
            S.fn[r2] = function (e3, t2, n2) {
                return e3 == null || typeof e3 == 'boolean'
                    ? i2.apply(this, arguments)
                    : this.animate(lt(r2, !0), e3, t2, n2)
            }
        }),
        S.each(
            {
                slideDown: lt('show'),
                slideUp: lt('hide'),
                slideToggle: lt('toggle'),
                fadeIn: { opacity: 'show' },
                fadeOut: { opacity: 'hide' },
                fadeToggle: { opacity: 'toggle' },
            },
            function (e2, r2) {
                S.fn[e2] = function (e3, t2, n2) {
                    return this.animate(r2, e3, t2, n2)
                }
            }
        ),
        (S.timers = []),
        (S.fx.tick = function () {
            var e2,
                t2 = 0,
                n2 = S.timers
            for (tt = Date.now(); t2 < n2.length; t2++)
                (e2 = n2[t2])() || n2[t2] !== e2 || n2.splice(t2--, 1)
            n2.length || S.fx.stop(), (tt = void 0)
        }),
        (S.fx.timer = function (e2) {
            S.timers.push(e2), S.fx.start()
        }),
        (S.fx.interval = 13),
        (S.fx.start = function () {
            nt || ((nt = !0), st())
        }),
        (S.fx.stop = function () {
            nt = null
        }),
        (S.fx.speeds = { slow: 600, fast: 200, _default: 400 }),
        (S.fn.delay = function (r2, e2) {
            return (
                (r2 = (S.fx && S.fx.speeds[r2]) || r2),
                (e2 = e2 || 'fx'),
                this.queue(e2, function (e3, t2) {
                    var n2 = C.setTimeout(e3, r2)
                    t2.stop = function () {
                        C.clearTimeout(n2)
                    }
                })
            )
        }),
        (rt = E.createElement('input')),
        (it = E.createElement('select').appendChild(E.createElement('option'))),
        (rt.type = 'checkbox'),
        (y.checkOn = rt.value !== ''),
        (y.optSelected = it.selected),
        ((rt = E.createElement('input')).value = 't'),
        (rt.type = 'radio'),
        (y.radioValue = rt.value === 't')
    var pt,
        dt = S.expr.attrHandle
    S.fn.extend({
        attr: function (e2, t2) {
            return $2(this, S.attr, e2, t2, 1 < arguments.length)
        },
        removeAttr: function (e2) {
            return this.each(function () {
                S.removeAttr(this, e2)
            })
        },
    }),
        S.extend({
            attr: function (e2, t2, n2) {
                var r2,
                    i2,
                    o2 = e2.nodeType
                if (o2 !== 3 && o2 !== 8 && o2 !== 2)
                    return typeof e2.getAttribute > 'u'
                        ? S.prop(e2, t2, n2)
                        : ((o2 === 1 && S.isXMLDoc(e2)) ||
                              (i2 =
                                  S.attrHooks[t2.toLowerCase()] ||
                                  (S.expr.match.bool.test(t2) ? pt : void 0)),
                          n2 !== void 0
                              ? n2 === null
                                  ? void S.removeAttr(e2, t2)
                                  : i2 &&
                                    'set' in i2 &&
                                    (r2 = i2.set(e2, n2, t2)) !== void 0
                                  ? r2
                                  : (e2.setAttribute(t2, n2 + ''), n2)
                              : i2 &&
                                'get' in i2 &&
                                (r2 = i2.get(e2, t2)) !== null
                              ? r2
                              : (r2 = S.find.attr(e2, t2)) == null
                              ? void 0
                              : r2)
            },
            attrHooks: {
                type: {
                    set: function (e2, t2) {
                        if (!y.radioValue && t2 === 'radio' && A(e2, 'input')) {
                            var n2 = e2.value
                            return (
                                e2.setAttribute('type', t2),
                                n2 && (e2.value = n2),
                                t2
                            )
                        }
                    },
                },
            },
            removeAttr: function (e2, t2) {
                var n2,
                    r2 = 0,
                    i2 = t2 && t2.match(P)
                if (i2 && e2.nodeType === 1)
                    for (; (n2 = i2[r2++]); ) e2.removeAttribute(n2)
            },
        }),
        (pt = {
            set: function (e2, t2, n2) {
                return (
                    t2 === !1 ? S.removeAttr(e2, n2) : e2.setAttribute(n2, n2),
                    n2
                )
            },
        }),
        S.each(S.expr.match.bool.source.match(/\w+/g), function (e2, t2) {
            var a2 = dt[t2] || S.find.attr
            dt[t2] = function (e3, t3, n2) {
                var r2,
                    i2,
                    o2 = t3.toLowerCase()
                return (
                    n2 ||
                        ((i2 = dt[o2]),
                        (dt[o2] = r2),
                        (r2 = a2(e3, t3, n2) != null ? o2 : null),
                        (dt[o2] = i2)),
                    r2
                )
            }
        })
    var ht = /^(?:input|select|textarea|button)$/i,
        gt = /^(?:a|area)$/i
    function vt(e2) {
        return (e2.match(P) || []).join(' ')
    }
    function yt(e2) {
        return (e2.getAttribute && e2.getAttribute('class')) || ''
    }
    function mt(e2) {
        return Array.isArray(e2)
            ? e2
            : (typeof e2 == 'string' && e2.match(P)) || []
    }
    S.fn.extend({
        prop: function (e2, t2) {
            return $2(this, S.prop, e2, t2, 1 < arguments.length)
        },
        removeProp: function (e2) {
            return this.each(function () {
                delete this[S.propFix[e2] || e2]
            })
        },
    }),
        S.extend({
            prop: function (e2, t2, n2) {
                var r2,
                    i2,
                    o2 = e2.nodeType
                if (o2 !== 3 && o2 !== 8 && o2 !== 2)
                    return (
                        (o2 === 1 && S.isXMLDoc(e2)) ||
                            ((t2 = S.propFix[t2] || t2),
                            (i2 = S.propHooks[t2])),
                        n2 !== void 0
                            ? i2 &&
                              'set' in i2 &&
                              (r2 = i2.set(e2, n2, t2)) !== void 0
                                ? r2
                                : (e2[t2] = n2)
                            : i2 &&
                              'get' in i2 &&
                              (r2 = i2.get(e2, t2)) !== null
                            ? r2
                            : e2[t2]
                    )
            },
            propHooks: {
                tabIndex: {
                    get: function (e2) {
                        var t2 = S.find.attr(e2, 'tabindex')
                        return t2
                            ? parseInt(t2, 10)
                            : ht.test(e2.nodeName) ||
                              (gt.test(e2.nodeName) && e2.href)
                            ? 0
                            : -1
                    },
                },
            },
            propFix: { for: 'htmlFor', class: 'className' },
        }),
        y.optSelected ||
            (S.propHooks.selected = {
                get: function (e2) {
                    var t2 = e2.parentNode
                    return (
                        t2 && t2.parentNode && t2.parentNode.selectedIndex, null
                    )
                },
                set: function (e2) {
                    var t2 = e2.parentNode
                    t2 &&
                        (t2.selectedIndex,
                        t2.parentNode && t2.parentNode.selectedIndex)
                },
            }),
        S.each(
            [
                'tabIndex',
                'readOnly',
                'maxLength',
                'cellSpacing',
                'cellPadding',
                'rowSpan',
                'colSpan',
                'useMap',
                'frameBorder',
                'contentEditable',
            ],
            function () {
                S.propFix[this.toLowerCase()] = this
            }
        ),
        S.fn.extend({
            addClass: function (t2) {
                var e2,
                    n2,
                    r2,
                    i2,
                    o2,
                    a2,
                    s2,
                    u2 = 0
                if (m(t2))
                    return this.each(function (e3) {
                        S(this).addClass(t2.call(this, e3, yt(this)))
                    })
                if ((e2 = mt(t2)).length) {
                    for (; (n2 = this[u2++]); )
                        if (
                            ((i2 = yt(n2)),
                            (r2 = n2.nodeType === 1 && ' ' + vt(i2) + ' '))
                        ) {
                            for (a2 = 0; (o2 = e2[a2++]); )
                                r2.indexOf(' ' + o2 + ' ') < 0 &&
                                    (r2 += o2 + ' ')
                            i2 !== (s2 = vt(r2)) && n2.setAttribute('class', s2)
                        }
                }
                return this
            },
            removeClass: function (t2) {
                var e2,
                    n2,
                    r2,
                    i2,
                    o2,
                    a2,
                    s2,
                    u2 = 0
                if (m(t2))
                    return this.each(function (e3) {
                        S(this).removeClass(t2.call(this, e3, yt(this)))
                    })
                if (!arguments.length) return this.attr('class', '')
                if ((e2 = mt(t2)).length) {
                    for (; (n2 = this[u2++]); )
                        if (
                            ((i2 = yt(n2)),
                            (r2 = n2.nodeType === 1 && ' ' + vt(i2) + ' '))
                        ) {
                            for (a2 = 0; (o2 = e2[a2++]); )
                                for (; -1 < r2.indexOf(' ' + o2 + ' '); )
                                    r2 = r2.replace(' ' + o2 + ' ', ' ')
                            i2 !== (s2 = vt(r2)) && n2.setAttribute('class', s2)
                        }
                }
                return this
            },
            toggleClass: function (i2, t2) {
                var o2 = typeof i2,
                    a2 = o2 === 'string' || Array.isArray(i2)
                return typeof t2 == 'boolean' && a2
                    ? t2
                        ? this.addClass(i2)
                        : this.removeClass(i2)
                    : m(i2)
                    ? this.each(function (e2) {
                          S(this).toggleClass(
                              i2.call(this, e2, yt(this), t2),
                              t2
                          )
                      })
                    : this.each(function () {
                          var e2, t3, n2, r2
                          if (a2)
                              for (
                                  t3 = 0, n2 = S(this), r2 = mt(i2);
                                  (e2 = r2[t3++]);

                              )
                                  n2.hasClass(e2)
                                      ? n2.removeClass(e2)
                                      : n2.addClass(e2)
                          else
                              (i2 !== void 0 && o2 !== 'boolean') ||
                                  ((e2 = yt(this)) &&
                                      Y.set(this, '__className__', e2),
                                  this.setAttribute &&
                                      this.setAttribute(
                                          'class',
                                          e2 || i2 === !1
                                              ? ''
                                              : Y.get(this, '__className__') ||
                                                    ''
                                      ))
                      })
            },
            hasClass: function (e2) {
                var t2,
                    n2,
                    r2 = 0
                for (t2 = ' ' + e2 + ' '; (n2 = this[r2++]); )
                    if (
                        n2.nodeType === 1 &&
                        -1 < (' ' + vt(yt(n2)) + ' ').indexOf(t2)
                    )
                        return !0
                return !1
            },
        })
    var xt = /\r/g
    S.fn.extend({
        val: function (n2) {
            var r2,
                e2,
                i2,
                t2 = this[0]
            return arguments.length
                ? ((i2 = m(n2)),
                  this.each(function (e3) {
                      var t3
                      this.nodeType === 1 &&
                          ((t3 = i2 ? n2.call(this, e3, S(this).val()) : n2) ==
                          null
                              ? (t3 = '')
                              : typeof t3 == 'number'
                              ? (t3 += '')
                              : Array.isArray(t3) &&
                                (t3 = S.map(t3, function (e4) {
                                    return e4 == null ? '' : e4 + ''
                                })),
                          ((r2 =
                              S.valHooks[this.type] ||
                              S.valHooks[this.nodeName.toLowerCase()]) &&
                              'set' in r2 &&
                              r2.set(this, t3, 'value') !== void 0) ||
                              (this.value = t3))
                  }))
                : t2
                ? (r2 =
                      S.valHooks[t2.type] ||
                      S.valHooks[t2.nodeName.toLowerCase()]) &&
                  'get' in r2 &&
                  (e2 = r2.get(t2, 'value')) !== void 0
                    ? e2
                    : typeof (e2 = t2.value) == 'string'
                    ? e2.replace(xt, '')
                    : e2 ?? ''
                : void 0
        },
    }),
        S.extend({
            valHooks: {
                option: {
                    get: function (e2) {
                        var t2 = S.find.attr(e2, 'value')
                        return t2 ?? vt(S.text(e2))
                    },
                },
                select: {
                    get: function (e2) {
                        var t2,
                            n2,
                            r2,
                            i2 = e2.options,
                            o2 = e2.selectedIndex,
                            a2 = e2.type === 'select-one',
                            s2 = a2 ? null : [],
                            u2 = a2 ? o2 + 1 : i2.length
                        for (r2 = o2 < 0 ? u2 : a2 ? o2 : 0; r2 < u2; r2++)
                            if (
                                ((n2 = i2[r2]).selected || r2 === o2) &&
                                !n2.disabled &&
                                (!n2.parentNode.disabled ||
                                    !A(n2.parentNode, 'optgroup'))
                            ) {
                                if (((t2 = S(n2).val()), a2)) return t2
                                s2.push(t2)
                            }
                        return s2
                    },
                    set: function (e2, t2) {
                        for (
                            var n2,
                                r2,
                                i2 = e2.options,
                                o2 = S.makeArray(t2),
                                a2 = i2.length;
                            a2--;

                        )
                            ((r2 = i2[a2]).selected =
                                -1 <
                                S.inArray(S.valHooks.option.get(r2), o2)) &&
                                (n2 = !0)
                        return n2 || (e2.selectedIndex = -1), o2
                    },
                },
            },
        }),
        S.each(['radio', 'checkbox'], function () {
            ;(S.valHooks[this] = {
                set: function (e2, t2) {
                    if (Array.isArray(t2))
                        return (e2.checked = -1 < S.inArray(S(e2).val(), t2))
                },
            }),
                y.checkOn ||
                    (S.valHooks[this].get = function (e2) {
                        return e2.getAttribute('value') === null
                            ? 'on'
                            : e2.value
                    })
        }),
        (y.focusin = 'onfocusin' in C)
    var bt = /^(?:focusinfocus|focusoutblur)$/,
        wt = function (e2) {
            e2.stopPropagation()
        }
    S.extend(S.event, {
        trigger: function (e2, t2, n2, r2) {
            var i2,
                o2,
                a2,
                s2,
                u2,
                l2,
                c2,
                f2,
                p2 = [n2 || E],
                d2 = v.call(e2, 'type') ? e2.type : e2,
                h2 = v.call(e2, 'namespace') ? e2.namespace.split('.') : []
            if (
                ((o2 = f2 = a2 = n2 = n2 || E),
                n2.nodeType !== 3 &&
                    n2.nodeType !== 8 &&
                    !bt.test(d2 + S.event.triggered) &&
                    (-1 < d2.indexOf('.') &&
                        ((d2 = (h2 = d2.split('.')).shift()), h2.sort()),
                    (u2 = d2.indexOf(':') < 0 && 'on' + d2),
                    ((e2 = e2[S.expando]
                        ? e2
                        : new S.Event(
                              d2,
                              typeof e2 == 'object' && e2
                          )).isTrigger = r2 ? 2 : 3),
                    (e2.namespace = h2.join('.')),
                    (e2.rnamespace = e2.namespace
                        ? new RegExp(
                              '(^|\\.)' + h2.join('\\.(?:.*\\.|)') + '(\\.|$)'
                          )
                        : null),
                    (e2.result = void 0),
                    e2.target || (e2.target = n2),
                    (t2 = t2 == null ? [e2] : S.makeArray(t2, [e2])),
                    (c2 = S.event.special[d2] || {}),
                    r2 || !c2.trigger || c2.trigger.apply(n2, t2) !== !1))
            ) {
                if (!r2 && !c2.noBubble && !x(n2)) {
                    for (
                        s2 = c2.delegateType || d2,
                            bt.test(s2 + d2) || (o2 = o2.parentNode);
                        o2;
                        o2 = o2.parentNode
                    )
                        p2.push(o2), (a2 = o2)
                    a2 === (n2.ownerDocument || E) &&
                        p2.push(a2.defaultView || a2.parentWindow || C)
                }
                for (i2 = 0; (o2 = p2[i2++]) && !e2.isPropagationStopped(); )
                    (f2 = o2),
                        (e2.type = 1 < i2 ? s2 : c2.bindType || d2),
                        (l2 =
                            (Y.get(o2, 'events') || Object.create(null))[
                                e2.type
                            ] && Y.get(o2, 'handle')) && l2.apply(o2, t2),
                        (l2 = u2 && o2[u2]) &&
                            l2.apply &&
                            V(o2) &&
                            ((e2.result = l2.apply(o2, t2)),
                            e2.result === !1 && e2.preventDefault())
                return (
                    (e2.type = d2),
                    r2 ||
                        e2.isDefaultPrevented() ||
                        (c2._default &&
                            c2._default.apply(p2.pop(), t2) !== !1) ||
                        !V(n2) ||
                        (u2 &&
                            m(n2[d2]) &&
                            !x(n2) &&
                            ((a2 = n2[u2]) && (n2[u2] = null),
                            (S.event.triggered = d2),
                            e2.isPropagationStopped() &&
                                f2.addEventListener(d2, wt),
                            n2[d2](),
                            e2.isPropagationStopped() &&
                                f2.removeEventListener(d2, wt),
                            (S.event.triggered = void 0),
                            a2 && (n2[u2] = a2))),
                    e2.result
                )
            }
        },
        simulate: function (e2, t2, n2) {
            var r2 = S.extend(new S.Event(), n2, { type: e2, isSimulated: !0 })
            S.event.trigger(r2, null, t2)
        },
    }),
        S.fn.extend({
            trigger: function (e2, t2) {
                return this.each(function () {
                    S.event.trigger(e2, t2, this)
                })
            },
            triggerHandler: function (e2, t2) {
                var n2 = this[0]
                if (n2) return S.event.trigger(e2, t2, n2, !0)
            },
        }),
        y.focusin ||
            S.each({ focus: 'focusin', blur: 'focusout' }, function (n2, r2) {
                var i2 = function (e2) {
                    S.event.simulate(r2, e2.target, S.event.fix(e2))
                }
                S.event.special[r2] = {
                    setup: function () {
                        var e2 = this.ownerDocument || this.document || this,
                            t2 = Y.access(e2, r2)
                        t2 || e2.addEventListener(n2, i2, !0),
                            Y.access(e2, r2, (t2 || 0) + 1)
                    },
                    teardown: function () {
                        var e2 = this.ownerDocument || this.document || this,
                            t2 = Y.access(e2, r2) - 1
                        t2
                            ? Y.access(e2, r2, t2)
                            : (e2.removeEventListener(n2, i2, !0),
                              Y.remove(e2, r2))
                    },
                }
            })
    var Tt = C.location,
        Ct = { guid: Date.now() },
        Et = /\?/
    S.parseXML = function (e2) {
        var t2
        if (!e2 || typeof e2 != 'string') return null
        try {
            t2 = new C.DOMParser().parseFromString(e2, 'text/xml')
        } catch {
            t2 = void 0
        }
        return (
            (t2 && !t2.getElementsByTagName('parsererror').length) ||
                S.error('Invalid XML: ' + e2),
            t2
        )
    }
    var St = /\[\]$/,
        kt = /\r?\n/g,
        At = /^(?:submit|button|image|reset|file)$/i,
        Nt = /^(?:input|select|textarea|keygen)/i
    function Dt(n2, e2, r2, i2) {
        var t2
        if (Array.isArray(e2))
            S.each(e2, function (e3, t3) {
                r2 || St.test(n2)
                    ? i2(n2, t3)
                    : Dt(
                          n2 +
                              '[' +
                              (typeof t3 == 'object' && t3 != null ? e3 : '') +
                              ']',
                          t3,
                          r2,
                          i2
                      )
            })
        else if (r2 || w(e2) !== 'object') i2(n2, e2)
        else for (t2 in e2) Dt(n2 + '[' + t2 + ']', e2[t2], r2, i2)
    }
    ;(S.param = function (e2, t2) {
        var n2,
            r2 = [],
            i2 = function (e3, t3) {
                var n3 = m(t3) ? t3() : t3
                r2[r2.length] =
                    encodeURIComponent(e3) + '=' + encodeURIComponent(n3 ?? '')
            }
        if (e2 == null) return ''
        if (Array.isArray(e2) || (e2.jquery && !S.isPlainObject(e2)))
            S.each(e2, function () {
                i2(this.name, this.value)
            })
        else for (n2 in e2) Dt(n2, e2[n2], t2, i2)
        return r2.join('&')
    }),
        S.fn.extend({
            serialize: function () {
                return S.param(this.serializeArray())
            },
            serializeArray: function () {
                return this.map(function () {
                    var e2 = S.prop(this, 'elements')
                    return e2 ? S.makeArray(e2) : this
                })
                    .filter(function () {
                        var e2 = this.type
                        return (
                            this.name &&
                            !S(this).is(':disabled') &&
                            Nt.test(this.nodeName) &&
                            !At.test(e2) &&
                            (this.checked || !pe.test(e2))
                        )
                    })
                    .map(function (e2, t2) {
                        var n2 = S(this).val()
                        return n2 == null
                            ? null
                            : Array.isArray(n2)
                            ? S.map(n2, function (e3) {
                                  return {
                                      name: t2.name,
                                      value: e3.replace(
                                          kt,
                                          `\r
`
                                      ),
                                  }
                              })
                            : {
                                  name: t2.name,
                                  value: n2.replace(
                                      kt,
                                      `\r
`
                                  ),
                              }
                    })
                    .get()
            },
        })
    var jt = /%20/g,
        qt = /#.*$/,
        Lt = /([?&])_=[^&]*/,
        Ht = /^(.*?):[ \t]*([^\r\n]*)$/gm,
        Ot = /^(?:GET|HEAD)$/,
        Pt = /^\/\//,
        Rt = {},
        Mt = {},
        It = '*/'.concat('*'),
        Wt = E.createElement('a')
    function Ft(o2) {
        return function (e2, t2) {
            typeof e2 != 'string' && ((t2 = e2), (e2 = '*'))
            var n2,
                r2 = 0,
                i2 = e2.toLowerCase().match(P) || []
            if (m(t2))
                for (; (n2 = i2[r2++]); )
                    n2[0] === '+'
                        ? ((n2 = n2.slice(1) || '*'),
                          (o2[n2] = o2[n2] || []).unshift(t2))
                        : (o2[n2] = o2[n2] || []).push(t2)
        }
    }
    function Bt(t2, i2, o2, a2) {
        var s2 = {},
            u2 = t2 === Mt
        function l2(e2) {
            var r2
            return (
                (s2[e2] = !0),
                S.each(t2[e2] || [], function (e3, t3) {
                    var n2 = t3(i2, o2, a2)
                    return typeof n2 != 'string' || u2 || s2[n2]
                        ? u2
                            ? !(r2 = n2)
                            : void 0
                        : (i2.dataTypes.unshift(n2), l2(n2), !1)
                }),
                r2
            )
        }
        return l2(i2.dataTypes[0]) || (!s2['*'] && l2('*'))
    }
    function $t(e2, t2) {
        var n2,
            r2,
            i2 = S.ajaxSettings.flatOptions || {}
        for (n2 in t2)
            t2[n2] !== void 0 && ((i2[n2] ? e2 : r2 || (r2 = {}))[n2] = t2[n2])
        return r2 && S.extend(!0, e2, r2), e2
    }
    ;(Wt.href = Tt.href),
        S.extend({
            active: 0,
            lastModified: {},
            etag: {},
            ajaxSettings: {
                url: Tt.href,
                type: 'GET',
                isLocal:
                    /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(
                        Tt.protocol
                    ),
                global: !0,
                processData: !0,
                async: !0,
                contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
                accepts: {
                    '*': It,
                    text: 'text/plain',
                    html: 'text/html',
                    xml: 'application/xml, text/xml',
                    json: 'application/json, text/javascript',
                },
                contents: { xml: /\bxml\b/, html: /\bhtml/, json: /\bjson\b/ },
                responseFields: {
                    xml: 'responseXML',
                    text: 'responseText',
                    json: 'responseJSON',
                },
                converters: {
                    '* text': String,
                    'text html': !0,
                    'text json': JSON.parse,
                    'text xml': S.parseXML,
                },
                flatOptions: { url: !0, context: !0 },
            },
            ajaxSetup: function (e2, t2) {
                return t2
                    ? $t($t(e2, S.ajaxSettings), t2)
                    : $t(S.ajaxSettings, e2)
            },
            ajaxPrefilter: Ft(Rt),
            ajaxTransport: Ft(Mt),
            ajax: function (e2, t2) {
                typeof e2 == 'object' && ((t2 = e2), (e2 = void 0)),
                    (t2 = t2 || {})
                var c2,
                    f2,
                    p2,
                    n2,
                    d2,
                    r2,
                    h2,
                    g2,
                    i2,
                    o2,
                    v2 = S.ajaxSetup({}, t2),
                    y2 = v2.context || v2,
                    m2 =
                        v2.context && (y2.nodeType || y2.jquery)
                            ? S(y2)
                            : S.event,
                    x2 = S.Deferred(),
                    b2 = S.Callbacks('once memory'),
                    w2 = v2.statusCode || {},
                    a2 = {},
                    s2 = {},
                    u2 = 'canceled',
                    T2 = {
                        readyState: 0,
                        getResponseHeader: function (e3) {
                            var t3
                            if (h2) {
                                if (!n2)
                                    for (n2 = {}; (t3 = Ht.exec(p2)); )
                                        n2[t3[1].toLowerCase() + ' '] = (
                                            n2[t3[1].toLowerCase() + ' '] || []
                                        ).concat(t3[2])
                                t3 = n2[e3.toLowerCase() + ' ']
                            }
                            return t3 == null ? null : t3.join(', ')
                        },
                        getAllResponseHeaders: function () {
                            return h2 ? p2 : null
                        },
                        setRequestHeader: function (e3, t3) {
                            return (
                                h2 == null &&
                                    ((e3 = s2[e3.toLowerCase()] =
                                        s2[e3.toLowerCase()] || e3),
                                    (a2[e3] = t3)),
                                this
                            )
                        },
                        overrideMimeType: function (e3) {
                            return h2 == null && (v2.mimeType = e3), this
                        },
                        statusCode: function (e3) {
                            var t3
                            if (e3)
                                if (h2) T2.always(e3[T2.status])
                                else for (t3 in e3) w2[t3] = [w2[t3], e3[t3]]
                            return this
                        },
                        abort: function (e3) {
                            var t3 = e3 || u2
                            return c2 && c2.abort(t3), l2(0, t3), this
                        },
                    }
                if (
                    (x2.promise(T2),
                    (v2.url = ((e2 || v2.url || Tt.href) + '').replace(
                        Pt,
                        Tt.protocol + '//'
                    )),
                    (v2.type = t2.method || t2.type || v2.method || v2.type),
                    (v2.dataTypes = (v2.dataType || '*')
                        .toLowerCase()
                        .match(P) || ['']),
                    v2.crossDomain == null)
                ) {
                    r2 = E.createElement('a')
                    try {
                        ;(r2.href = v2.url),
                            (r2.href = r2.href),
                            (v2.crossDomain =
                                Wt.protocol + '//' + Wt.host !=
                                r2.protocol + '//' + r2.host)
                    } catch {
                        v2.crossDomain = !0
                    }
                }
                if (
                    (v2.data &&
                        v2.processData &&
                        typeof v2.data != 'string' &&
                        (v2.data = S.param(v2.data, v2.traditional)),
                    Bt(Rt, v2, t2, T2),
                    h2)
                )
                    return T2
                for (i2 in ((g2 = S.event && v2.global) &&
                    S.active++ == 0 &&
                    S.event.trigger('ajaxStart'),
                (v2.type = v2.type.toUpperCase()),
                (v2.hasContent = !Ot.test(v2.type)),
                (f2 = v2.url.replace(qt, '')),
                v2.hasContent
                    ? v2.data &&
                      v2.processData &&
                      (v2.contentType || '').indexOf(
                          'application/x-www-form-urlencoded'
                      ) === 0 &&
                      (v2.data = v2.data.replace(jt, '+'))
                    : ((o2 = v2.url.slice(f2.length)),
                      v2.data &&
                          (v2.processData || typeof v2.data == 'string') &&
                          ((f2 += (Et.test(f2) ? '&' : '?') + v2.data),
                          delete v2.data),
                      v2.cache === !1 &&
                          ((f2 = f2.replace(Lt, '$1')),
                          (o2 =
                              (Et.test(f2) ? '&' : '?') +
                              '_=' +
                              Ct.guid++ +
                              o2)),
                      (v2.url = f2 + o2)),
                v2.ifModified &&
                    (S.lastModified[f2] &&
                        T2.setRequestHeader(
                            'If-Modified-Since',
                            S.lastModified[f2]
                        ),
                    S.etag[f2] &&
                        T2.setRequestHeader('If-None-Match', S.etag[f2])),
                ((v2.data && v2.hasContent && v2.contentType !== !1) ||
                    t2.contentType) &&
                    T2.setRequestHeader('Content-Type', v2.contentType),
                T2.setRequestHeader(
                    'Accept',
                    v2.dataTypes[0] && v2.accepts[v2.dataTypes[0]]
                        ? v2.accepts[v2.dataTypes[0]] +
                              (v2.dataTypes[0] !== '*'
                                  ? ', ' + It + '; q=0.01'
                                  : '')
                        : v2.accepts['*']
                ),
                v2.headers))
                    T2.setRequestHeader(i2, v2.headers[i2])
                if (
                    v2.beforeSend &&
                    (v2.beforeSend.call(y2, T2, v2) === !1 || h2)
                )
                    return T2.abort()
                if (
                    ((u2 = 'abort'),
                    b2.add(v2.complete),
                    T2.done(v2.success),
                    T2.fail(v2.error),
                    (c2 = Bt(Mt, v2, t2, T2)))
                ) {
                    if (
                        ((T2.readyState = 1),
                        g2 && m2.trigger('ajaxSend', [T2, v2]),
                        h2)
                    )
                        return T2
                    v2.async &&
                        0 < v2.timeout &&
                        (d2 = C.setTimeout(function () {
                            T2.abort('timeout')
                        }, v2.timeout))
                    try {
                        ;(h2 = !1), c2.send(a2, l2)
                    } catch (e3) {
                        if (h2) throw e3
                        l2(-1, e3)
                    }
                } else l2(-1, 'No Transport')
                function l2(e3, t3, n3, r3) {
                    var i3,
                        o3,
                        a3,
                        s3,
                        u3,
                        l3 = t3
                    h2 ||
                        ((h2 = !0),
                        d2 && C.clearTimeout(d2),
                        (c2 = void 0),
                        (p2 = r3 || ''),
                        (T2.readyState = 0 < e3 ? 4 : 0),
                        (i3 = (200 <= e3 && e3 < 300) || e3 === 304),
                        n3 &&
                            (s3 = (function (e4, t4, n4) {
                                for (
                                    var r4,
                                        i4,
                                        o4,
                                        a4,
                                        s4 = e4.contents,
                                        u4 = e4.dataTypes;
                                    u4[0] === '*';

                                )
                                    u4.shift(),
                                        r4 === void 0 &&
                                            (r4 =
                                                e4.mimeType ||
                                                t4.getResponseHeader(
                                                    'Content-Type'
                                                ))
                                if (r4) {
                                    for (i4 in s4)
                                        if (s4[i4] && s4[i4].test(r4)) {
                                            u4.unshift(i4)
                                            break
                                        }
                                }
                                if (u4[0] in n4) o4 = u4[0]
                                else {
                                    for (i4 in n4) {
                                        if (
                                            !u4[0] ||
                                            e4.converters[i4 + ' ' + u4[0]]
                                        ) {
                                            o4 = i4
                                            break
                                        }
                                        a4 || (a4 = i4)
                                    }
                                    o4 = o4 || a4
                                }
                                if (o4)
                                    return (
                                        o4 !== u4[0] && u4.unshift(o4), n4[o4]
                                    )
                            })(v2, T2, n3)),
                        !i3 &&
                            -1 < S.inArray('script', v2.dataTypes) &&
                            (v2.converters['text script'] = function () {}),
                        (s3 = (function (e4, t4, n4, r4) {
                            var i4,
                                o4,
                                a4,
                                s4,
                                u4,
                                l4 = {},
                                c3 = e4.dataTypes.slice()
                            if (c3[1])
                                for (a4 in e4.converters)
                                    l4[a4.toLowerCase()] = e4.converters[a4]
                            for (o4 = c3.shift(); o4; )
                                if (
                                    (e4.responseFields[o4] &&
                                        (n4[e4.responseFields[o4]] = t4),
                                    !u4 &&
                                        r4 &&
                                        e4.dataFilter &&
                                        (t4 = e4.dataFilter(t4, e4.dataType)),
                                    (u4 = o4),
                                    (o4 = c3.shift()))
                                ) {
                                    if (o4 === '*') o4 = u4
                                    else if (u4 !== '*' && u4 !== o4) {
                                        if (
                                            !(a4 =
                                                l4[u4 + ' ' + o4] ||
                                                l4['* ' + o4])
                                        ) {
                                            for (i4 in l4)
                                                if (
                                                    (s4 = i4.split(' '))[1] ===
                                                        o4 &&
                                                    (a4 =
                                                        l4[u4 + ' ' + s4[0]] ||
                                                        l4['* ' + s4[0]])
                                                ) {
                                                    a4 === !0
                                                        ? (a4 = l4[i4])
                                                        : l4[i4] !== !0 &&
                                                          ((o4 = s4[0]),
                                                          c3.unshift(s4[1]))
                                                    break
                                                }
                                        }
                                        if (a4 !== !0)
                                            if (a4 && e4.throws) t4 = a4(t4)
                                            else
                                                try {
                                                    t4 = a4(t4)
                                                } catch (e5) {
                                                    return {
                                                        state: 'parsererror',
                                                        error: a4
                                                            ? e5
                                                            : 'No conversion from ' +
                                                              u4 +
                                                              ' to ' +
                                                              o4,
                                                    }
                                                }
                                    }
                                }
                            return { state: 'success', data: t4 }
                        })(v2, s3, T2, i3)),
                        i3
                            ? (v2.ifModified &&
                                  ((u3 =
                                      T2.getResponseHeader('Last-Modified')) &&
                                      (S.lastModified[f2] = u3),
                                  (u3 = T2.getResponseHeader('etag')) &&
                                      (S.etag[f2] = u3)),
                              e3 === 204 || v2.type === 'HEAD'
                                  ? (l3 = 'nocontent')
                                  : e3 === 304
                                  ? (l3 = 'notmodified')
                                  : ((l3 = s3.state),
                                    (o3 = s3.data),
                                    (i3 = !(a3 = s3.error))))
                            : ((a3 = l3),
                              (!e3 && l3) ||
                                  ((l3 = 'error'), e3 < 0 && (e3 = 0))),
                        (T2.status = e3),
                        (T2.statusText = (t3 || l3) + ''),
                        i3
                            ? x2.resolveWith(y2, [o3, l3, T2])
                            : x2.rejectWith(y2, [T2, l3, a3]),
                        T2.statusCode(w2),
                        (w2 = void 0),
                        g2 &&
                            m2.trigger(i3 ? 'ajaxSuccess' : 'ajaxError', [
                                T2,
                                v2,
                                i3 ? o3 : a3,
                            ]),
                        b2.fireWith(y2, [T2, l3]),
                        g2 &&
                            (m2.trigger('ajaxComplete', [T2, v2]),
                            --S.active || S.event.trigger('ajaxStop')))
                }
                return T2
            },
            getJSON: function (e2, t2, n2) {
                return S.get(e2, t2, n2, 'json')
            },
            getScript: function (e2, t2) {
                return S.get(e2, void 0, t2, 'script')
            },
        }),
        S.each(['get', 'post'], function (e2, i2) {
            S[i2] = function (e3, t2, n2, r2) {
                return (
                    m(t2) && ((r2 = r2 || n2), (n2 = t2), (t2 = void 0)),
                    S.ajax(
                        S.extend(
                            {
                                url: e3,
                                type: i2,
                                dataType: r2,
                                data: t2,
                                success: n2,
                            },
                            S.isPlainObject(e3) && e3
                        )
                    )
                )
            }
        }),
        S.ajaxPrefilter(function (e2) {
            var t2
            for (t2 in e2.headers)
                t2.toLowerCase() === 'content-type' &&
                    (e2.contentType = e2.headers[t2] || '')
        }),
        (S._evalUrl = function (e2, t2, n2) {
            return S.ajax({
                url: e2,
                type: 'GET',
                dataType: 'script',
                cache: !0,
                async: !1,
                global: !1,
                converters: { 'text script': function () {} },
                dataFilter: function (e3) {
                    S.globalEval(e3, t2, n2)
                },
            })
        }),
        S.fn.extend({
            wrapAll: function (e2) {
                var t2
                return (
                    this[0] &&
                        (m(e2) && (e2 = e2.call(this[0])),
                        (t2 = S(e2, this[0].ownerDocument).eq(0).clone(!0)),
                        this[0].parentNode && t2.insertBefore(this[0]),
                        t2
                            .map(function () {
                                for (var e3 = this; e3.firstElementChild; )
                                    e3 = e3.firstElementChild
                                return e3
                            })
                            .append(this)),
                    this
                )
            },
            wrapInner: function (n2) {
                return m(n2)
                    ? this.each(function (e2) {
                          S(this).wrapInner(n2.call(this, e2))
                      })
                    : this.each(function () {
                          var e2 = S(this),
                              t2 = e2.contents()
                          t2.length ? t2.wrapAll(n2) : e2.append(n2)
                      })
            },
            wrap: function (t2) {
                var n2 = m(t2)
                return this.each(function (e2) {
                    S(this).wrapAll(n2 ? t2.call(this, e2) : t2)
                })
            },
            unwrap: function (e2) {
                return (
                    this.parent(e2)
                        .not('body')
                        .each(function () {
                            S(this).replaceWith(this.childNodes)
                        }),
                    this
                )
            },
        }),
        (S.expr.pseudos.hidden = function (e2) {
            return !S.expr.pseudos.visible(e2)
        }),
        (S.expr.pseudos.visible = function (e2) {
            return !!(
                e2.offsetWidth ||
                e2.offsetHeight ||
                e2.getClientRects().length
            )
        }),
        (S.ajaxSettings.xhr = function () {
            try {
                return new C.XMLHttpRequest()
            } catch {}
        })
    var _t = { 0: 200, 1223: 204 },
        zt = S.ajaxSettings.xhr()
    ;(y.cors = !!zt && 'withCredentials' in zt),
        (y.ajax = zt = !!zt),
        S.ajaxTransport(function (i2) {
            var o2, a2
            if (y.cors || (zt && !i2.crossDomain))
                return {
                    send: function (e2, t2) {
                        var n2,
                            r2 = i2.xhr()
                        if (
                            (r2.open(
                                i2.type,
                                i2.url,
                                i2.async,
                                i2.username,
                                i2.password
                            ),
                            i2.xhrFields)
                        )
                            for (n2 in i2.xhrFields) r2[n2] = i2.xhrFields[n2]
                        for (n2 in (i2.mimeType &&
                            r2.overrideMimeType &&
                            r2.overrideMimeType(i2.mimeType),
                        i2.crossDomain ||
                            e2['X-Requested-With'] ||
                            (e2['X-Requested-With'] = 'XMLHttpRequest'),
                        e2))
                            r2.setRequestHeader(n2, e2[n2])
                        ;(o2 = function (e3) {
                            return function () {
                                o2 &&
                                    ((o2 =
                                        a2 =
                                        r2.onload =
                                        r2.onerror =
                                        r2.onabort =
                                        r2.ontimeout =
                                        r2.onreadystatechange =
                                            null),
                                    e3 === 'abort'
                                        ? r2.abort()
                                        : e3 === 'error'
                                        ? typeof r2.status != 'number'
                                            ? t2(0, 'error')
                                            : t2(r2.status, r2.statusText)
                                        : t2(
                                              _t[r2.status] || r2.status,
                                              r2.statusText,
                                              (r2.responseType || 'text') !==
                                                  'text' ||
                                                  typeof r2.responseText !=
                                                      'string'
                                                  ? { binary: r2.response }
                                                  : { text: r2.responseText },
                                              r2.getAllResponseHeaders()
                                          ))
                            }
                        }),
                            (r2.onload = o2()),
                            (a2 = r2.onerror = r2.ontimeout = o2('error')),
                            r2.onabort !== void 0
                                ? (r2.onabort = a2)
                                : (r2.onreadystatechange = function () {
                                      r2.readyState === 4 &&
                                          C.setTimeout(function () {
                                              o2 && a2()
                                          })
                                  }),
                            (o2 = o2('abort'))
                        try {
                            r2.send((i2.hasContent && i2.data) || null)
                        } catch (e3) {
                            if (o2) throw e3
                        }
                    },
                    abort: function () {
                        o2 && o2()
                    },
                }
        }),
        S.ajaxPrefilter(function (e2) {
            e2.crossDomain && (e2.contents.script = !1)
        }),
        S.ajaxSetup({
            accepts: {
                script: 'text/javascript, application/javascript, application/ecmascript, application/x-ecmascript',
            },
            contents: { script: /\b(?:java|ecma)script\b/ },
            converters: {
                'text script': function (e2) {
                    return S.globalEval(e2), e2
                },
            },
        }),
        S.ajaxPrefilter('script', function (e2) {
            e2.cache === void 0 && (e2.cache = !1),
                e2.crossDomain && (e2.type = 'GET')
        }),
        S.ajaxTransport('script', function (n2) {
            var r2, i2
            if (n2.crossDomain || n2.scriptAttrs)
                return {
                    send: function (e2, t2) {
                        ;(r2 = S('<script>')
                            .attr(n2.scriptAttrs || {})
                            .prop({ charset: n2.scriptCharset, src: n2.url })
                            .on(
                                'load error',
                                (i2 = function (e3) {
                                    r2.remove(),
                                        (i2 = null),
                                        e3 &&
                                            t2(
                                                e3.type === 'error' ? 404 : 200,
                                                e3.type
                                            )
                                })
                            )),
                            E.head.appendChild(r2[0])
                    },
                    abort: function () {
                        i2 && i2()
                    },
                }
        })
    var Ut,
        Xt = [],
        Vt = /(=)\?(?=&|$)|\?\?/
    S.ajaxSetup({
        jsonp: 'callback',
        jsonpCallback: function () {
            var e2 = Xt.pop() || S.expando + '_' + Ct.guid++
            return (this[e2] = !0), e2
        },
    }),
        S.ajaxPrefilter('json jsonp', function (e2, t2, n2) {
            var r2,
                i2,
                o2,
                a2 =
                    e2.jsonp !== !1 &&
                    (Vt.test(e2.url)
                        ? 'url'
                        : typeof e2.data == 'string' &&
                          (e2.contentType || '').indexOf(
                              'application/x-www-form-urlencoded'
                          ) === 0 &&
                          Vt.test(e2.data) &&
                          'data')
            if (a2 || e2.dataTypes[0] === 'jsonp')
                return (
                    (r2 = e2.jsonpCallback =
                        m(e2.jsonpCallback)
                            ? e2.jsonpCallback()
                            : e2.jsonpCallback),
                    a2
                        ? (e2[a2] = e2[a2].replace(Vt, '$1' + r2))
                        : e2.jsonp !== !1 &&
                          (e2.url +=
                              (Et.test(e2.url) ? '&' : '?') +
                              e2.jsonp +
                              '=' +
                              r2),
                    (e2.converters['script json'] = function () {
                        return o2 || S.error(r2 + ' was not called'), o2[0]
                    }),
                    (e2.dataTypes[0] = 'json'),
                    (i2 = C[r2]),
                    (C[r2] = function () {
                        o2 = arguments
                    }),
                    n2.always(function () {
                        i2 === void 0 ? S(C).removeProp(r2) : (C[r2] = i2),
                            e2[r2] &&
                                ((e2.jsonpCallback = t2.jsonpCallback),
                                Xt.push(r2)),
                            o2 && m(i2) && i2(o2[0]),
                            (o2 = i2 = void 0)
                    }),
                    'script'
                )
        }),
        (y.createHTMLDocument =
            (((Ut = E.implementation.createHTMLDocument('').body).innerHTML =
                '<form></form><form></form>'),
            Ut.childNodes.length === 2)),
        (S.parseHTML = function (e2, t2, n2) {
            return typeof e2 != 'string'
                ? []
                : (typeof t2 == 'boolean' && ((n2 = t2), (t2 = !1)),
                  t2 ||
                      (y.createHTMLDocument
                          ? (((r2 = (t2 =
                                E.implementation.createHTMLDocument(
                                    ''
                                )).createElement('base')).href =
                                E.location.href),
                            t2.head.appendChild(r2))
                          : (t2 = E)),
                  (o2 = !n2 && []),
                  (i2 = N.exec(e2))
                      ? [t2.createElement(i2[1])]
                      : ((i2 = xe([e2], t2, o2)),
                        o2 && o2.length && S(o2).remove(),
                        S.merge([], i2.childNodes)))
            var r2, i2, o2
        }),
        (S.fn.load = function (e2, t2, n2) {
            var r2,
                i2,
                o2,
                a2 = this,
                s2 = e2.indexOf(' ')
            return (
                -1 < s2 && ((r2 = vt(e2.slice(s2))), (e2 = e2.slice(0, s2))),
                m(t2)
                    ? ((n2 = t2), (t2 = void 0))
                    : t2 && typeof t2 == 'object' && (i2 = 'POST'),
                0 < a2.length &&
                    S.ajax({
                        url: e2,
                        type: i2 || 'GET',
                        dataType: 'html',
                        data: t2,
                    })
                        .done(function (e3) {
                            ;(o2 = arguments),
                                a2.html(
                                    r2
                                        ? S('<div>')
                                              .append(S.parseHTML(e3))
                                              .find(r2)
                                        : e3
                                )
                        })
                        .always(
                            n2 &&
                                function (e3, t3) {
                                    a2.each(function () {
                                        n2.apply(
                                            this,
                                            o2 || [e3.responseText, t3, e3]
                                        )
                                    })
                                }
                        ),
                this
            )
        }),
        (S.expr.pseudos.animated = function (t2) {
            return S.grep(S.timers, function (e2) {
                return t2 === e2.elem
            }).length
        }),
        (S.offset = {
            setOffset: function (e2, t2, n2) {
                var r2,
                    i2,
                    o2,
                    a2,
                    s2,
                    u2,
                    l2 = S.css(e2, 'position'),
                    c2 = S(e2),
                    f2 = {}
                l2 === 'static' && (e2.style.position = 'relative'),
                    (s2 = c2.offset()),
                    (o2 = S.css(e2, 'top')),
                    (u2 = S.css(e2, 'left')),
                    (l2 === 'absolute' || l2 === 'fixed') &&
                    -1 < (o2 + u2).indexOf('auto')
                        ? ((a2 = (r2 = c2.position()).top), (i2 = r2.left))
                        : ((a2 = parseFloat(o2) || 0),
                          (i2 = parseFloat(u2) || 0)),
                    m(t2) && (t2 = t2.call(e2, n2, S.extend({}, s2))),
                    t2.top != null && (f2.top = t2.top - s2.top + a2),
                    t2.left != null && (f2.left = t2.left - s2.left + i2),
                    'using' in t2
                        ? t2.using.call(e2, f2)
                        : (typeof f2.top == 'number' && (f2.top += 'px'),
                          typeof f2.left == 'number' && (f2.left += 'px'),
                          c2.css(f2))
            },
        }),
        S.fn.extend({
            offset: function (t2) {
                if (arguments.length)
                    return t2 === void 0
                        ? this
                        : this.each(function (e3) {
                              S.offset.setOffset(this, t2, e3)
                          })
                var e2,
                    n2,
                    r2 = this[0]
                return r2
                    ? r2.getClientRects().length
                        ? ((e2 = r2.getBoundingClientRect()),
                          (n2 = r2.ownerDocument.defaultView),
                          {
                              top: e2.top + n2.pageYOffset,
                              left: e2.left + n2.pageXOffset,
                          })
                        : { top: 0, left: 0 }
                    : void 0
            },
            position: function () {
                if (this[0]) {
                    var e2,
                        t2,
                        n2,
                        r2 = this[0],
                        i2 = { top: 0, left: 0 }
                    if (S.css(r2, 'position') === 'fixed')
                        t2 = r2.getBoundingClientRect()
                    else {
                        for (
                            t2 = this.offset(),
                                n2 = r2.ownerDocument,
                                e2 = r2.offsetParent || n2.documentElement;
                            e2 &&
                            (e2 === n2.body || e2 === n2.documentElement) &&
                            S.css(e2, 'position') === 'static';

                        )
                            e2 = e2.parentNode
                        e2 &&
                            e2 !== r2 &&
                            e2.nodeType === 1 &&
                            (((i2 = S(e2).offset()).top += S.css(
                                e2,
                                'borderTopWidth',
                                !0
                            )),
                            (i2.left += S.css(e2, 'borderLeftWidth', !0)))
                    }
                    return {
                        top: t2.top - i2.top - S.css(r2, 'marginTop', !0),
                        left: t2.left - i2.left - S.css(r2, 'marginLeft', !0),
                    }
                }
            },
            offsetParent: function () {
                return this.map(function () {
                    for (
                        var e2 = this.offsetParent;
                        e2 && S.css(e2, 'position') === 'static';

                    )
                        e2 = e2.offsetParent
                    return e2 || re
                })
            },
        }),
        S.each(
            { scrollLeft: 'pageXOffset', scrollTop: 'pageYOffset' },
            function (t2, i2) {
                var o2 = i2 === 'pageYOffset'
                S.fn[t2] = function (e2) {
                    return $2(
                        this,
                        function (e3, t3, n2) {
                            var r2
                            if (
                                (x(e3)
                                    ? (r2 = e3)
                                    : e3.nodeType === 9 &&
                                      (r2 = e3.defaultView),
                                n2 === void 0)
                            )
                                return r2 ? r2[i2] : e3[t3]
                            r2
                                ? r2.scrollTo(
                                      o2 ? r2.pageXOffset : n2,
                                      o2 ? n2 : r2.pageYOffset
                                  )
                                : (e3[t3] = n2)
                        },
                        t2,
                        e2,
                        arguments.length
                    )
                }
            }
        ),
        S.each(['top', 'left'], function (e2, n2) {
            S.cssHooks[n2] = $e(y.pixelPosition, function (e3, t2) {
                if (t2)
                    return (
                        (t2 = Be(e3, n2)),
                        Me.test(t2) ? S(e3).position()[n2] + 'px' : t2
                    )
            })
        }),
        S.each({ Height: 'height', Width: 'width' }, function (a2, s2) {
            S.each(
                { padding: 'inner' + a2, content: s2, '': 'outer' + a2 },
                function (r2, o2) {
                    S.fn[o2] = function (e2, t2) {
                        var n2 =
                                arguments.length &&
                                (r2 || typeof e2 != 'boolean'),
                            i2 =
                                r2 ||
                                (e2 === !0 || t2 === !0 ? 'margin' : 'border')
                        return $2(
                            this,
                            function (e3, t3, n3) {
                                var r3
                                return x(e3)
                                    ? o2.indexOf('outer') === 0
                                        ? e3['inner' + a2]
                                        : e3.document.documentElement[
                                              'client' + a2
                                          ]
                                    : e3.nodeType === 9
                                    ? ((r3 = e3.documentElement),
                                      Math.max(
                                          e3.body['scroll' + a2],
                                          r3['scroll' + a2],
                                          e3.body['offset' + a2],
                                          r3['offset' + a2],
                                          r3['client' + a2]
                                      ))
                                    : n3 === void 0
                                    ? S.css(e3, t3, i2)
                                    : S.style(e3, t3, n3, i2)
                            },
                            s2,
                            n2 ? e2 : void 0,
                            n2
                        )
                    }
                }
            )
        }),
        S.each(
            [
                'ajaxStart',
                'ajaxStop',
                'ajaxComplete',
                'ajaxError',
                'ajaxSuccess',
                'ajaxSend',
            ],
            function (e2, t2) {
                S.fn[t2] = function (e3) {
                    return this.on(t2, e3)
                }
            }
        ),
        S.fn.extend({
            bind: function (e2, t2, n2) {
                return this.on(e2, null, t2, n2)
            },
            unbind: function (e2, t2) {
                return this.off(e2, null, t2)
            },
            delegate: function (e2, t2, n2, r2) {
                return this.on(t2, e2, n2, r2)
            },
            undelegate: function (e2, t2, n2) {
                return arguments.length === 1
                    ? this.off(e2, '**')
                    : this.off(t2, e2 || '**', n2)
            },
            hover: function (e2, t2) {
                return this.mouseenter(e2).mouseleave(t2 || e2)
            },
        }),
        S.each(
            'blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu'.split(
                ' '
            ),
            function (e2, n2) {
                S.fn[n2] = function (e3, t2) {
                    return 0 < arguments.length
                        ? this.on(n2, null, e3, t2)
                        : this.trigger(n2)
                }
            }
        )
    var Gt = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g
    ;(S.proxy = function (e2, t2) {
        var n2, r2, i2
        if (
            (typeof t2 == 'string' && ((n2 = e2[t2]), (t2 = e2), (e2 = n2)),
            m(e2))
        )
            return (
                (r2 = s.call(arguments, 2)),
                ((i2 = function () {
                    return e2.apply(t2 || this, r2.concat(s.call(arguments)))
                }).guid = e2.guid =
                    e2.guid || S.guid++),
                i2
            )
    }),
        (S.holdReady = function (e2) {
            e2 ? S.readyWait++ : S.ready(!0)
        }),
        (S.isArray = Array.isArray),
        (S.parseJSON = JSON.parse),
        (S.nodeName = A),
        (S.isFunction = m),
        (S.isWindow = x),
        (S.camelCase = X),
        (S.type = w),
        (S.now = Date.now),
        (S.isNumeric = function (e2) {
            var t2 = S.type(e2)
            return (
                (t2 === 'number' || t2 === 'string') &&
                !isNaN(e2 - parseFloat(e2))
            )
        }),
        (S.trim = function (e2) {
            return e2 == null ? '' : (e2 + '').replace(Gt, '')
        }),
        typeof define == 'function' &&
            define.amd &&
            define('jquery', [], function () {
                return S
            })
    var Yt = C.jQuery,
        Qt = C.$
    return (
        (S.noConflict = function (e2) {
            return (
                C.$ === S && (C.$ = Qt),
                e2 && C.jQuery === S && (C.jQuery = Yt),
                S
            )
        }),
        typeof e > 'u' && (C.jQuery = C.$ = S),
        S
    )
}),
    $.ajaxSetup({ cache: !1 })
function wasTouched() {
    ;(window.isTouch = !0),
        document.removeEventListener('touchstart', wasTouched, { passive: !0 }),
        (document.documentElement.className =
            document.documentElement.className.replace('no-touch', 'touch')),
        document.dispatchEvent(new CustomEvent('theme:touch', { bubbles: !0 }))
}
document.addEventListener('touchstart', wasTouched, { passive: !0 })
/*!
 * Squirrelly JS
 * https://squirrelly.js.org/
 */ ;(function (e, t) {
    typeof exports == 'object' && typeof module < 'u'
        ? t(exports)
        : typeof define == 'function' && define.amd
        ? define(['exports'], t)
        : t(((e = typeof globalThis < 'u' ? globalThis : e || self).Sqrl = {}))
})(this, function (e) {
    'use strict'
    function t(e2) {
        var n2,
            r2,
            a2 = new Error(e2)
        return (
            (n2 = a2),
            (r2 = t.prototype),
            Object.setPrototypeOf
                ? Object.setPrototypeOf(n2, r2)
                : (n2.__proto__ = r2),
            a2
        )
    }
    function n(e2, n2, r2) {
        var a2 = n2.slice(0, r2).split(/\n/),
            i2 = a2.length,
            s2 = a2[i2 - 1].length + 1
        throw t(
            (e2 +=
                ' at line ' +
                i2 +
                ' col ' +
                s2 +
                `:

  ` +
                n2.split(/\n/)[i2 - 1] +
                `
  ` +
                Array(s2).join(' ') +
                '^')
        )
    }
    t.prototype = Object.create(Error.prototype, {
        name: { value: 'Squirrelly Error', enumerable: !1 },
    })
    var r = new Function('return this')().Promise,
        a = !1
    try {
        a = new Function('return (async function(){}).constructor')()
    } catch (e2) {
        if (!(e2 instanceof SyntaxError)) throw e2
    }
    function i(e2, t2) {
        return Object.prototype.hasOwnProperty.call(e2, t2)
    }
    function s(e2, t2, n2) {
        for (var r2 in t2)
            i(t2, r2) &&
                (t2[r2] == null ||
                typeof t2[r2] != 'object' ||
                (r2 !== 'storage' && r2 !== 'prefixes') ||
                n2
                    ? (e2[r2] = t2[r2])
                    : (e2[r2] = s({}, t2[r2])))
        return e2
    }
    var c = /^async +/,
        o =
            /`(?:\\[\s\S]|\${(?:[^{}]|{(?:[^{}]|{[^}]*})*})*}|(?!\${)[^\\`])*`/g,
        l = /'(?:\\[\s\w"'\\`]|[^\n\r'\\])*?'/g,
        f = /"(?:\\[\s\w"'\\`]|[^\n\r"\\])*?"/g,
        u = /[.*+\-?^${}()|[\]\\]/g
    function p(e2) {
        return u.test(e2) ? e2.replace(u, '\\$&') : e2
    }
    function h(e2, r2) {
        r2.rmWhitespace &&
            (e2 = e2
                .replace(
                    /[\r\n]+/g,
                    `
`
                )
                .replace(/^\s+|\s+$/gm, '')),
            (o.lastIndex = 0),
            (l.lastIndex = 0),
            (f.lastIndex = 0)
        var a2 = r2.prefixes,
            i2 = [a2.h, a2.b, a2.i, a2.r, a2.c, a2.e].reduce(function (e3, t2) {
                return e3 && t2 ? e3 + '|' + p(t2) : t2 ? p(t2) : e3
            }, ''),
            s2 = new RegExp(
                '([|()]|=>)|(\'|"|`|\\/\\*)|\\s*((\\/)?(-|_)?' +
                    p(r2.tags[1]) +
                    ')',
                'g'
            ),
            u2 = new RegExp(
                '([^]*?)' + p(r2.tags[0]) + '(-|_)?\\s*(' + i2 + ')?\\s*',
                'g'
            ),
            h2 = 0,
            d2 = !1
        function g2(t2, a3) {
            var i3,
                p2 = { f: [] },
                g3 = 0,
                v3 = 'c'
            function m3(t3) {
                var a4 = e2.slice(h2, t3),
                    i4 = a4.trim()
                if (v3 === 'f')
                    i4 === 'safe'
                        ? (p2.raw = !0)
                        : r2.async && c.test(i4)
                        ? ((i4 = i4.replace(c, '')), p2.f.push([i4, '', !0]))
                        : p2.f.push([i4, ''])
                else if (v3 === 'fp') p2.f[p2.f.length - 1][1] += i4
                else if (v3 === 'err') {
                    if (i4) {
                        var s3 = a4.search(/\S/)
                        n('invalid syntax', e2, h2 + s3)
                    }
                } else p2[v3] = i4
                h2 = t3 + 1
            }
            for (
                a3 === 'h' || a3 === 'b' || a3 === 'c'
                    ? (v3 = 'n')
                    : a3 === 'r' && ((p2.raw = !0), (a3 = 'i')),
                    s2.lastIndex = h2;
                (i3 = s2.exec(e2)) !== null;

            ) {
                var y3 = i3[1],
                    x2 = i3[2],
                    b2 = i3[3],
                    w2 = i3[4],
                    F2 = i3[5],
                    S2 = i3.index
                if (y3)
                    y3 === '('
                        ? (g3 === 0 &&
                              (v3 === 'n'
                                  ? (m3(S2), (v3 = 'p'))
                                  : v3 === 'f' && (m3(S2), (v3 = 'fp'))),
                          g3++)
                        : y3 === ')'
                        ? --g3 === 0 && v3 !== 'c' && (m3(S2), (v3 = 'err'))
                        : g3 === 0 && y3 === '|'
                        ? (m3(S2), (v3 = 'f'))
                        : y3 === '=>' && (m3(S2), (h2 += 1), (v3 = 'res'))
                else if (x2)
                    if (x2 === '/*') {
                        var I2 = e2.indexOf('*/', s2.lastIndex)
                        I2 === -1 && n('unclosed comment', e2, i3.index),
                            (s2.lastIndex = I2 + 2)
                    } else
                        x2 === "'"
                            ? ((l.lastIndex = i3.index),
                              l.exec(e2)
                                  ? (s2.lastIndex = l.lastIndex)
                                  : n('unclosed string', e2, i3.index))
                            : x2 === '"'
                            ? ((f.lastIndex = i3.index),
                              f.exec(e2)
                                  ? (s2.lastIndex = f.lastIndex)
                                  : n('unclosed string', e2, i3.index))
                            : x2 === '`' &&
                              ((o.lastIndex = i3.index),
                              o.exec(e2)
                                  ? (s2.lastIndex = o.lastIndex)
                                  : n('unclosed string', e2, i3.index))
                else if (b2)
                    return (
                        m3(S2),
                        (h2 = S2 + i3[0].length),
                        (u2.lastIndex = h2),
                        (d2 = F2),
                        w2 && a3 === 'h' && (a3 = 's'),
                        (p2.t = a3),
                        p2
                    )
            }
            return n('unclosed tag', e2, t2), p2
        }
        var v2 = (function i3(s3, o2) {
            ;(s3.b = []), (s3.d = [])
            var l2,
                f2 = !1,
                p2 = []
            function v3(e3, t2) {
                e3 &&
                    (e3 = (function (e4, t3, n2, r3) {
                        var a3, i4
                        return (
                            typeof t3.autoTrim == 'string'
                                ? (a3 = i4 = t3.autoTrim)
                                : Array.isArray(t3.autoTrim) &&
                                  ((a3 = t3.autoTrim[1]),
                                  (i4 = t3.autoTrim[0])),
                            (n2 || n2 === !1) && (a3 = n2),
                            (r3 || r3 === !1) && (i4 = r3),
                            a3 === 'slurp' && i4 === 'slurp'
                                ? e4.trim()
                                : (a3 === '_' || a3 === 'slurp'
                                      ? (e4 = String.prototype.trimLeft
                                            ? e4.trimLeft()
                                            : e4.replace(
                                                  /^[\s\uFEFF\xA0]+/,
                                                  ''
                                              ))
                                      : (a3 !== '-' && a3 !== 'nl') ||
                                        (e4 = e4.replace(
                                            /^(?:\n|\r|\r\n)/,
                                            ''
                                        )),
                                  i4 === '_' || i4 === 'slurp'
                                      ? (e4 = String.prototype.trimRight
                                            ? e4.trimRight()
                                            : e4.replace(
                                                  /[\s\uFEFF\xA0]+$/,
                                                  ''
                                              ))
                                      : (i4 !== '-' && i4 !== 'nl') ||
                                        (e4 = e4.replace(
                                            /(?:\n|\r|\r\n)$/,
                                            ''
                                        )),
                                  e4)
                        )
                    })(e3, r2, d2, t2)) &&
                    ((e3 = e3
                        .replace(/\\|'/g, '\\$&')
                        .replace(/\r\n|\n|\r/g, '\\n')),
                    p2.push(e3))
            }
            for (; (l2 = u2.exec(e2)) !== null; ) {
                var m3,
                    y3 = l2[1],
                    x2 = l2[2],
                    b2 = l2[3] || ''
                for (var w2 in a2)
                    if (a2[w2] === b2) {
                        m3 = w2
                        break
                    }
                v3(y3, x2),
                    (h2 = l2.index + l2[0].length),
                    m3 || n('unrecognized tag type: ' + b2, e2, h2)
                var F2 = g2(l2.index, m3),
                    S2 = F2.t
                if (S2 === 'h') {
                    var I2 = F2.n || ''
                    r2.async &&
                        c.test(I2) &&
                        ((F2.a = !0), (F2.n = I2.replace(c, ''))),
                        (F2 = i3(F2)),
                        p2.push(F2)
                } else if (S2 === 'c') {
                    if (s3.n === F2.n)
                        return (
                            f2 ? ((f2.d = p2), s3.b.push(f2)) : (s3.d = p2), s3
                        )
                    n(
                        "Helper start and end don't match",
                        e2,
                        l2.index + l2[0].length
                    )
                } else if (S2 === 'b') {
                    f2 ? ((f2.d = p2), s3.b.push(f2)) : (s3.d = p2)
                    var R2 = F2.n || ''
                    r2.async &&
                        c.test(R2) &&
                        ((F2.a = !0), (F2.n = R2.replace(c, ''))),
                        (f2 = F2),
                        (p2 = [])
                } else if (S2 === 's') {
                    var T2 = F2.n || ''
                    r2.async &&
                        c.test(T2) &&
                        ((F2.a = !0), (F2.n = T2.replace(c, ''))),
                        p2.push(F2)
                } else p2.push(F2)
            }
            if (!o2) throw t('unclosed helper "' + s3.n + '"')
            return v3(e2.slice(h2, e2.length), !1), (s3.d = p2), s3
        })({ f: [] }, !0)
        if (r2.plugins)
            for (var m2 = 0; m2 < r2.plugins.length; m2++) {
                var y2 = r2.plugins[m2]
                y2.processAST && (v2.d = y2.processAST(v2.d, r2))
            }
        return v2.d
    }
    function d(e2, t2) {
        var n2 = h(e2, t2),
            r2 =
                "var tR='';" +
                (t2.useWith ? 'with(' + t2.varName + '||{}){' : '') +
                x(n2, t2) +
                'if(cb){cb(null,tR)} return tR' +
                (t2.useWith ? '}' : '')
        if (t2.plugins)
            for (var a2 = 0; a2 < t2.plugins.length; a2++) {
                var i2 = t2.plugins[a2]
                i2.processFnString && (r2 = i2.processFnString(r2, t2))
            }
        return r2
    }
    function g(e2, t2) {
        for (var n2 = 0; n2 < t2.length; n2++) {
            var r2 = t2[n2][0],
                a2 = t2[n2][1]
            ;(e2 = (t2[n2][2] ? 'await ' : '') + "c.l('F','" + r2 + "')(" + e2),
                a2 && (e2 += ',' + a2),
                (e2 += ')')
        }
        return e2
    }
    function v(e2, t2, n2, r2, a2, i2) {
        var s2 =
            '{exec:' +
            (a2 ? 'async ' : '') +
            y(n2, t2, e2) +
            ',params:[' +
            r2 +
            ']'
        return (
            i2 && (s2 += ",name:'" + i2 + "'"),
            a2 && (s2 += ',async:true'),
            (s2 += '}')
        )
    }
    function m(e2, t2) {
        for (var n2 = '[', r2 = 0; r2 < e2.length; r2++) {
            var a2 = e2[r2]
            ;(n2 += v(t2, a2.res || '', a2.d, a2.p || '', a2.a, a2.n)),
                r2 < e2.length && (n2 += ',')
        }
        return (n2 += ']')
    }
    function y(e2, t2, n2) {
        return 'function(' + t2 + "){var tR='';" + x(e2, n2) + 'return tR}'
    }
    function x(e2, t2) {
        for (var n2 = 0, r2 = e2.length, a2 = ''; n2 < r2; n2++) {
            var i2 = e2[n2]
            if (typeof i2 == 'string') a2 += "tR+='" + i2 + "';"
            else {
                var s2 = i2.t,
                    c2 = i2.c || '',
                    o2 = i2.f,
                    l2 = i2.n || '',
                    f2 = i2.p || '',
                    u2 = i2.res || '',
                    p2 = i2.b,
                    h2 = !!i2.a
                if (s2 === 'i') {
                    t2.defaultFilter &&
                        (c2 = "c.l('F','" + t2.defaultFilter + "')(" + c2 + ')')
                    var d2 = g(c2, o2)
                    !i2.raw &&
                        t2.autoEscape &&
                        (d2 = "c.l('F','e')(" + d2 + ')'),
                        (a2 += 'tR+=' + d2 + ';')
                } else if (s2 === 'h')
                    if (t2.storage.nativeHelpers.get(l2))
                        a2 += t2.storage.nativeHelpers.get(l2)(i2, t2)
                    else {
                        var y2 =
                            (h2 ? 'await ' : '') +
                            "c.l('H','" +
                            l2 +
                            "')(" +
                            v(t2, u2, i2.d, f2, h2)
                        ;(y2 += p2 ? ',' + m(p2, t2) : ',[]'),
                            (a2 += 'tR+=' + g((y2 += ',c)'), o2) + ';')
                    }
                else
                    s2 === 's'
                        ? (a2 +=
                              'tR+=' +
                              g(
                                  (h2 ? 'await ' : '') +
                                      "c.l('H','" +
                                      l2 +
                                      "')({params:[" +
                                      f2 +
                                      ']},[],c)',
                                  o2
                              ) +
                              ';')
                        : s2 === 'e' &&
                          (a2 +=
                              c2 +
                              `
`)
            }
        }
        return a2
    }
    var b = (function () {
            function e2(e3) {
                this.cache = e3
            }
            return (
                (e2.prototype.define = function (e3, t2) {
                    this.cache[e3] = t2
                }),
                (e2.prototype.get = function (e3) {
                    return this.cache[e3]
                }),
                (e2.prototype.remove = function (e3) {
                    delete this.cache[e3]
                }),
                (e2.prototype.reset = function () {
                    this.cache = {}
                }),
                (e2.prototype.load = function (e3) {
                    s(this.cache, e3, !0)
                }),
                e2
            )
        })(),
        w = new b({})
    function F(e2, n2, r2, a2) {
        if (n2 && n2.length > 0)
            throw t(
                (a2 ? 'Native' : '') +
                    "Helper '" +
                    e2 +
                    "' doesn't accept blocks"
            )
        if (r2 && r2.length > 0)
            throw t(
                (a2 ? 'Native' : '') +
                    "Helper '" +
                    e2 +
                    "' doesn't accept filters"
            )
    }
    var S = new b({
            each: function (e2, t2) {
                var n2 = '',
                    r2 = e2.params[0]
                if ((F('each', t2, !1), e2.async))
                    return new Promise(function (t3) {
                        ;(function e3(t4, n3, r3, a3, i2) {
                            r3(t4[n3], n3).then(function (s2) {
                                ;(a3 += s2),
                                    n3 === t4.length - 1
                                        ? i2(a3)
                                        : e3(t4, n3 + 1, r3, a3, i2)
                            })
                        })(r2, 0, e2.exec, n2, t3)
                    })
                for (var a2 = 0; a2 < r2.length; a2++) n2 += e2.exec(r2[a2], a2)
                return n2
            },
            foreach: function (e2, t2) {
                var n2 = e2.params[0]
                if ((F('foreach', t2, !1), e2.async))
                    return new Promise(function (t3) {
                        ;(function e3(t4, n3, r3, a3, i2, s2) {
                            a3(n3[r3], t4[n3[r3]]).then(function (c2) {
                                ;(i2 += c2),
                                    r3 === n3.length - 1
                                        ? s2(i2)
                                        : e3(t4, n3, r3 + 1, a3, i2, s2)
                            })
                        })(n2, Object.keys(n2), 0, e2.exec, '', t3)
                    })
                var r2 = ''
                for (var a2 in n2) i(n2, a2) && (r2 += e2.exec(a2, n2[a2]))
                return r2
            },
            include: function (e2, n2, r2) {
                F('include', n2, !1)
                var a2 = r2.storage.templates.get(e2.params[0])
                if (!a2)
                    throw t('Could not fetch template "' + e2.params[0] + '"')
                return a2(e2.params[1], r2)
            },
            extends: function (e2, n2, r2) {
                var a2 = e2.params[1] || {}
                a2.content = e2.exec()
                for (var i2 = 0; i2 < n2.length; i2++) {
                    var s2 = n2[i2]
                    a2[s2.name] = s2.exec()
                }
                var c2 = r2.storage.templates.get(e2.params[0])
                if (!c2)
                    throw t('Could not fetch template "' + e2.params[0] + '"')
                return c2(a2, r2)
            },
            useScope: function (e2, t2) {
                return F('useScope', t2, !1), e2.exec(e2.params[0])
            },
        }),
        I = new b({
            if: function (e2, t2) {
                F('if', !1, e2.f, !0)
                var n2 = 'if(' + e2.p + '){' + x(e2.d, t2) + '}'
                if (e2.b)
                    for (var r2 = 0; r2 < e2.b.length; r2++) {
                        var a2 = e2.b[r2]
                        a2.n === 'else'
                            ? (n2 += 'else{' + x(a2.d, t2) + '}')
                            : a2.n === 'elif' &&
                              (n2 +=
                                  'else if(' + a2.p + '){' + x(a2.d, t2) + '}')
                    }
                return n2
            },
            try: function (e2, n2) {
                if (
                    (F('try', !1, e2.f, !0),
                    !e2.b || e2.b.length !== 1 || e2.b[0].n !== 'catch')
                )
                    throw t("native helper 'try' only accepts 1 block, 'catch'")
                var r2 = 'try{' + x(e2.d, n2) + '}',
                    a2 = e2.b[0]
                return (r2 +=
                    'catch' +
                    (a2.res ? '(' + a2.res + ')' : '') +
                    '{' +
                    x(a2.d, n2) +
                    '}')
            },
            block: function (e2, t2) {
                return (
                    F('block', e2.b, e2.f, !0),
                    'if(!' +
                        t2.varName +
                        '[' +
                        e2.p +
                        ']){tR+=(' +
                        y(e2.d, '', t2) +
                        ')()}else{tR+=' +
                        t2.varName +
                        '[' +
                        e2.p +
                        ']}'
                )
            },
        }),
        R = {
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#39;',
        }
    function T(e2) {
        return R[e2]
    }
    var E = new b({
            e: function (e2) {
                var t2 = String(e2)
                return /[&<>"']/.test(t2) ? t2.replace(/[&<>"']/g, T) : t2
            },
        }),
        j = {
            varName: 'it',
            autoTrim: [!1, 'nl'],
            autoEscape: !0,
            defaultFilter: !1,
            tags: ['{{', '}}'],
            l: function (e2, n2) {
                if (e2 === 'H') {
                    var r2 = this.storage.helpers.get(n2)
                    if (r2) return r2
                    throw t("Can't find helper '" + n2 + "'")
                }
                if (e2 === 'F') {
                    var a2 = this.storage.filters.get(n2)
                    if (a2) return a2
                    throw t("Can't find filter '" + n2 + "'")
                }
            },
            async: !1,
            storage: { helpers: S, nativeHelpers: I, filters: E, templates: w },
            prefixes: { h: '@', b: '#', i: '', r: '*', c: '/', e: '!' },
            cache: !1,
            plugins: [],
            useWith: !1,
        }
    function H(e2, t2) {
        var n2 = {}
        return s(n2, j), t2 && s(n2, t2), e2 && s(n2, e2), n2.l.bind(n2), n2
    }
    function O(e2, n2) {
        var r2 = H(n2 || {}),
            i2 = Function
        if (r2.async) {
            if (!a) throw t("This environment doesn't support async/await")
            i2 = a
        }
        try {
            return new i2(r2.varName, 'c', 'cb', d(e2, r2))
        } catch (n3) {
            throw n3 instanceof SyntaxError
                ? t(
                      `Bad template syntax

` +
                          n3.message +
                          `
` +
                          Array(n3.message.length + 1).join('=') +
                          `
` +
                          d(e2, r2)
                  )
                : n3
        }
    }
    function _(e2, t2) {
        var n2
        return t2.cache && t2.name && t2.storage.templates.get(t2.name)
            ? t2.storage.templates.get(t2.name)
            : ((n2 = typeof e2 == 'function' ? e2 : O(e2, t2)),
              t2.cache && t2.name && t2.storage.templates.define(t2.name, n2),
              n2)
    }
    j.l.bind(j),
        (e.compile = O),
        (e.compileScope = x),
        (e.compileScopeIntoFunction = y),
        (e.compileToString = d),
        (e.defaultConfig = j),
        (e.filters = E),
        (e.getConfig = H),
        (e.helpers = S),
        (e.nativeHelpers = I),
        (e.parse = h),
        (e.render = function (e2, n2, a2, i2) {
            var s2 = H(a2 || {})
            if (!s2.async) return _(e2, s2)(n2, s2)
            if (!i2) {
                if (typeof r == 'function')
                    return new r(function (t2, r2) {
                        try {
                            t2(_(e2, s2)(n2, s2))
                        } catch (e3) {
                            r2(e3)
                        }
                    })
                throw t(
                    "Please provide a callback function, this env doesn't support Promises"
                )
            }
            try {
                _(e2, s2)(n2, s2, i2)
            } catch (e3) {
                return i2(e3)
            }
        }),
        (e.templates = w),
        Object.defineProperty(e, '__esModule', { value: !0 })
})
/*!
 * enquire.js v2.1.6 - Awesome Media Queries in JavaScript
 * Copyright (c) 2017 Nick Williams - http://wicky.nillia.ms/enquire.js
 * License: MIT */ ;(function (a) {
    if (typeof exports == 'object' && typeof module < 'u') module.exports = a()
    else if (typeof define == 'function' && define.amd) define([], a)
    else {
        var b
        ;(b =
            typeof window < 'u'
                ? window
                : typeof global < 'u'
                ? global
                : typeof self < 'u'
                ? self
                : this),
            (b.enquire = a())
    }
})(function () {
    return (function a(b, c, d) {
        function e(g2, h) {
            if (!c[g2]) {
                if (!b[g2]) {
                    var i = typeof require == 'function' && require
                    if (!h && i) return i(g2, !0)
                    if (f) return f(g2, !0)
                    var j = new Error("Cannot find module '" + g2 + "'")
                    throw ((j.code = 'MODULE_NOT_FOUND'), j)
                }
                var k = (c[g2] = { exports: {} })
                b[g2][0].call(
                    k.exports,
                    function (a2) {
                        var c2 = b[g2][1][a2]
                        return e(c2 || a2)
                    },
                    k,
                    k.exports,
                    a,
                    b,
                    c,
                    d
                )
            }
            return c[g2].exports
        }
        for (
            var f = typeof require == 'function' && require, g = 0;
            g < d.length;
            g++
        )
            e(d[g])
        return e
    })(
        {
            1: [
                function (a, b, c) {
                    function d(a2, b2) {
                        ;(this.query = a2),
                            (this.isUnconditional = b2),
                            (this.handlers = []),
                            (this.mql = window.matchMedia(a2))
                        var c2 = this
                        ;(this.listener = function (a3) {
                            ;(c2.mql = a3.currentTarget || a3), c2.assess()
                        }),
                            this.mql.addListener(this.listener)
                    }
                    var e = a(3),
                        f = a(4).each
                    ;(d.prototype = {
                        constuctor: d,
                        addHandler: function (a2) {
                            var b2 = new e(a2)
                            this.handlers.push(b2), this.matches() && b2.on()
                        },
                        removeHandler: function (a2) {
                            var b2 = this.handlers
                            f(b2, function (c2, d2) {
                                if (c2.equals(a2))
                                    return c2.destroy(), !b2.splice(d2, 1)
                            })
                        },
                        matches: function () {
                            return this.mql.matches || this.isUnconditional
                        },
                        clear: function () {
                            f(this.handlers, function (a2) {
                                a2.destroy()
                            }),
                                this.mql.removeListener(this.listener),
                                (this.handlers.length = 0)
                        },
                        assess: function () {
                            var a2 = this.matches() ? 'on' : 'off'
                            f(this.handlers, function (b2) {
                                b2[a2]()
                            })
                        },
                    }),
                        (b.exports = d)
                },
                { 3: 3, 4: 4 },
            ],
            2: [
                function (a, b, c) {
                    function d() {
                        if (!window.matchMedia)
                            throw new Error(
                                'matchMedia not present, legacy browsers require a polyfill'
                            )
                        ;(this.queries = {}),
                            (this.browserIsIncapable =
                                !window.matchMedia('only all').matches)
                    }
                    var e = a(1),
                        f = a(4),
                        g = f.each,
                        h = f.isFunction,
                        i = f.isArray
                    ;(d.prototype = {
                        constructor: d,
                        register: function (a2, b2, c2) {
                            var d2 = this.queries,
                                f2 = c2 && this.browserIsIncapable
                            return (
                                d2[a2] || (d2[a2] = new e(a2, f2)),
                                h(b2) && (b2 = { match: b2 }),
                                i(b2) || (b2 = [b2]),
                                g(b2, function (b3) {
                                    h(b3) && (b3 = { match: b3 }),
                                        d2[a2].addHandler(b3)
                                }),
                                this
                            )
                        },
                        unregister: function (a2, b2) {
                            var c2 = this.queries[a2]
                            return (
                                c2 &&
                                    (b2
                                        ? c2.removeHandler(b2)
                                        : (c2.clear(),
                                          delete this.queries[a2])),
                                this
                            )
                        },
                    }),
                        (b.exports = d)
                },
                { 1: 1, 4: 4 },
            ],
            3: [
                function (a, b, c) {
                    function d(a2) {
                        ;(this.options = a2), !a2.deferSetup && this.setup()
                    }
                    ;(d.prototype = {
                        constructor: d,
                        setup: function () {
                            this.options.setup && this.options.setup(),
                                (this.initialised = !0)
                        },
                        on: function () {
                            !this.initialised && this.setup(),
                                this.options.match && this.options.match()
                        },
                        off: function () {
                            this.options.unmatch && this.options.unmatch()
                        },
                        destroy: function () {
                            this.options.destroy
                                ? this.options.destroy()
                                : this.off()
                        },
                        equals: function (a2) {
                            return (
                                this.options === a2 || this.options.match === a2
                            )
                        },
                    }),
                        (b.exports = d)
                },
                {},
            ],
            4: [
                function (a, b, c) {
                    function d(a2, b2) {
                        var c2 = 0,
                            d2 = a2.length
                        for (c2; c2 < d2 && b2(a2[c2], c2) !== !1; c2++);
                    }
                    function e(a2) {
                        return (
                            Object.prototype.toString.apply(a2) ===
                            '[object Array]'
                        )
                    }
                    function f(a2) {
                        return typeof a2 == 'function'
                    }
                    b.exports = { isFunction: f, isArray: e, each: d }
                },
                {},
            ],
            5: [
                function (a, b, c) {
                    var d = a(2)
                    b.exports = new d()
                },
                { 2: 2 },
            ],
        },
        {},
        [5]
    )(5)
})
/*!
 * Flickity PACKAGED v2.2.1
 * Touch, responsive, flickable carousels
 *
 * Licensed GPLv3 for open source use
 * or Flickity Commercial License for commercial use
 *
 * https://flickity.metafizzy.co
 * Copyright 2015-2019 Metafizzy
 */ ;(function (e, i) {
    typeof define == 'function' && define.amd
        ? define('jquery-bridget/jquery-bridget', ['jquery'], function (t) {
              return i(e, t)
          })
        : typeof module == 'object' && module.exports
        ? (module.exports = i(e, require('jquery')))
        : (e.jQueryBridget = i(e, e.jQuery))
})(window, function (t, e) {
    'use strict'
    var d = Array.prototype.slice,
        i = t.console,
        u =
            i === void 0
                ? function () {}
                : function (t2) {
                      i.error(t2)
                  }
    function n(h, s, c) {
        ;(c = c || e || t.jQuery) &&
            (s.prototype.option ||
                (s.prototype.option = function (t2) {
                    c.isPlainObject(t2) &&
                        (this.options = c.extend(!0, this.options, t2))
                }),
            (c.fn[h] = function (t2) {
                if (typeof t2 != 'string')
                    return (
                        (n2 = t2),
                        this.each(function (t3, e3) {
                            var i3 = c.data(e3, h)
                            i3
                                ? (i3.option(n2), i3._init())
                                : ((i3 = new s(e3, n2)), c.data(e3, h, i3))
                        }),
                        this
                    )
                var e2,
                    o2,
                    r,
                    a,
                    l,
                    n2,
                    i2 = d.call(arguments, 1)
                return (
                    (r = i2),
                    (l = '$().' + h + '("' + (o2 = t2) + '")'),
                    (e2 = this).each(function (t3, e3) {
                        var i3 = c.data(e3, h)
                        if (i3) {
                            var n3 = i3[o2]
                            if (n3 && o2.charAt(0) != '_') {
                                var s2 = n3.apply(i3, r)
                                a = a === void 0 ? s2 : a
                            } else u(l + ' is not a valid method')
                        } else u(h + ' not initialized. Cannot call methods, i.e. ' + l)
                    }),
                    a !== void 0 ? a : e2
                )
            }),
            o(c))
    }
    function o(t2) {
        !t2 || (t2 && t2.bridget) || (t2.bridget = n)
    }
    return o(e || t.jQuery), n
}),
    (function (t, e) {
        typeof define == 'function' && define.amd
            ? define('ev-emitter/ev-emitter', e)
            : typeof module == 'object' && module.exports
            ? (module.exports = e())
            : (t.EvEmitter = e())
    })(typeof window < 'u' ? window : this, function () {
        function t() {}
        var e = t.prototype
        return (
            (e.on = function (t2, e2) {
                if (t2 && e2) {
                    var i = (this._events = this._events || {}),
                        n = (i[t2] = i[t2] || [])
                    return n.indexOf(e2) == -1 && n.push(e2), this
                }
            }),
            (e.once = function (t2, e2) {
                if (t2 && e2) {
                    this.on(t2, e2)
                    var i = (this._onceEvents = this._onceEvents || {})
                    return ((i[t2] = i[t2] || {})[e2] = !0), this
                }
            }),
            (e.off = function (t2, e2) {
                var i = this._events && this._events[t2]
                if (i && i.length) {
                    var n = i.indexOf(e2)
                    return n != -1 && i.splice(n, 1), this
                }
            }),
            (e.emitEvent = function (t2, e2) {
                var i = this._events && this._events[t2]
                if (i && i.length) {
                    ;(i = i.slice(0)), (e2 = e2 || [])
                    for (
                        var n = this._onceEvents && this._onceEvents[t2], s = 0;
                        s < i.length;
                        s++
                    ) {
                        var o = i[s]
                        n && n[o] && (this.off(t2, o), delete n[o]),
                            o.apply(this, e2)
                    }
                    return this
                }
            }),
            (e.allOff = function () {
                delete this._events, delete this._onceEvents
            }),
            t
        )
    }),
    (function (t, e) {
        typeof define == 'function' && define.amd
            ? define('get-size/get-size', e)
            : typeof module == 'object' && module.exports
            ? (module.exports = e())
            : (t.getSize = e())
    })(window, function () {
        'use strict'
        function m(t) {
            var e = parseFloat(t)
            return t.indexOf('%') == -1 && !isNaN(e) && e
        }
        var i =
                typeof console > 'u'
                    ? function () {}
                    : function (t) {
                          console.error(t)
                      },
            y = [
                'paddingLeft',
                'paddingRight',
                'paddingTop',
                'paddingBottom',
                'marginLeft',
                'marginRight',
                'marginTop',
                'marginBottom',
                'borderLeftWidth',
                'borderRightWidth',
                'borderTopWidth',
                'borderBottomWidth',
            ],
            b = y.length
        function E(t) {
            var e = getComputedStyle(t)
            return (
                e ||
                    i(
                        'Style returned ' +
                            e +
                            '. Are you running this code in a hidden iframe on Firefox? See https://bit.ly/getsizebug1'
                    ),
                e
            )
        }
        var S,
            C = !1
        function x(t) {
            if (
                ((function () {
                    if (!C) {
                        C = !0
                        var t2 = document.createElement('div')
                        ;(t2.style.width = '200px'),
                            (t2.style.padding = '1px 2px 3px 4px'),
                            (t2.style.borderStyle = 'solid'),
                            (t2.style.borderWidth = '1px 2px 3px 4px'),
                            (t2.style.boxSizing = 'border-box')
                        var e2 = document.body || document.documentElement
                        e2.appendChild(t2)
                        var i3 = E(t2)
                        ;(S = Math.round(m(i3.width)) == 200),
                            (x.isBoxSizeOuter = S),
                            e2.removeChild(t2)
                    }
                })(),
                typeof t == 'string' && (t = document.querySelector(t)),
                t && typeof t == 'object' && t.nodeType)
            ) {
                var e = E(t)
                if (e.display == 'none')
                    return (function () {
                        for (
                            var t2 = {
                                    width: 0,
                                    height: 0,
                                    innerWidth: 0,
                                    innerHeight: 0,
                                    outerWidth: 0,
                                    outerHeight: 0,
                                },
                                e2 = 0;
                            e2 < b;
                            e2++
                        )
                            t2[y[e2]] = 0
                        return t2
                    })()
                var i2 = {}
                ;(i2.width = t.offsetWidth), (i2.height = t.offsetHeight)
                for (
                    var n = (i2.isBorderBox = e.boxSizing == 'border-box'),
                        s = 0;
                    s < b;
                    s++
                ) {
                    var o = y[s],
                        r = e[o],
                        a = parseFloat(r)
                    i2[o] = isNaN(a) ? 0 : a
                }
                var l = i2.paddingLeft + i2.paddingRight,
                    h = i2.paddingTop + i2.paddingBottom,
                    c = i2.marginLeft + i2.marginRight,
                    d = i2.marginTop + i2.marginBottom,
                    u = i2.borderLeftWidth + i2.borderRightWidth,
                    f = i2.borderTopWidth + i2.borderBottomWidth,
                    p = n && S,
                    g = m(e.width)
                g !== !1 && (i2.width = g + (p ? 0 : l + u))
                var v = m(e.height)
                return (
                    v !== !1 && (i2.height = v + (p ? 0 : h + f)),
                    (i2.innerWidth = i2.width - (l + u)),
                    (i2.innerHeight = i2.height - (h + f)),
                    (i2.outerWidth = i2.width + c),
                    (i2.outerHeight = i2.height + d),
                    i2
                )
            }
        }
        return x
    }),
    (function (t, e) {
        'use strict'
        typeof define == 'function' && define.amd
            ? define('desandro-matches-selector/matches-selector', e)
            : typeof module == 'object' && module.exports
            ? (module.exports = e())
            : (t.matchesSelector = e())
    })(window, function () {
        'use strict'
        var i = (function () {
            var t = window.Element.prototype
            if (t.matches) return 'matches'
            if (t.matchesSelector) return 'matchesSelector'
            for (
                var e = ['webkit', 'moz', 'ms', 'o'], i2 = 0;
                i2 < e.length;
                i2++
            ) {
                var n = e[i2] + 'MatchesSelector'
                if (t[n]) return n
            }
        })()
        return function (t, e) {
            return t[i](e)
        }
    }),
    (function (e, i) {
        typeof define == 'function' && define.amd
            ? define(
                  'fizzy-ui-utils/utils',
                  ['desandro-matches-selector/matches-selector'],
                  function (t) {
                      return i(e, t)
                  }
              )
            : typeof module == 'object' && module.exports
            ? (module.exports = i(e, require('desandro-matches-selector')))
            : (e.fizzyUIUtils = i(e, e.matchesSelector))
    })(window, function (h, o) {
        var c = {
                extend: function (t, e2) {
                    for (var i in e2) t[i] = e2[i]
                    return t
                },
                modulo: function (t, e2) {
                    return ((t % e2) + e2) % e2
                },
            },
            e = Array.prototype.slice
        ;(c.makeArray = function (t) {
            return Array.isArray(t)
                ? t
                : t == null
                ? []
                : typeof t == 'object' && typeof t.length == 'number'
                ? e.call(t)
                : [t]
        }),
            (c.removeFrom = function (t, e2) {
                var i = t.indexOf(e2)
                i != -1 && t.splice(i, 1)
            }),
            (c.getParent = function (t, e2) {
                for (; t.parentNode && t != document.body; )
                    if (((t = t.parentNode), o(t, e2))) return t
            }),
            (c.getQueryElement = function (t) {
                return typeof t == 'string' ? document.querySelector(t) : t
            }),
            (c.handleEvent = function (t) {
                var e2 = 'on' + t.type
                this[e2] && this[e2](t)
            }),
            (c.filterFindElements = function (t, n) {
                t = c.makeArray(t)
                var s = []
                return (
                    t.forEach(function (t2) {
                        if (t2 instanceof HTMLElement)
                            if (n) {
                                o(t2, n) && s.push(t2)
                                for (
                                    var e2 = t2.querySelectorAll(n), i = 0;
                                    i < e2.length;
                                    i++
                                )
                                    s.push(e2[i])
                            } else s.push(t2)
                    }),
                    s
                )
            }),
            (c.debounceMethod = function (t, e2, n) {
                n = n || 100
                var s = t.prototype[e2],
                    o2 = e2 + 'Timeout'
                t.prototype[e2] = function () {
                    var t2 = this[o2]
                    clearTimeout(t2)
                    var e3 = arguments,
                        i = this
                    this[o2] = setTimeout(function () {
                        s.apply(i, e3), delete i[o2]
                    }, n)
                }
            }),
            (c.docReady = function (t) {
                var e2 = document.readyState
                e2 == 'complete' || e2 == 'interactive'
                    ? setTimeout(t)
                    : document.addEventListener('DOMContentLoaded', t)
            }),
            (c.toDashed = function (t) {
                return t
                    .replace(/(.)([A-Z])/g, function (t2, e2, i) {
                        return e2 + '-' + i
                    })
                    .toLowerCase()
            })
        var d = h.console
        return (
            (c.htmlInit = function (a, l) {
                c.docReady(function () {
                    var t = c.toDashed(l),
                        s = 'data-' + t,
                        e2 = document.querySelectorAll('[' + s + ']'),
                        i = document.querySelectorAll('.js-' + t),
                        n = c.makeArray(e2).concat(c.makeArray(i)),
                        o2 = s + '-options',
                        r = h.jQuery
                    n.forEach(function (e3) {
                        var t2,
                            i2 = e3.getAttribute(s) || e3.getAttribute(o2)
                        try {
                            t2 = i2 && JSON.parse(i2)
                        } catch (t3) {
                            return void (
                                d &&
                                d.error(
                                    'Error parsing ' +
                                        s +
                                        ' on ' +
                                        e3.className +
                                        ': ' +
                                        t3
                                )
                            )
                        }
                        var n2 = new a(e3, t2)
                        r && r.data(e3, l, n2)
                    })
                })
            }),
            c
        )
    }),
    (function (e, i) {
        typeof define == 'function' && define.amd
            ? define('flickity/js/cell', ['get-size/get-size'], function (t) {
                  return i(e, t)
              })
            : typeof module == 'object' && module.exports
            ? (module.exports = i(e, require('get-size')))
            : ((e.Flickity = e.Flickity || {}),
              (e.Flickity.Cell = i(e, e.getSize)))
    })(window, function (t, e) {
        function i(t2, e2) {
            ;(this.element = t2), (this.parent = e2), this.create()
        }
        var n = i.prototype
        return (
            (n.create = function () {
                ;(this.element.style.position = 'absolute'),
                    this.element.setAttribute('aria-hidden', 'true'),
                    (this.x = 0),
                    (this.shift = 0)
            }),
            (n.destroy = function () {
                this.unselect(), (this.element.style.position = '')
                var t2 = this.parent.originSide
                this.element.style[t2] = ''
            }),
            (n.getSize = function () {
                this.size = e(this.element)
            }),
            (n.setPosition = function (t2) {
                ;(this.x = t2), this.updateTarget(), this.renderPosition(t2)
            }),
            (n.updateTarget = n.setDefaultTarget =
                function () {
                    var t2 =
                        this.parent.originSide == 'left'
                            ? 'marginLeft'
                            : 'marginRight'
                    this.target =
                        this.x +
                        this.size[t2] +
                        this.size.width * this.parent.cellAlign
                }),
            (n.renderPosition = function (t2) {
                var e2 = this.parent.originSide
                this.element.style[e2] = this.parent.getPositionValue(t2)
            }),
            (n.select = function () {
                this.element.classList.add('is-selected'),
                    this.element.removeAttribute('aria-hidden')
            }),
            (n.unselect = function () {
                this.element.classList.remove('is-selected'),
                    this.element.setAttribute('aria-hidden', 'true')
            }),
            (n.wrapShift = function (t2) {
                ;(this.shift = t2),
                    this.renderPosition(
                        this.x + this.parent.slideableWidth * t2
                    )
            }),
            (n.remove = function () {
                this.element.parentNode.removeChild(this.element)
            }),
            i
        )
    }),
    (function (t, e) {
        typeof define == 'function' && define.amd
            ? define('flickity/js/slide', e)
            : typeof module == 'object' && module.exports
            ? (module.exports = e())
            : ((t.Flickity = t.Flickity || {}), (t.Flickity.Slide = e()))
    })(window, function () {
        'use strict'
        function t(t2) {
            ;(this.parent = t2),
                (this.isOriginLeft = t2.originSide == 'left'),
                (this.cells = []),
                (this.outerWidth = 0),
                (this.height = 0)
        }
        var e = t.prototype
        return (
            (e.addCell = function (t2) {
                if (
                    (this.cells.push(t2),
                    (this.outerWidth += t2.size.outerWidth),
                    (this.height = Math.max(t2.size.outerHeight, this.height)),
                    this.cells.length == 1)
                ) {
                    this.x = t2.x
                    var e2 = this.isOriginLeft ? 'marginLeft' : 'marginRight'
                    this.firstMargin = t2.size[e2]
                }
            }),
            (e.updateTarget = function () {
                var t2 = this.isOriginLeft ? 'marginRight' : 'marginLeft',
                    e2 = this.getLastCell(),
                    i = e2 ? e2.size[t2] : 0,
                    n = this.outerWidth - (this.firstMargin + i)
                this.target =
                    this.x + this.firstMargin + n * this.parent.cellAlign
            }),
            (e.getLastCell = function () {
                return this.cells[this.cells.length - 1]
            }),
            (e.select = function () {
                this.cells.forEach(function (t2) {
                    t2.select()
                })
            }),
            (e.unselect = function () {
                this.cells.forEach(function (t2) {
                    t2.unselect()
                })
            }),
            (e.getCellElements = function () {
                return this.cells.map(function (t2) {
                    return t2.element
                })
            }),
            t
        )
    }),
    (function (e, i) {
        typeof define == 'function' && define.amd
            ? define(
                  'flickity/js/animate',
                  ['fizzy-ui-utils/utils'],
                  function (t) {
                      return i(e, t)
                  }
              )
            : typeof module == 'object' && module.exports
            ? (module.exports = i(e, require('fizzy-ui-utils')))
            : ((e.Flickity = e.Flickity || {}),
              (e.Flickity.animatePrototype = i(e, e.fizzyUIUtils)))
    })(window, function (t, e) {
        var i = {
            startAnimation: function () {
                this.isAnimating ||
                    ((this.isAnimating = !0),
                    (this.restingFrames = 0),
                    this.animate())
            },
            animate: function () {
                this.applyDragForce(), this.applySelectedAttraction()
                var t2 = this.x
                if (
                    (this.integratePhysics(),
                    this.positionSlider(),
                    this.settle(t2),
                    this.isAnimating)
                ) {
                    var e2 = this
                    requestAnimationFrame(function () {
                        e2.animate()
                    })
                }
            },
            positionSlider: function () {
                var t2 = this.x
                this.options.wrapAround &&
                    1 < this.cells.length &&
                    ((t2 = e.modulo(t2, this.slideableWidth)),
                    (t2 -= this.slideableWidth),
                    this.shiftWrapCells(t2)),
                    this.setTranslateX(t2, this.isAnimating),
                    this.dispatchScrollEvent()
            },
            setTranslateX: function (t2, e2) {
                ;(t2 += this.cursorPosition),
                    (t2 = this.options.rightToLeft ? -t2 : t2)
                var i2 = this.getPositionValue(t2)
                this.slider.style.transform = e2
                    ? 'translate3d(' + i2 + ',0,0)'
                    : 'translateX(' + i2 + ')'
            },
            dispatchScrollEvent: function () {
                var t2 = this.slides[0]
                if (t2) {
                    var e2 = -this.x - t2.target,
                        i2 = e2 / this.slidesWidth
                    this.dispatchEvent('scroll', null, [i2, e2])
                }
            },
            positionSliderAtSelected: function () {
                this.cells.length &&
                    ((this.x = -this.selectedSlide.target),
                    (this.velocity = 0),
                    this.positionSlider())
            },
            getPositionValue: function (t2) {
                return this.options.percentPosition
                    ? 0.01 * Math.round((t2 / this.size.innerWidth) * 1e4) + '%'
                    : Math.round(t2) + 'px'
            },
            settle: function (t2) {
                this.isPointerDown ||
                    Math.round(100 * this.x) != Math.round(100 * t2) ||
                    this.restingFrames++,
                    2 < this.restingFrames &&
                        ((this.isAnimating = !1),
                        delete this.isFreeScrolling,
                        this.positionSlider(),
                        this.dispatchEvent('settle', null, [
                            this.selectedIndex,
                        ]))
            },
            shiftWrapCells: function (t2) {
                var e2 = this.cursorPosition + t2
                this._shiftCells(this.beforeShiftCells, e2, -1)
                var i2 =
                    this.size.innerWidth -
                    (t2 + this.slideableWidth + this.cursorPosition)
                this._shiftCells(this.afterShiftCells, i2, 1)
            },
            _shiftCells: function (t2, e2, i2) {
                for (var n = 0; n < t2.length; n++) {
                    var s = t2[n],
                        o = 0 < e2 ? i2 : 0
                    s.wrapShift(o), (e2 -= s.size.outerWidth)
                }
            },
            _unshiftCells: function (t2) {
                if (t2 && t2.length)
                    for (var e2 = 0; e2 < t2.length; e2++) t2[e2].wrapShift(0)
            },
            integratePhysics: function () {
                ;(this.x += this.velocity),
                    (this.velocity *= this.getFrictionFactor())
            },
            applyForce: function (t2) {
                this.velocity += t2
            },
            getFrictionFactor: function () {
                return (
                    1 -
                    this.options[
                        this.isFreeScrolling ? 'freeScrollFriction' : 'friction'
                    ]
                )
            },
            getRestingPosition: function () {
                return this.x + this.velocity / (1 - this.getFrictionFactor())
            },
            applyDragForce: function () {
                if (this.isDraggable && this.isPointerDown) {
                    var t2 = this.dragX - this.x - this.velocity
                    this.applyForce(t2)
                }
            },
            applySelectedAttraction: function () {
                if (
                    !(this.isDraggable && this.isPointerDown) &&
                    !this.isFreeScrolling &&
                    this.slides.length
                ) {
                    var t2 =
                        (-1 * this.selectedSlide.target - this.x) *
                        this.options.selectedAttraction
                    this.applyForce(t2)
                }
            },
        }
        return i
    }),
    (function (r, a) {
        if (typeof define == 'function' && define.amd)
            define('flickity/js/flickity', [
                'ev-emitter/ev-emitter',
                'get-size/get-size',
                'fizzy-ui-utils/utils',
                './cell',
                './slide',
                './animate',
            ], function (t2, e, i, n, s, o) {
                return a(r, t2, e, i, n, s, o)
            })
        else if (typeof module == 'object' && module.exports)
            module.exports = a(
                r,
                require('ev-emitter'),
                require('get-size'),
                require('fizzy-ui-utils'),
                require('./cell'),
                require('./slide'),
                require('./animate')
            )
        else {
            var t = r.Flickity
            r.Flickity = a(
                r,
                r.EvEmitter,
                r.getSize,
                r.fizzyUIUtils,
                t.Cell,
                t.Slide,
                t.animatePrototype
            )
        }
    })(window, function (n, t, e, a, i, r, s) {
        var l = n.jQuery,
            o = n.getComputedStyle,
            h = n.console
        function c(t2, e2) {
            for (t2 = a.makeArray(t2); t2.length; ) e2.appendChild(t2.shift())
        }
        var d = 0,
            u = {}
        function f(t2, e2) {
            var i2 = a.getQueryElement(t2)
            if (i2) {
                if (((this.element = i2), this.element.flickityGUID)) {
                    var n2 = u[this.element.flickityGUID]
                    return n2.option(e2), n2
                }
                l && (this.$element = l(this.element)),
                    (this.options = a.extend({}, this.constructor.defaults)),
                    this.option(e2),
                    this._create()
            } else h && h.error('Bad element for Flickity: ' + (i2 || t2))
        }
        ;(f.defaults = {
            accessibility: !0,
            cellAlign: 'center',
            freeScrollFriction: 0.075,
            friction: 0.28,
            namespaceJQueryEvents: !0,
            percentPosition: !0,
            resize: !0,
            selectedAttraction: 0.025,
            setGallerySize: !0,
        }),
            (f.createMethods = [])
        var p = f.prototype
        a.extend(p, t.prototype),
            (p._create = function () {
                var t2 = (this.guid = ++d)
                for (var e2 in ((this.element.flickityGUID = t2),
                ((u[t2] = this).selectedIndex = 0),
                (this.restingFrames = 0),
                (this.x = 0),
                (this.velocity = 0),
                (this.originSide = this.options.rightToLeft ? 'right' : 'left'),
                (this.viewport = document.createElement('div')),
                (this.viewport.className = 'flickity-viewport'),
                this._createSlider(),
                (this.options.resize || this.options.watchCSS) &&
                    n.addEventListener('resize', this),
                this.options.on)) {
                    var i2 = this.options.on[e2]
                    this.on(e2, i2)
                }
                f.createMethods.forEach(function (t3) {
                    this[t3]()
                }, this),
                    this.options.watchCSS ? this.watchCSS() : this.activate()
            }),
            (p.option = function (t2) {
                a.extend(this.options, t2)
            }),
            (p.activate = function () {
                this.isActive ||
                    ((this.isActive = !0),
                    this.element.classList.add('flickity-enabled'),
                    this.options.rightToLeft &&
                        this.element.classList.add('flickity-rtl'),
                    this.getSize(),
                    c(
                        this._filterFindCellElements(this.element.children),
                        this.slider
                    ),
                    this.viewport.appendChild(this.slider),
                    this.element.appendChild(this.viewport),
                    this.reloadCells(),
                    this.options.accessibility &&
                        ((this.element.tabIndex = 0),
                        this.element.addEventListener('keydown', this)),
                    this.emitEvent('activate'),
                    this.selectInitialIndex(),
                    (this.isInitActivated = !0),
                    this.dispatchEvent('ready'))
            }),
            (p._createSlider = function () {
                var t2 = document.createElement('div')
                ;(t2.className = 'flickity-slider'),
                    (t2.style[this.originSide] = 0),
                    (this.slider = t2)
            }),
            (p._filterFindCellElements = function (t2) {
                return a.filterFindElements(t2, this.options.cellSelector)
            }),
            (p.reloadCells = function () {
                ;(this.cells = this._makeCells(this.slider.children)),
                    this.positionCells(),
                    this._getWrapShiftCells(),
                    this.setGallerySize()
            }),
            (p._makeCells = function (t2) {
                return this._filterFindCellElements(t2).map(function (t3) {
                    return new i(t3, this)
                }, this)
            }),
            (p.getLastCell = function () {
                return this.cells[this.cells.length - 1]
            }),
            (p.getLastSlide = function () {
                return this.slides[this.slides.length - 1]
            }),
            (p.positionCells = function () {
                this._sizeCells(this.cells), this._positionCells(0)
            }),
            (p._positionCells = function (t2) {
                ;(t2 = t2 || 0),
                    (this.maxCellHeight = (t2 && this.maxCellHeight) || 0)
                var e2 = 0
                if (0 < t2) {
                    var i2 = this.cells[t2 - 1]
                    e2 = i2.x + i2.size.outerWidth
                }
                for (var n2 = this.cells.length, s2 = t2; s2 < n2; s2++) {
                    var o2 = this.cells[s2]
                    o2.setPosition(e2),
                        (e2 += o2.size.outerWidth),
                        (this.maxCellHeight = Math.max(
                            o2.size.outerHeight,
                            this.maxCellHeight
                        ))
                }
                ;(this.slideableWidth = e2),
                    this.updateSlides(),
                    this._containSlides(),
                    (this.slidesWidth = n2
                        ? this.getLastSlide().target - this.slides[0].target
                        : 0)
            }),
            (p._sizeCells = function (t2) {
                t2.forEach(function (t3) {
                    t3.getSize()
                })
            }),
            (p.updateSlides = function () {
                if (((this.slides = []), this.cells.length)) {
                    var n2 = new r(this)
                    this.slides.push(n2)
                    var s2 =
                            this.originSide == 'left'
                                ? 'marginRight'
                                : 'marginLeft',
                        o2 = this._getCanCellFit()
                    this.cells.forEach(function (t2, e2) {
                        if (n2.cells.length) {
                            var i2 =
                                n2.outerWidth -
                                n2.firstMargin +
                                (t2.size.outerWidth - t2.size[s2])
                            o2.call(this, e2, i2) ||
                                (n2.updateTarget(),
                                (n2 = new r(this)),
                                this.slides.push(n2)),
                                n2.addCell(t2)
                        } else n2.addCell(t2)
                    }, this),
                        n2.updateTarget(),
                        this.updateSelectedSlide()
                }
            }),
            (p._getCanCellFit = function () {
                var t2 = this.options.groupCells
                if (!t2)
                    return function () {
                        return !1
                    }
                if (typeof t2 == 'number') {
                    var e2 = parseInt(t2, 10)
                    return function (t3) {
                        return t3 % e2 != 0
                    }
                }
                var i2 = typeof t2 == 'string' && t2.match(/^(\d+)%$/),
                    n2 = i2 ? parseInt(i2[1], 10) / 100 : 1
                return function (t3, e3) {
                    return e3 <= (this.size.innerWidth + 1) * n2
                }
            }),
            (p._init = p.reposition =
                function () {
                    this.positionCells(), this.positionSliderAtSelected()
                }),
            (p.getSize = function () {
                ;(this.size = e(this.element)),
                    this.setCellAlign(),
                    (this.cursorPosition =
                        this.size.innerWidth * this.cellAlign)
            })
        var g = {
            center: { left: 0.5, right: 0.5 },
            left: { left: 0, right: 1 },
            right: { right: 0, left: 1 },
        }
        return (
            (p.setCellAlign = function () {
                var t2 = g[this.options.cellAlign]
                this.cellAlign = t2
                    ? t2[this.originSide]
                    : this.options.cellAlign
            }),
            (p.setGallerySize = function () {
                if (this.options.setGallerySize) {
                    var t2 =
                        this.options.adaptiveHeight && this.selectedSlide
                            ? this.selectedSlide.height
                            : this.maxCellHeight
                    this.viewport.style.height = t2 + 'px'
                }
            }),
            (p._getWrapShiftCells = function () {
                if (this.options.wrapAround) {
                    this._unshiftCells(this.beforeShiftCells),
                        this._unshiftCells(this.afterShiftCells)
                    var t2 = this.cursorPosition,
                        e2 = this.cells.length - 1
                    ;(this.beforeShiftCells = this._getGapCells(t2, e2, -1)),
                        (t2 = this.size.innerWidth - this.cursorPosition),
                        (this.afterShiftCells = this._getGapCells(t2, 0, 1))
                }
            }),
            (p._getGapCells = function (t2, e2, i2) {
                for (var n2 = []; 0 < t2; ) {
                    var s2 = this.cells[e2]
                    if (!s2) break
                    n2.push(s2), (e2 += i2), (t2 -= s2.size.outerWidth)
                }
                return n2
            }),
            (p._containSlides = function () {
                if (
                    this.options.contain &&
                    !this.options.wrapAround &&
                    this.cells.length
                ) {
                    var t2 = this.options.rightToLeft,
                        e2 = t2 ? 'marginRight' : 'marginLeft',
                        i2 = t2 ? 'marginLeft' : 'marginRight',
                        n2 = this.slideableWidth - this.getLastCell().size[i2],
                        s2 = n2 < this.size.innerWidth,
                        o2 = this.cursorPosition + this.cells[0].size[e2],
                        r2 = n2 - this.size.innerWidth * (1 - this.cellAlign)
                    this.slides.forEach(function (t3) {
                        s2
                            ? (t3.target = n2 * this.cellAlign)
                            : ((t3.target = Math.max(t3.target, o2)),
                              (t3.target = Math.min(t3.target, r2)))
                    }, this)
                }
            }),
            (p.dispatchEvent = function (t2, e2, i2) {
                var n2 = e2 ? [e2].concat(i2) : i2
                if ((this.emitEvent(t2, n2), l && this.$element)) {
                    var s2 = (t2 += this.options.namespaceJQueryEvents
                        ? '.flickity'
                        : '')
                    if (e2) {
                        var o2 = l.Event(e2)
                        ;(o2.type = t2), (s2 = o2)
                    }
                    this.$element.trigger(s2, i2)
                }
            }),
            (p.select = function (t2, e2, i2) {
                if (
                    this.isActive &&
                    ((t2 = parseInt(t2, 10)),
                    this._wrapSelect(t2),
                    (this.options.wrapAround || e2) &&
                        (t2 = a.modulo(t2, this.slides.length)),
                    this.slides[t2])
                ) {
                    var n2 = this.selectedIndex
                    ;(this.selectedIndex = t2),
                        this.updateSelectedSlide(),
                        i2
                            ? this.positionSliderAtSelected()
                            : this.startAnimation(),
                        this.options.adaptiveHeight && this.setGallerySize(),
                        this.dispatchEvent('select', null, [t2]),
                        t2 != n2 && this.dispatchEvent('change', null, [t2]),
                        this.dispatchEvent('cellSelect')
                }
            }),
            (p._wrapSelect = function (t2) {
                var e2 = this.slides.length
                if (!(this.options.wrapAround && 1 < e2)) return t2
                var i2 = a.modulo(t2, e2),
                    n2 = Math.abs(i2 - this.selectedIndex),
                    s2 = Math.abs(i2 + e2 - this.selectedIndex),
                    o2 = Math.abs(i2 - e2 - this.selectedIndex)
                !this.isDragSelect && s2 < n2
                    ? (t2 += e2)
                    : !this.isDragSelect && o2 < n2 && (t2 -= e2),
                    t2 < 0
                        ? (this.x -= this.slideableWidth)
                        : e2 <= t2 && (this.x += this.slideableWidth)
            }),
            (p.previous = function (t2, e2) {
                this.select(this.selectedIndex - 1, t2, e2)
            }),
            (p.next = function (t2, e2) {
                this.select(this.selectedIndex + 1, t2, e2)
            }),
            (p.updateSelectedSlide = function () {
                var t2 = this.slides[this.selectedIndex]
                t2 &&
                    (this.unselectSelectedSlide(),
                    (this.selectedSlide = t2).select(),
                    (this.selectedCells = t2.cells),
                    (this.selectedElements = t2.getCellElements()),
                    (this.selectedCell = t2.cells[0]),
                    (this.selectedElement = this.selectedElements[0]))
            }),
            (p.unselectSelectedSlide = function () {
                this.selectedSlide && this.selectedSlide.unselect()
            }),
            (p.selectInitialIndex = function () {
                var t2 = this.options.initialIndex
                if (this.isInitActivated)
                    this.select(this.selectedIndex, !1, !0)
                else {
                    if (t2 && typeof t2 == 'string' && this.queryCell(t2))
                        return void this.selectCell(t2, !1, !0)
                    var e2 = 0
                    t2 && this.slides[t2] && (e2 = t2), this.select(e2, !1, !0)
                }
            }),
            (p.selectCell = function (t2, e2, i2) {
                var n2 = this.queryCell(t2)
                if (n2) {
                    var s2 = this.getCellSlideIndex(n2)
                    this.select(s2, e2, i2)
                }
            }),
            (p.getCellSlideIndex = function (t2) {
                for (var e2 = 0; e2 < this.slides.length; e2++)
                    if (this.slides[e2].cells.indexOf(t2) != -1) return e2
            }),
            (p.getCell = function (t2) {
                for (var e2 = 0; e2 < this.cells.length; e2++) {
                    var i2 = this.cells[e2]
                    if (i2.element == t2) return i2
                }
            }),
            (p.getCells = function (t2) {
                t2 = a.makeArray(t2)
                var i2 = []
                return (
                    t2.forEach(function (t3) {
                        var e2 = this.getCell(t3)
                        e2 && i2.push(e2)
                    }, this),
                    i2
                )
            }),
            (p.getCellElements = function () {
                return this.cells.map(function (t2) {
                    return t2.element
                })
            }),
            (p.getParentCell = function (t2) {
                var e2 = this.getCell(t2)
                return (
                    e2 ||
                    ((t2 = a.getParent(t2, '.flickity-slider > *')),
                    this.getCell(t2))
                )
            }),
            (p.getAdjacentCellElements = function (t2, e2) {
                if (!t2) return this.selectedSlide.getCellElements()
                e2 = e2 === void 0 ? this.selectedIndex : e2
                var i2 = this.slides.length
                if (i2 <= 1 + 2 * t2) return this.getCellElements()
                for (var n2 = [], s2 = e2 - t2; s2 <= e2 + t2; s2++) {
                    var o2 = this.options.wrapAround ? a.modulo(s2, i2) : s2,
                        r2 = this.slides[o2]
                    r2 && (n2 = n2.concat(r2.getCellElements()))
                }
                return n2
            }),
            (p.queryCell = function (t2) {
                if (typeof t2 == 'number') return this.cells[t2]
                if (typeof t2 == 'string') {
                    if (t2.match(/^[#\.]?[\d\/]/)) return
                    t2 = this.element.querySelector(t2)
                }
                return this.getCell(t2)
            }),
            (p.uiChange = function () {
                this.emitEvent('uiChange')
            }),
            (p.childUIPointerDown = function (t2) {
                t2.type != 'touchstart' && t2.preventDefault(), this.focus()
            }),
            (p.onresize = function () {
                this.watchCSS(), this.resize()
            }),
            a.debounceMethod(f, 'onresize', 150),
            (p.resize = function () {
                if (this.isActive) {
                    this.getSize(),
                        this.options.wrapAround &&
                            (this.x = a.modulo(this.x, this.slideableWidth)),
                        this.positionCells(),
                        this._getWrapShiftCells(),
                        this.setGallerySize(),
                        this.emitEvent('resize')
                    var t2 = this.selectedElements && this.selectedElements[0]
                    this.selectCell(t2, !1, !0)
                }
            }),
            (p.watchCSS = function () {
                this.options.watchCSS &&
                    (o(this.element, ':after').content.indexOf('flickity') != -1
                        ? this.activate()
                        : this.deactivate())
            }),
            (p.onkeydown = function (t2) {
                var e2 =
                    document.activeElement &&
                    document.activeElement != this.element
                if (this.options.accessibility && !e2) {
                    var i2 = f.keyboardHandlers[t2.keyCode]
                    i2 && i2.call(this)
                }
            }),
            (f.keyboardHandlers = {
                37: function () {
                    var t2 = this.options.rightToLeft ? 'next' : 'previous'
                    this.uiChange(), this[t2]()
                },
                39: function () {
                    var t2 = this.options.rightToLeft ? 'previous' : 'next'
                    this.uiChange(), this[t2]()
                },
            }),
            (p.focus = function () {
                var t2 = n.pageYOffset
                this.element.focus({ preventScroll: !0 }),
                    n.pageYOffset != t2 && n.scrollTo(n.pageXOffset, t2)
            }),
            (p.deactivate = function () {
                this.isActive &&
                    (this.element.classList.remove('flickity-enabled'),
                    this.element.classList.remove('flickity-rtl'),
                    this.unselectSelectedSlide(),
                    this.cells.forEach(function (t2) {
                        t2.destroy()
                    }),
                    this.element.removeChild(this.viewport),
                    c(this.slider.children, this.element),
                    this.options.accessibility &&
                        (this.element.removeAttribute('tabIndex'),
                        this.element.removeEventListener('keydown', this)),
                    (this.isActive = !1),
                    this.emitEvent('deactivate'))
            }),
            (p.destroy = function () {
                this.deactivate(),
                    n.removeEventListener('resize', this),
                    this.allOff(),
                    this.emitEvent('destroy'),
                    l &&
                        this.$element &&
                        l.removeData(this.element, 'flickity'),
                    delete this.element.flickityGUID,
                    delete u[this.guid]
            }),
            a.extend(p, s),
            (f.data = function (t2) {
                var e2 = (t2 = a.getQueryElement(t2)) && t2.flickityGUID
                return e2 && u[e2]
            }),
            a.htmlInit(f, 'flickity'),
            l && l.bridget && l.bridget('flickity', f),
            (f.setJQuery = function (t2) {
                l = t2
            }),
            (f.Cell = i),
            (f.Slide = r),
            f
        )
    }),
    (function (e, i) {
        typeof define == 'function' && define.amd
            ? define(
                  'unipointer/unipointer',
                  ['ev-emitter/ev-emitter'],
                  function (t) {
                      return i(e, t)
                  }
              )
            : typeof module == 'object' && module.exports
            ? (module.exports = i(e, require('ev-emitter')))
            : (e.Unipointer = i(e, e.EvEmitter))
    })(window, function (s, t) {
        function e() {}
        var i = (e.prototype = Object.create(t.prototype))
        ;(i.bindStartEvent = function (t2) {
            this._bindStartEvent(t2, !0)
        }),
            (i.unbindStartEvent = function (t2) {
                this._bindStartEvent(t2, !1)
            }),
            (i._bindStartEvent = function (t2, e2) {
                var i2 = (e2 = e2 === void 0 || e2)
                        ? 'addEventListener'
                        : 'removeEventListener',
                    n2 = 'mousedown'
                s.PointerEvent
                    ? (n2 = 'pointerdown')
                    : 'ontouchstart' in s && (n2 = 'touchstart'),
                    t2[i2](n2, this)
            }),
            (i.handleEvent = function (t2) {
                var e2 = 'on' + t2.type
                this[e2] && this[e2](t2)
            }),
            (i.getTouch = function (t2) {
                for (var e2 = 0; e2 < t2.length; e2++) {
                    var i2 = t2[e2]
                    if (i2.identifier == this.pointerIdentifier) return i2
                }
            }),
            (i.onmousedown = function (t2) {
                var e2 = t2.button
                ;(e2 && e2 !== 0 && e2 !== 1) || this._pointerDown(t2, t2)
            }),
            (i.ontouchstart = function (t2) {
                this._pointerDown(t2, t2.changedTouches[0])
            }),
            (i.onpointerdown = function (t2) {
                this._pointerDown(t2, t2)
            }),
            (i._pointerDown = function (t2, e2) {
                t2.button ||
                    this.isPointerDown ||
                    ((this.isPointerDown = !0),
                    (this.pointerIdentifier =
                        e2.pointerId !== void 0 ? e2.pointerId : e2.identifier),
                    this.pointerDown(t2, e2))
            }),
            (i.pointerDown = function (t2, e2) {
                this._bindPostStartEvents(t2),
                    this.emitEvent('pointerDown', [t2, e2])
            })
        var n = {
            mousedown: ['mousemove', 'mouseup'],
            touchstart: ['touchmove', 'touchend', 'touchcancel'],
            pointerdown: ['pointermove', 'pointerup', 'pointercancel'],
        }
        return (
            (i._bindPostStartEvents = function (t2) {
                if (t2) {
                    var e2 = n[t2.type]
                    e2.forEach(function (t3) {
                        s.addEventListener(t3, this)
                    }, this),
                        (this._boundPointerEvents = e2)
                }
            }),
            (i._unbindPostStartEvents = function () {
                this._boundPointerEvents &&
                    (this._boundPointerEvents.forEach(function (t2) {
                        s.removeEventListener(t2, this)
                    }, this),
                    delete this._boundPointerEvents)
            }),
            (i.onmousemove = function (t2) {
                this._pointerMove(t2, t2)
            }),
            (i.onpointermove = function (t2) {
                t2.pointerId == this.pointerIdentifier &&
                    this._pointerMove(t2, t2)
            }),
            (i.ontouchmove = function (t2) {
                var e2 = this.getTouch(t2.changedTouches)
                e2 && this._pointerMove(t2, e2)
            }),
            (i._pointerMove = function (t2, e2) {
                this.pointerMove(t2, e2)
            }),
            (i.pointerMove = function (t2, e2) {
                this.emitEvent('pointerMove', [t2, e2])
            }),
            (i.onmouseup = function (t2) {
                this._pointerUp(t2, t2)
            }),
            (i.onpointerup = function (t2) {
                t2.pointerId == this.pointerIdentifier &&
                    this._pointerUp(t2, t2)
            }),
            (i.ontouchend = function (t2) {
                var e2 = this.getTouch(t2.changedTouches)
                e2 && this._pointerUp(t2, e2)
            }),
            (i._pointerUp = function (t2, e2) {
                this._pointerDone(), this.pointerUp(t2, e2)
            }),
            (i.pointerUp = function (t2, e2) {
                this.emitEvent('pointerUp', [t2, e2])
            }),
            (i._pointerDone = function () {
                this._pointerReset(),
                    this._unbindPostStartEvents(),
                    this.pointerDone()
            }),
            (i._pointerReset = function () {
                ;(this.isPointerDown = !1), delete this.pointerIdentifier
            }),
            (i.pointerDone = function () {}),
            (i.onpointercancel = function (t2) {
                t2.pointerId == this.pointerIdentifier &&
                    this._pointerCancel(t2, t2)
            }),
            (i.ontouchcancel = function (t2) {
                var e2 = this.getTouch(t2.changedTouches)
                e2 && this._pointerCancel(t2, e2)
            }),
            (i._pointerCancel = function (t2, e2) {
                this._pointerDone(), this.pointerCancel(t2, e2)
            }),
            (i.pointerCancel = function (t2, e2) {
                this.emitEvent('pointerCancel', [t2, e2])
            }),
            (e.getPointerPoint = function (t2) {
                return { x: t2.pageX, y: t2.pageY }
            }),
            e
        )
    }),
    (function (e, i) {
        typeof define == 'function' && define.amd
            ? define(
                  'unidragger/unidragger',
                  ['unipointer/unipointer'],
                  function (t) {
                      return i(e, t)
                  }
              )
            : typeof module == 'object' && module.exports
            ? (module.exports = i(e, require('unipointer')))
            : (e.Unidragger = i(e, e.Unipointer))
    })(window, function (o, t) {
        function e() {}
        var i = (e.prototype = Object.create(t.prototype))
        ;(i.bindHandles = function () {
            this._bindHandles(!0)
        }),
            (i.unbindHandles = function () {
                this._bindHandles(!1)
            }),
            (i._bindHandles = function (t2) {
                for (
                    var e2 = (t2 = t2 === void 0 || t2)
                            ? 'addEventListener'
                            : 'removeEventListener',
                        i2 = t2 ? this._touchActionValue : '',
                        n = 0;
                    n < this.handles.length;
                    n++
                ) {
                    var s2 = this.handles[n]
                    this._bindStartEvent(s2, t2),
                        s2[e2]('click', this),
                        o.PointerEvent && (s2.style.touchAction = i2)
                }
            }),
            (i._touchActionValue = 'none'),
            (i.pointerDown = function (t2, e2) {
                this.okayPointerDown(t2) &&
                    ((this.pointerDownPointer = e2),
                    t2.preventDefault(),
                    this.pointerDownBlur(),
                    this._bindPostStartEvents(t2),
                    this.emitEvent('pointerDown', [t2, e2]))
            })
        var s = { TEXTAREA: !0, INPUT: !0, SELECT: !0, OPTION: !0 },
            r = {
                radio: !0,
                checkbox: !0,
                button: !0,
                submit: !0,
                image: !0,
                file: !0,
            }
        return (
            (i.okayPointerDown = function (t2) {
                var e2 = s[t2.target.nodeName],
                    i2 = r[t2.target.type],
                    n = !e2 || i2
                return n || this._pointerReset(), n
            }),
            (i.pointerDownBlur = function () {
                var t2 = document.activeElement
                t2 && t2.blur && t2 != document.body && t2.blur()
            }),
            (i.pointerMove = function (t2, e2) {
                var i2 = this._dragPointerMove(t2, e2)
                this.emitEvent('pointerMove', [t2, e2, i2]),
                    this._dragMove(t2, e2, i2)
            }),
            (i._dragPointerMove = function (t2, e2) {
                var i2 = {
                    x: e2.pageX - this.pointerDownPointer.pageX,
                    y: e2.pageY - this.pointerDownPointer.pageY,
                }
                return (
                    !this.isDragging &&
                        this.hasDragStarted(i2) &&
                        this._dragStart(t2, e2),
                    i2
                )
            }),
            (i.hasDragStarted = function (t2) {
                return 3 < Math.abs(t2.x) || 3 < Math.abs(t2.y)
            }),
            (i.pointerUp = function (t2, e2) {
                this.emitEvent('pointerUp', [t2, e2]),
                    this._dragPointerUp(t2, e2)
            }),
            (i._dragPointerUp = function (t2, e2) {
                this.isDragging
                    ? this._dragEnd(t2, e2)
                    : this._staticClick(t2, e2)
            }),
            (i._dragStart = function (t2, e2) {
                ;(this.isDragging = !0),
                    (this.isPreventingClicks = !0),
                    this.dragStart(t2, e2)
            }),
            (i.dragStart = function (t2, e2) {
                this.emitEvent('dragStart', [t2, e2])
            }),
            (i._dragMove = function (t2, e2, i2) {
                this.isDragging && this.dragMove(t2, e2, i2)
            }),
            (i.dragMove = function (t2, e2, i2) {
                t2.preventDefault(), this.emitEvent('dragMove', [t2, e2, i2])
            }),
            (i._dragEnd = function (t2, e2) {
                ;(this.isDragging = !1),
                    setTimeout(
                        function () {
                            delete this.isPreventingClicks
                        }.bind(this)
                    ),
                    this.dragEnd(t2, e2)
            }),
            (i.dragEnd = function (t2, e2) {
                this.emitEvent('dragEnd', [t2, e2])
            }),
            (i.onclick = function (t2) {
                this.isPreventingClicks && t2.preventDefault()
            }),
            (i._staticClick = function (t2, e2) {
                ;(this.isIgnoringMouseUp && t2.type == 'mouseup') ||
                    (this.staticClick(t2, e2),
                    t2.type != 'mouseup' &&
                        ((this.isIgnoringMouseUp = !0),
                        setTimeout(
                            function () {
                                delete this.isIgnoringMouseUp
                            }.bind(this),
                            400
                        )))
            }),
            (i.staticClick = function (t2, e2) {
                this.emitEvent('staticClick', [t2, e2])
            }),
            (e.getPointerPoint = t.getPointerPoint),
            e
        )
    }),
    (function (n, s) {
        typeof define == 'function' && define.amd
            ? define(
                  'flickity/js/drag',
                  [
                      './flickity',
                      'unidragger/unidragger',
                      'fizzy-ui-utils/utils',
                  ],
                  function (t, e, i) {
                      return s(n, t, e, i)
                  }
              )
            : typeof module == 'object' && module.exports
            ? (module.exports = s(
                  n,
                  require('./flickity'),
                  require('unidragger'),
                  require('fizzy-ui-utils')
              ))
            : (n.Flickity = s(n, n.Flickity, n.Unidragger, n.fizzyUIUtils))
    })(window, function (i, t, e, a) {
        a.extend(t.defaults, { draggable: '>1', dragThreshold: 3 }),
            t.createMethods.push('_createDrag')
        var n = t.prototype
        a.extend(n, e.prototype), (n._touchActionValue = 'pan-y')
        var s = 'createTouch' in document,
            o = !1
        ;(n._createDrag = function () {
            this.on('activate', this.onActivateDrag),
                this.on('uiChange', this._uiChangeDrag),
                this.on('deactivate', this.onDeactivateDrag),
                this.on('cellChange', this.updateDraggable),
                s &&
                    !o &&
                    (i.addEventListener('touchmove', function () {}), (o = !0))
        }),
            (n.onActivateDrag = function () {
                ;(this.handles = [this.viewport]),
                    this.bindHandles(),
                    this.updateDraggable()
            }),
            (n.onDeactivateDrag = function () {
                this.unbindHandles(),
                    this.element.classList.remove('is-draggable')
            }),
            (n.updateDraggable = function () {
                this.options.draggable == '>1'
                    ? (this.isDraggable = 1 < this.slides.length)
                    : (this.isDraggable = this.options.draggable),
                    this.isDraggable
                        ? this.element.classList.add('is-draggable')
                        : this.element.classList.remove('is-draggable')
            }),
            (n.bindDrag = function () {
                ;(this.options.draggable = !0), this.updateDraggable()
            }),
            (n.unbindDrag = function () {
                ;(this.options.draggable = !1), this.updateDraggable()
            }),
            (n._uiChangeDrag = function () {
                delete this.isFreeScrolling
            }),
            (n.pointerDown = function (t2, e2) {
                this.isDraggable
                    ? this.okayPointerDown(t2) &&
                      (this._pointerDownPreventDefault(t2),
                      this.pointerDownFocus(t2),
                      document.activeElement != this.element &&
                          this.pointerDownBlur(),
                      (this.dragX = this.x),
                      this.viewport.classList.add('is-pointer-down'),
                      (this.pointerDownScroll = l()),
                      i.addEventListener('scroll', this),
                      this._pointerDownDefault(t2, e2))
                    : this._pointerDownDefault(t2, e2)
            }),
            (n._pointerDownDefault = function (t2, e2) {
                ;(this.pointerDownPointer = {
                    pageX: e2.pageX,
                    pageY: e2.pageY,
                }),
                    this._bindPostStartEvents(t2),
                    this.dispatchEvent('pointerDown', t2, [e2])
            })
        var r = { INPUT: !0, TEXTAREA: !0, SELECT: !0 }
        function l() {
            return { x: i.pageXOffset, y: i.pageYOffset }
        }
        return (
            (n.pointerDownFocus = function (t2) {
                r[t2.target.nodeName] || this.focus()
            }),
            (n._pointerDownPreventDefault = function (t2) {
                var e2 = t2.type == 'touchstart',
                    i2 = t2.pointerType == 'touch',
                    n2 = r[t2.target.nodeName]
                e2 || i2 || n2 || t2.preventDefault()
            }),
            (n.hasDragStarted = function (t2) {
                return Math.abs(t2.x) > this.options.dragThreshold
            }),
            (n.pointerUp = function (t2, e2) {
                delete this.isTouchScrolling,
                    this.viewport.classList.remove('is-pointer-down'),
                    this.dispatchEvent('pointerUp', t2, [e2]),
                    this._dragPointerUp(t2, e2)
            }),
            (n.pointerDone = function () {
                i.removeEventListener('scroll', this),
                    delete this.pointerDownScroll
            }),
            (n.dragStart = function (t2, e2) {
                this.isDraggable &&
                    ((this.dragStartPosition = this.x),
                    this.startAnimation(),
                    i.removeEventListener('scroll', this),
                    this.dispatchEvent('dragStart', t2, [e2]))
            }),
            (n.pointerMove = function (t2, e2) {
                var i2 = this._dragPointerMove(t2, e2)
                this.dispatchEvent('pointerMove', t2, [e2, i2]),
                    this._dragMove(t2, e2, i2)
            }),
            (n.dragMove = function (t2, e2, i2) {
                if (this.isDraggable) {
                    t2.preventDefault()
                    var n2 = this.options.rightToLeft ? -1 : 1
                    this.options.wrapAround &&
                        (i2.x = i2.x % this.slideableWidth)
                    var s2 = this.dragStartPosition + i2.x * n2
                    if (!this.options.wrapAround && this.slides.length) {
                        var o2 = Math.max(
                            -this.slides[0].target,
                            this.dragStartPosition
                        )
                        s2 = o2 < s2 ? 0.5 * (s2 + o2) : s2
                        var r2 = Math.min(
                            -this.getLastSlide().target,
                            this.dragStartPosition
                        )
                        s2 = s2 < r2 ? 0.5 * (s2 + r2) : s2
                    }
                    this.dragX !== s2 && (this.previousDragX = this.dragX),
                        (this.dragX = s2),
                        (this.dragMoveTime = new Date()),
                        this.dispatchEvent('dragMove', t2, [e2, i2])
                }
            }),
            (n.dragEnd = function (t2, e2) {
                if (this.isDraggable) {
                    this.options.freeScroll && (this.isFreeScrolling = !0)
                    var i2 = this.dragEndRestingSelect()
                    if (this.options.freeScroll && !this.options.wrapAround) {
                        var n2 = this.getRestingPosition()
                        this.isFreeScrolling =
                            -n2 > this.slides[0].target &&
                            -n2 < this.getLastSlide().target
                    } else
                        this.options.freeScroll ||
                            i2 != this.selectedIndex ||
                            (i2 += this.dragEndBoostSelect())
                    delete this.previousDragX,
                        (this.isDragSelect = this.options.wrapAround),
                        this.select(i2),
                        delete this.isDragSelect,
                        this.dispatchEvent('dragEnd', t2, [e2])
                }
            }),
            (n.dragEndRestingSelect = function () {
                var t2 = this.getRestingPosition(),
                    e2 = Math.abs(
                        this.getSlideDistance(-t2, this.selectedIndex)
                    ),
                    i2 = this._getClosestResting(t2, e2, 1),
                    n2 = this._getClosestResting(t2, e2, -1)
                return i2.distance < n2.distance ? i2.index : n2.index
            }),
            (n._getClosestResting = function (t2, e2, i2) {
                for (
                    var n2 = this.selectedIndex,
                        s2 = 1 / 0,
                        o2 =
                            this.options.contain && !this.options.wrapAround
                                ? function (t3, e3) {
                                      return t3 <= e3
                                  }
                                : function (t3, e3) {
                                      return t3 < e3
                                  };
                    o2(e2, s2) &&
                    ((n2 += i2),
                    (s2 = e2),
                    (e2 = this.getSlideDistance(-t2, n2)) !== null);

                )
                    e2 = Math.abs(e2)
                return { distance: s2, index: n2 - i2 }
            }),
            (n.getSlideDistance = function (t2, e2) {
                var i2 = this.slides.length,
                    n2 = this.options.wrapAround && 1 < i2,
                    s2 = n2 ? a.modulo(e2, i2) : e2,
                    o2 = this.slides[s2]
                if (!o2) return null
                var r2 = n2 ? this.slideableWidth * Math.floor(e2 / i2) : 0
                return t2 - (o2.target + r2)
            }),
            (n.dragEndBoostSelect = function () {
                if (
                    this.previousDragX === void 0 ||
                    !this.dragMoveTime ||
                    100 < new Date() - this.dragMoveTime
                )
                    return 0
                var t2 = this.getSlideDistance(-this.dragX, this.selectedIndex),
                    e2 = this.previousDragX - this.dragX
                return 0 < t2 && 0 < e2 ? 1 : t2 < 0 && e2 < 0 ? -1 : 0
            }),
            (n.staticClick = function (t2, e2) {
                var i2 = this.getParentCell(t2.target),
                    n2 = i2 && i2.element,
                    s2 = i2 && this.cells.indexOf(i2)
                this.dispatchEvent('staticClick', t2, [e2, n2, s2])
            }),
            (n.onscroll = function () {
                var t2 = l(),
                    e2 = this.pointerDownScroll.x - t2.x,
                    i2 = this.pointerDownScroll.y - t2.y
                ;(3 < Math.abs(e2) || 3 < Math.abs(i2)) && this._pointerDone()
            }),
            t
        )
    }),
    (function (n, s) {
        typeof define == 'function' && define.amd
            ? define(
                  'flickity/js/prev-next-button',
                  [
                      './flickity',
                      'unipointer/unipointer',
                      'fizzy-ui-utils/utils',
                  ],
                  function (t, e, i) {
                      return s(n, t, e, i)
                  }
              )
            : typeof module == 'object' && module.exports
            ? (module.exports = s(
                  n,
                  require('./flickity'),
                  require('unipointer'),
                  require('fizzy-ui-utils')
              ))
            : s(n, n.Flickity, n.Unipointer, n.fizzyUIUtils)
    })(window, function (t, e, i, n) {
        'use strict'
        var s = 'http://www.w3.org/2000/svg'
        function o(t2, e2) {
            ;(this.direction = t2), (this.parent = e2), this._create()
        }
        ;((o.prototype = Object.create(i.prototype))._create = function () {
            ;(this.isEnabled = !0), (this.isPrevious = this.direction == -1)
            var t2 = this.parent.options.rightToLeft ? 1 : -1
            this.isLeft = this.direction == t2
            var e2 = (this.element = document.createElement('button'))
            ;(e2.className = 'flickity-button flickity-prev-next-button'),
                (e2.className += this.isPrevious ? ' previous' : ' next'),
                e2.setAttribute('type', 'button'),
                this.disable(),
                e2.setAttribute(
                    'aria-label',
                    this.isPrevious ? 'Previous' : 'Next'
                )
            var i2 = this.createSVG()
            e2.appendChild(i2),
                this.parent.on('select', this.update.bind(this)),
                this.on(
                    'pointerDown',
                    this.parent.childUIPointerDown.bind(this.parent)
                )
        }),
            (o.prototype.activate = function () {
                this.bindStartEvent(this.element),
                    this.element.addEventListener('click', this),
                    this.parent.element.appendChild(this.element)
            }),
            (o.prototype.deactivate = function () {
                this.parent.element.removeChild(this.element),
                    this.unbindStartEvent(this.element),
                    this.element.removeEventListener('click', this)
            }),
            (o.prototype.createSVG = function () {
                var t2 = document.createElementNS(s, 'svg')
                t2.setAttribute('class', 'flickity-button-icon'),
                    t2.setAttribute('viewBox', '0 0 100 100')
                var e2,
                    i2 = document.createElementNS(s, 'path'),
                    n2 =
                        typeof (e2 = this.parent.options.arrowShape) != 'string'
                            ? 'M ' +
                              e2.x0 +
                              ',50 L ' +
                              e2.x1 +
                              ',' +
                              (e2.y1 + 50) +
                              ' L ' +
                              e2.x2 +
                              ',' +
                              (e2.y2 + 50) +
                              ' L ' +
                              e2.x3 +
                              ',50  L ' +
                              e2.x2 +
                              ',' +
                              (50 - e2.y2) +
                              ' L ' +
                              e2.x1 +
                              ',' +
                              (50 - e2.y1) +
                              ' Z'
                            : e2
                return (
                    i2.setAttribute('d', n2),
                    i2.setAttribute('class', 'arrow'),
                    this.isLeft ||
                        i2.setAttribute(
                            'transform',
                            'translate(100, 100) rotate(180) '
                        ),
                    t2.appendChild(i2),
                    t2
                )
            }),
            (o.prototype.handleEvent = n.handleEvent),
            (o.prototype.onclick = function () {
                if (this.isEnabled) {
                    this.parent.uiChange()
                    var t2 = this.isPrevious ? 'previous' : 'next'
                    this.parent[t2]()
                }
            }),
            (o.prototype.enable = function () {
                this.isEnabled ||
                    ((this.element.disabled = !1), (this.isEnabled = !0))
            }),
            (o.prototype.disable = function () {
                this.isEnabled &&
                    ((this.element.disabled = !0), (this.isEnabled = !1))
            }),
            (o.prototype.update = function () {
                var t2 = this.parent.slides
                if (this.parent.options.wrapAround && 1 < t2.length)
                    this.enable()
                else {
                    var e2 = t2.length ? t2.length - 1 : 0,
                        i2 = this.isPrevious ? 0 : e2
                    this[
                        this.parent.selectedIndex == i2 ? 'disable' : 'enable'
                    ]()
                }
            }),
            (o.prototype.destroy = function () {
                this.deactivate(), this.allOff()
            }),
            n.extend(e.defaults, {
                prevNextButtons: !0,
                arrowShape: { x0: 10, x1: 60, y1: 50, x2: 70, y2: 40, x3: 30 },
            }),
            e.createMethods.push('_createPrevNextButtons')
        var r = e.prototype
        return (
            (r._createPrevNextButtons = function () {
                this.options.prevNextButtons &&
                    ((this.prevButton = new o(-1, this)),
                    (this.nextButton = new o(1, this)),
                    this.on('activate', this.activatePrevNextButtons))
            }),
            (r.activatePrevNextButtons = function () {
                this.prevButton.activate(),
                    this.nextButton.activate(),
                    this.on('deactivate', this.deactivatePrevNextButtons)
            }),
            (r.deactivatePrevNextButtons = function () {
                this.prevButton.deactivate(),
                    this.nextButton.deactivate(),
                    this.off('deactivate', this.deactivatePrevNextButtons)
            }),
            (e.PrevNextButton = o),
            e
        )
    }),
    (function (n, s) {
        typeof define == 'function' && define.amd
            ? define(
                  'flickity/js/page-dots',
                  [
                      './flickity',
                      'unipointer/unipointer',
                      'fizzy-ui-utils/utils',
                  ],
                  function (t, e, i) {
                      return s(n, t, e, i)
                  }
              )
            : typeof module == 'object' && module.exports
            ? (module.exports = s(
                  n,
                  require('./flickity'),
                  require('unipointer'),
                  require('fizzy-ui-utils')
              ))
            : s(n, n.Flickity, n.Unipointer, n.fizzyUIUtils)
    })(window, function (t, e, i, n) {
        function s(t2) {
            ;(this.parent = t2), this._create()
        }
        ;((s.prototype = Object.create(i.prototype))._create = function () {
            ;(this.holder = document.createElement('ol')),
                (this.holder.className = 'flickity-page-dots'),
                (this.dots = []),
                (this.handleClick = this.onClick.bind(this)),
                this.on(
                    'pointerDown',
                    this.parent.childUIPointerDown.bind(this.parent)
                )
        }),
            (s.prototype.activate = function () {
                this.setDots(),
                    this.holder.addEventListener('click', this.handleClick),
                    this.bindStartEvent(this.holder),
                    this.parent.element.appendChild(this.holder)
            }),
            (s.prototype.deactivate = function () {
                this.holder.removeEventListener('click', this.handleClick),
                    this.unbindStartEvent(this.holder),
                    this.parent.element.removeChild(this.holder)
            }),
            (s.prototype.setDots = function () {
                var t2 = this.parent.slides.length - this.dots.length
                0 < t2 ? this.addDots(t2) : t2 < 0 && this.removeDots(-t2)
            }),
            (s.prototype.addDots = function (t2) {
                for (
                    var e2 = document.createDocumentFragment(),
                        i2 = [],
                        n2 = this.dots.length,
                        s2 = n2 + t2,
                        o2 = n2;
                    o2 < s2;
                    o2++
                ) {
                    var r = document.createElement('li')
                    ;(r.className = 'dot'),
                        r.setAttribute('aria-label', 'Page dot ' + (o2 + 1)),
                        e2.appendChild(r),
                        i2.push(r)
                }
                this.holder.appendChild(e2), (this.dots = this.dots.concat(i2))
            }),
            (s.prototype.removeDots = function (t2) {
                this.dots
                    .splice(this.dots.length - t2, t2)
                    .forEach(function (t3) {
                        this.holder.removeChild(t3)
                    }, this)
            }),
            (s.prototype.updateSelected = function () {
                this.selectedDot &&
                    ((this.selectedDot.className = 'dot'),
                    this.selectedDot.removeAttribute('aria-current')),
                    this.dots.length &&
                        ((this.selectedDot =
                            this.dots[this.parent.selectedIndex]),
                        (this.selectedDot.className = 'dot is-selected'),
                        this.selectedDot.setAttribute('aria-current', 'step'))
            }),
            (s.prototype.onTap = s.prototype.onClick =
                function (t2) {
                    var e2 = t2.target
                    if (e2.nodeName == 'LI') {
                        this.parent.uiChange()
                        var i2 = this.dots.indexOf(e2)
                        this.parent.select(i2)
                    }
                }),
            (s.prototype.destroy = function () {
                this.deactivate(), this.allOff()
            }),
            (e.PageDots = s),
            n.extend(e.defaults, { pageDots: !0 }),
            e.createMethods.push('_createPageDots')
        var o = e.prototype
        return (
            (o._createPageDots = function () {
                this.options.pageDots &&
                    ((this.pageDots = new s(this)),
                    this.on('activate', this.activatePageDots),
                    this.on('select', this.updateSelectedPageDots),
                    this.on('cellChange', this.updatePageDots),
                    this.on('resize', this.updatePageDots),
                    this.on('deactivate', this.deactivatePageDots))
            }),
            (o.activatePageDots = function () {
                this.pageDots.activate()
            }),
            (o.updateSelectedPageDots = function () {
                this.pageDots.updateSelected()
            }),
            (o.updatePageDots = function () {
                this.pageDots.setDots()
            }),
            (o.deactivatePageDots = function () {
                this.pageDots.deactivate()
            }),
            (e.PageDots = s),
            e
        )
    }),
    (function (t, n) {
        typeof define == 'function' && define.amd
            ? define(
                  'flickity/js/player',
                  [
                      'ev-emitter/ev-emitter',
                      'fizzy-ui-utils/utils',
                      './flickity',
                  ],
                  function (t2, e, i) {
                      return n(t2, e, i)
                  }
              )
            : typeof module == 'object' && module.exports
            ? (module.exports = n(
                  require('ev-emitter'),
                  require('fizzy-ui-utils'),
                  require('./flickity')
              ))
            : n(t.EvEmitter, t.fizzyUIUtils, t.Flickity)
    })(window, function (t, e, i) {
        function n(t2) {
            ;(this.parent = t2),
                (this.state = 'stopped'),
                (this.onVisibilityChange = this.visibilityChange.bind(this)),
                (this.onVisibilityPlay = this.visibilityPlay.bind(this))
        }
        ;((n.prototype = Object.create(t.prototype)).play = function () {
            this.state != 'playing' &&
                (document.hidden
                    ? document.addEventListener(
                          'visibilitychange',
                          this.onVisibilityPlay
                      )
                    : ((this.state = 'playing'),
                      document.addEventListener(
                          'visibilitychange',
                          this.onVisibilityChange
                      ),
                      this.tick()))
        }),
            (n.prototype.tick = function () {
                if (this.state == 'playing') {
                    var t2 = this.parent.options.autoPlay
                    t2 = typeof t2 == 'number' ? t2 : 3e3
                    var e2 = this
                    this.clear(),
                        (this.timeout = setTimeout(function () {
                            e2.parent.next(!0), e2.tick()
                        }, t2))
                }
            }),
            (n.prototype.stop = function () {
                ;(this.state = 'stopped'),
                    this.clear(),
                    document.removeEventListener(
                        'visibilitychange',
                        this.onVisibilityChange
                    )
            }),
            (n.prototype.clear = function () {
                clearTimeout(this.timeout)
            }),
            (n.prototype.pause = function () {
                this.state == 'playing' &&
                    ((this.state = 'paused'), this.clear())
            }),
            (n.prototype.unpause = function () {
                this.state == 'paused' && this.play()
            }),
            (n.prototype.visibilityChange = function () {
                this[document.hidden ? 'pause' : 'unpause']()
            }),
            (n.prototype.visibilityPlay = function () {
                this.play(),
                    document.removeEventListener(
                        'visibilitychange',
                        this.onVisibilityPlay
                    )
            }),
            e.extend(i.defaults, { pauseAutoPlayOnHover: !0 }),
            i.createMethods.push('_createPlayer')
        var s = i.prototype
        return (
            (s._createPlayer = function () {
                ;(this.player = new n(this)),
                    this.on('activate', this.activatePlayer),
                    this.on('uiChange', this.stopPlayer),
                    this.on('pointerDown', this.stopPlayer),
                    this.on('deactivate', this.deactivatePlayer)
            }),
            (s.activatePlayer = function () {
                this.options.autoPlay &&
                    (this.player.play(),
                    this.element.addEventListener('mouseenter', this))
            }),
            (s.playPlayer = function () {
                this.player.play()
            }),
            (s.stopPlayer = function () {
                this.player.stop()
            }),
            (s.pausePlayer = function () {
                this.player.pause()
            }),
            (s.unpausePlayer = function () {
                this.player.unpause()
            }),
            (s.deactivatePlayer = function () {
                this.player.stop(),
                    this.element.removeEventListener('mouseenter', this)
            }),
            (s.onmouseenter = function () {
                this.options.pauseAutoPlayOnHover &&
                    (this.player.pause(),
                    this.element.addEventListener('mouseleave', this))
            }),
            (s.onmouseleave = function () {
                this.player.unpause(),
                    this.element.removeEventListener('mouseleave', this)
            }),
            (i.Player = n),
            i
        )
    }),
    (function (i, n) {
        typeof define == 'function' && define.amd
            ? define(
                  'flickity/js/add-remove-cell',
                  ['./flickity', 'fizzy-ui-utils/utils'],
                  function (t, e) {
                      return n(i, t, e)
                  }
              )
            : typeof module == 'object' && module.exports
            ? (module.exports = n(
                  i,
                  require('./flickity'),
                  require('fizzy-ui-utils')
              ))
            : n(i, i.Flickity, i.fizzyUIUtils)
    })(window, function (t, e, n) {
        var i = e.prototype
        return (
            (i.insert = function (t2, e2) {
                var i2 = this._makeCells(t2)
                if (i2 && i2.length) {
                    var n2 = this.cells.length
                    e2 = e2 === void 0 ? n2 : e2
                    var s,
                        o,
                        r =
                            ((s = i2),
                            (o = document.createDocumentFragment()),
                            s.forEach(function (t3) {
                                o.appendChild(t3.element)
                            }),
                            o),
                        a = e2 == n2
                    if (a) this.slider.appendChild(r)
                    else {
                        var l = this.cells[e2].element
                        this.slider.insertBefore(r, l)
                    }
                    if (e2 === 0) this.cells = i2.concat(this.cells)
                    else if (a) this.cells = this.cells.concat(i2)
                    else {
                        var h = this.cells.splice(e2, n2 - e2)
                        this.cells = this.cells.concat(i2).concat(h)
                    }
                    this._sizeCells(i2), this.cellChange(e2, !0)
                }
            }),
            (i.append = function (t2) {
                this.insert(t2, this.cells.length)
            }),
            (i.prepend = function (t2) {
                this.insert(t2, 0)
            }),
            (i.remove = function (t2) {
                var e2 = this.getCells(t2)
                if (e2 && e2.length) {
                    var i2 = this.cells.length - 1
                    e2.forEach(function (t3) {
                        t3.remove()
                        var e3 = this.cells.indexOf(t3)
                        ;(i2 = Math.min(e3, i2)), n.removeFrom(this.cells, t3)
                    }, this),
                        this.cellChange(i2, !0)
                }
            }),
            (i.cellSizeChange = function (t2) {
                var e2 = this.getCell(t2)
                if (e2) {
                    e2.getSize()
                    var i2 = this.cells.indexOf(e2)
                    this.cellChange(i2)
                }
            }),
            (i.cellChange = function (t2, e2) {
                var i2 = this.selectedElement
                this._positionCells(t2),
                    this._getWrapShiftCells(),
                    this.setGallerySize()
                var n2 = this.getCell(i2)
                n2 && (this.selectedIndex = this.getCellSlideIndex(n2)),
                    (this.selectedIndex = Math.min(
                        this.slides.length - 1,
                        this.selectedIndex
                    )),
                    this.emitEvent('cellChange', [t2]),
                    this.select(this.selectedIndex),
                    e2 && this.positionSliderAtSelected()
            }),
            e
        )
    }),
    (function (i, n) {
        typeof define == 'function' && define.amd
            ? define(
                  'flickity/js/lazyload',
                  ['./flickity', 'fizzy-ui-utils/utils'],
                  function (t, e) {
                      return n(i, t, e)
                  }
              )
            : typeof module == 'object' && module.exports
            ? (module.exports = n(
                  i,
                  require('./flickity'),
                  require('fizzy-ui-utils')
              ))
            : n(i, i.Flickity, i.fizzyUIUtils)
    })(window, function (t, e, o) {
        'use strict'
        e.createMethods.push('_createLazyload')
        var i = e.prototype
        function s(t2, e2) {
            ;(this.img = t2), (this.flickity = e2), this.load()
        }
        return (
            (i._createLazyload = function () {
                this.on('select', this.lazyLoad)
            }),
            (i.lazyLoad = function () {
                var t2 = this.options.lazyLoad
                if (t2) {
                    var e2 = typeof t2 == 'number' ? t2 : 0,
                        i2 = this.getAdjacentCellElements(e2),
                        n = []
                    i2.forEach(function (t3) {
                        var e3 = (function (t4) {
                            if (t4.nodeName == 'IMG') {
                                var e4 = t4.getAttribute(
                                        'data-flickity-lazyload'
                                    ),
                                    i3 = t4.getAttribute(
                                        'data-flickity-lazyload-src'
                                    ),
                                    n2 = t4.getAttribute(
                                        'data-flickity-lazyload-srcset'
                                    )
                                if (e4 || i3 || n2) return [t4]
                            }
                            var s2 = t4.querySelectorAll(
                                'img[data-flickity-lazyload], img[data-flickity-lazyload-src], img[data-flickity-lazyload-srcset]'
                            )
                            return o.makeArray(s2)
                        })(t3)
                        n = n.concat(e3)
                    }),
                        n.forEach(function (t3) {
                            new s(t3, this)
                        }, this)
                }
            }),
            (s.prototype.handleEvent = o.handleEvent),
            (s.prototype.load = function () {
                this.img.addEventListener('load', this),
                    this.img.addEventListener('error', this)
                var t2 =
                        this.img.getAttribute('data-flickity-lazyload') ||
                        this.img.getAttribute('data-flickity-lazyload-src'),
                    e2 = this.img.getAttribute('data-flickity-lazyload-srcset')
                ;(this.img.src = t2),
                    e2 && this.img.setAttribute('srcset', e2),
                    this.img.removeAttribute('data-flickity-lazyload'),
                    this.img.removeAttribute('data-flickity-lazyload-src'),
                    this.img.removeAttribute('data-flickity-lazyload-srcset')
            }),
            (s.prototype.onload = function (t2) {
                this.complete(t2, 'flickity-lazyloaded')
            }),
            (s.prototype.onerror = function (t2) {
                this.complete(t2, 'flickity-lazyerror')
            }),
            (s.prototype.complete = function (t2, e2) {
                this.img.removeEventListener('load', this),
                    this.img.removeEventListener('error', this)
                var i2 = this.flickity.getParentCell(this.img),
                    n = i2 && i2.element
                this.flickity.cellSizeChange(n),
                    this.img.classList.add(e2),
                    this.flickity.dispatchEvent('lazyLoad', t2, n)
            }),
            (e.LazyLoader = s),
            e
        )
    }),
    (function (t) {
        typeof define == 'function' && define.amd
            ? define(
                  'flickity/js/index',
                  [
                      './flickity',
                      './drag',
                      './prev-next-button',
                      './page-dots',
                      './player',
                      './add-remove-cell',
                      './lazyload',
                  ],
                  t
              )
            : typeof module == 'object' &&
              module.exports &&
              (module.exports = t(
                  require('./flickity'),
                  require('./drag'),
                  require('./prev-next-button'),
                  require('./page-dots'),
                  require('./player'),
                  require('./add-remove-cell'),
                  require('./lazyload')
              ))
    })(function (t) {
        return t
    }),
    (function (t, e) {
        typeof define == 'function' && define.amd
            ? define(
                  'flickity-as-nav-for/as-nav-for',
                  ['flickity/js/index', 'fizzy-ui-utils/utils'],
                  e
              )
            : typeof module == 'object' && module.exports
            ? (module.exports = e(
                  require('flickity'),
                  require('fizzy-ui-utils')
              ))
            : (t.Flickity = e(t.Flickity, t.fizzyUIUtils))
    })(window, function (n, s) {
        n.createMethods.push('_createAsNavFor')
        var t = n.prototype
        return (
            (t._createAsNavFor = function () {
                this.on('activate', this.activateAsNavFor),
                    this.on('deactivate', this.deactivateAsNavFor),
                    this.on('destroy', this.destroyAsNavFor)
                var t2 = this.options.asNavFor
                if (t2) {
                    var e = this
                    setTimeout(function () {
                        e.setNavCompanion(t2)
                    })
                }
            }),
            (t.setNavCompanion = function (t2) {
                t2 = s.getQueryElement(t2)
                var e = n.data(t2)
                if (e && e != this) {
                    this.navCompanion = e
                    var i = this
                    ;(this.onNavCompanionSelect = function () {
                        i.navCompanionSelect()
                    }),
                        e.on('select', this.onNavCompanionSelect),
                        this.on('staticClick', this.onNavStaticClick),
                        this.navCompanionSelect(!0)
                }
            }),
            (t.navCompanionSelect = function (t2) {
                var e = this.navCompanion && this.navCompanion.selectedCells
                if (e) {
                    var i,
                        n2,
                        s2,
                        o = e[0],
                        r = this.navCompanion.cells.indexOf(o),
                        a = r + e.length - 1,
                        l = Math.floor(
                            ((i = r),
                            (n2 = a),
                            (s2 = this.navCompanion.cellAlign),
                            (n2 - i) * s2 + i)
                        )
                    if (
                        (this.selectCell(l, !1, t2),
                        this.removeNavSelectedElements(),
                        !(l >= this.cells.length))
                    ) {
                        var h = this.cells.slice(r, 1 + a)
                        ;(this.navSelectedElements = h.map(function (t3) {
                            return t3.element
                        })),
                            this.changeNavSelectedClass('add')
                    }
                }
            }),
            (t.changeNavSelectedClass = function (e) {
                this.navSelectedElements.forEach(function (t2) {
                    t2.classList[e]('is-nav-selected')
                })
            }),
            (t.activateAsNavFor = function () {
                this.navCompanionSelect(!0)
            }),
            (t.removeNavSelectedElements = function () {
                this.navSelectedElements &&
                    (this.changeNavSelectedClass('remove'),
                    delete this.navSelectedElements)
            }),
            (t.onNavStaticClick = function (t2, e, i, n2) {
                typeof n2 == 'number' && this.navCompanion.selectCell(n2)
            }),
            (t.deactivateAsNavFor = function () {
                this.removeNavSelectedElements()
            }),
            (t.destroyAsNavFor = function () {
                this.navCompanion &&
                    (this.navCompanion.off('select', this.onNavCompanionSelect),
                    this.off('staticClick', this.onNavStaticClick),
                    delete this.navCompanion)
            }),
            n
        )
    }),
    (function (e, i) {
        'use strict'
        typeof define == 'function' && define.amd
            ? define(
                  'imagesloaded/imagesloaded',
                  ['ev-emitter/ev-emitter'],
                  function (t) {
                      return i(e, t)
                  }
              )
            : typeof module == 'object' && module.exports
            ? (module.exports = i(e, require('ev-emitter')))
            : (e.imagesLoaded = i(e, e.EvEmitter))
    })(typeof window < 'u' ? window : this, function (e, t) {
        var o = e.jQuery,
            r = e.console
        function a(t2, e2) {
            for (var i2 in e2) t2[i2] = e2[i2]
            return t2
        }
        var l = Array.prototype.slice
        function h(t2, e2, i2) {
            if (!(this instanceof h)) return new h(t2, e2, i2)
            var n2,
                s = t2
            typeof t2 == 'string' && (s = document.querySelectorAll(t2)),
                s
                    ? ((this.elements =
                          ((n2 = s),
                          Array.isArray(n2)
                              ? n2
                              : typeof n2 == 'object' &&
                                typeof n2.length == 'number'
                              ? l.call(n2)
                              : [n2])),
                      (this.options = a({}, this.options)),
                      typeof e2 == 'function' ? (i2 = e2) : a(this.options, e2),
                      i2 && this.on('always', i2),
                      this.getImages(),
                      o && (this.jqDeferred = new o.Deferred()),
                      setTimeout(this.check.bind(this)))
                    : r.error('Bad element for imagesLoaded ' + (s || t2))
        }
        ;((h.prototype = Object.create(t.prototype)).options = {}),
            (h.prototype.getImages = function () {
                ;(this.images = []),
                    this.elements.forEach(this.addElementImages, this)
            }),
            (h.prototype.addElementImages = function (t2) {
                t2.nodeName == 'IMG' && this.addImage(t2),
                    this.options.background === !0 &&
                        this.addElementBackgroundImages(t2)
                var e2 = t2.nodeType
                if (e2 && c[e2]) {
                    for (
                        var i2 = t2.querySelectorAll('img'), n2 = 0;
                        n2 < i2.length;
                        n2++
                    ) {
                        var s = i2[n2]
                        this.addImage(s)
                    }
                    if (typeof this.options.background == 'string') {
                        var o2 = t2.querySelectorAll(this.options.background)
                        for (n2 = 0; n2 < o2.length; n2++) {
                            var r2 = o2[n2]
                            this.addElementBackgroundImages(r2)
                        }
                    }
                }
            })
        var c = { 1: !0, 9: !0, 11: !0 }
        function i(t2) {
            this.img = t2
        }
        function n(t2, e2) {
            ;(this.url = t2), (this.element = e2), (this.img = new Image())
        }
        return (
            (h.prototype.addElementBackgroundImages = function (t2) {
                var e2 = getComputedStyle(t2)
                if (e2)
                    for (
                        var i2 = /url\((['"])?(.*?)\1\)/gi,
                            n2 = i2.exec(e2.backgroundImage);
                        n2 !== null;

                    ) {
                        var s = n2 && n2[2]
                        s && this.addBackground(s, t2),
                            (n2 = i2.exec(e2.backgroundImage))
                    }
            }),
            (h.prototype.addImage = function (t2) {
                var e2 = new i(t2)
                this.images.push(e2)
            }),
            (h.prototype.addBackground = function (t2, e2) {
                var i2 = new n(t2, e2)
                this.images.push(i2)
            }),
            (h.prototype.check = function () {
                var n2 = this
                function e2(t2, e3, i2) {
                    setTimeout(function () {
                        n2.progress(t2, e3, i2)
                    })
                }
                ;(this.progressedCount = 0),
                    (this.hasAnyBroken = !1),
                    this.images.length
                        ? this.images.forEach(function (t2) {
                              t2.once('progress', e2), t2.check()
                          })
                        : this.complete()
            }),
            (h.prototype.progress = function (t2, e2, i2) {
                this.progressedCount++,
                    (this.hasAnyBroken = this.hasAnyBroken || !t2.isLoaded),
                    this.emitEvent('progress', [this, t2, e2]),
                    this.jqDeferred &&
                        this.jqDeferred.notify &&
                        this.jqDeferred.notify(this, t2),
                    this.progressedCount == this.images.length &&
                        this.complete(),
                    this.options.debug && r && r.log('progress: ' + i2, t2, e2)
            }),
            (h.prototype.complete = function () {
                var t2 = this.hasAnyBroken ? 'fail' : 'done'
                if (
                    ((this.isComplete = !0),
                    this.emitEvent(t2, [this]),
                    this.emitEvent('always', [this]),
                    this.jqDeferred)
                ) {
                    var e2 = this.hasAnyBroken ? 'reject' : 'resolve'
                    this.jqDeferred[e2](this)
                }
            }),
            ((i.prototype = Object.create(t.prototype)).check = function () {
                this.getIsImageComplete()
                    ? this.confirm(this.img.naturalWidth !== 0, 'naturalWidth')
                    : ((this.proxyImage = new Image()),
                      this.proxyImage.addEventListener('load', this),
                      this.proxyImage.addEventListener('error', this),
                      this.img.addEventListener('load', this),
                      this.img.addEventListener('error', this),
                      (this.proxyImage.src = this.img.src))
            }),
            (i.prototype.getIsImageComplete = function () {
                return this.img.complete && this.img.naturalWidth
            }),
            (i.prototype.confirm = function (t2, e2) {
                ;(this.isLoaded = t2),
                    this.emitEvent('progress', [this, this.img, e2])
            }),
            (i.prototype.handleEvent = function (t2) {
                var e2 = 'on' + t2.type
                this[e2] && this[e2](t2)
            }),
            (i.prototype.onload = function () {
                this.confirm(!0, 'onload'), this.unbindEvents()
            }),
            (i.prototype.onerror = function () {
                this.confirm(!1, 'onerror'), this.unbindEvents()
            }),
            (i.prototype.unbindEvents = function () {
                this.proxyImage.removeEventListener('load', this),
                    this.proxyImage.removeEventListener('error', this),
                    this.img.removeEventListener('load', this),
                    this.img.removeEventListener('error', this)
            }),
            ((n.prototype = Object.create(i.prototype)).check = function () {
                this.img.addEventListener('load', this),
                    this.img.addEventListener('error', this),
                    (this.img.src = this.url),
                    this.getIsImageComplete() &&
                        (this.confirm(
                            this.img.naturalWidth !== 0,
                            'naturalWidth'
                        ),
                        this.unbindEvents())
            }),
            (n.prototype.unbindEvents = function () {
                this.img.removeEventListener('load', this),
                    this.img.removeEventListener('error', this)
            }),
            (n.prototype.confirm = function (t2, e2) {
                ;(this.isLoaded = t2),
                    this.emitEvent('progress', [this, this.element, e2])
            }),
            (h.makeJQueryPlugin = function (t2) {
                ;(t2 = t2 || e.jQuery) &&
                    ((o = t2).fn.imagesLoaded = function (t3, e2) {
                        return new h(this, t3, e2).jqDeferred.promise(o(this))
                    })
            })(),
            h
        )
    }),
    (function (i, n) {
        typeof define == 'function' && define.amd
            ? define(
                  ['flickity/js/index', 'imagesloaded/imagesloaded'],
                  function (t, e) {
                      return n(i, t, e)
                  }
              )
            : typeof module == 'object' && module.exports
            ? (module.exports = n(
                  i,
                  require('flickity'),
                  require('imagesloaded')
              ))
            : (i.Flickity = n(i, i.Flickity, i.imagesLoaded))
    })(window, function (t, e, i) {
        'use strict'
        e.createMethods.push('_createImagesLoaded')
        var n = e.prototype
        return (
            (n._createImagesLoaded = function () {
                this.on('activate', this.imagesLoaded)
            }),
            (n.imagesLoaded = function () {
                if (this.options.imagesLoaded) {
                    var n2 = this
                    i(this.slider).on('progress', function (t2, e2) {
                        var i2 = n2.getParentCell(e2.img)
                        n2.cellSizeChange(i2 && i2.element),
                            n2.options.freeScroll ||
                                n2.positionSliderAtSelected()
                    })
                }
            }),
            e
        )
    }),
    (function (i) {
        'use strict'
        typeof define == 'function' && define.amd
            ? define(['jquery'], i)
            : typeof exports < 'u'
            ? (module.exports = i(require('jquery')))
            : i(jQuery)
    })(function (i) {
        'use strict'
        var e = window.Slick || {}
        ;(e = (function () {
            function e2(e3, o) {
                var s,
                    n = this
                ;(n.defaults = {
                    accessibility: !0,
                    adaptiveHeight: !1,
                    appendArrows: i(e3),
                    appendDots: i(e3),
                    arrows: !0,
                    asNavFor: null,
                    prevArrow:
                        '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
                    nextArrow:
                        '<button class="slick-next" aria-label="Next" type="button">Next</button>',
                    autoplay: !1,
                    autoplaySpeed: 3e3,
                    centerMode: !1,
                    centerPadding: '50px',
                    cssEase: 'ease',
                    customPaging: function (e4, t2) {
                        return i('<button type="button" />').text(t2 + 1)
                    },
                    dots: !1,
                    dotsClass: 'slick-dots',
                    draggable: !0,
                    easing: 'linear',
                    edgeFriction: 0.35,
                    fade: !1,
                    focusOnSelect: !1,
                    focusOnChange: !1,
                    infinite: !0,
                    initialSlide: 0,
                    lazyLoad: 'ondemand',
                    mobileFirst: !1,
                    pauseOnHover: !0,
                    pauseOnFocus: !0,
                    pauseOnDotsHover: !1,
                    respondTo: 'window',
                    responsive: null,
                    rows: 1,
                    rtl: !1,
                    slide: '',
                    slidesPerRow: 1,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    speed: 500,
                    swipe: !0,
                    swipeToSlide: !1,
                    touchMove: !0,
                    touchThreshold: 5,
                    useCSS: !0,
                    useTransform: !0,
                    variableWidth: !1,
                    vertical: !1,
                    verticalSwiping: !1,
                    waitForAnimate: !0,
                    zIndex: 1e3,
                }),
                    (n.initials = {
                        animating: !1,
                        dragging: !1,
                        autoPlayTimer: null,
                        currentDirection: 0,
                        currentLeft: null,
                        currentSlide: 0,
                        direction: 1,
                        $dots: null,
                        listWidth: null,
                        listHeight: null,
                        loadIndex: 0,
                        $nextArrow: null,
                        $prevArrow: null,
                        scrolling: !1,
                        slideCount: null,
                        slideWidth: null,
                        $slideTrack: null,
                        $slides: null,
                        sliding: !1,
                        slideOffset: 0,
                        swipeLeft: null,
                        swiping: !1,
                        $list: null,
                        touchObject: {},
                        transformsEnabled: !1,
                        unslicked: !1,
                    }),
                    i.extend(n, n.initials),
                    (n.activeBreakpoint = null),
                    (n.animType = null),
                    (n.animProp = null),
                    (n.breakpoints = []),
                    (n.breakpointSettings = []),
                    (n.cssTransitions = !1),
                    (n.focussed = !1),
                    (n.interrupted = !1),
                    (n.hidden = 'hidden'),
                    (n.paused = !0),
                    (n.positionProp = null),
                    (n.respondTo = null),
                    (n.rowCount = 1),
                    (n.shouldClick = !0),
                    (n.$slider = i(e3)),
                    (n.$slidesCache = null),
                    (n.transformType = null),
                    (n.transitionType = null),
                    (n.visibilityChange = 'visibilitychange'),
                    (n.windowWidth = 0),
                    (n.windowTimer = null),
                    (s = i(e3).data('slick') || {}),
                    (n.options = i.extend({}, n.defaults, o, s)),
                    (n.currentSlide = n.options.initialSlide),
                    (n.originalSettings = n.options),
                    typeof document.mozHidden < 'u'
                        ? ((n.hidden = 'mozHidden'),
                          (n.visibilityChange = 'mozvisibilitychange'))
                        : typeof document.webkitHidden < 'u' &&
                          ((n.hidden = 'webkitHidden'),
                          (n.visibilityChange = 'webkitvisibilitychange')),
                    (n.autoPlay = i.proxy(n.autoPlay, n)),
                    (n.autoPlayClear = i.proxy(n.autoPlayClear, n)),
                    (n.autoPlayIterator = i.proxy(n.autoPlayIterator, n)),
                    (n.changeSlide = i.proxy(n.changeSlide, n)),
                    (n.clickHandler = i.proxy(n.clickHandler, n)),
                    (n.selectHandler = i.proxy(n.selectHandler, n)),
                    (n.setPosition = i.proxy(n.setPosition, n)),
                    (n.swipeHandler = i.proxy(n.swipeHandler, n)),
                    (n.dragHandler = i.proxy(n.dragHandler, n)),
                    (n.keyHandler = i.proxy(n.keyHandler, n)),
                    (n.instanceUid = t++),
                    (n.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/),
                    n.registerBreakpoints(),
                    n.init(!0)
            }
            var t = 0
            return e2
        })()),
            (e.prototype.activateADA = function () {
                var i2 = this
                i2.$slideTrack
                    .find('.slick-active')
                    .attr({ 'aria-hidden': 'false' })
                    .find('a, input, button, select')
                    .attr({ tabindex: '0' })
            }),
            (e.prototype.addSlide = e.prototype.slickAdd =
                function (e2, t, o) {
                    var s = this
                    if (typeof t == 'boolean') (o = t), (t = null)
                    else if (t < 0 || t >= s.slideCount) return !1
                    s.unload(),
                        typeof t == 'number'
                            ? t === 0 && s.$slides.length === 0
                                ? i(e2).appendTo(s.$slideTrack)
                                : o
                                ? i(e2).insertBefore(s.$slides.eq(t))
                                : i(e2).insertAfter(s.$slides.eq(t))
                            : o === !0
                            ? i(e2).prependTo(s.$slideTrack)
                            : i(e2).appendTo(s.$slideTrack),
                        (s.$slides = s.$slideTrack.children(
                            this.options.slide
                        )),
                        s.$slideTrack.children(this.options.slide).detach(),
                        s.$slideTrack.append(s.$slides),
                        s.$slides.each(function (e3, t2) {
                            i(t2).attr('data-slick-index', e3)
                        }),
                        (s.$slidesCache = s.$slides),
                        s.reinit()
                }),
            (e.prototype.animateHeight = function () {
                var i2 = this
                if (
                    i2.options.slidesToShow === 1 &&
                    i2.options.adaptiveHeight === !0 &&
                    i2.options.vertical === !1
                ) {
                    var e2 = i2.$slides.eq(i2.currentSlide).outerHeight(!0)
                    i2.$list.animate({ height: e2 }, i2.options.speed)
                }
            }),
            (e.prototype.animateSlide = function (e2, t) {
                var o = {},
                    s = this
                s.animateHeight(),
                    s.options.rtl === !0 &&
                        s.options.vertical === !1 &&
                        (e2 = -e2),
                    s.transformsEnabled === !1
                        ? s.options.vertical === !1
                            ? s.$slideTrack.animate(
                                  { left: e2 },
                                  s.options.speed,
                                  s.options.easing,
                                  t
                              )
                            : s.$slideTrack.animate(
                                  { top: e2 },
                                  s.options.speed,
                                  s.options.easing,
                                  t
                              )
                        : s.cssTransitions === !1
                        ? (s.options.rtl === !0 &&
                              (s.currentLeft = -s.currentLeft),
                          i({ animStart: s.currentLeft }).animate(
                              { animStart: e2 },
                              {
                                  duration: s.options.speed,
                                  easing: s.options.easing,
                                  step: function (i2) {
                                      ;(i2 = Math.ceil(i2)),
                                          s.options.vertical === !1
                                              ? ((o[s.animType] =
                                                    'translate(' +
                                                    i2 +
                                                    'px, 0px)'),
                                                s.$slideTrack.css(o))
                                              : ((o[s.animType] =
                                                    'translate(0px,' +
                                                    i2 +
                                                    'px)'),
                                                s.$slideTrack.css(o))
                                  },
                                  complete: function () {
                                      t && t.call()
                                  },
                              }
                          ))
                        : (s.applyTransition(),
                          (e2 = Math.ceil(e2)),
                          s.options.vertical === !1
                              ? (o[s.animType] =
                                    'translate3d(' + e2 + 'px, 0px, 0px)')
                              : (o[s.animType] =
                                    'translate3d(0px,' + e2 + 'px, 0px)'),
                          s.$slideTrack.css(o),
                          t &&
                              setTimeout(function () {
                                  s.disableTransition(), t.call()
                              }, s.options.speed))
            }),
            (e.prototype.getNavTarget = function () {
                var e2 = this,
                    t = e2.options.asNavFor
                return t && t !== null && (t = i(t).not(e2.$slider)), t
            }),
            (e.prototype.asNavFor = function (e2) {
                var t = this,
                    o = t.getNavTarget()
                o !== null &&
                    typeof o == 'object' &&
                    o.each(function () {
                        var t2 = i(this).slick('getSlick')
                        t2.unslicked || t2.slideHandler(e2, !0)
                    })
            }),
            (e.prototype.applyTransition = function (i2) {
                var e2 = this,
                    t = {}
                e2.options.fade === !1
                    ? (t[e2.transitionType] =
                          e2.transformType +
                          ' ' +
                          e2.options.speed +
                          'ms ' +
                          e2.options.cssEase)
                    : (t[e2.transitionType] =
                          'opacity ' +
                          e2.options.speed +
                          'ms ' +
                          e2.options.cssEase),
                    e2.options.fade === !1
                        ? e2.$slideTrack.css(t)
                        : e2.$slides.eq(i2).css(t)
            }),
            (e.prototype.autoPlay = function () {
                var i2 = this
                i2.autoPlayClear(),
                    i2.slideCount > i2.options.slidesToShow &&
                        (i2.autoPlayTimer = setInterval(
                            i2.autoPlayIterator,
                            i2.options.autoplaySpeed
                        ))
            }),
            (e.prototype.autoPlayClear = function () {
                var i2 = this
                i2.autoPlayTimer && clearInterval(i2.autoPlayTimer)
            }),
            (e.prototype.autoPlayIterator = function () {
                var i2 = this,
                    e2 = i2.currentSlide + i2.options.slidesToScroll
                i2.paused ||
                    i2.interrupted ||
                    i2.focussed ||
                    (i2.options.infinite === !1 &&
                        (i2.direction === 1 &&
                        i2.currentSlide + 1 === i2.slideCount - 1
                            ? (i2.direction = 0)
                            : i2.direction === 0 &&
                              ((e2 =
                                  i2.currentSlide - i2.options.slidesToScroll),
                              i2.currentSlide - 1 === 0 && (i2.direction = 1))),
                    i2.slideHandler(e2))
            }),
            (e.prototype.buildArrows = function () {
                var e2 = this
                e2.options.arrows === !0 &&
                    ((e2.$prevArrow = i(e2.options.prevArrow).addClass(
                        'slick-arrow'
                    )),
                    (e2.$nextArrow = i(e2.options.nextArrow).addClass(
                        'slick-arrow'
                    )),
                    e2.slideCount > e2.options.slidesToShow
                        ? (e2.$prevArrow
                              .removeClass('slick-hidden')
                              .removeAttr('aria-hidden tabindex'),
                          e2.$nextArrow
                              .removeClass('slick-hidden')
                              .removeAttr('aria-hidden tabindex'),
                          e2.htmlExpr.test(e2.options.prevArrow) &&
                              e2.$prevArrow.prependTo(e2.options.appendArrows),
                          e2.htmlExpr.test(e2.options.nextArrow) &&
                              e2.$nextArrow.appendTo(e2.options.appendArrows),
                          e2.options.infinite !== !0 &&
                              e2.$prevArrow
                                  .addClass('slick-disabled')
                                  .attr('aria-disabled', 'true'))
                        : e2.$prevArrow
                              .add(e2.$nextArrow)
                              .addClass('slick-hidden')
                              .attr({
                                  'aria-disabled': 'true',
                                  tabindex: '-1',
                              }))
            }),
            (e.prototype.buildDots = function () {
                var e2,
                    t,
                    o = this
                if (
                    o.options.dots === !0 &&
                    o.slideCount > o.options.slidesToShow
                ) {
                    for (
                        o.$slider.addClass('slick-dotted'),
                            t = i('<ul />').addClass(o.options.dotsClass),
                            e2 = 0;
                        e2 <= o.getDotCount();
                        e2 += 1
                    )
                        t.append(
                            i('<li />').append(
                                o.options.customPaging.call(this, o, e2)
                            )
                        )
                    ;(o.$dots = t.appendTo(o.options.appendDots)),
                        o.$dots.find('li').first().addClass('slick-active')
                }
            }),
            (e.prototype.buildOut = function () {
                var e2 = this
                ;(e2.$slides = e2.$slider
                    .children(e2.options.slide + ':not(.slick-cloned)')
                    .addClass('slick-slide')),
                    (e2.slideCount = e2.$slides.length),
                    e2.$slides.each(function (e3, t) {
                        i(t)
                            .attr('data-slick-index', e3)
                            .data('originalStyling', i(t).attr('style') || '')
                    }),
                    e2.$slider.addClass('slick-slider'),
                    (e2.$slideTrack =
                        e2.slideCount === 0
                            ? i('<div class="slick-track"/>').appendTo(
                                  e2.$slider
                              )
                            : e2.$slides
                                  .wrapAll('<div class="slick-track"/>')
                                  .parent()),
                    (e2.$list = e2.$slideTrack
                        .wrap('<div class="slick-list"/>')
                        .parent()),
                    e2.$slideTrack.css('opacity', 0),
                    (e2.options.centerMode !== !0 &&
                        e2.options.swipeToSlide !== !0) ||
                        (e2.options.slidesToScroll = 1),
                    i('img[data-lazy]', e2.$slider)
                        .not('[src]')
                        .addClass('slick-loading'),
                    e2.setupInfinite(),
                    e2.buildArrows(),
                    e2.buildDots(),
                    e2.updateDots(),
                    e2.setSlideClasses(
                        typeof e2.currentSlide == 'number' ? e2.currentSlide : 0
                    ),
                    e2.options.draggable === !0 &&
                        e2.$list.addClass('draggable')
            }),
            (e.prototype.buildRows = function () {
                var i2,
                    e2,
                    t,
                    o,
                    s,
                    n,
                    r,
                    l = this
                if (
                    ((o = document.createDocumentFragment()),
                    (n = l.$slider.children()),
                    l.options.rows > 0)
                ) {
                    for (
                        r = l.options.slidesPerRow * l.options.rows,
                            s = Math.ceil(n.length / r),
                            i2 = 0;
                        i2 < s;
                        i2++
                    ) {
                        var d = document.createElement('div')
                        for (e2 = 0; e2 < l.options.rows; e2++) {
                            var a = document.createElement('div')
                            for (t = 0; t < l.options.slidesPerRow; t++) {
                                var c =
                                    i2 * r + (e2 * l.options.slidesPerRow + t)
                                n.get(c) && a.appendChild(n.get(c))
                            }
                            d.appendChild(a)
                        }
                        o.appendChild(d)
                    }
                    l.$slider.empty().append(o),
                        l.$slider
                            .children()
                            .children()
                            .children()
                            .css({
                                width: 100 / l.options.slidesPerRow + '%',
                                display: 'inline-block',
                            })
                }
            }),
            (e.prototype.checkResponsive = function (e2, t) {
                var o,
                    s,
                    n,
                    r = this,
                    l = !1,
                    d = r.$slider.width(),
                    a = window.innerWidth || i(window).width()
                if (
                    (r.respondTo === 'window'
                        ? (n = a)
                        : r.respondTo === 'slider'
                        ? (n = d)
                        : r.respondTo === 'min' && (n = Math.min(a, d)),
                    r.options.responsive &&
                        r.options.responsive.length &&
                        r.options.responsive !== null)
                ) {
                    s = null
                    for (o in r.breakpoints)
                        r.breakpoints.hasOwnProperty(o) &&
                            (r.originalSettings.mobileFirst === !1
                                ? n < r.breakpoints[o] && (s = r.breakpoints[o])
                                : n > r.breakpoints[o] &&
                                  (s = r.breakpoints[o]))
                    s !== null
                        ? r.activeBreakpoint !== null
                            ? (s !== r.activeBreakpoint || t) &&
                              ((r.activeBreakpoint = s),
                              r.breakpointSettings[s] === 'unslick'
                                  ? r.unslick(s)
                                  : ((r.options = i.extend(
                                        {},
                                        r.originalSettings,
                                        r.breakpointSettings[s]
                                    )),
                                    e2 === !0 &&
                                        (r.currentSlide =
                                            r.options.initialSlide),
                                    r.refresh(e2)),
                              (l = s))
                            : ((r.activeBreakpoint = s),
                              r.breakpointSettings[s] === 'unslick'
                                  ? r.unslick(s)
                                  : ((r.options = i.extend(
                                        {},
                                        r.originalSettings,
                                        r.breakpointSettings[s]
                                    )),
                                    e2 === !0 &&
                                        (r.currentSlide =
                                            r.options.initialSlide),
                                    r.refresh(e2)),
                              (l = s))
                        : r.activeBreakpoint !== null &&
                          ((r.activeBreakpoint = null),
                          (r.options = r.originalSettings),
                          e2 === !0 &&
                              (r.currentSlide = r.options.initialSlide),
                          r.refresh(e2),
                          (l = s)),
                        e2 ||
                            l === !1 ||
                            r.$slider.trigger('breakpoint', [r, l])
                }
            }),
            (e.prototype.changeSlide = function (e2, t) {
                var o,
                    s,
                    n,
                    r = this,
                    l = i(e2.currentTarget)
                switch (
                    (l.is('a') && e2.preventDefault(),
                    l.is('li') || (l = l.closest('li')),
                    (n = r.slideCount % r.options.slidesToScroll !== 0),
                    (o = n
                        ? 0
                        : (r.slideCount - r.currentSlide) %
                          r.options.slidesToScroll),
                    e2.data.message)
                ) {
                    case 'previous':
                        ;(s =
                            o === 0
                                ? r.options.slidesToScroll
                                : r.options.slidesToShow - o),
                            r.slideCount > r.options.slidesToShow &&
                                r.slideHandler(r.currentSlide - s, !1, t)
                        break
                    case 'next':
                        ;(s = o === 0 ? r.options.slidesToScroll : o),
                            r.slideCount > r.options.slidesToShow &&
                                r.slideHandler(r.currentSlide + s, !1, t)
                        break
                    case 'index':
                        var d =
                            e2.data.index === 0
                                ? 0
                                : e2.data.index ||
                                  l.index() * r.options.slidesToScroll
                        r.slideHandler(r.checkNavigable(d), !1, t),
                            l.children().trigger('focus')
                        break
                    default:
                        return
                }
            }),
            (e.prototype.checkNavigable = function (i2) {
                var e2,
                    t,
                    o = this
                if (
                    ((e2 = o.getNavigableIndexes()),
                    (t = 0),
                    i2 > e2[e2.length - 1])
                )
                    i2 = e2[e2.length - 1]
                else
                    for (var s in e2) {
                        if (i2 < e2[s]) {
                            i2 = t
                            break
                        }
                        t = e2[s]
                    }
                return i2
            }),
            (e.prototype.cleanUpEvents = function () {
                var e2 = this
                e2.options.dots &&
                    e2.$dots !== null &&
                    (i('li', e2.$dots)
                        .off('click.slick', e2.changeSlide)
                        .off('mouseenter.slick', i.proxy(e2.interrupt, e2, !0))
                        .off('mouseleave.slick', i.proxy(e2.interrupt, e2, !1)),
                    e2.options.accessibility === !0 &&
                        e2.$dots.off('keydown.slick', e2.keyHandler)),
                    e2.$slider.off('focus.slick blur.slick'),
                    e2.options.arrows === !0 &&
                        e2.slideCount > e2.options.slidesToShow &&
                        (e2.$prevArrow &&
                            e2.$prevArrow.off('click.slick', e2.changeSlide),
                        e2.$nextArrow &&
                            e2.$nextArrow.off('click.slick', e2.changeSlide),
                        e2.options.accessibility === !0 &&
                            (e2.$prevArrow &&
                                e2.$prevArrow.off(
                                    'keydown.slick',
                                    e2.keyHandler
                                ),
                            e2.$nextArrow &&
                                e2.$nextArrow.off(
                                    'keydown.slick',
                                    e2.keyHandler
                                ))),
                    e2.$list.off(
                        'touchstart.slick mousedown.slick',
                        e2.swipeHandler
                    ),
                    e2.$list.off(
                        'touchmove.slick mousemove.slick',
                        e2.swipeHandler
                    ),
                    e2.$list.off(
                        'touchend.slick mouseup.slick',
                        e2.swipeHandler
                    ),
                    e2.$list.off(
                        'touchcancel.slick mouseleave.slick',
                        e2.swipeHandler
                    ),
                    e2.$list.off('click.slick', e2.clickHandler),
                    i(document).off(e2.visibilityChange, e2.visibility),
                    e2.cleanUpSlideEvents(),
                    e2.options.accessibility === !0 &&
                        e2.$list.off('keydown.slick', e2.keyHandler),
                    e2.options.focusOnSelect === !0 &&
                        i(e2.$slideTrack)
                            .children()
                            .off('click.slick', e2.selectHandler),
                    i(window).off(
                        'orientationchange.slick.slick-' + e2.instanceUid,
                        e2.orientationChange
                    ),
                    i(window).off(
                        'resize.slick.slick-' + e2.instanceUid,
                        e2.resize
                    ),
                    i('[draggable!=true]', e2.$slideTrack).off(
                        'dragstart',
                        e2.preventDefault
                    ),
                    i(window).off(
                        'load.slick.slick-' + e2.instanceUid,
                        e2.setPosition
                    )
            }),
            (e.prototype.cleanUpSlideEvents = function () {
                var e2 = this
                e2.$list.off('mouseenter.slick', i.proxy(e2.interrupt, e2, !0)),
                    e2.$list.off(
                        'mouseleave.slick',
                        i.proxy(e2.interrupt, e2, !1)
                    )
            }),
            (e.prototype.cleanUpRows = function () {
                var i2,
                    e2 = this
                e2.options.rows > 0 &&
                    ((i2 = e2.$slides.children().children()),
                    i2.removeAttr('style'),
                    e2.$slider.empty().append(i2))
            }),
            (e.prototype.clickHandler = function (i2) {
                var e2 = this
                e2.shouldClick === !1 &&
                    (i2.stopImmediatePropagation(),
                    i2.stopPropagation(),
                    i2.preventDefault())
            }),
            (e.prototype.destroy = function (e2) {
                var t = this
                t.autoPlayClear(),
                    (t.touchObject = {}),
                    t.cleanUpEvents(),
                    i('.slick-cloned', t.$slider).detach(),
                    t.$dots && t.$dots.remove(),
                    t.$prevArrow &&
                        t.$prevArrow.length &&
                        (t.$prevArrow
                            .removeClass(
                                'slick-disabled slick-arrow slick-hidden'
                            )
                            .removeAttr('aria-hidden aria-disabled tabindex')
                            .css('display', ''),
                        t.htmlExpr.test(t.options.prevArrow) &&
                            t.$prevArrow.remove()),
                    t.$nextArrow &&
                        t.$nextArrow.length &&
                        (t.$nextArrow
                            .removeClass(
                                'slick-disabled slick-arrow slick-hidden'
                            )
                            .removeAttr('aria-hidden aria-disabled tabindex')
                            .css('display', ''),
                        t.htmlExpr.test(t.options.nextArrow) &&
                            t.$nextArrow.remove()),
                    t.$slides &&
                        (t.$slides
                            .removeClass(
                                'slick-slide slick-active slick-center slick-visible slick-current'
                            )
                            .removeAttr('aria-hidden')
                            .removeAttr('data-slick-index')
                            .each(function () {
                                i(this).attr(
                                    'style',
                                    i(this).data('originalStyling')
                                )
                            }),
                        t.$slideTrack.children(this.options.slide).detach(),
                        t.$slideTrack.detach(),
                        t.$list.detach(),
                        t.$slider.append(t.$slides)),
                    t.cleanUpRows(),
                    t.$slider.removeClass('slick-slider'),
                    t.$slider.removeClass('slick-initialized'),
                    t.$slider.removeClass('slick-dotted'),
                    (t.unslicked = !0),
                    e2 || t.$slider.trigger('destroy', [t])
            }),
            (e.prototype.disableTransition = function (i2) {
                var e2 = this,
                    t = {}
                ;(t[e2.transitionType] = ''),
                    e2.options.fade === !1
                        ? e2.$slideTrack.css(t)
                        : e2.$slides.eq(i2).css(t)
            }),
            (e.prototype.fadeSlide = function (i2, e2) {
                var t = this
                t.cssTransitions === !1
                    ? (t.$slides.eq(i2).css({ zIndex: t.options.zIndex }),
                      t.$slides
                          .eq(i2)
                          .animate(
                              { opacity: 1 },
                              t.options.speed,
                              t.options.easing,
                              e2
                          ))
                    : (t.applyTransition(i2),
                      t.$slides
                          .eq(i2)
                          .css({ opacity: 1, zIndex: t.options.zIndex }),
                      e2 &&
                          setTimeout(function () {
                              t.disableTransition(i2), e2.call()
                          }, t.options.speed))
            }),
            (e.prototype.fadeSlideOut = function (i2) {
                var e2 = this
                e2.cssTransitions === !1
                    ? e2.$slides
                          .eq(i2)
                          .animate(
                              { opacity: 0, zIndex: e2.options.zIndex - 2 },
                              e2.options.speed,
                              e2.options.easing
                          )
                    : (e2.applyTransition(i2),
                      e2.$slides
                          .eq(i2)
                          .css({ opacity: 0, zIndex: e2.options.zIndex - 2 }))
            }),
            (e.prototype.filterSlides = e.prototype.slickFilter =
                function (i2) {
                    var e2 = this
                    i2 !== null &&
                        ((e2.$slidesCache = e2.$slides),
                        e2.unload(),
                        e2.$slideTrack.children(this.options.slide).detach(),
                        e2.$slidesCache.filter(i2).appendTo(e2.$slideTrack),
                        e2.reinit())
                }),
            (e.prototype.focusHandler = function () {
                var e2 = this
                e2.$slider
                    .off('focus.slick blur.slick')
                    .on('focus.slick', '*', function (t) {
                        var o = i(this)
                        setTimeout(function () {
                            e2.options.pauseOnFocus &&
                                o.is(':focus') &&
                                ((e2.focussed = !0), e2.autoPlay())
                        }, 0)
                    })
                    .on('blur.slick', '*', function (t) {
                        i(this),
                            e2.options.pauseOnFocus &&
                                ((e2.focussed = !1), e2.autoPlay())
                    })
            }),
            (e.prototype.getCurrent = e.prototype.slickCurrentSlide =
                function () {
                    var i2 = this
                    return i2.currentSlide
                }),
            (e.prototype.getDotCount = function () {
                var i2 = this,
                    e2 = 0,
                    t = 0,
                    o = 0
                if (i2.options.infinite === !0)
                    if (i2.slideCount <= i2.options.slidesToShow) ++o
                    else
                        for (; e2 < i2.slideCount; )
                            ++o,
                                (e2 = t + i2.options.slidesToScroll),
                                (t +=
                                    i2.options.slidesToScroll <=
                                    i2.options.slidesToShow
                                        ? i2.options.slidesToScroll
                                        : i2.options.slidesToShow)
                else if (i2.options.centerMode === !0) o = i2.slideCount
                else if (i2.options.asNavFor)
                    for (; e2 < i2.slideCount; )
                        ++o,
                            (e2 = t + i2.options.slidesToScroll),
                            (t +=
                                i2.options.slidesToScroll <=
                                i2.options.slidesToShow
                                    ? i2.options.slidesToScroll
                                    : i2.options.slidesToShow)
                else
                    o =
                        1 +
                        Math.ceil(
                            (i2.slideCount - i2.options.slidesToShow) /
                                i2.options.slidesToScroll
                        )
                return o - 1
            }),
            (e.prototype.getLeft = function (i2) {
                var e2,
                    t,
                    o,
                    s,
                    n = this,
                    r = 0
                return (
                    (n.slideOffset = 0),
                    (t = n.$slides.first().outerHeight(!0)),
                    n.options.infinite === !0
                        ? (n.slideCount > n.options.slidesToShow &&
                              ((n.slideOffset =
                                  n.slideWidth * n.options.slidesToShow * -1),
                              (s = -1),
                              n.options.vertical === !0 &&
                                  n.options.centerMode === !0 &&
                                  (n.options.slidesToShow === 2
                                      ? (s = -1.5)
                                      : n.options.slidesToShow === 1 &&
                                        (s = -2)),
                              (r = t * n.options.slidesToShow * s)),
                          n.slideCount % n.options.slidesToScroll !== 0 &&
                              i2 + n.options.slidesToScroll > n.slideCount &&
                              n.slideCount > n.options.slidesToShow &&
                              (i2 > n.slideCount
                                  ? ((n.slideOffset =
                                        (n.options.slidesToShow -
                                            (i2 - n.slideCount)) *
                                        n.slideWidth *
                                        -1),
                                    (r =
                                        (n.options.slidesToShow -
                                            (i2 - n.slideCount)) *
                                        t *
                                        -1))
                                  : ((n.slideOffset =
                                        (n.slideCount %
                                            n.options.slidesToScroll) *
                                        n.slideWidth *
                                        -1),
                                    (r =
                                        (n.slideCount %
                                            n.options.slidesToScroll) *
                                        t *
                                        -1))))
                        : i2 + n.options.slidesToShow > n.slideCount &&
                          ((n.slideOffset =
                              (i2 + n.options.slidesToShow - n.slideCount) *
                              n.slideWidth),
                          (r =
                              (i2 + n.options.slidesToShow - n.slideCount) *
                              t)),
                    n.slideCount <= n.options.slidesToShow &&
                        ((n.slideOffset = 0), (r = 0)),
                    n.options.centerMode === !0 &&
                    n.slideCount <= n.options.slidesToShow
                        ? (n.slideOffset =
                              (n.slideWidth *
                                  Math.floor(n.options.slidesToShow)) /
                                  2 -
                              (n.slideWidth * n.slideCount) / 2)
                        : n.options.centerMode === !0 &&
                          n.options.infinite === !0
                        ? (n.slideOffset +=
                              n.slideWidth *
                                  Math.floor(n.options.slidesToShow / 2) -
                              n.slideWidth)
                        : n.options.centerMode === !0 &&
                          ((n.slideOffset = 0),
                          (n.slideOffset +=
                              n.slideWidth *
                              Math.floor(n.options.slidesToShow / 2))),
                    (e2 =
                        n.options.vertical === !1
                            ? i2 * n.slideWidth * -1 + n.slideOffset
                            : i2 * t * -1 + r),
                    n.options.variableWidth === !0 &&
                        ((o =
                            n.slideCount <= n.options.slidesToShow ||
                            n.options.infinite === !1
                                ? n.$slideTrack.children('.slick-slide').eq(i2)
                                : n.$slideTrack
                                      .children('.slick-slide')
                                      .eq(i2 + n.options.slidesToShow)),
                        (e2 =
                            n.options.rtl === !0
                                ? o[0]
                                    ? (n.$slideTrack.width() -
                                          o[0].offsetLeft -
                                          o.width()) *
                                      -1
                                    : 0
                                : o[0]
                                ? o[0].offsetLeft * -1
                                : 0),
                        n.options.centerMode === !0 &&
                            ((o =
                                n.slideCount <= n.options.slidesToShow ||
                                n.options.infinite === !1
                                    ? n.$slideTrack
                                          .children('.slick-slide')
                                          .eq(i2)
                                    : n.$slideTrack
                                          .children('.slick-slide')
                                          .eq(i2 + n.options.slidesToShow + 1)),
                            (e2 =
                                n.options.rtl === !0
                                    ? o[0]
                                        ? (n.$slideTrack.width() -
                                              o[0].offsetLeft -
                                              o.width()) *
                                          -1
                                        : 0
                                    : o[0]
                                    ? o[0].offsetLeft * -1
                                    : 0),
                            (e2 += (n.$list.width() - o.outerWidth()) / 2))),
                    e2
                )
            }),
            (e.prototype.getOption = e.prototype.slickGetOption =
                function (i2) {
                    var e2 = this
                    return e2.options[i2]
                }),
            (e.prototype.getNavigableIndexes = function () {
                var i2,
                    e2 = this,
                    t = 0,
                    o = 0,
                    s = []
                for (
                    e2.options.infinite === !1
                        ? (i2 = e2.slideCount)
                        : ((t = e2.options.slidesToScroll * -1),
                          (o = e2.options.slidesToScroll * -1),
                          (i2 = 2 * e2.slideCount));
                    t < i2;

                )
                    s.push(t),
                        (t = o + e2.options.slidesToScroll),
                        (o +=
                            e2.options.slidesToScroll <= e2.options.slidesToShow
                                ? e2.options.slidesToScroll
                                : e2.options.slidesToShow)
                return s
            }),
            (e.prototype.getSlick = function () {
                return this
            }),
            (e.prototype.getSlideCount = function () {
                var e2,
                    t,
                    o,
                    s,
                    n = this
                return (
                    (s =
                        n.options.centerMode === !0
                            ? Math.floor(n.$list.width() / 2)
                            : 0),
                    (o = n.swipeLeft * -1 + s),
                    n.options.swipeToSlide === !0
                        ? (n.$slideTrack
                              .find('.slick-slide')
                              .each(function (e3, s2) {
                                  var r, l, d
                                  if (
                                      ((r = i(s2).outerWidth()),
                                      (l = s2.offsetLeft),
                                      n.options.centerMode !== !0 &&
                                          (l += r / 2),
                                      (d = l + r),
                                      o < d)
                                  )
                                      return (t = s2), !1
                              }),
                          (e2 =
                              Math.abs(
                                  i(t).attr('data-slick-index') - n.currentSlide
                              ) || 1))
                        : n.options.slidesToScroll
                )
            }),
            (e.prototype.goTo = e.prototype.slickGoTo =
                function (i2, e2) {
                    var t = this
                    t.changeSlide(
                        { data: { message: 'index', index: parseInt(i2) } },
                        e2
                    )
                }),
            (e.prototype.init = function (e2) {
                var t = this
                i(t.$slider).hasClass('slick-initialized') ||
                    (i(t.$slider).addClass('slick-initialized'),
                    t.buildRows(),
                    t.buildOut(),
                    t.setProps(),
                    t.startLoad(),
                    t.loadSlider(),
                    t.initializeEvents(),
                    t.updateArrows(),
                    t.updateDots(),
                    t.checkResponsive(!0),
                    t.focusHandler()),
                    e2 && t.$slider.trigger('init', [t]),
                    t.options.accessibility === !0 && t.initADA(),
                    t.options.autoplay && ((t.paused = !1), t.autoPlay())
            }),
            (e.prototype.initADA = function () {
                var e2 = this,
                    t = Math.ceil(e2.slideCount / e2.options.slidesToShow),
                    o = e2.getNavigableIndexes().filter(function (i2) {
                        return i2 >= 0 && i2 < e2.slideCount
                    })
                e2.$slides
                    .add(e2.$slideTrack.find('.slick-cloned'))
                    .attr({ 'aria-hidden': 'true', tabindex: '-1' })
                    .find('a, input, button, select')
                    .attr({ tabindex: '-1' }),
                    e2.$dots !== null &&
                        (e2.$slides
                            .not(e2.$slideTrack.find('.slick-cloned'))
                            .each(function (t2) {
                                var s2 = o.indexOf(t2)
                                if (
                                    (i(this).attr({
                                        role: 'tabpanel',
                                        id: 'slick-slide' + e2.instanceUid + t2,
                                        tabindex: -1,
                                    }),
                                    s2 !== -1)
                                ) {
                                    var n2 =
                                        'slick-slide-control' +
                                        e2.instanceUid +
                                        s2
                                    i('#' + n2).length &&
                                        i(this).attr({ 'aria-describedby': n2 })
                                }
                            }),
                        e2.$dots
                            .attr('role', 'tablist')
                            .find('li')
                            .each(function (s2) {
                                var n2 = o[s2]
                                i(this).attr({ role: 'presentation' }),
                                    i(this)
                                        .find('button')
                                        .first()
                                        .attr({
                                            role: 'tab',
                                            id:
                                                'slick-slide-control' +
                                                e2.instanceUid +
                                                s2,
                                            'aria-controls':
                                                'slick-slide' +
                                                e2.instanceUid +
                                                n2,
                                            'aria-label': s2 + 1 + ' of ' + t,
                                            'aria-selected': null,
                                            tabindex: '-1',
                                        })
                            })
                            .eq(e2.currentSlide)
                            .find('button')
                            .attr({ 'aria-selected': 'true', tabindex: '0' })
                            .end())
                for (
                    var s = e2.currentSlide, n = s + e2.options.slidesToShow;
                    s < n;
                    s++
                )
                    e2.options.focusOnChange
                        ? e2.$slides.eq(s).attr({ tabindex: '0' })
                        : e2.$slides.eq(s).removeAttr('tabindex')
                e2.activateADA()
            }),
            (e.prototype.initArrowEvents = function () {
                var i2 = this
                i2.options.arrows === !0 &&
                    i2.slideCount > i2.options.slidesToShow &&
                    (i2.$prevArrow
                        .off('click.slick')
                        .on(
                            'click.slick',
                            { message: 'previous' },
                            i2.changeSlide
                        ),
                    i2.$nextArrow
                        .off('click.slick')
                        .on('click.slick', { message: 'next' }, i2.changeSlide),
                    i2.options.accessibility === !0 &&
                        (i2.$prevArrow.on('keydown.slick', i2.keyHandler),
                        i2.$nextArrow.on('keydown.slick', i2.keyHandler)))
            }),
            (e.prototype.initDotEvents = function () {
                var e2 = this
                e2.options.dots === !0 &&
                    e2.slideCount > e2.options.slidesToShow &&
                    (i('li', e2.$dots).on(
                        'click.slick',
                        { message: 'index' },
                        e2.changeSlide
                    ),
                    e2.options.accessibility === !0 &&
                        e2.$dots.on('keydown.slick', e2.keyHandler)),
                    e2.options.dots === !0 &&
                        e2.options.pauseOnDotsHover === !0 &&
                        e2.slideCount > e2.options.slidesToShow &&
                        i('li', e2.$dots)
                            .on(
                                'mouseenter.slick',
                                i.proxy(e2.interrupt, e2, !0)
                            )
                            .on(
                                'mouseleave.slick',
                                i.proxy(e2.interrupt, e2, !1)
                            )
            }),
            (e.prototype.initSlideEvents = function () {
                var e2 = this
                e2.options.pauseOnHover &&
                    (e2.$list.on(
                        'mouseenter.slick',
                        i.proxy(e2.interrupt, e2, !0)
                    ),
                    e2.$list.on(
                        'mouseleave.slick',
                        i.proxy(e2.interrupt, e2, !1)
                    ))
            }),
            (e.prototype.initializeEvents = function () {
                var e2 = this
                e2.initArrowEvents(),
                    e2.initDotEvents(),
                    e2.initSlideEvents(),
                    e2.$list.on(
                        'touchstart.slick mousedown.slick',
                        { action: 'start' },
                        e2.swipeHandler
                    ),
                    e2.$list.on(
                        'touchmove.slick mousemove.slick',
                        { action: 'move' },
                        e2.swipeHandler
                    ),
                    e2.$list.on(
                        'touchend.slick mouseup.slick',
                        { action: 'end' },
                        e2.swipeHandler
                    ),
                    e2.$list.on(
                        'touchcancel.slick mouseleave.slick',
                        { action: 'end' },
                        e2.swipeHandler
                    ),
                    e2.$list.on('click.slick', e2.clickHandler),
                    i(document).on(
                        e2.visibilityChange,
                        i.proxy(e2.visibility, e2)
                    ),
                    e2.options.accessibility === !0 &&
                        e2.$list.on('keydown.slick', e2.keyHandler),
                    e2.options.focusOnSelect === !0 &&
                        i(e2.$slideTrack)
                            .children()
                            .on('click.slick', e2.selectHandler),
                    i(window).on(
                        'orientationchange.slick.slick-' + e2.instanceUid,
                        i.proxy(e2.orientationChange, e2)
                    ),
                    i(window).on(
                        'resize.slick.slick-' + e2.instanceUid,
                        i.proxy(e2.resize, e2)
                    ),
                    i('[draggable!=true]', e2.$slideTrack).on(
                        'dragstart',
                        e2.preventDefault
                    ),
                    i(window).on(
                        'load.slick.slick-' + e2.instanceUid,
                        e2.setPosition
                    ),
                    i(e2.setPosition)
            }),
            (e.prototype.initUI = function () {
                var i2 = this
                i2.options.arrows === !0 &&
                    i2.slideCount > i2.options.slidesToShow &&
                    (i2.$prevArrow.show(), i2.$nextArrow.show()),
                    i2.options.dots === !0 &&
                        i2.slideCount > i2.options.slidesToShow &&
                        i2.$dots.show()
            }),
            (e.prototype.keyHandler = function (i2) {
                var e2 = this
                i2.target.tagName.match('TEXTAREA|INPUT|SELECT') ||
                    (i2.keyCode === 37 && e2.options.accessibility === !0
                        ? e2.changeSlide({
                              data: {
                                  message:
                                      e2.options.rtl === !0
                                          ? 'next'
                                          : 'previous',
                              },
                          })
                        : i2.keyCode === 39 &&
                          e2.options.accessibility === !0 &&
                          e2.changeSlide({
                              data: {
                                  message:
                                      e2.options.rtl === !0
                                          ? 'previous'
                                          : 'next',
                              },
                          }))
            }),
            (e.prototype.lazyLoad = function () {
                function e2(e3) {
                    i('img[data-lazy]', e3).each(function () {
                        var e4 = i(this),
                            t2 = i(this).attr('data-lazy'),
                            o2 = i(this).attr('data-srcset'),
                            s2 =
                                i(this).attr('data-sizes') ||
                                r.$slider.attr('data-sizes'),
                            n2 = document.createElement('img')
                        ;(n2.onload = function () {
                            e4.animate({ opacity: 0 }, 100, function () {
                                o2 &&
                                    (e4.attr('srcset', o2),
                                    s2 && e4.attr('sizes', s2)),
                                    e4
                                        .attr('src', t2)
                                        .animate(
                                            { opacity: 1 },
                                            200,
                                            function () {
                                                e4.removeAttr(
                                                    'data-lazy data-srcset data-sizes'
                                                ).removeClass('slick-loading')
                                            }
                                        ),
                                    r.$slider.trigger('lazyLoaded', [r, e4, t2])
                            })
                        }),
                            (n2.onerror = function () {
                                e4
                                    .removeAttr('data-lazy')
                                    .removeClass('slick-loading')
                                    .addClass('slick-lazyload-error'),
                                    r.$slider.trigger('lazyLoadError', [
                                        r,
                                        e4,
                                        t2,
                                    ])
                            }),
                            (n2.src = t2)
                    })
                }
                var t,
                    o,
                    s,
                    n,
                    r = this
                if (
                    (r.options.centerMode === !0
                        ? r.options.infinite === !0
                            ? ((s =
                                  r.currentSlide +
                                  (r.options.slidesToShow / 2 + 1)),
                              (n = s + r.options.slidesToShow + 2))
                            : ((s = Math.max(
                                  0,
                                  r.currentSlide -
                                      (r.options.slidesToShow / 2 + 1)
                              )),
                              (n =
                                  2 +
                                  (r.options.slidesToShow / 2 + 1) +
                                  r.currentSlide))
                        : ((s = r.options.infinite
                              ? r.options.slidesToShow + r.currentSlide
                              : r.currentSlide),
                          (n = Math.ceil(s + r.options.slidesToShow)),
                          r.options.fade === !0 &&
                              (s > 0 && s--, n <= r.slideCount && n++)),
                    (t = r.$slider.find('.slick-slide').slice(s, n)),
                    r.options.lazyLoad === 'anticipated')
                )
                    for (
                        var l = s - 1,
                            d = n,
                            a = r.$slider.find('.slick-slide'),
                            c = 0;
                        c < r.options.slidesToScroll;
                        c++
                    )
                        l < 0 && (l = r.slideCount - 1),
                            (t = t.add(a.eq(l))),
                            (t = t.add(a.eq(d))),
                            l--,
                            d++
                e2(t),
                    r.slideCount <= r.options.slidesToShow
                        ? ((o = r.$slider.find('.slick-slide')), e2(o))
                        : r.currentSlide >=
                          r.slideCount - r.options.slidesToShow
                        ? ((o = r.$slider
                              .find('.slick-cloned')
                              .slice(0, r.options.slidesToShow)),
                          e2(o))
                        : r.currentSlide === 0 &&
                          ((o = r.$slider
                              .find('.slick-cloned')
                              .slice(r.options.slidesToShow * -1)),
                          e2(o))
            }),
            (e.prototype.loadSlider = function () {
                var i2 = this
                i2.setPosition(),
                    i2.$slideTrack.css({ opacity: 1 }),
                    i2.$slider.removeClass('slick-loading'),
                    i2.initUI(),
                    i2.options.lazyLoad === 'progressive' &&
                        i2.progressiveLazyLoad()
            }),
            (e.prototype.next = e.prototype.slickNext =
                function () {
                    var i2 = this
                    i2.changeSlide({ data: { message: 'next' } })
                }),
            (e.prototype.orientationChange = function () {
                var i2 = this
                i2.checkResponsive(), i2.setPosition()
            }),
            (e.prototype.pause = e.prototype.slickPause =
                function () {
                    var i2 = this
                    i2.autoPlayClear(), (i2.paused = !0)
                }),
            (e.prototype.play = e.prototype.slickPlay =
                function () {
                    var i2 = this
                    i2.autoPlay(),
                        (i2.options.autoplay = !0),
                        (i2.paused = !1),
                        (i2.focussed = !1),
                        (i2.interrupted = !1)
                }),
            (e.prototype.postSlide = function (e2) {
                var t = this
                if (
                    !t.unslicked &&
                    (t.$slider.trigger('afterChange', [t, e2]),
                    (t.animating = !1),
                    t.slideCount > t.options.slidesToShow && t.setPosition(),
                    (t.swipeLeft = null),
                    t.options.autoplay && t.autoPlay(),
                    t.options.accessibility === !0 &&
                        (t.initADA(), t.options.focusOnChange))
                ) {
                    var o = i(t.$slides.get(t.currentSlide))
                    o.attr('tabindex', 0).focus()
                }
            }),
            (e.prototype.prev = e.prototype.slickPrev =
                function () {
                    var i2 = this
                    i2.changeSlide({ data: { message: 'previous' } })
                }),
            (e.prototype.preventDefault = function (i2) {
                i2.preventDefault()
            }),
            (e.prototype.progressiveLazyLoad = function (e2) {
                e2 = e2 || 1
                var t,
                    o,
                    s,
                    n,
                    r,
                    l = this,
                    d = i('img[data-lazy]', l.$slider)
                d.length
                    ? ((t = d.first()),
                      (o = t.attr('data-lazy')),
                      (s = t.attr('data-srcset')),
                      (n =
                          t.attr('data-sizes') || l.$slider.attr('data-sizes')),
                      (r = document.createElement('img')),
                      (r.onload = function () {
                          s && (t.attr('srcset', s), n && t.attr('sizes', n)),
                              t
                                  .attr('src', o)
                                  .removeAttr(
                                      'data-lazy data-srcset data-sizes'
                                  )
                                  .removeClass('slick-loading'),
                              l.options.adaptiveHeight === !0 &&
                                  l.setPosition(),
                              l.$slider.trigger('lazyLoaded', [l, t, o]),
                              l.progressiveLazyLoad()
                      }),
                      (r.onerror = function () {
                          e2 < 3
                              ? setTimeout(function () {
                                    l.progressiveLazyLoad(e2 + 1)
                                }, 500)
                              : (t
                                    .removeAttr('data-lazy')
                                    .removeClass('slick-loading')
                                    .addClass('slick-lazyload-error'),
                                l.$slider.trigger('lazyLoadError', [l, t, o]),
                                l.progressiveLazyLoad())
                      }),
                      (r.src = o))
                    : l.$slider.trigger('allImagesLoaded', [l])
            }),
            (e.prototype.refresh = function (e2) {
                var t,
                    o,
                    s = this
                ;(o = s.slideCount - s.options.slidesToShow),
                    !s.options.infinite &&
                        s.currentSlide > o &&
                        (s.currentSlide = o),
                    s.slideCount <= s.options.slidesToShow &&
                        (s.currentSlide = 0),
                    (t = s.currentSlide),
                    s.destroy(!0),
                    i.extend(s, s.initials, { currentSlide: t }),
                    s.init(),
                    e2 ||
                        s.changeSlide(
                            { data: { message: 'index', index: t } },
                            !1
                        )
            }),
            (e.prototype.registerBreakpoints = function () {
                var e2,
                    t,
                    o,
                    s = this,
                    n = s.options.responsive || null
                if (i.type(n) === 'array' && n.length) {
                    s.respondTo = s.options.respondTo || 'window'
                    for (e2 in n)
                        if (
                            ((o = s.breakpoints.length - 1),
                            n.hasOwnProperty(e2))
                        ) {
                            for (t = n[e2].breakpoint; o >= 0; )
                                s.breakpoints[o] &&
                                    s.breakpoints[o] === t &&
                                    s.breakpoints.splice(o, 1),
                                    o--
                            s.breakpoints.push(t),
                                (s.breakpointSettings[t] = n[e2].settings)
                        }
                    s.breakpoints.sort(function (i2, e3) {
                        return s.options.mobileFirst ? i2 - e3 : e3 - i2
                    })
                }
            }),
            (e.prototype.reinit = function () {
                var e2 = this
                ;(e2.$slides = e2.$slideTrack
                    .children(e2.options.slide)
                    .addClass('slick-slide')),
                    (e2.slideCount = e2.$slides.length),
                    e2.currentSlide >= e2.slideCount &&
                        e2.currentSlide !== 0 &&
                        (e2.currentSlide =
                            e2.currentSlide - e2.options.slidesToScroll),
                    e2.slideCount <= e2.options.slidesToShow &&
                        (e2.currentSlide = 0),
                    e2.registerBreakpoints(),
                    e2.setProps(),
                    e2.setupInfinite(),
                    e2.buildArrows(),
                    e2.updateArrows(),
                    e2.initArrowEvents(),
                    e2.buildDots(),
                    e2.updateDots(),
                    e2.initDotEvents(),
                    e2.cleanUpSlideEvents(),
                    e2.initSlideEvents(),
                    e2.checkResponsive(!1, !0),
                    e2.options.focusOnSelect === !0 &&
                        i(e2.$slideTrack)
                            .children()
                            .on('click.slick', e2.selectHandler),
                    e2.setSlideClasses(
                        typeof e2.currentSlide == 'number' ? e2.currentSlide : 0
                    ),
                    e2.setPosition(),
                    e2.focusHandler(),
                    (e2.paused = !e2.options.autoplay),
                    e2.autoPlay(),
                    e2.$slider.trigger('reInit', [e2])
            }),
            (e.prototype.resize = function () {
                var e2 = this
                i(window).width() !== e2.windowWidth &&
                    (clearTimeout(e2.windowDelay),
                    (e2.windowDelay = window.setTimeout(function () {
                        ;(e2.windowWidth = i(window).width()),
                            e2.checkResponsive(),
                            e2.unslicked || e2.setPosition()
                    }, 50)))
            }),
            (e.prototype.removeSlide = e.prototype.slickRemove =
                function (i2, e2, t) {
                    var o = this
                    return (
                        typeof i2 == 'boolean'
                            ? ((e2 = i2),
                              (i2 = e2 === !0 ? 0 : o.slideCount - 1))
                            : (i2 = e2 === !0 ? --i2 : i2),
                        !(
                            o.slideCount < 1 ||
                            i2 < 0 ||
                            i2 > o.slideCount - 1
                        ) &&
                            (o.unload(),
                            t === !0
                                ? o.$slideTrack.children().remove()
                                : o.$slideTrack
                                      .children(this.options.slide)
                                      .eq(i2)
                                      .remove(),
                            (o.$slides = o.$slideTrack.children(
                                this.options.slide
                            )),
                            o.$slideTrack.children(this.options.slide).detach(),
                            o.$slideTrack.append(o.$slides),
                            (o.$slidesCache = o.$slides),
                            void o.reinit())
                    )
                }),
            (e.prototype.setCSS = function (i2) {
                var e2,
                    t,
                    o = this,
                    s = {}
                o.options.rtl === !0 && (i2 = -i2),
                    (e2 =
                        o.positionProp == 'left'
                            ? Math.ceil(i2) + 'px'
                            : '0px'),
                    (t =
                        o.positionProp == 'top' ? Math.ceil(i2) + 'px' : '0px'),
                    (s[o.positionProp] = i2),
                    o.transformsEnabled === !1
                        ? o.$slideTrack.css(s)
                        : ((s = {}),
                          o.cssTransitions === !1
                              ? ((s[o.animType] =
                                    'translate(' + e2 + ', ' + t + ')'),
                                o.$slideTrack.css(s))
                              : ((s[o.animType] =
                                    'translate3d(' + e2 + ', ' + t + ', 0px)'),
                                o.$slideTrack.css(s)))
            }),
            (e.prototype.setDimensions = function () {
                var i2 = this
                i2.options.vertical === !1
                    ? i2.options.centerMode === !0 &&
                      i2.$list.css({
                          padding: '0px ' + i2.options.centerPadding,
                      })
                    : (i2.$list.height(
                          i2.$slides.first().outerHeight(!0) *
                              i2.options.slidesToShow
                      ),
                      i2.options.centerMode === !0 &&
                          i2.$list.css({
                              padding: i2.options.centerPadding + ' 0px',
                          })),
                    (i2.listWidth = i2.$list.width()),
                    (i2.listHeight = i2.$list.height()),
                    i2.options.vertical === !1 &&
                    i2.options.variableWidth === !1
                        ? ((i2.slideWidth = Math.ceil(
                              i2.listWidth / i2.options.slidesToShow
                          )),
                          i2.$slideTrack.width(
                              Math.ceil(
                                  i2.slideWidth *
                                      i2.$slideTrack.children('.slick-slide')
                                          .length
                              )
                          ))
                        : i2.options.variableWidth === !0
                        ? i2.$slideTrack.width(5e3 * i2.slideCount)
                        : ((i2.slideWidth = Math.ceil(i2.listWidth)),
                          i2.$slideTrack.height(
                              Math.ceil(
                                  i2.$slides.first().outerHeight(!0) *
                                      i2.$slideTrack.children('.slick-slide')
                                          .length
                              )
                          ))
                var e2 =
                    i2.$slides.first().outerWidth(!0) -
                    i2.$slides.first().width()
                i2.options.variableWidth === !1 &&
                    i2.$slideTrack
                        .children('.slick-slide')
                        .width(i2.slideWidth - e2)
            }),
            (e.prototype.setFade = function () {
                var e2,
                    t = this
                t.$slides.each(function (o, s) {
                    ;(e2 = t.slideWidth * o * -1),
                        t.options.rtl === !0
                            ? i(s).css({
                                  position: 'relative',
                                  right: e2,
                                  top: 0,
                                  zIndex: t.options.zIndex - 2,
                                  opacity: 0,
                              })
                            : i(s).css({
                                  position: 'relative',
                                  left: e2,
                                  top: 0,
                                  zIndex: t.options.zIndex - 2,
                                  opacity: 0,
                              })
                }),
                    t.$slides
                        .eq(t.currentSlide)
                        .css({ zIndex: t.options.zIndex - 1, opacity: 1 })
            }),
            (e.prototype.setHeight = function () {
                var i2 = this
                if (
                    i2.options.slidesToShow === 1 &&
                    i2.options.adaptiveHeight === !0 &&
                    i2.options.vertical === !1
                ) {
                    var e2 = i2.$slides.eq(i2.currentSlide).outerHeight(!0)
                    i2.$list.css('height', e2)
                }
            }),
            (e.prototype.setOption = e.prototype.slickSetOption =
                function () {
                    var e2,
                        t,
                        o,
                        s,
                        n,
                        r = this,
                        l = !1
                    if (
                        (i.type(arguments[0]) === 'object'
                            ? ((o = arguments[0]),
                              (l = arguments[1]),
                              (n = 'multiple'))
                            : i.type(arguments[0]) === 'string' &&
                              ((o = arguments[0]),
                              (s = arguments[1]),
                              (l = arguments[2]),
                              arguments[0] === 'responsive' &&
                              i.type(arguments[1]) === 'array'
                                  ? (n = 'responsive')
                                  : typeof arguments[1] < 'u' &&
                                    (n = 'single')),
                        n === 'single')
                    )
                        r.options[o] = s
                    else if (n === 'multiple')
                        i.each(o, function (i2, e3) {
                            r.options[i2] = e3
                        })
                    else if (n === 'responsive')
                        for (t in s)
                            if (i.type(r.options.responsive) !== 'array')
                                r.options.responsive = [s[t]]
                            else {
                                for (
                                    e2 = r.options.responsive.length - 1;
                                    e2 >= 0;

                                )
                                    r.options.responsive[e2].breakpoint ===
                                        s[t].breakpoint &&
                                        r.options.responsive.splice(e2, 1),
                                        e2--
                                r.options.responsive.push(s[t])
                            }
                    l && (r.unload(), r.reinit())
                }),
            (e.prototype.setPosition = function () {
                var i2 = this
                i2.setDimensions(),
                    i2.setHeight(),
                    i2.options.fade === !1
                        ? i2.setCSS(i2.getLeft(i2.currentSlide))
                        : i2.setFade(),
                    i2.$slider.trigger('setPosition', [i2])
            }),
            (e.prototype.setProps = function () {
                var i2 = this,
                    e2 = document.body.style
                ;(i2.positionProp =
                    i2.options.vertical === !0 ? 'top' : 'left'),
                    i2.positionProp === 'top'
                        ? i2.$slider.addClass('slick-vertical')
                        : i2.$slider.removeClass('slick-vertical'),
                    (e2.WebkitTransition === void 0 &&
                        e2.MozTransition === void 0 &&
                        e2.msTransition === void 0) ||
                        (i2.options.useCSS === !0 && (i2.cssTransitions = !0)),
                    i2.options.fade &&
                        (typeof i2.options.zIndex == 'number'
                            ? i2.options.zIndex < 3 && (i2.options.zIndex = 3)
                            : (i2.options.zIndex = i2.defaults.zIndex)),
                    e2.OTransform !== void 0 &&
                        ((i2.animType = 'OTransform'),
                        (i2.transformType = '-o-transform'),
                        (i2.transitionType = 'OTransition'),
                        e2.perspectiveProperty === void 0 &&
                            e2.webkitPerspective === void 0 &&
                            (i2.animType = !1)),
                    e2.MozTransform !== void 0 &&
                        ((i2.animType = 'MozTransform'),
                        (i2.transformType = '-moz-transform'),
                        (i2.transitionType = 'MozTransition'),
                        e2.perspectiveProperty === void 0 &&
                            e2.MozPerspective === void 0 &&
                            (i2.animType = !1)),
                    e2.webkitTransform !== void 0 &&
                        ((i2.animType = 'webkitTransform'),
                        (i2.transformType = '-webkit-transform'),
                        (i2.transitionType = 'webkitTransition'),
                        e2.perspectiveProperty === void 0 &&
                            e2.webkitPerspective === void 0 &&
                            (i2.animType = !1)),
                    e2.msTransform !== void 0 &&
                        ((i2.animType = 'msTransform'),
                        (i2.transformType = '-ms-transform'),
                        (i2.transitionType = 'msTransition'),
                        e2.msTransform === void 0 && (i2.animType = !1)),
                    e2.transform !== void 0 &&
                        i2.animType !== !1 &&
                        ((i2.animType = 'transform'),
                        (i2.transformType = 'transform'),
                        (i2.transitionType = 'transition')),
                    (i2.transformsEnabled =
                        i2.options.useTransform &&
                        i2.animType !== null &&
                        i2.animType !== !1)
            }),
            (e.prototype.setSlideClasses = function (i2) {
                var e2,
                    t,
                    o,
                    s,
                    n = this
                if (
                    ((t = n.$slider
                        .find('.slick-slide')
                        .removeClass('slick-active slick-center slick-current')
                        .attr('aria-hidden', 'true')),
                    n.$slides.eq(i2).addClass('slick-current'),
                    n.options.centerMode === !0)
                ) {
                    var r = n.options.slidesToShow % 2 === 0 ? 1 : 0
                    ;(e2 = Math.floor(n.options.slidesToShow / 2)),
                        n.options.infinite === !0 &&
                            (i2 >= e2 && i2 <= n.slideCount - 1 - e2
                                ? n.$slides
                                      .slice(i2 - e2 + r, i2 + e2 + 1)
                                      .addClass('slick-active')
                                      .attr('aria-hidden', 'false')
                                : ((o = n.options.slidesToShow + i2),
                                  t
                                      .slice(o - e2 + 1 + r, o + e2 + 2)
                                      .addClass('slick-active')
                                      .attr('aria-hidden', 'false')),
                            i2 === 0
                                ? t
                                      .eq(t.length - 1 - n.options.slidesToShow)
                                      .addClass('slick-center')
                                : i2 === n.slideCount - 1 &&
                                  t
                                      .eq(n.options.slidesToShow)
                                      .addClass('slick-center')),
                        n.$slides.eq(i2).addClass('slick-center')
                } else
                    i2 >= 0 && i2 <= n.slideCount - n.options.slidesToShow
                        ? n.$slides
                              .slice(i2, i2 + n.options.slidesToShow)
                              .addClass('slick-active')
                              .attr('aria-hidden', 'false')
                        : t.length <= n.options.slidesToShow
                        ? t
                              .addClass('slick-active')
                              .attr('aria-hidden', 'false')
                        : ((s = n.slideCount % n.options.slidesToShow),
                          (o =
                              n.options.infinite === !0
                                  ? n.options.slidesToShow + i2
                                  : i2),
                          n.options.slidesToShow == n.options.slidesToScroll &&
                          n.slideCount - i2 < n.options.slidesToShow
                              ? t
                                    .slice(
                                        o - (n.options.slidesToShow - s),
                                        o + s
                                    )
                                    .addClass('slick-active')
                                    .attr('aria-hidden', 'false')
                              : t
                                    .slice(o, o + n.options.slidesToShow)
                                    .addClass('slick-active')
                                    .attr('aria-hidden', 'false'))
                ;(n.options.lazyLoad !== 'ondemand' &&
                    n.options.lazyLoad !== 'anticipated') ||
                    n.lazyLoad()
            }),
            (e.prototype.setupInfinite = function () {
                var e2,
                    t,
                    o,
                    s = this
                if (
                    (s.options.fade === !0 && (s.options.centerMode = !1),
                    s.options.infinite === !0 &&
                        s.options.fade === !1 &&
                        ((t = null), s.slideCount > s.options.slidesToShow))
                ) {
                    for (
                        o =
                            s.options.centerMode === !0
                                ? s.options.slidesToShow + 1
                                : s.options.slidesToShow,
                            e2 = s.slideCount;
                        e2 > s.slideCount - o;
                        e2 -= 1
                    )
                        (t = e2 - 1),
                            i(s.$slides[t])
                                .clone(!0)
                                .attr('id', '')
                                .attr('data-slick-index', t - s.slideCount)
                                .prependTo(s.$slideTrack)
                                .addClass('slick-cloned')
                    for (e2 = 0; e2 < o + s.slideCount; e2 += 1)
                        (t = e2),
                            i(s.$slides[t])
                                .clone(!0)
                                .attr('id', '')
                                .attr('data-slick-index', t + s.slideCount)
                                .appendTo(s.$slideTrack)
                                .addClass('slick-cloned')
                    s.$slideTrack
                        .find('.slick-cloned')
                        .find('[id]')
                        .each(function () {
                            i(this).attr('id', '')
                        })
                }
            }),
            (e.prototype.interrupt = function (i2) {
                var e2 = this
                i2 || e2.autoPlay(), (e2.interrupted = i2)
            }),
            (e.prototype.selectHandler = function (e2) {
                var t = this,
                    o = i(e2.target).is('.slick-slide')
                        ? i(e2.target)
                        : i(e2.target).parents('.slick-slide'),
                    s = parseInt(o.attr('data-slick-index'))
                return (
                    s || (s = 0),
                    t.slideCount <= t.options.slidesToShow
                        ? void t.slideHandler(s, !1, !0)
                        : void t.slideHandler(s)
                )
            }),
            (e.prototype.slideHandler = function (i2, e2, t) {
                var o,
                    s,
                    n,
                    r,
                    l,
                    d = null,
                    a = this
                if (
                    ((e2 = e2 || !1),
                    !(
                        (a.animating === !0 &&
                            a.options.waitForAnimate === !0) ||
                        (a.options.fade === !0 && a.currentSlide === i2)
                    ))
                )
                    return (
                        e2 === !1 && a.asNavFor(i2),
                        (o = i2),
                        (d = a.getLeft(o)),
                        (r = a.getLeft(a.currentSlide)),
                        (a.currentLeft =
                            a.swipeLeft === null ? r : a.swipeLeft),
                        a.options.infinite === !1 &&
                        a.options.centerMode === !1 &&
                        (i2 < 0 ||
                            i2 > a.getDotCount() * a.options.slidesToScroll)
                            ? void (
                                  a.options.fade === !1 &&
                                  ((o = a.currentSlide),
                                  t !== !0 &&
                                  a.slideCount > a.options.slidesToShow
                                      ? a.animateSlide(r, function () {
                                            a.postSlide(o)
                                        })
                                      : a.postSlide(o))
                              )
                            : a.options.infinite === !1 &&
                              a.options.centerMode === !0 &&
                              (i2 < 0 ||
                                  i2 > a.slideCount - a.options.slidesToScroll)
                            ? void (
                                  a.options.fade === !1 &&
                                  ((o = a.currentSlide),
                                  t !== !0 &&
                                  a.slideCount > a.options.slidesToShow
                                      ? a.animateSlide(r, function () {
                                            a.postSlide(o)
                                        })
                                      : a.postSlide(o))
                              )
                            : (a.options.autoplay &&
                                  clearInterval(a.autoPlayTimer),
                              (s =
                                  o < 0
                                      ? a.slideCount %
                                            a.options.slidesToScroll !==
                                        0
                                          ? a.slideCount -
                                            (a.slideCount %
                                                a.options.slidesToScroll)
                                          : a.slideCount + o
                                      : o >= a.slideCount
                                      ? a.slideCount %
                                            a.options.slidesToScroll !==
                                        0
                                          ? 0
                                          : o - a.slideCount
                                      : o),
                              (a.animating = !0),
                              a.$slider.trigger('beforeChange', [
                                  a,
                                  a.currentSlide,
                                  s,
                              ]),
                              (n = a.currentSlide),
                              (a.currentSlide = s),
                              a.setSlideClasses(a.currentSlide),
                              a.options.asNavFor &&
                                  ((l = a.getNavTarget()),
                                  (l = l.slick('getSlick')),
                                  l.slideCount <= l.options.slidesToShow &&
                                      l.setSlideClasses(a.currentSlide)),
                              a.updateDots(),
                              a.updateArrows(),
                              a.options.fade === !0
                                  ? (t !== !0
                                        ? (a.fadeSlideOut(n),
                                          a.fadeSlide(s, function () {
                                              a.postSlide(s)
                                          }))
                                        : a.postSlide(s),
                                    void a.animateHeight())
                                  : void (t !== !0 &&
                                    a.slideCount > a.options.slidesToShow
                                        ? a.animateSlide(d, function () {
                                              a.postSlide(s)
                                          })
                                        : a.postSlide(s)))
                    )
            }),
            (e.prototype.startLoad = function () {
                var i2 = this
                i2.options.arrows === !0 &&
                    i2.slideCount > i2.options.slidesToShow &&
                    (i2.$prevArrow.hide(), i2.$nextArrow.hide()),
                    i2.options.dots === !0 &&
                        i2.slideCount > i2.options.slidesToShow &&
                        i2.$dots.hide(),
                    i2.$slider.addClass('slick-loading')
            }),
            (e.prototype.swipeDirection = function () {
                var i2,
                    e2,
                    t,
                    o,
                    s = this
                return (
                    (i2 = s.touchObject.startX - s.touchObject.curX),
                    (e2 = s.touchObject.startY - s.touchObject.curY),
                    (t = Math.atan2(e2, i2)),
                    (o = Math.round((180 * t) / Math.PI)),
                    o < 0 && (o = 360 - Math.abs(o)),
                    (o <= 45 && o >= 0) || (o <= 360 && o >= 315)
                        ? s.options.rtl === !1
                            ? 'left'
                            : 'right'
                        : o >= 135 && o <= 225
                        ? s.options.rtl === !1
                            ? 'right'
                            : 'left'
                        : s.options.verticalSwiping === !0
                        ? o >= 35 && o <= 135
                            ? 'down'
                            : 'up'
                        : 'vertical'
                )
            }),
            (e.prototype.swipeEnd = function (i2) {
                var e2,
                    t,
                    o = this
                if (((o.dragging = !1), (o.swiping = !1), o.scrolling))
                    return (o.scrolling = !1), !1
                if (
                    ((o.interrupted = !1),
                    (o.shouldClick = !(o.touchObject.swipeLength > 10)),
                    o.touchObject.curX === void 0)
                )
                    return !1
                if (
                    (o.touchObject.edgeHit === !0 &&
                        o.$slider.trigger('edge', [o, o.swipeDirection()]),
                    o.touchObject.swipeLength >= o.touchObject.minSwipe)
                ) {
                    switch ((t = o.swipeDirection())) {
                        case 'left':
                        case 'down':
                            ;(e2 = o.options.swipeToSlide
                                ? o.checkNavigable(
                                      o.currentSlide + o.getSlideCount()
                                  )
                                : o.currentSlide + o.getSlideCount()),
                                (o.currentDirection = 0)
                            break
                        case 'right':
                        case 'up':
                            ;(e2 = o.options.swipeToSlide
                                ? o.checkNavigable(
                                      o.currentSlide - o.getSlideCount()
                                  )
                                : o.currentSlide - o.getSlideCount()),
                                (o.currentDirection = 1)
                    }
                    t != 'vertical' &&
                        (o.slideHandler(e2),
                        (o.touchObject = {}),
                        o.$slider.trigger('swipe', [o, t]))
                } else
                    o.touchObject.startX !== o.touchObject.curX &&
                        (o.slideHandler(o.currentSlide), (o.touchObject = {}))
            }),
            (e.prototype.swipeHandler = function (i2) {
                var e2 = this
                if (
                    !(
                        e2.options.swipe === !1 ||
                        ('ontouchend' in document && e2.options.swipe === !1) ||
                        (e2.options.draggable === !1 &&
                            i2.type.indexOf('mouse') !== -1)
                    )
                )
                    switch (
                        ((e2.touchObject.fingerCount =
                            i2.originalEvent &&
                            i2.originalEvent.touches !== void 0
                                ? i2.originalEvent.touches.length
                                : 1),
                        (e2.touchObject.minSwipe =
                            e2.listWidth / e2.options.touchThreshold),
                        e2.options.verticalSwiping === !0 &&
                            (e2.touchObject.minSwipe =
                                e2.listHeight / e2.options.touchThreshold),
                        i2.data.action)
                    ) {
                        case 'start':
                            e2.swipeStart(i2)
                            break
                        case 'move':
                            e2.swipeMove(i2)
                            break
                        case 'end':
                            e2.swipeEnd(i2)
                    }
            }),
            (e.prototype.swipeMove = function (i2) {
                var e2,
                    t,
                    o,
                    s,
                    n,
                    r,
                    l = this
                return (
                    (n =
                        i2.originalEvent !== void 0
                            ? i2.originalEvent.touches
                            : null),
                    !(!l.dragging || l.scrolling || (n && n.length !== 1)) &&
                        ((e2 = l.getLeft(l.currentSlide)),
                        (l.touchObject.curX =
                            n !== void 0 ? n[0].pageX : i2.clientX),
                        (l.touchObject.curY =
                            n !== void 0 ? n[0].pageY : i2.clientY),
                        (l.touchObject.swipeLength = Math.round(
                            Math.sqrt(
                                Math.pow(
                                    l.touchObject.curX - l.touchObject.startX,
                                    2
                                )
                            )
                        )),
                        (r = Math.round(
                            Math.sqrt(
                                Math.pow(
                                    l.touchObject.curY - l.touchObject.startY,
                                    2
                                )
                            )
                        )),
                        !l.options.verticalSwiping && !l.swiping && r > 4
                            ? ((l.scrolling = !0), !1)
                            : (l.options.verticalSwiping === !0 &&
                                  (l.touchObject.swipeLength = r),
                              (t = l.swipeDirection()),
                              i2.originalEvent !== void 0 &&
                                  l.touchObject.swipeLength > 4 &&
                                  ((l.swiping = !0), i2.preventDefault()),
                              (s =
                                  (l.options.rtl === !1 ? 1 : -1) *
                                  (l.touchObject.curX > l.touchObject.startX
                                      ? 1
                                      : -1)),
                              l.options.verticalSwiping === !0 &&
                                  (s =
                                      l.touchObject.curY > l.touchObject.startY
                                          ? 1
                                          : -1),
                              (o = l.touchObject.swipeLength),
                              (l.touchObject.edgeHit = !1),
                              l.options.infinite === !1 &&
                                  ((l.currentSlide === 0 && t === 'right') ||
                                      (l.currentSlide >= l.getDotCount() &&
                                          t === 'left')) &&
                                  ((o =
                                      l.touchObject.swipeLength *
                                      l.options.edgeFriction),
                                  (l.touchObject.edgeHit = !0)),
                              l.options.vertical === !1
                                  ? (l.swipeLeft = e2 + o * s)
                                  : (l.swipeLeft =
                                        e2 +
                                        o *
                                            (l.$list.height() / l.listWidth) *
                                            s),
                              l.options.verticalSwiping === !0 &&
                                  (l.swipeLeft = e2 + o * s),
                              l.options.fade !== !0 &&
                                  l.options.touchMove !== !1 &&
                                  (l.animating === !0
                                      ? ((l.swipeLeft = null), !1)
                                      : void l.setCSS(l.swipeLeft))))
                )
            }),
            (e.prototype.swipeStart = function (i2) {
                var e2,
                    t = this
                return (
                    (t.interrupted = !0),
                    t.touchObject.fingerCount !== 1 ||
                    t.slideCount <= t.options.slidesToShow
                        ? ((t.touchObject = {}), !1)
                        : (i2.originalEvent !== void 0 &&
                              i2.originalEvent.touches !== void 0 &&
                              (e2 = i2.originalEvent.touches[0]),
                          (t.touchObject.startX = t.touchObject.curX =
                              e2 !== void 0 ? e2.pageX : i2.clientX),
                          (t.touchObject.startY = t.touchObject.curY =
                              e2 !== void 0 ? e2.pageY : i2.clientY),
                          void (t.dragging = !0))
                )
            }),
            (e.prototype.unfilterSlides = e.prototype.slickUnfilter =
                function () {
                    var i2 = this
                    i2.$slidesCache !== null &&
                        (i2.unload(),
                        i2.$slideTrack.children(this.options.slide).detach(),
                        i2.$slidesCache.appendTo(i2.$slideTrack),
                        i2.reinit())
                }),
            (e.prototype.unload = function () {
                var e2 = this
                i('.slick-cloned', e2.$slider).remove(),
                    e2.$dots && e2.$dots.remove(),
                    e2.$prevArrow &&
                        e2.htmlExpr.test(e2.options.prevArrow) &&
                        e2.$prevArrow.remove(),
                    e2.$nextArrow &&
                        e2.htmlExpr.test(e2.options.nextArrow) &&
                        e2.$nextArrow.remove(),
                    e2.$slides
                        .removeClass(
                            'slick-slide slick-active slick-visible slick-current'
                        )
                        .attr('aria-hidden', 'true')
                        .css('width', '')
            }),
            (e.prototype.unslick = function (i2) {
                var e2 = this
                e2.$slider.trigger('unslick', [e2, i2]), e2.destroy()
            }),
            (e.prototype.updateArrows = function () {
                var i2,
                    e2 = this
                ;(i2 = Math.floor(e2.options.slidesToShow / 2)),
                    e2.options.arrows === !0 &&
                        e2.slideCount > e2.options.slidesToShow &&
                        !e2.options.infinite &&
                        (e2.$prevArrow
                            .removeClass('slick-disabled')
                            .attr('aria-disabled', 'false'),
                        e2.$nextArrow
                            .removeClass('slick-disabled')
                            .attr('aria-disabled', 'false'),
                        e2.currentSlide === 0
                            ? (e2.$prevArrow
                                  .addClass('slick-disabled')
                                  .attr('aria-disabled', 'true'),
                              e2.$nextArrow
                                  .removeClass('slick-disabled')
                                  .attr('aria-disabled', 'false'))
                            : ((e2.currentSlide >=
                                  e2.slideCount - e2.options.slidesToShow &&
                                  e2.options.centerMode === !1) ||
                                  (e2.currentSlide >= e2.slideCount - 1 &&
                                      e2.options.centerMode === !0)) &&
                              (e2.$nextArrow
                                  .addClass('slick-disabled')
                                  .attr('aria-disabled', 'true'),
                              e2.$prevArrow
                                  .removeClass('slick-disabled')
                                  .attr('aria-disabled', 'false')))
            }),
            (e.prototype.updateDots = function () {
                var i2 = this
                i2.$dots !== null &&
                    (i2.$dots.find('li').removeClass('slick-active').end(),
                    i2.$dots
                        .find('li')
                        .eq(
                            Math.floor(
                                i2.currentSlide / i2.options.slidesToScroll
                            )
                        )
                        .addClass('slick-active'))
            }),
            (e.prototype.visibility = function () {
                var i2 = this
                i2.options.autoplay &&
                    (document[i2.hidden]
                        ? (i2.interrupted = !0)
                        : (i2.interrupted = !1))
            }),
            (i.fn.slick = function () {
                var i2,
                    t,
                    o = this,
                    s = arguments[0],
                    n = Array.prototype.slice.call(arguments, 1),
                    r = o.length
                for (i2 = 0; i2 < r; i2++)
                    if (
                        (typeof s == 'object' || typeof s > 'u'
                            ? (o[i2].slick = new e(o[i2], s))
                            : (t = o[i2].slick[s].apply(o[i2].slick, n)),
                        typeof t < 'u')
                    )
                        return t
                return o
            })
    })
/**!
 * jquery.visible.min.js
 * https://github.com/customd/jquery-visible
 * @license MIT (https://github.com/customd/jquery-visible/blob/master/LICENSE.txt)
 */ ;(function (t) {
    var i = t(window)
    t.fn.visible = function (t2, e, o) {
        if (!(this.length < 1)) {
            var r = this.length > 1 ? this.eq(0) : this,
                n = r.get(0),
                f = i.width(),
                h = i.height(),
                o = o || 'both',
                l = e === !0 ? n.offsetWidth * n.offsetHeight : !0
            if (typeof n.getBoundingClientRect == 'function') {
                var g = n.getBoundingClientRect(),
                    u = g.top >= 0 && g.top < h,
                    s = g.bottom > 0 && g.bottom <= h,
                    c = g.left >= 0 && g.left < f,
                    a = g.right > 0 && g.right <= f,
                    v = t2 ? u || s : u && s,
                    b = t2 ? c || a : c && a
                if (o === 'both') return l && v && b
                if (o === 'vertical') return l && v
                if (o === 'horizontal') return l && b
            } else {
                var d = i.scrollTop(),
                    p = d + h,
                    w = i.scrollLeft(),
                    m = w + f,
                    y = r.offset(),
                    z = y.top,
                    B = z + r.height(),
                    C = y.left,
                    R = C + r.width(),
                    j = t2 === !0 ? B : z,
                    q = t2 === !0 ? z : B,
                    H = t2 === !0 ? R : C,
                    L = t2 === !0 ? C : R
                if (o === 'both')
                    return !!l && p >= q && j >= d && m >= L && H >= w
                if (o === 'vertical') return !!l && p >= q && j >= d
                if (o === 'horizontal') return !!l && m >= L && H >= w
            }
        }
    }
})(jQuery),
    (ajaxify = function (settings) {
        settings = settings || {}
        var linkParent = settings.linkParent || '.pagination',
            parentContainer = settings.parentContainer || '#MainContent',
            endlessScrollContainer =
                settings.endlessScrollContainer || '.EndlessScroll',
            endlessClickContainer =
                settings.endlessClickContainer || '.EndlessClick',
            endlessOffset = settings.endlessOffset || 0,
            ajaxinateContainer = settings.ajaxinateContainer || '.Ajaxinate',
            ajaxinateLink = settings.ajaxinateLink || '.page a',
            sectionId =
                $(endlessScrollContainer)
                    .closest('[data-section-id]')
                    .data('section-id') ||
                $(endlessClickContainer)
                    .closest('[data-section-id]')
                    .data('section-id') ||
                $(ajaxinateContainer)
                    .closest('[data-section-id]')
                    .data('section-id') ||
                '',
            fade = settings.fade || 'fast',
            textChange = settings.textChange || 'Loading'
        const callback = settings.callback || !1
        var linkElem, contentContainer, pageNumber, pageType, action, moreURL
        ;($.loadMore = function () {
            moreURL.length
                ? $.ajax({
                      type: 'GET',
                      dataType: 'html',
                      url: moreURL,
                      success: function (data) {
                          pageType == 'ajax'
                              ? ($(ajaxinateContainer)
                                    .not('[data-page="' + pageNumber + '"]')
                                    .hide(),
                                history.pushState({}, pageNumber, moreURL))
                              : $(linkElem).fadeOut(fade)
                          var filteredData = $(data)
                              .find(contentContainer)
                              .html()
                          $(contentContainer)
                              .find('.gridSpacer, .pagination')
                              .remove()
                              .end()
                              .append(filteredData),
                              pageType == 'endlessScroll'
                                  ? $.endlessScroll()
                                  : pageType == 'ajax'
                                  ? $.ajaxinationClick()
                                  : pageType == 'endlessClick' &&
                                    $.endlessClick(),
                              $(document).trigger('ajaxify:updated', [data]),
                              callback &&
                                  typeof callback == 'function' &&
                                  callback(data)
                      },
                  })
                : $(document).trigger('ajaxify:updated')
        }),
            ($.endlessScroll = function () {
                ;(action =
                    'scroll.endlessScroll--' +
                    sectionId +
                    ' load resize.endlessScroll--' +
                    sectionId),
                    $(window).on(action, function () {
                        if (
                            ((contentContainer = endlessScrollContainer),
                            (moreURL = $(
                                contentContainer + ':last-of-type ' + linkElem
                            ).attr('href')),
                            (pageType = 'endlessScroll'),
                            $(linkElem).text(textChange),
                            $(contentContainer + ':last-of-type ' + linkElem)
                                .length)
                        ) {
                            var bottom = $(parentContainer).outerHeight(),
                                docTop =
                                    $(document).scrollTop() +
                                    $(window).height() +
                                    endlessOffset
                            docTop > bottom &&
                                ($(window).off(action), $.loadMore())
                        }
                    })
            }),
            ($.endlessClick = function () {
                $(linkElem).on('click', function (e) {
                    e.preventDefault(),
                        (action = 'click'),
                        (contentContainer = endlessClickContainer),
                        (moreURL = $(this).attr('href')),
                        (pageType = 'endlessClick'),
                        $(linkElem).text(textChange),
                        $(linkElem).off(action),
                        $(linkElem).on('click', function (e2) {
                            e2.preventDefault()
                        }),
                        $.loadMore()
                })
            }),
            ($.ajaxinationClick = function () {
                $(linkElem).on('click', function (e) {
                    e.preventDefault(),
                        (action = 'click'),
                        (contentContainer = ajaxinateContainer),
                        (moreURL = $(this).attr('href')),
                        (pageNumber = $(this).attr('data-number')),
                        (pageType = 'ajax'),
                        $(contentContainer + '[data-page="' + pageNumber + '"]')
                            .length
                            ? ($(contentContainer)
                                  .not('[data-page="' + pageNumber + '"]')
                                  .hide(),
                              $(
                                  contentContainer +
                                      '[data-page="' +
                                      pageNumber +
                                      '"]'
                              ).fadeIn(fade),
                              history.pushState({}, pageNumber, moreURL))
                            : ($(linkElem).off(action), $.loadMore()),
                        $('html, body').animate(
                            { scrollTop: $(parentContainer).offset().top },
                            300
                        )
                })
            }),
            $(endlessClickContainer).length &&
                ((linkElem = linkParent + ' a'), $.endlessClick()),
            $(ajaxinateContainer).length &&
                ((linkElem = ajaxinateLink), $.ajaxinationClick()),
            $(endlessScrollContainer).length &&
                ((linkElem = linkParent + ' a'), $.endlessScroll())
    })
/*!
 * Scroll lock 2.1.5
 * https://github.com/FL3NKEY/scroll-lock
 */ ;(function (e, t) {
    typeof exports == 'object' && typeof module == 'object'
        ? (module.exports = t())
        : typeof define == 'function' && define.amd
        ? define([], t)
        : typeof exports == 'object'
        ? (exports.scrollLock = t())
        : (e.scrollLock = t())
})(this, function () {
    return (function (l) {
        var r = {}
        function o(e) {
            if (r[e]) return r[e].exports
            var t = (r[e] = { i: e, l: !1, exports: {} })
            return l[e].call(t.exports, t, t.exports, o), (t.l = !0), t.exports
        }
        return (
            (o.m = l),
            (o.c = r),
            (o.d = function (e, t, l2) {
                o.o(e, t) ||
                    Object.defineProperty(e, t, { enumerable: !0, get: l2 })
            }),
            (o.r = function (e) {
                typeof Symbol < 'u' &&
                    Symbol.toStringTag &&
                    Object.defineProperty(e, Symbol.toStringTag, {
                        value: 'Module',
                    }),
                    Object.defineProperty(e, '__esModule', { value: !0 })
            }),
            (o.t = function (t, e) {
                if (
                    (1 & e && (t = o(t)),
                    8 & e ||
                        (4 & e && typeof t == 'object' && t && t.__esModule))
                )
                    return t
                var l2 = Object.create(null)
                if (
                    (o.r(l2),
                    Object.defineProperty(l2, 'default', {
                        enumerable: !0,
                        value: t,
                    }),
                    2 & e && typeof t != 'string')
                )
                    for (var r2 in t)
                        o.d(
                            l2,
                            r2,
                            function (e2) {
                                return t[e2]
                            }.bind(null, r2)
                        )
                return l2
            }),
            (o.n = function (e) {
                var t =
                    e && e.__esModule
                        ? function () {
                              return e.default
                          }
                        : function () {
                              return e
                          }
                return o.d(t, 'a', t), t
            }),
            (o.o = function (e, t) {
                return Object.prototype.hasOwnProperty.call(e, t)
            }),
            (o.p = ''),
            o((o.s = 0))
        )
    })([
        function (e, t, l) {
            'use strict'
            l.r(t)
            var r = function (e2) {
                    return Array.isArray(e2) ? e2 : [e2]
                },
                a = function (e2) {
                    return e2 instanceof Node
                },
                o = function (e2, t2) {
                    if (e2 && t2) {
                        e2 = e2 instanceof NodeList ? e2 : [e2]
                        for (
                            var l2 = 0;
                            l2 < e2.length && t2(e2[l2], l2, e2.length) !== !0;
                            l2++
                        );
                    }
                },
                n = function (e2) {
                    return console.error('[scroll-lock] '.concat(e2))
                },
                b = function (e2) {
                    if (Array.isArray(e2)) return e2.join(', ')
                },
                c = function (e2) {
                    var t2 = []
                    return (
                        o(e2, function (e3) {
                            return t2.push(e3)
                        }),
                        t2
                    )
                },
                h = function (e2, t2) {
                    var l2 =
                            !(
                                2 < arguments.length && arguments[2] !== void 0
                            ) || arguments[2],
                        r2 =
                            3 < arguments.length && arguments[3] !== void 0
                                ? arguments[3]
                                : document
                    if (l2 && c(r2.querySelectorAll(t2)).indexOf(e2) !== -1)
                        return e2
                    for (
                        ;
                        (e2 = e2.parentElement) &&
                        c(r2.querySelectorAll(t2)).indexOf(e2) === -1;

                    );
                    return e2
                },
                v = function (e2, t2) {
                    var l2 =
                        2 < arguments.length && arguments[2] !== void 0
                            ? arguments[2]
                            : document
                    return c(l2.querySelectorAll(t2)).indexOf(e2) !== -1
                },
                i = function (e2) {
                    if (e2) return getComputedStyle(e2).overflow === 'hidden'
                },
                m = function (e2) {
                    if (e2) return !!i(e2) || e2.scrollTop <= 0
                },
                S = function (e2) {
                    if (e2) {
                        if (i(e2)) return !0
                        var t2 = e2.scrollTop
                        return e2.scrollHeight <= t2 + e2.offsetHeight
                    }
                },
                y = function (e2) {
                    if (e2) return !!i(e2) || e2.scrollLeft <= 0
                },
                k = function (e2) {
                    if (e2) {
                        if (i(e2)) return !0
                        var t2 = e2.scrollLeft
                        return e2.scrollWidth <= t2 + e2.offsetWidth
                    }
                }
            l.d(t, 'disablePageScroll', function () {
                return d
            }),
                l.d(t, 'enablePageScroll', function () {
                    return s
                }),
                l.d(t, 'getScrollState', function () {
                    return f
                }),
                l.d(t, 'clearQueueScrollLocks', function () {
                    return p
                }),
                l.d(t, 'getTargetScrollBarWidth', function () {
                    return g
                }),
                l.d(t, 'getCurrentTargetScrollBarWidth', function () {
                    return A
                }),
                l.d(t, 'getPageScrollBarWidth', function () {
                    return G
                }),
                l.d(t, 'getCurrentPageScrollBarWidth', function () {
                    return T
                }),
                l.d(t, 'addScrollableTarget', function () {
                    return L
                }),
                l.d(t, 'removeScrollableTarget', function () {
                    return W
                }),
                l.d(t, 'addScrollableSelector', function () {
                    return x
                }),
                l.d(t, 'removeScrollableSelector', function () {
                    return F
                }),
                l.d(t, 'addLockableTarget', function () {
                    return Y
                }),
                l.d(t, 'addLockableSelector', function () {
                    return E
                }),
                l.d(t, 'setFillGapMethod', function () {
                    return O
                }),
                l.d(t, 'addFillGapTarget', function () {
                    return P
                }),
                l.d(t, 'removeFillGapTarget', function () {
                    return j
                }),
                l.d(t, 'addFillGapSelector', function () {
                    return q
                }),
                l.d(t, 'removeFillGapSelector', function () {
                    return M
                }),
                l.d(t, 'refillGaps', function () {
                    return N
                })
            var u = ['padding', 'margin', 'width', 'max-width', 'none'],
                w = {
                    scroll: !0,
                    queue: 0,
                    scrollableSelectors: ['[data-scroll-lock-scrollable]'],
                    lockableSelectors: ['body', '[data-scroll-lock-lockable]'],
                    fillGapSelectors: [
                        'body',
                        '[data-scroll-lock-fill-gap]',
                        '[data-scroll-lock-lockable]',
                    ],
                    fillGapMethod: u[0],
                    startTouchY: 0,
                    startTouchX: 0,
                },
                d = function (e2) {
                    w.queue <= 0 && ((w.scroll = !1), B(), X()),
                        L(e2),
                        w.queue++
                },
                s = function (e2) {
                    0 < w.queue && w.queue--,
                        w.queue <= 0 && ((w.scroll = !0), C(), Q()),
                        W(e2)
                },
                f = function () {
                    return w.scroll
                },
                p = function () {
                    w.queue = 0
                },
                g = function (e2) {
                    var t2 =
                        1 < arguments.length &&
                        arguments[1] !== void 0 &&
                        arguments[1]
                    if (a(e2)) {
                        var l2 = e2.style.overflowY
                        t2
                            ? f() ||
                              (e2.style.overflowY = e2.getAttribute(
                                  'data-scroll-lock-saved-overflow-y-property'
                              ))
                            : (e2.style.overflowY = 'scroll')
                        var r2 = A(e2)
                        return (e2.style.overflowY = l2), r2
                    }
                    return 0
                },
                A = function (e2) {
                    if (a(e2)) {
                        if (e2 === document.body) {
                            var t2 = document.documentElement.clientWidth
                            return window.innerWidth - t2
                        }
                        var l2 = e2.style.borderLeftWidth,
                            r2 = e2.style.borderRightWidth
                        ;(e2.style.borderLeftWidth = '0px'),
                            (e2.style.borderRightWidth = '0px')
                        var o2 = e2.offsetWidth - e2.clientWidth
                        return (
                            (e2.style.borderLeftWidth = l2),
                            (e2.style.borderRightWidth = r2),
                            o2
                        )
                    }
                    return 0
                },
                G = function () {
                    var e2 =
                        0 < arguments.length &&
                        arguments[0] !== void 0 &&
                        arguments[0]
                    return g(document.body, e2)
                },
                T = function () {
                    return A(document.body)
                },
                L = function (e2) {
                    e2 &&
                        r(e2).map(function (e3) {
                            o(e3, function (e4) {
                                a(e4)
                                    ? e4.setAttribute(
                                          'data-scroll-lock-scrollable',
                                          ''
                                      )
                                    : n('"'.concat(e4, '" is not a Element.'))
                            })
                        })
                },
                W = function (e2) {
                    e2 &&
                        r(e2).map(function (e3) {
                            o(e3, function (e4) {
                                a(e4)
                                    ? e4.removeAttribute(
                                          'data-scroll-lock-scrollable'
                                      )
                                    : n('"'.concat(e4, '" is not a Element.'))
                            })
                        })
                },
                x = function (e2) {
                    e2 &&
                        r(e2).map(function (e3) {
                            w.scrollableSelectors.push(e3)
                        })
                },
                F = function (e2) {
                    e2 &&
                        r(e2).map(function (t2) {
                            w.scrollableSelectors =
                                w.scrollableSelectors.filter(function (e3) {
                                    return e3 !== t2
                                })
                        })
                },
                Y = function (e2) {
                    e2 &&
                        (r(e2).map(function (e3) {
                            o(e3, function (e4) {
                                a(e4)
                                    ? e4.setAttribute(
                                          'data-scroll-lock-lockable',
                                          ''
                                      )
                                    : n('"'.concat(e4, '" is not a Element.'))
                            })
                        }),
                        f() || B())
                },
                E = function (e2) {
                    e2 &&
                        (r(e2).map(function (e3) {
                            w.lockableSelectors.push(e3)
                        }),
                        f() || B(),
                        q(e2))
                },
                O = function (e2) {
                    if (e2)
                        if (u.indexOf(e2) !== -1) (w.fillGapMethod = e2), N()
                        else {
                            var t2 = u.join(', ')
                            n(
                                '"'
                                    .concat(
                                        e2,
                                        `" method is not available!
Available fill gap methods: `
                                    )
                                    .concat(t2, '.')
                            )
                        }
                },
                P = function (e2) {
                    e2 &&
                        r(e2).map(function (e3) {
                            o(e3, function (e4) {
                                a(e4)
                                    ? (e4.setAttribute(
                                          'data-scroll-lock-fill-gap',
                                          ''
                                      ),
                                      w.scroll || H(e4))
                                    : n('"'.concat(e4, '" is not a Element.'))
                            })
                        })
                },
                j = function (e2) {
                    e2 &&
                        r(e2).map(function (e3) {
                            o(e3, function (e4) {
                                a(e4)
                                    ? (e4.removeAttribute(
                                          'data-scroll-lock-fill-gap'
                                      ),
                                      w.scroll || I(e4))
                                    : n('"'.concat(e4, '" is not a Element.'))
                            })
                        })
                },
                q = function (e2) {
                    e2 &&
                        r(e2).map(function (e3) {
                            w.fillGapSelectors.indexOf(e3) === -1 &&
                                (w.fillGapSelectors.push(e3), w.scroll || D(e3))
                        })
                },
                M = function (e2) {
                    e2 &&
                        r(e2).map(function (t2) {
                            ;(w.fillGapSelectors = w.fillGapSelectors.filter(
                                function (e3) {
                                    return e3 !== t2
                                }
                            )),
                                w.scroll || z(t2)
                        })
                },
                N = function () {
                    w.scroll || X()
                },
                B = function () {
                    var e2 = b(w.lockableSelectors)
                    K(e2)
                },
                C = function () {
                    var e2 = b(w.lockableSelectors)
                    R(e2)
                },
                K = function (e2) {
                    var t2 = document.querySelectorAll(e2)
                    o(t2, function (e3) {
                        U(e3)
                    })
                },
                R = function (e2) {
                    var t2 = document.querySelectorAll(e2)
                    o(t2, function (e3) {
                        _(e3)
                    })
                },
                U = function (e2) {
                    if (
                        a(e2) &&
                        e2.getAttribute('data-scroll-lock-locked') !== 'true'
                    ) {
                        var t2 = window.getComputedStyle(e2)
                        e2.setAttribute(
                            'data-scroll-lock-saved-overflow-y-property',
                            t2.overflowY
                        ),
                            e2.setAttribute(
                                'data-scroll-lock-saved-inline-overflow-property',
                                e2.style.overflow
                            ),
                            e2.setAttribute(
                                'data-scroll-lock-saved-inline-overflow-y-property',
                                e2.style.overflowY
                            ),
                            (e2.style.overflow = 'hidden'),
                            e2.setAttribute('data-scroll-lock-locked', 'true')
                    }
                },
                _ = function (e2) {
                    a(e2) &&
                        e2.getAttribute('data-scroll-lock-locked') === 'true' &&
                        ((e2.style.overflow = e2.getAttribute(
                            'data-scroll-lock-saved-inline-overflow-property'
                        )),
                        (e2.style.overflowY = e2.getAttribute(
                            'data-scroll-lock-saved-inline-overflow-y-property'
                        )),
                        e2.removeAttribute(
                            'data-scroll-lock-saved-overflow-property'
                        ),
                        e2.removeAttribute(
                            'data-scroll-lock-saved-inline-overflow-property'
                        ),
                        e2.removeAttribute(
                            'data-scroll-lock-saved-inline-overflow-y-property'
                        ),
                        e2.removeAttribute('data-scroll-lock-locked'))
                },
                X = function () {
                    w.fillGapSelectors.map(function (e2) {
                        D(e2)
                    })
                },
                Q = function () {
                    w.fillGapSelectors.map(function (e2) {
                        z(e2)
                    })
                },
                D = function (e2) {
                    var t2 = document.querySelectorAll(e2),
                        l2 = w.lockableSelectors.indexOf(e2) !== -1
                    o(t2, function (e3) {
                        H(e3, l2)
                    })
                },
                H = function (e2) {
                    var t2 =
                        1 < arguments.length &&
                        arguments[1] !== void 0 &&
                        arguments[1]
                    if (a(e2)) {
                        var l2
                        if (
                            e2.getAttribute('data-scroll-lock-lockable') ===
                                '' ||
                            t2
                        )
                            l2 = g(e2, !0)
                        else {
                            var r2 = h(e2, b(w.lockableSelectors))
                            l2 = g(r2, !0)
                        }
                        e2.getAttribute('data-scroll-lock-filled-gap') ===
                            'true' && I(e2)
                        var o2 = window.getComputedStyle(e2)
                        if (
                            (e2.setAttribute(
                                'data-scroll-lock-filled-gap',
                                'true'
                            ),
                            e2.setAttribute(
                                'data-scroll-lock-current-fill-gap-method',
                                w.fillGapMethod
                            ),
                            w.fillGapMethod === 'margin')
                        ) {
                            var n2 = parseFloat(o2.marginRight)
                            e2.style.marginRight = ''.concat(n2 + l2, 'px')
                        } else if (w.fillGapMethod === 'width')
                            e2.style.width = 'calc(100% - '.concat(l2, 'px)')
                        else if (w.fillGapMethod === 'max-width')
                            e2.style.maxWidth = 'calc(100% - '.concat(l2, 'px)')
                        else if (w.fillGapMethod === 'padding') {
                            var c2 = parseFloat(o2.paddingRight)
                            e2.style.paddingRight = ''.concat(c2 + l2, 'px')
                        }
                    }
                },
                z = function (e2) {
                    var t2 = document.querySelectorAll(e2)
                    o(t2, function (e3) {
                        I(e3)
                    })
                },
                I = function (e2) {
                    if (
                        a(e2) &&
                        e2.getAttribute('data-scroll-lock-filled-gap') ===
                            'true'
                    ) {
                        var t2 = e2.getAttribute(
                            'data-scroll-lock-current-fill-gap-method'
                        )
                        e2.removeAttribute('data-scroll-lock-filled-gap'),
                            e2.removeAttribute(
                                'data-scroll-lock-current-fill-gap-method'
                            ),
                            t2 === 'margin'
                                ? (e2.style.marginRight = '')
                                : t2 === 'width'
                                ? (e2.style.width = '')
                                : t2 === 'max-width'
                                ? (e2.style.maxWidth = '')
                                : t2 === 'padding' &&
                                  (e2.style.paddingRight = '')
                    }
                }
            typeof window < 'u' &&
                window.addEventListener('resize', function (e2) {
                    N()
                }),
                typeof document < 'u' &&
                    (document.addEventListener('touchstart', function (e2) {
                        w.scroll ||
                            ((w.startTouchY = e2.touches[0].clientY),
                            (w.startTouchX = e2.touches[0].clientX))
                    }),
                    document.addEventListener(
                        'touchmove',
                        function (n2) {
                            if (!w.scroll) {
                                var e2 = w.startTouchY,
                                    t2 = w.startTouchX,
                                    l2 = n2.touches[0].clientY,
                                    r2 = n2.touches[0].clientX
                                if (n2.touches.length < 2) {
                                    var c2 = b(w.scrollableSelectors),
                                        a2 = e2 < l2,
                                        i2 = l2 < e2,
                                        u2 = t2 < r2,
                                        d2 = r2 < t2,
                                        s2 = e2 + 3 < l2,
                                        f2 = l2 < e2 - 3,
                                        p2 = t2 + 3 < r2,
                                        g2 = r2 < t2 - 3
                                    ;(function e3(t3) {
                                        var l3 =
                                            1 < arguments.length &&
                                            arguments[1] !== void 0 &&
                                            arguments[1]
                                        if (t3) {
                                            var r3 = h(t3, c2, !1)
                                            if (v(t3, 'input[type="range"]'))
                                                return !1
                                            if (
                                                l3 ||
                                                (v(
                                                    t3,
                                                    'textarea, [contenteditable="true"]'
                                                ) &&
                                                    h(t3, c2)) ||
                                                v(t3, c2)
                                            ) {
                                                var o2 = !1
                                                y(t3) && k(t3)
                                                    ? ((a2 && m(t3)) ||
                                                          (i2 && S(t3))) &&
                                                      (o2 = !0)
                                                    : m(t3) && S(t3)
                                                    ? ((u2 && y(t3)) ||
                                                          (d2 && k(t3))) &&
                                                      (o2 = !0)
                                                    : ((s2 && m(t3)) ||
                                                          (f2 && S(t3)) ||
                                                          (p2 && y(t3)) ||
                                                          (g2 && k(t3))) &&
                                                      (o2 = !0),
                                                    o2 &&
                                                        (r3
                                                            ? e3(r3, !0)
                                                            : n2.cancelable &&
                                                              n2.preventDefault())
                                            } else e3(r3)
                                        } else
                                            n2.cancelable && n2.preventDefault()
                                    })(n2.target)
                                }
                            }
                        },
                        { passive: !1 }
                    ),
                    document.addEventListener('touchend', function (e2) {
                        w.scroll || ((w.startTouchY = 0), (w.startTouchX = 0))
                    }))
            var J = {
                    hide: function (e2) {
                        n(`"hide" is deprecated! Use "disablePageScroll" instead. 
 https://github.com/FL3NKEY/scroll-lock#disablepagescrollscrollabletarget`),
                            d(e2)
                    },
                    show: function (e2) {
                        n(`"show" is deprecated! Use "enablePageScroll" instead. 
 https://github.com/FL3NKEY/scroll-lock#enablepagescrollscrollabletarget`),
                            s(e2)
                    },
                    toggle: function (e2) {
                        n('"toggle" is deprecated! Do not use it.'),
                            f() ? d() : s(e2)
                    },
                    getState: function () {
                        return (
                            n(`"getState" is deprecated! Use "getScrollState" instead. 
 https://github.com/FL3NKEY/scroll-lock#getscrollstate`),
                            f()
                        )
                    },
                    getWidth: function () {
                        return (
                            n(`"getWidth" is deprecated! Use "getPageScrollBarWidth" instead. 
 https://github.com/FL3NKEY/scroll-lock#getpagescrollbarwidth`),
                            G()
                        )
                    },
                    getCurrentWidth: function () {
                        return (
                            n(`"getCurrentWidth" is deprecated! Use "getCurrentPageScrollBarWidth" instead. 
 https://github.com/FL3NKEY/scroll-lock#getcurrentpagescrollbarwidth`),
                            T()
                        )
                    },
                    setScrollableTargets: function (e2) {
                        n(`"setScrollableTargets" is deprecated! Use "addScrollableTarget" instead. 
 https://github.com/FL3NKEY/scroll-lock#addscrollabletargetscrollabletarget`),
                            L(e2)
                    },
                    setFillGapSelectors: function (e2) {
                        n(`"setFillGapSelectors" is deprecated! Use "addFillGapSelector" instead. 
 https://github.com/FL3NKEY/scroll-lock#addfillgapselectorfillgapselector`),
                            q(e2)
                    },
                    setFillGapTargets: function (e2) {
                        n(`"setFillGapTargets" is deprecated! Use "addFillGapTarget" instead. 
 https://github.com/FL3NKEY/scroll-lock#addfillgaptargetfillgaptarget`),
                            P(e2)
                    },
                    clearQueue: function () {
                        n(`"clearQueue" is deprecated! Use "clearQueueScrollLocks" instead. 
 https://github.com/FL3NKEY/scroll-lock#clearqueuescrolllocks`),
                            p()
                    },
                },
                V = (function (o2) {
                    for (var e2 = 1; e2 < arguments.length; e2++) {
                        var n2 = arguments[e2] != null ? arguments[e2] : {},
                            t2 = Object.keys(n2)
                        typeof Object.getOwnPropertySymbols == 'function' &&
                            (t2 = t2.concat(
                                Object.getOwnPropertySymbols(n2).filter(
                                    function (e3) {
                                        return Object.getOwnPropertyDescriptor(
                                            n2,
                                            e3
                                        ).enumerable
                                    }
                                )
                            )),
                            t2.forEach(function (e3) {
                                var t3, l2, r2
                                ;(t3 = o2),
                                    (r2 = n2[(l2 = e3)]),
                                    l2 in t3
                                        ? Object.defineProperty(t3, l2, {
                                              value: r2,
                                              enumerable: !0,
                                              configurable: !0,
                                              writable: !0,
                                          })
                                        : (t3[l2] = r2)
                            })
                    }
                    return o2
                })(
                    {
                        disablePageScroll: d,
                        enablePageScroll: s,
                        getScrollState: f,
                        clearQueueScrollLocks: p,
                        getTargetScrollBarWidth: g,
                        getCurrentTargetScrollBarWidth: A,
                        getPageScrollBarWidth: G,
                        getCurrentPageScrollBarWidth: T,
                        addScrollableSelector: x,
                        removeScrollableSelector: F,
                        addScrollableTarget: L,
                        removeScrollableTarget: W,
                        addLockableSelector: E,
                        addLockableTarget: Y,
                        addFillGapSelector: q,
                        removeFillGapSelector: M,
                        addFillGapTarget: P,
                        removeFillGapTarget: j,
                        setFillGapMethod: O,
                        refillGaps: N,
                        _state: w,
                    },
                    J
                )
            t.default = V
        },
    ]).default
})
var LibraryLoader = (function () {
    var types = { link: 'link', script: 'script' },
        status = { requested: 'requested', loaded: 'loaded' },
        cloudCdn = 'https://cdn.shopify.com/shopifycloud/',
        libraries = {
            youtubeSdk: {
                tagId: 'youtube-sdk',
                src: 'https://www.youtube.com/iframe_api',
                type: types.script,
            },
            plyrShopifyStyles: {
                tagId: 'plyr-shopify-styles',
                src: cloudCdn + 'shopify-plyr/v1.0/shopify-plyr.css',
                type: types.link,
            },
            modelViewerUiStyles: {
                tagId: 'shopify-model-viewer-ui-styles',
                src:
                    cloudCdn +
                    'model-viewer-ui/assets/v1.0/model-viewer-ui.css',
                type: types.link,
            },
        }
    function load(libraryName, callback) {
        var library = libraries[libraryName]
        if (library && library.status !== status.requested) {
            if (
                ((callback = callback || function () {}),
                library.status === status.loaded)
            ) {
                callback()
                return
            }
            library.status = status.requested
            var tag
            switch (library.type) {
                case types.script:
                    tag = createScriptTag(library, callback)
                    break
                case types.link:
                    tag = createLinkTag(library, callback)
                    break
            }
            ;(tag.id = library.tagId), (library.element = tag)
            var firstScriptTag = document.getElementsByTagName(library.type)[0]
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)
        }
    }
    function createScriptTag(library, callback) {
        var tag = document.createElement('script')
        return (
            (tag.src = library.src),
            tag.addEventListener('load', function () {
                ;(library.status = status.loaded), callback()
            }),
            tag
        )
    }
    function createLinkTag(library, callback) {
        var tag = document.createElement('link')
        return (
            (tag.href = library.src),
            (tag.rel = 'stylesheet'),
            (tag.type = 'text/css'),
            tag.addEventListener('load', function () {
                ;(library.status = status.loaded), callback()
            }),
            tag
        )
    }
    return { load }
})()
jQuery(function ($2) {
    var Sections = {
            init: function () {
                $2(document)
                    .on('shopify:section:load', this._onSectionLoad)
                    .on('shopify:section:unload', this._onSectionUnload)
                    .on('shopify:section:select', this._onSectionSelect)
                    .on('shopify:section:deselect', this._onSectionDeselect)
                    .on('shopify:block:select', this._onBlockSelect)
                    .on('shopify:block:deselect', this._onBlockDeselect)
            },
            _onSectionLoad: function (e) {
                var section =
                    $2(e.target)
                        .children('[data-section-type]')
                        .data('section-type') || !1
                switch ((Site.animations.animateAll(), section)) {
                    case 'header':
                        _loadHeader(e.target)
                        break
                    case 'footer':
                        _loadFooter(e.target)
                        break
                    case 'product':
                        _loadProduct(e.target)
                        break
                    case 'gallery':
                        _loadGallery(e.target)
                        break
                    case 'mosaic':
                        _loadMosaic(e.target)
                    case 'map':
                        _loadGmap(e.target)
                        break
                    case 'slideshow':
                        _loadHero(e.target)
                        break
                    case 'collection-template':
                        _loadCollectionTemplate(e.target)
                        break
                    case 'featured-collection':
                        _loadFeaturedCollection(e.target)
                        break
                    case 'related-products':
                        _loadRelatedProductsTemplate(e.target)
                        break
                    case 'blog-template':
                        _loadBlogTemplate(e.target)
                        break
                    case 'featured-blog':
                        _loadFeaturedBlog(e.target)
                        break
                    case 'featured-video':
                        _loadFeaturedVideo(e.target)
                        break
                    case 'logo-list':
                        _loadLogoList(e.target)
                        break
                    case 'contact-section':
                        _loadContactSection(e.target)
                        break
                    case 'about-template':
                        _loadAboutTemplate(e.target)
                        break
                    case 'faq-template':
                        _loadFaqList(e.target)
                        break
                    case 'faq-section':
                        _loadFaqList(e.target)
                        break
                    case 'popup':
                        _selectPopup(e.target)
                        break
                }
                function _selectPopup(t) {
                    Popup.init()
                }
                function _loadHeader(t) {
                    Site.header.resetHeader(),
                        Site.nav.hide(),
                        Site.nav.init(),
                        Site.header.init(),
                        Search.init(),
                        $2('.template-cart').length || Cart.init(),
                        setTimeout(function () {
                            $2(window).scroll()
                        }, 100)
                }
                function _loadFooter(t) {
                    Site.footer()
                }
                function _loadProduct(t) {
                    var sectionId = $2(t)
                            .find('[data-section-id]')
                            .data('section-id'),
                        update = !0
                    Product.init(update, sectionId),
                        Site.video(),
                        Site.initReviews(),
                        Site.preventBannerContentOverflow()
                }
                function _loadGmap(t) {
                    Gmap.init()
                }
                function _loadFeaturedBlog(t) {
                    Blog.init()
                }
                function _loadBlogTemplate(t) {
                    ajaxify(), Blog.init()
                }
                function _loadGallery(t) {
                    var slider = $2(t).find('.js-slider'),
                        autoplay = slider.data('autoplay'),
                        options = JSON.parse(
                            slider.data('slick').replace(/'/g, '"')
                        )
                    ;(options = $2.extend({}, options, {
                        autoplay,
                        prevArrow:
                            '<button class="slick-prev slick-arrow" aria-label="' +
                            theme.translations.previous +
                            '" type="button">' +
                            theme.icons.arrowSlider +
                            '</button>',
                        nextArrow:
                            '<button class="slick-next slick-arrow" aria-label="' +
                            theme.translations.next +
                            '" type="button">' +
                            theme.icons.arrowSlider +
                            '</button>',
                    })),
                        slider.on('init', function () {
                            $2(this).removeClass('gallery-slider--is-loading')
                        }),
                        slider.slick(options)
                }
                function _loadMosaic(t) {
                    var section2 = $2(t),
                        slider = $2(t).find('.js-mosaic__blocks'),
                        sectionId = $2(t).children().first().data('section-id'),
                        lastWindowWidth =
                            window.innerWidth ||
                            document.documentElement.clientWidth
                    Site.sliders.initMobileSlider(slider),
                        Site.video(),
                        $2(window).on(
                            'resize.' + sectionId,
                            Reqs.debounce(function () {
                                var windowWidth =
                                    window.innerWidth ||
                                    document.documentElement.clientWidth
                                lastWindowWidth != windowWidth &&
                                    Site.sliders.initMobileSlider(slider),
                                    (lastWindowWidth = windowWidth)
                            }, 250)
                        )
                }
                function _loadHero(t) {
                    var hero = $2(t).find('.js-hero-slider'),
                        sectionId = $2(t)
                            .find('[data-section-id]')
                            .data('section-id'),
                        autoplay = hero.data('autoplay'),
                        options = JSON.parse(
                            hero.data('slick').replace(/'/g, '"')
                        ),
                        scrollDownBtn = $2(t).find('.js-scroll-down')
                    ;(options = $2.extend({}, options, {
                        autoplay,
                        prevArrow:
                            '<button class="slick-prev slick-arrow" aria-label="' +
                            theme.translations.previous +
                            '" type="button">' +
                            theme.icons.arrowSlider +
                            '</button>',
                        nextArrow:
                            '<button class="slick-next slick-arrow" aria-label="' +
                            theme.translations.next +
                            '" type="button">' +
                            theme.icons.arrowSlider +
                            '</button>',
                    })),
                        hero.on('init', function () {
                            var currentStyle = $2(this)
                                .find('.js-slide[data-slick-index="1"]')
                                .data('style')
                            $2(this).attr('data-current-style', currentStyle),
                                $2(this).removeClass('hero--is-loading')
                        }),
                        hero.on(
                            'beforeChange',
                            function (event, slick, currentSlide, nextSlide) {
                                var activeSlide = parseInt(nextSlide + 1),
                                    $nextSlide = $2(this).find(
                                        '.js-slide[data-slick-index="' +
                                            activeSlide +
                                            '"]'
                                    ),
                                    currentStyle = $nextSlide.data('style')
                                $2(this).attr(
                                    'data-current-style',
                                    currentStyle
                                )
                            }
                        ),
                        hero.slick(options),
                        $2(window).on(
                            'scroll.' + sectionId + ' resize.' + sectionId,
                            Reqs.throttle(function () {
                                var windowHeight = $2(window).height(),
                                    windowScroll = window.scrollY,
                                    heroHeight = hero.height(),
                                    heroOffsetTop = hero.offset().top
                                heroOffsetTop + heroHeight >= windowScroll &&
                                heroOffsetTop - windowHeight <= windowScroll &&
                                autoplay
                                    ? hero.slick('slickPlay')
                                    : hero.slick('slickPause')
                            }, 100)
                        ),
                        scrollDownBtn.on('click', function (e2) {
                            e2.preventDefault()
                            var headerHeight = 59,
                                scrollToPosition = parseInt(
                                    hero.offset().top +
                                        hero.outerHeight() -
                                        headerHeight
                                )
                            $2('html, body')
                                .stop(!0, !1)
                                .animate({ scrollTop: scrollToPosition })
                        }),
                        Site.header.resetHeader(),
                        Site.header.init()
                }
                function _loadFeaturedCollection(t) {
                    var collectionGrid = $2(t).find('.js-collection-grid'),
                        sectionId = collectionGrid.data('section-id')
                    Collection.init(),
                        Site.initReviews(),
                        Site.sliders.collection(),
                        Site.sliders.setCarouselState(collectionGrid),
                        $2(window).on(
                            'resize.' + sectionId,
                            Reqs.debounce(function () {
                                Site.sliders.setCarouselState(collectionGrid)
                            }, 250)
                        )
                }
                function _loadCollectionTemplate(t) {
                    Collection.init(),
                        Site.sliders.collection(),
                        Site.initReviews(),
                        Site.preventBannerContentOverflow()
                }
                function _loadFeaturedVideo(t) {
                    Site.video()
                }
                function _loadLogoList(t) {
                    var slider = $2(t).find('[data-logo-list-slider]')
                    Site.sliders.logoListSlider(slider)
                }
                function _loadContactSection() {
                    Site.preventBannerContentOverflow()
                }
                function _loadAboutTemplate(t) {
                    Site.header.init(), Site.preventBannerContentOverflow()
                }
                function _loadRelatedProductsTemplate(t) {
                    RelatedProducts.init()
                }
                function _loadFaqList(t) {
                    var $faqList = $2(t).find('.faq-list')
                    $faqList.on(
                        'click',
                        '.faq-list__item-question',
                        function (e2) {
                            e2.preventDefault(),
                                $2(this).parent().toggleClass('is-expanded')
                        }
                    )
                }
            },
            _onSectionUnload: function (e) {
                var section =
                    e.target.children[0].getAttribute('data-section-type') || !1
                switch (section) {
                    case 'header':
                        _unloadHeader(e.target)
                        break
                    case 'gallery':
                        _unloadGallery(e.target)
                        break
                    case 'slideshow':
                        _unloadHero(e.target)
                        break
                    case 'logo-list':
                        _unloadLogoList(e.target)
                        break
                    case 'mosaic':
                        _unloadMosaic(e.target)
                        break
                    case 'popup':
                        _unloadPopup(e.target)
                        break
                    case 'product':
                        _unloadProduct(e.target)
                        break
                    case 'collection-template':
                        _unloadProductGrid(e.target)
                        break
                    case 'featured-collection':
                        _unloadProductGrid(e.target)
                        break
                    case 'related-products':
                        _unloadProductGrid(e.target)
                        break
                    case 'blog-template':
                        _unloadBlogTemplate(e.target)
                        break
                }
                function _unloadHeader(t) {
                    $2(window).off('scroll.header resize.header')
                }
                function _unloadGallery(t) {
                    var slider = $2(t).find('.js-slider')
                    slider.slick('unslick'), $2(window).off('scroll.gallery')
                }
                function _unloadHero(t) {
                    var hero = $2(t).find('.js-hero-slider'),
                        sectionId = $2(t)
                            .find('[data-section-id]')
                            .data('section-id')
                    hero.slick('unslick'),
                        $2(window)
                            .off('scroll.' + sectionId)
                            .off('resize.' + sectionId)
                }
                function _unloadLogoList(t) {
                    var sectionId = $2(t)
                        .find('[data-section-id]')
                        .data('section-id')
                    $2(window).off('resize.' + sectionId)
                }
                function _unloadMosaic(t) {
                    var slider = $2(t).find('.js-mosaic__blocks'),
                        isSlickActive = slider.hasClass('slick-initialized'),
                        sectionId = (sectionId = $2(t)
                            .children()
                            .first()
                            .data('section-id'))
                    isSlickActive && slider.slick('unslick'),
                        $2(window).off('resize.' + sectionId)
                }
                function _unloadPopup(t) {
                    Popup.hide()
                }
                function _unloadProduct(t) {
                    var $container = $2(t).children().first(),
                        sectionId = $container.data('section-id'),
                        namespace = '.product' + sectionId,
                        $shopBar = $2('#shop-bar')
                    $shopBar.remove(),
                        ProductVideo.removeSectionVideos(sectionId),
                        ProductModel.removeSectionModels(sectionId),
                        $2(window).off('resize.product'),
                        $2(window).off('scroll.product'),
                        $container.off(namespace)
                }
                function _unloadProductGrid(t) {
                    var sectionId = $2(t).children().first().data('section-id'),
                        actions =
                            'resize.' +
                            sectionId +
                            ' scroll.endlessScroll--' +
                            sectionId +
                            ' load resize.endlessScroll--' +
                            sectionId
                    $2(window).off(actions)
                }
                function _unloadBlogTemplate(t) {
                    var sectionId = $2(t).children().first().data('section-id'),
                        actions =
                            'scroll.endlessScroll--' +
                            sectionId +
                            ' load resize.endlessScroll--' +
                            sectionId
                    $2(window).off(actions)
                }
            },
            _onSectionSelect: function (e) {
                var section =
                    e.target.children[0].getAttribute('data-section-type') ||
                    e.target.children[1].getAttribute('data-section-type') ||
                    e.target.children[2].getAttribute('data-section-type') ||
                    !1
                switch (section) {
                    case 'header':
                        _selectHeader(e.target)
                        break
                    case 'blog-template':
                        _selectBlog(e.target)
                        break
                    case 'popup':
                        _selectPopup(e.target)
                        break
                }
                function _selectHeader(t) {
                    Site.header.resetHeader(),
                        Site.nav.hide(),
                        Site.header.init()
                }
                function _selectPopup(t) {
                    Popup.init()
                }
                function _selectBlog(t) {
                    Blog.init()
                }
            },
            _onSectionDeselect: function (e) {
                var section =
                    e.target.children[0].getAttribute('data-section-type') || !1
                switch (section) {
                    case 'header':
                        _deselectHeader(e.target)
                        break
                }
                function _deselectHeader(t) {
                    Site.nav.hide()
                }
            },
            _onBlockSelect: function (e) {
                var block = e.target.getAttribute('data-block') || !1
                switch (block) {
                    case 'slide':
                        _selectBlockSlide(e.target)
                        break
                    case 'mosaic':
                        _selectBlockMosaic(e.target)
                        break
                    case 'testimonial':
                        _selectBlockTestimonial(e.target)
                        break
                    case 'logo-list-slide':
                        _selectBlockLogoListSlide(e.target)
                        break
                }
                function _selectBlockSlide(t) {
                    var slider = $2(t).parents('.slick-slider'),
                        index = $2(t)
                            .parents('.slick-slide:not(.slick-cloned)')
                            .attr('data-slick-index')
                    slider.slick('slickGoTo', index), slider.slick('slickPause')
                }
                function _selectBlockMosaic(t) {
                    var $slider = $2(t).parents('.js-mosaic__blocks'),
                        isSlickActive = $slider.hasClass('slick-initialized'),
                        index
                    isSlickActive &&
                        ((index = $2(t)
                            .parents('.slick-slide:not(.slick-cloned)')
                            .attr('data-slick-index')),
                        $slider.slick('slickGoTo', index),
                        $slider.slick('slickPause')),
                        Site.video()
                }
                function _selectBlockLogoListSlide(t) {
                    var $slider = $2(t).parents('[data-logo-list-slider]'),
                        index = $2(t).attr('data-slide-index')
                    $slider.data('flickity') &&
                        ($slider.flickity('select', index),
                        $slider.flickity('pausePlayer'))
                }
            },
            _onBlockDeselect: function (e) {
                var block = e.target.getAttribute('data-block') || !1
                switch (block) {
                    case 'slide':
                        _deselectBlockSlide(e.target)
                        break
                    case 'logo-list-slide':
                        _deselectBlockLogoListSlide(e.target)
                        break
                }
                function _deselectBlockSlide(t) {
                    var $slider = $2(t).parents('.slick-slider'),
                        autoplay = $slider.data('autoplay')
                    autoplay && $slider.slick('slickPlay')
                }
                function _deselectBlockLogoListSlide(t) {
                    var $slider = $2(t).parents('[data-logo-list-slider]')
                    $slider.flickity('unpausePlayer')
                }
            },
        },
        s
    ;(window.Site = {
        settings: { b: $2('body'), w: $2(window), d: $2(document) },
        init: function () {
            ;(s = this.settings),
                this.general(),
                this.header.init(),
                this.footer(),
                this.nav.init(),
                this.sliders.init(),
                this.addresses.init(),
                this.keyboardAccessible(),
                this.video(),
                this.faq(),
                this.checkReviewsApp(),
                this.getQueryParameter('customer_posted') == 'true' &&
                    ($2('body').addClass('signUp-posted'),
                    s.d.scrollTop(s.d.height() - s.w.height()))
        },
        general: function () {
            $2('body').removeClass('is-page-loading'),
                s.b.on('click', '.share-link', function (event) {
                    event.preventDefault()
                    var el = $2(this),
                        popup = el.attr('data-network'),
                        link = el.attr('href'),
                        w = 700,
                        h = 400
                    switch (popup) {
                        case 'twitter':
                            h = 300
                            break
                    }
                    window.open(link, popup, 'width=' + w + ', height=' + h)
                }),
                s.b.on('click', '[data-anchor-link]', function (e) {
                    var anchor = $2(this).attr('href')
                    if ($2(anchor).length) {
                        var anchorTop = $2(anchor).offset().top - 60
                        $2('html, body')
                            .stop()
                            .animate({ scrollTop: anchorTop }),
                            e.preventDefault()
                    }
                })
        },
        getQueryParameter: function (name) {
            name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]')
            var regex = new RegExp('[\\?&]' + name + '=([^&#]*)'),
                results = regex.exec(location.search)
            return results === null
                ? ''
                : decodeURIComponent(results[1].replace(/\+/g, ' '))
        },
        keyboardAccessible: function () {
            s.w.mousedown(function (event) {
                s.b.addClass('no-outline')
            }),
                s.w.keyup(function (event) {
                    event.keyCode === 9 && s.b.removeClass('no-outline')
                })
        },
        preventBannerContentOverflow: function () {
            var selectors = {
                bannerContainer: '[data-banner-container]',
                bannerContent: '[data-banner-content]',
            }
            $2(selectors.bannerContainer).each(function () {
                var $content = $2(selectors.bannerContent, this),
                    contentHeight = parseInt($content.outerHeight(!0))
                $2(this).css('min-height', contentHeight)
            })
        },
        header: {
            init: function () {
                var $header = $2('.site-header'),
                    $headerContainer = $2('#shopify-section-header'),
                    $announcementContainer = $2(
                        '#shopify-section-announcement'
                    ),
                    $bodyWrap = $2('.bodyWrap'),
                    headerTransparent = Site.isHeaderTransparent(),
                    lastWindowWidth =
                        window.innerWidth ||
                        document.documentElement.clientWidth,
                    namespace = '.header'
                checkNavigationOverlapping(),
                    stickyHeaderState(),
                    $2(window)
                        .off(namespace)
                        .on('load', checkNavigationOverlapping)
                        .on(
                            'scroll' + namespace,
                            Reqs.throttle(stickyHeaderState, 50)
                        )
                        .on(
                            'resize' + namespace,
                            Reqs.throttle(Site.setCartClosePosition, 50)
                        )
                        .on(
                            'resize' + namespace,
                            Reqs.debounce(function () {
                                var windowWidth =
                                    window.innerWidth ||
                                    document.documentElement.clientWidth
                                lastWindowWidth != windowWidth &&
                                    checkNavigationOverlapping(),
                                    (lastWindowWidth = windowWidth)
                            }, 250)
                        )
                function stickyHeaderState() {
                    var scrolled = window.scrollY,
                        contentTop = $bodyWrap.offset().top
                    scrolled > contentTop
                        ? ($headerContainer.addClass(
                              'shopify-section-header--fixed'
                          ),
                          $announcementContainer.addClass(
                              'shopify-section-header--fixed'
                          ),
                          $header
                              .addClass('header--has-scrolled')
                              .removeClass('header--transparent'))
                        : ($headerContainer.removeClass(
                              'shopify-section-header--fixed'
                          ),
                          $announcementContainer.removeClass(
                              'shopify-section-header--fixed'
                          ),
                          $header.removeClass('header--has-scrolled'),
                          headerTransparent &&
                              $header.addClass('header--transparent'))
                }
                function checkNavigationOverlapping() {
                    var isNavigationOverlapping = getNavigationOverlapping(),
                        isDesktop = $2(window).width() >= 1025
                    isNavigationOverlapping || !isDesktop
                        ? $header
                              .removeClass(
                                  'header--is-standard header--search-visible'
                              )
                              .addClass('header--is-hamburger')
                        : ($header
                              .removeClass('header--is-hamburger')
                              .addClass('header--is-standard'),
                          Site.nav.hide()),
                        setBodySpacer(),
                        $2(document).one('shopify:section:unload', function () {
                            setTimeout(setBodySpacer, 100)
                        })
                }
                function getNavigationOverlapping() {
                    $header
                        .addClass('header--is-standard')
                        .removeClass('header--is-hamburger')
                    var headerContainerWidth = $2(
                            '.site-header .container > .row'
                        ).width(),
                        navMenuWidth = getMenuItemsWidth(),
                        isNavigationOverlapping = !1,
                        isNavCentered =
                            $header.hasClass(
                                'header--logo_center_links_center'
                            ) ||
                            $header.hasClass('header--logo_left_links_center'),
                        isNavLeftLogoCentered =
                            $header.hasClass(
                                'header--logo_center_links_left'
                            ) ||
                            $header.hasClass('header--logo_left_links_left'),
                        additionalSpace = 40,
                        headerIconsWidth = $2('.header__icons').outerWidth(),
                        logoWidth = getLogoWidth()
                    return (
                        isNavCentered &&
                            ((logoWidth =
                                logoWidth < headerIconsWidth
                                    ? headerIconsWidth
                                    : logoWidth),
                            (logoWidth = logoWidth * 2),
                            (headerIconsWidth = 0)),
                        (isNavigationOverlapping =
                            parseInt(headerContainerWidth) <
                            parseInt(navMenuWidth)),
                        isNavLeftLogoCentered &&
                            (isNavigationOverlapping =
                                parseInt(
                                    (headerContainerWidth - logoWidth) / 2
                                ) < parseInt(navMenuWidth)),
                        isNavigationOverlapping
                    )
                }
                function getLogoWidth() {
                    var logoWidth = 0,
                        $logoImage = $2('.logo__image-link'),
                        $logoText = $2('.logo__text')
                    return (
                        $logoImage.length &&
                            (logoWidth = $logoImage.data('width')),
                        $logoText.length &&
                            (logoWidth += $logoText.outerWidth()),
                        logoWidth
                    )
                }
                function getMenuItemsWidth() {
                    var itemsWidth = 0
                    return (
                        $2('.nav-standard .menu > .menu-item').each(
                            function () {
                                itemsWidth += $2(this).outerWidth(!0)
                            }
                        ),
                        itemsWidth
                    )
                }
                function setBodySpacer() {
                    var headerTransparent2 = Site.isHeaderTransparent()
                    $header.toggleClass(
                        'header--transparent',
                        headerTransparent2
                    ),
                        headerTransparent2
                            ? $bodyWrap.removeAttr('data-spacer')
                            : ($bodyWrap.attr('data-spacer', 'default'),
                              $header.hasClass('header--is-hamburger')
                                  ? $bodyWrap.attr('data-spacer', 'small')
                                  : $header.hasClass(
                                        'header--logo_center_links_center'
                                    ) && $bodyWrap.attr('data-spacer', 'large'))
                }
            },
            resetHeader: function () {
                var $body = $2('body'),
                    $bodyWrap = $2('.bodyWrap'),
                    $hamburger = $2('#hamburger-menu'),
                    $transformElements = $2(
                        '.site-header, .site-alert, .bodyWrap, .shop-bar'
                    ),
                    scrollableElement = document.querySelector(
                        '.nav-hamburger .nav-inner'
                    )
                $body.removeClass('nav--is-visible'),
                    $bodyWrap.removeAttr('style'),
                    $transformElements.css('transform', 'none'),
                    $hamburger.removeClass('open'),
                    scrollLock.enablePageScroll(scrollableElement),
                    $body.hasClass('cart--is-visible') &&
                        $2('.js-cartToggle').eq(0).trigger('click')
            },
        },
        isHeaderTransparent: function () {
            var $header = $2('.site-header'),
                headerFull =
                    $2('.main-content')
                        .children()
                        .first('.shopify-section')
                        .hasClass('header--full') ||
                    $2('.main-content')
                        .children()
                        .first('.shopify-section')
                        .find('[data-header-style="index"]').length,
                headerTransparent = !!(
                    $header.data('transparent') && headerFull
                )
            return headerTransparent
        },
        setCartClosePosition: function () {
            if ($2('#cartTotal').length) {
                var $cartBtnClose = $2('.cart-drawer .js-cartToggle'),
                    scrollTop = window.scrollY,
                    cartBtnPositionTop =
                        $2('#cartTotal').offset().top - scrollTop,
                    containerPadding = 40,
                    cartBtnTop = cartBtnPositionTop - containerPadding
                $cartBtnClose.css('top', cartBtnTop)
            }
        },
        footer: function () {
            var $productContainer = $2('.js-product-template'),
                $siteFooter = $2('.site-footer'),
                shopifyLink = document.querySelector('[data-powered-link] a')
            shopifyLink && shopifyLink.relList.add('noopener')
            var selectors = {
                    disclosureLocale: '[data-disclosure-locale]',
                    disclosureCurrency: '[data-disclosure-currency]',
                },
                $disclosureLocale = $2(selectors.disclosureLocale, $siteFooter),
                disclosureLocale = {},
                $disclosureCurrency = $2(
                    selectors.disclosureCurrency,
                    $siteFooter
                ),
                disclosureCurrency = {}
            $disclosureLocale.length &&
                (disclosureLocale = new Disclosure($disclosureLocale)),
                $disclosureCurrency.length &&
                    (disclosureCurrency = new Disclosure($disclosureCurrency)),
                $2(window).on(
                    'scroll',
                    Reqs.throttle(function () {
                        var scrolled = window.scrollY,
                            $shopBar = $2('#shop-bar')
                        if ($productContainer.length && $shopBar.length) {
                            var productContainerOffset =
                                $productContainer.offset().top
                            scrolled > productContainerOffset
                                ? ($shopBar.addClass('shop-bar--is-visible'),
                                  $siteFooter.addClass('site-footer--push'))
                                : scrolled < productContainerOffset - 60 &&
                                  ($shopBar.removeClass('shop-bar--is-visible'),
                                  $siteFooter.removeClass('site-footer--push'))
                        }
                    }, 100)
                )
        },
        video: function () {
            Reqs.lightbox(),
                $2('.js-video').each(function () {
                    $2(this).magnificPopup({
                        closeMarkup:
                            '<button title="%title%" type="button" class="mfp-close">' +
                            theme.icons.close +
                            '</button>',
                        type: 'iframe',
                        mainClass: 'mfp-fade',
                        removalDelay: 160,
                        preloader: !1,
                        autoFocusLast: !1,
                        fixedContentPos: !1,
                        iframe: {
                            markup: '<div class="mfp-iframe-scaler"><div class="mfp-close"></div><iframe class="mfp-iframe" frameborder="0" allowfullscreen allow="autoplay, fullscreen"></iframe></div>',
                            patterns: {
                                youtube: {
                                    index: 'youtube.com/',
                                    id: function (url) {
                                        var m = url.match(
                                            /^.*(?:youtu.be\/|v\/|e\/|u\/\w+\/|embed\/|v=)([^#\&\?]*).*/
                                        )
                                        return !m || !m[1] ? null : m[1]
                                    },
                                    src: '//www.youtube.com/embed/%id%?autoplay=1&rel=0modestbranding=0',
                                },
                                youtube_short: {
                                    index: 'youtu.be/',
                                    id: 'youtu.be/',
                                    src: '//www.youtube.com/embed/%id%?autoplay=1&autohide=0&branding=0&cc_load_policy=0&controls=0&fs=0&iv_load_policy=3&modestbranding=1&playsinline=1&quality=hd720&rel=0&showinfo=0&wmode=opaque',
                                },
                            },
                            srcAction: 'iframe_src',
                        },
                    })
                })
        },
        faq: function () {
            $2('.faq-list__item-question').on('click', function (e) {
                e.preventDefault(), $2(this).parent().toggleClass('is-expanded')
            })
        },
        sliders: {
            init: function () {
                this.hero(),
                    this.collection(),
                    this.gallery(),
                    this.mosaic(),
                    this.logoList()
            },
            hero: function () {
                var hero = $2('.js-hero-slider'),
                    scrollDownBtn = $2('.js-scroll-down'),
                    isWindowLoaded = !1
                hero.each(function () {
                    var currentHero = $2(this),
                        sectionId = $2(this)
                            .closest('[data-section-id]')
                            .data('section-id'),
                        autoplay = currentHero.data('autoplay'),
                        options = JSON.parse(
                            currentHero.data('slick').replace(/'/g, '"')
                        )
                    ;(options = $2.extend({}, options, {
                        autoplay: !1,
                        prevArrow:
                            '<button class="slick-prev slick-arrow" aria-label="' +
                            theme.translations.previous +
                            '" type="button">' +
                            theme.icons.arrowSlider +
                            '</button>',
                        nextArrow:
                            '<button class="slick-next slick-arrow" aria-label="' +
                            theme.translations.next +
                            '" type="button">' +
                            theme.icons.arrowSlider +
                            '</button>',
                    })),
                        currentHero.on('init', function () {
                            var currentStyle = $2(this)
                                .find('.js-slide[data-slick-index="1"]')
                                .data('style')
                            $2(this)
                                .attr('data-current-style', currentStyle)
                                .removeClass('hero--is-loading')
                        }),
                        currentHero.on(
                            'beforeChange',
                            function (event, slick, currentSlide, nextSlide) {
                                var activeSlide = parseInt(nextSlide + 1),
                                    $nextSlide = $2(this).find(
                                        '.js-slide[data-slick-index="' +
                                            activeSlide +
                                            '"]'
                                    ),
                                    currentStyle = $nextSlide.data('style')
                                $2(this).attr(
                                    'data-current-style',
                                    currentStyle
                                )
                            }
                        ),
                        currentHero.slick(options),
                        $2(window).on(
                            'scroll.' + sectionId + ' resize.' + sectionId,
                            Reqs.throttle(function () {
                                var isSlideshowVisible = currentHero.visible(
                                        !0
                                    ),
                                    slickInitialized =
                                        currentHero.hasClass(
                                            'slick-initialized'
                                        )
                                slickInitialized &&
                                    (isWindowLoaded &&
                                    isSlideshowVisible &&
                                    autoplay
                                        ? currentHero.slick('slickPlay')
                                        : currentHero.slick('slickPause'))
                            }, 100)
                        ),
                        $2(window).on('load', function () {
                            ;(isWindowLoaded = !0),
                                autoplay && hero.slick('slickPlay')
                        })
                }),
                    $2('.slick-list').attr('tabindex', '-1'),
                    scrollDownBtn.on('click', function (e) {
                        e.preventDefault()
                        var headerHeight = 59,
                            scrollToPosition = parseInt(
                                hero.offset().top +
                                    hero.outerHeight() -
                                    headerHeight
                            )
                        $2('html, body')
                            .stop(!0, !1)
                            .animate({ scrollTop: scrollToPosition })
                    })
            },
            collection: function () {
                var $container = $2('.js-collection-grid'),
                    $carousel = $2('.js-collection-slider')
                $2('.quickView-button', $carousel).on('click', function () {
                    $2(this)
                        .closest('.slick-slide')
                        .addClass('slick-slide--quickView')
                }),
                    $2('html, body').on('quickView:show', function () {
                        setQuickViewPosition(),
                            $carousel
                                .find('.slick-slide--quickView')
                                .removeClass('slick-slide--quickView')
                    }),
                    $2('html, body').on('quickView:ajax', setQuickViewPosition),
                    $container.each(function () {
                        Site.sliders.setCarouselState($2(this))
                    }),
                    $carousel.each(function () {
                        Site.removeAnimationClass($2(this))
                    }),
                    $2(window).on(
                        'resize',
                        Reqs.debounce(function () {
                            setQuickViewPosition(),
                                $container.each(function () {
                                    Site.sliders.setCarouselState($2(this))
                                })
                        }, 250)
                    )
                function setQuickViewPosition() {
                    var $slide = $carousel.find('.slick-slide--quickView')
                    if (
                        ($slide.length ||
                            ($slide = $carousel
                                .find('.quickView--is-visible')
                                .closest('.slick-slide')),
                        $carousel.length && $slide.length)
                    ) {
                        var $quickView = $slide.find('.quickView-wrap'),
                            offsetLeft =
                                $carousel
                                    .find('.slick-slide.slick-current')
                                    .position().left - $slide.position().left
                        $quickView.css('left', offsetLeft)
                    }
                }
            },
            setCarouselState: function ($container) {
                if (typeof $container > 'u') return
                var $carousel = $container.find('.js-collection-slider')
                if ($carousel.length) {
                    Site.removeAnimationClass($container)
                    var isDesktopInitialized =
                            $carousel.hasClass('slick-initialized'),
                        slidesPerRow = parseInt(
                            $container.data('slides-per-row')
                        ),
                        windowWidth =
                            window.innerWidth ||
                            document.documentElement.clientWidth ||
                            document.body.clientWidth,
                        options = {
                            slidesPerRow,
                            infinite: !1,
                            dots: !1,
                            prevArrow:
                                '<button class="slick-prev slick-arrow" aria-label="' +
                                theme.translations.previous +
                                '" type="button">' +
                                theme.icons.arrowLong +
                                '</button>',
                            nextArrow:
                                '<button class="slick-next slick-arrow" aria-label="' +
                                theme.translations.next +
                                '" type="button">' +
                                theme.icons.arrowLong +
                                '</button>',
                            responsive: [
                                {
                                    breakpoint: 1024,
                                    settings: { slidesPerRow: 2 },
                                },
                            ],
                        }
                    windowWidth >= 768
                        ? initCarousel()
                        : isDesktopInitialized && $carousel.slick('unslick'),
                        setArrowsPosition()
                }
                function initCarousel() {
                    isDesktopInitialized ||
                        ($carousel.on('init', setArrowsPosition),
                        $carousel
                            .slick(options)
                            .on('beforeChange', function () {
                                $2('.quickView--is-visible').length &&
                                    QuickView.hide()
                            }))
                }
                function setArrowsPosition() {
                    var $arrows = $carousel.find('.slick-arrow'),
                        arrowTop =
                            $carousel
                                .find('.product-block__image')
                                .outerHeight() / 2
                    $arrows.css('top', arrowTop)
                }
            },
            gallery: function () {
                var slider = $2('.js-slider')
                slider.each(function () {
                    var currentSlider = $2(this),
                        autoplay = currentSlider.data('autoplay'),
                        options = JSON.parse(
                            currentSlider.data('slick').replace(/'/g, '"')
                        )
                    ;(options = $2.extend({}, options, {
                        autoplay: !1,
                        prevArrow:
                            '<button class="slick-prev slick-arrow" aria-label="' +
                            theme.translations.previous +
                            '" type="button">' +
                            theme.icons.arrowSlider +
                            '</button>',
                        nextArrow:
                            '<button class="slick-next slick-arrow" aria-label="' +
                            theme.translations.next +
                            '" type="button">' +
                            theme.icons.arrowSlider +
                            '</button>',
                    })),
                        currentSlider.on('init', function () {
                            $2(this).removeClass('gallery-slider--is-loading')
                        }),
                        currentSlider.slick(options),
                        $2(window)
                            .on(
                                'scroll.gallery',
                                Reqs.debounce(function () {
                                    var isSliderVisible =
                                        isAnyPartOfElementInViewport(
                                            currentSlider.get(0)
                                        )
                                    isSliderVisible && autoplay
                                        ? currentSlider.slick('slickPlay')
                                        : currentSlider.slick('slickPause')
                                }, 150)
                            )
                            .on('load', function () {
                                autoplay && currentSlider.slick('slickPlay')
                            })
                })
                function isAnyPartOfElementInViewport(el) {
                    const rect = el.getBoundingClientRect(),
                        windowHeight =
                            window.innerHeight ||
                            document.documentElement.clientHeight,
                        windowWidth =
                            window.innerWidth ||
                            document.documentElement.clientWidth,
                        vertInView =
                            rect.top <= windowHeight &&
                            rect.top + rect.height >= 0,
                        horInView =
                            rect.left <= windowWidth &&
                            rect.left + rect.width >= 0
                    return vertInView && horInView
                }
            },
            mosaic: function () {
                var self2 = this,
                    slider = $2('.js-mosaic__blocks')
                slider.each(function () {
                    var currentSlider = $2(this),
                        sectionId = $2(this)
                            .closest('[data-section-id]')
                            .data('section-id'),
                        lastWindowWidth =
                            window.innerWidth ||
                            document.documentElement.clientWidth
                    self2.initMobileSlider(currentSlider),
                        $2(window).on(
                            'resize.' + sectionId,
                            Reqs.debounce(function () {
                                var windowWidth =
                                    window.innerWidth ||
                                    document.documentElement.clientWidth
                                lastWindowWidth != windowWidth &&
                                    self2.initMobileSlider(currentSlider),
                                    (lastWindowWidth = windowWidth)
                            }, 250)
                        )
                })
            },
            initMobileSlider: function (currentSlider) {
                var isMobile = $2(window).width() < 768,
                    isSlickActive = currentSlider.hasClass('slick-initialized'),
                    options = {
                        infinite: !0,
                        autoplay: !1,
                        speed: 300,
                        slidesToShow: 1,
                        arrows: !0,
                        prevArrow:
                            '<button class="slick-prev slick-arrow" aria-label="' +
                            theme.translations.previous +
                            '" type="button">' +
                            theme.icons.arrowSlider +
                            '</button>',
                        nextArrow:
                            '<button class="slick-next slick-arrow" aria-label="' +
                            theme.translations.next +
                            '" type="button">' +
                            theme.icons.arrowSlider +
                            '</button>',
                        dots: !1,
                    }
                isMobile && !isSlickActive
                    ? currentSlider.slick(options)
                    : !isMobile &&
                      isSlickActive &&
                      currentSlider.slick('unslick')
            },
            logoList: function () {
                var slider = $2('[data-logo-list-slider]')
                slider.each(function () {
                    var currentSlider = $2(this),
                        sectionId = currentSlider
                            .closest('[data-section-id]')
                            .attr('data-section-id')
                    Site.sliders.logoListSlider(currentSlider),
                        $2(window).on(
                            'resize.' + sectionId,
                            Reqs.debounce(
                                Site.sliders.logoListSlider.bind(
                                    this,
                                    currentSlider
                                ),
                                250
                            )
                        )
                })
            },
            logoListSlider: function (slider) {
                var windowWidth =
                        window.innerWidth ||
                        document.documentElement.clientWidth ||
                        document.body.clientWidth,
                    itemWidth = 220,
                    itemsWidth = slider.find('[data-block]').length * itemWidth
                itemsWidth > windowWidth &&
                    !slider.data('flickity') &&
                    slider.flickity({
                        prevNextButtons: !1,
                        pageDots: !1,
                        draggable: !0,
                        adaptiveHeight: !1,
                        autoPlay: 4e3,
                        contain: !0,
                        wrapAround: !0,
                    })
            },
            initSlickSlider: function (slider, options) {
                var isSlickActive = slider.hasClass('slick-initialized')
                isSlickActive || slider.slick(options)
            },
            destroySlickSlider: function (slider) {
                var isSlickActive = slider.hasClass('slick-initialized')
                isSlickActive && slider.slick('unslick')
            },
            checkThumbnailsOverflow: function ($thumbs) {
                var thumbWidth = $thumbs.find('.js-slide').outerWidth(),
                    slidesCount = $thumbs.find('.js-slide').length,
                    slidesWidth = parseInt(thumbWidth * slidesCount),
                    slidesContainerWidth = $thumbs.width()
                return slidesContainerWidth < slidesWidth
            },
        },
        nav: {
            getWidth: function () {
                var ww = $2(window).outerWidth()
                return ww >= 1280 ? ww / 3 : ww >= 768 ? (ww * 2) / 3 : ww
            },
            init: function () {
                Site.nav.bindings(), Site.nav.activeLinks()
            },
            bindings: function () {
                var $body = $2('body'),
                    $header = $2('.site-header'),
                    namespace = '.header',
                    scrollLockTimeout = 0
                $body.off(namespace),
                    $2(document).off(namespace),
                    $2('.js-menuToggle').off(namespace),
                    $2('[data-dropdown-parent], .nav-main a[href^="#"]').off(
                        namespace
                    ),
                    $2('.nav-standard .menu-item--dropdown').off(namespace),
                    $2('.nav-standard .menu-item--meganav').off(namespace),
                    $2('.nav-standard .toggle-submenu').off(namespace),
                    $2('[data-dropdown-trigger]').off(namespace),
                    $2('.js-searchToggle').off(namespace),
                    $2('.js-menuToggle').on('click' + namespace, function (e) {
                        e.preventDefault(),
                            $2('body').hasClass('nav--is-visible')
                                ? Site.nav.hide()
                                : Site.nav.show()
                    }),
                    $2('[data-dropdown-parent]').on(
                        'mouseenter' + namespace,
                        function (e) {
                            window.isTouch ||
                                $2(this)
                                    .addClass('is-expanded')
                                    .find('[aria-expanded]')
                                    .attr('aria-expanded', !0)
                                    .end()
                                    .siblings()
                                    .removeClass('is-expanded')
                                    .find('[aria-expanded]')
                                    .attr('aria-expanded', !1)
                        }
                    ),
                    $2('.nav-standard .menu-item--dropdown').on(
                        'mouseleave' + namespace,
                        function () {
                            $2(this)
                                .removeClass('is-expanded')
                                .find('[aria-expanded]')
                                .attr('aria-expanded', !1)
                        }
                    ),
                    $2('.nav-standard .menu-item--meganav')
                        .on('mouseenter' + namespace, function () {
                            $2('.site-header').addClass(
                                'header--megamenu-visible'
                            ),
                                $2(this)
                                    .find('.visible-nav-link')
                                    .removeAttr('tabindex')
                        })
                        .on('mouseleave' + namespace, function () {
                            $2(this)
                                .removeClass('is-expanded')
                                .find('[aria-expanded]')
                                .attr('aria-expanded', !1),
                                $2('.site-header').removeClass(
                                    'header--megamenu-visible'
                                ),
                                $2('.visible-nav-link').attr('tabindex', '-1')
                        }),
                    $2('[data-dropdown-trigger], .nav-main a[href^="#"]').on(
                        'click' + namespace,
                        function (e) {
                            e.preventDefault()
                            var el = $2(this).parent(),
                                isSubmenuOpen = el.hasClass('is-expanded')
                            isSubmenuOpen
                                ? (Site.nav.submenu.close(el),
                                  Site.nav.submenuStandard.close(el))
                                : (Site.nav.submenu.open(el),
                                  Site.nav.submenuStandard.open(el))
                        }
                    ),
                    $body.on('keyup' + namespace, function (e) {
                        if (
                            !(
                                e.keyCode !== slate.utils.keyboardKeys.TAB &&
                                e.keyCode !== slate.utils.keyboardKeys.ESCAPE
                            )
                        ) {
                            var $focusedElement = $2(e.target),
                                isSubmenuChild =
                                    $focusedElement.parents('.submenu').length,
                                isHamburgerChild =
                                    $focusedElement.parents(
                                        '.nav-hamburger'
                                    ).length,
                                isSearchChild =
                                    $focusedElement.parents('.nav-search')
                                        .length ||
                                    !$focusedElement.is(
                                        '.js-searchToggle--open'
                                    )
                            e.keyCode === slate.utils.keyboardKeys.TAB
                                ? (isSubmenuChild ||
                                      Site.nav.submenuStandard.close(),
                                  isHamburgerChild || Site.nav.hide(),
                                  isSearchChild ||
                                      (Site.nav.search.close(), Search.close()))
                                : e.keyCode ===
                                      slate.utils.keyboardKeys.ESCAPE &&
                                  (Site.nav.submenuStandard.close(),
                                  Site.nav.search.close(),
                                  Search.close(),
                                  Site.nav.hide())
                        }
                    }),
                    $2('.js-searchToggle').on(
                        'click' + namespace,
                        function (e) {
                            if (
                                (e.preventDefault(),
                                $header.hasClass('header--search-visible'))
                            )
                                Site.nav.search.close(), Search.close()
                            else {
                                var search = $2(this).data('search-nav')
                                Site.nav.search.open(search)
                            }
                        }
                    ),
                    $2(document).on('click' + namespace, function (e) {
                        $2(e.target).is(
                            '.nav-search-overlay, .nav-search-overlay *, .js-searchToggle, .js-searchToggle *'
                        ) ||
                            ($header.hasClass('header--search-visible') &&
                                (Site.nav.search.close(), Search.close()))
                    }),
                    $body.on('click' + namespace, function (e) {
                        $2(e.target).is(
                            '.js-menuToggle, .js-menuToggle *, .nav-main *'
                        ) || Site.nav.hide()
                    })
            },
            show: function () {
                var navMenuWidth = $2('.nav-hamburger').width() + 'px',
                    $body = $2('body'),
                    $hamburger = $2('#hamburger-menu'),
                    $transformElements = $2(
                        '.site-header, .site-alert, .bodyWrap, .shop-bar'
                    ),
                    isNotMobileNav = document.querySelector('header.header--is-hamburger') == null,
                    scrollableElement = document.querySelector(
                        '.nav-hamburger .nav-inner'
                    )
                    if (isNotMobileNav) {
                      scrollLock.disablePageScroll(scrollableElement)
                    } else {
                      $body.addClass('hide-scrollbar')
                    }

                    $hamburger.addClass('open'),
                    $body.addClass('nav--is-visible'),
                    $2('.header__icons a:not(.js-menuToggle)').attr(
                        'tabindex',
                        '-1'
                    ),
                    $2('.nav-hamburger')
                        .find('button, a')
                        .removeAttr('tabindex'),
                    $transformElements.css({
                        transform: 'translateX(' + navMenuWidth + ')',
                    }),
                    $2(window).on(
                        'resize.siteNav',
                        Reqs.debounce(function () {
                            var isHamburger = $2('.site-header').hasClass(
                                'header--is-hamburger'
                            )
                            isHamburger &&
                                ((navMenuWidth =
                                    $2('.nav-hamburger').width() + 'px'),
                                $transformElements.css({
                                    transform:
                                        'translateX(' + navMenuWidth + ')',
                                }))
                        }, 100)
                    )
            },
            hide: function () {
                var $body = $2('body'),
                    $hamburger = $2('#hamburger-menu'),
                    $transformElements = $2(
                        '.site-header, .site-alert, .bodyWrap, .shop-bar'
                    ),
                    scrollableElement = document.querySelector(
                        '.nav-hamburger .nav-inner'
                    )
                $body.hasClass('nav--is-visible') &&
                    ($hamburger.removeClass('open'),
                    $body
                        .addClass('nav--is-hiding')
                        .removeClass('nav--is-visible'),
                    $transformElements.css({ transform: 'none' }),
                    this.scrollLockTimeout &&
                        clearTimeout(this.scrollLockTimeout),
                    (this.scrollLockTimeout = setTimeout(function () {
                        scrollLock.enablePageScroll(scrollableElement),
                            $body.removeClass('nav--is-hiding')
                    }, 500)),
                    $2(window).off('resize.siteNav'),
                    $2('.header__icons a').removeAttr('tabindex'),
                    $2('.nav-hamburger')
                        .find('button, a')
                        .attr('tabindex', '-1'))
            },
            activeLinks: function () {
                var $menu_items = $2('.menu-item'),
                    $submenu_items = $2('.submenu-item')
                $menu_items.each(function () {
                    $2(this).find('> a').attr('href') ===
                    window.location.pathname
                        ? $2(this).addClass('is-active')
                        : $submenu_items.each(function () {
                              if (
                                  $2(this).find('> a').attr('href') ===
                                  window.location.pathname
                              )
                                  $2(this).addClass('is-active'),
                                      $2(this)
                                          .closest('.menu-item.has-submenu')
                                          .addClass('is-active')
                              else return
                          })
                })
            },
            submenuStandard: {
                open: function (el) {
                    el
                        .parent()
                        .siblings('.menu-item--meganav')
                        .removeClass('is-expanded')
                        .find('[aria-expanded]')
                        .attr('aria-expanded', !1),
                        el
                            .parent()
                            .siblings('.menu-item--meganav')
                            .find('.visible-nav-link')
                            .attr('tabindex', '-1'),
                        el
                            .addClass('is-expanded')
                            .children()
                            .attr('aria-expanded', !0),
                        el
                            .parent()
                            .find('.visible-nav-link')
                            .removeAttr('tabindex'),
                        el.hasClass('menu-item--meganav') &&
                            ($2('.site-header').addClass(
                                'header--megamenu-visible'
                            ),
                            el.find('.visible-nav-link').removeAttr('tabindex'))
                },
                close: function () {
                    $2('.visible-nav-link').attr('tabindex', '-1'),
                        $2('.nav-standard li')
                            .removeClass('is-expanded')
                            .find('[aria-expanded]')
                            .attr('aria-expanded', !1),
                        $2('.site-header').removeClass(
                            'header--megamenu-visible'
                        )
                },
            },
            submenu: {
                open: function (el) {
                    var $elSubMenu = $2(el)
                    $elSubMenu
                        .addClass('is-expanded')
                        .find('> .submenu')
                        .stop(!0)
                        .slideDown('fast'),
                        $elSubMenu
                            .find('.visible-nav-link')
                            .removeAttr('tabindex')
                },
                close: function (el) {
                    var $elSubMenu = $2(el)
                    $elSubMenu
                        .removeClass('is-expanded')
                        .find('> .submenu')
                        .stop(!0)
                        .slideUp('fast'),
                        $elSubMenu
                            .find('.visible-nav-link')
                            .attr('tabindex', '-1')
                },
            },
            search: {
                open: function (search) {
                    var $header = $2('.site-header'),
                        $searchToggleBtn = $2('.js-searchToggle'),
                        $searchInput = $2(search).find('.nav-search-input'),
                        $clickableElements = $2(search).find(
                            '.nav-search-input, .nav-search-submit, .js-searchToggle--close'
                        )
                    $header.addClass('header--search-visible'),
                        $searchToggleBtn.attr('aria-expanded', !0),
                        $clickableElements.removeAttr('tabindex'),
                        $searchInput.focus().select()
                },
                close: function () {
                    var $header = $2('.site-header'),
                        $searchToggleBtn = $2('.js-searchToggle'),
                        $searchToggleBtnOpen = $2('.js-searchToggle--open'),
                        $clickableElements = $2(
                            '.nav-search-input, .nav-search-submit, .js-searchToggle--close'
                        ),
                        isSearchVisible = $header.hasClass(
                            'header--search-visible'
                        )
                    $clickableElements.attr('tabindex', '-1'),
                        $searchToggleBtn.attr('aria-expanded', !1),
                        isSearchVisible &&
                            ($header
                                .addClass('header--search-hiding')
                                .removeClass('header--search-visible'),
                            $searchToggleBtnOpen.focus(),
                            setTimeout(function () {
                                $header.removeClass('header--search-hiding')
                            }, 300))
                },
            },
        },
        addresses: {
            addAddressForm: $2('.js-addAddress > form'),
            editAddressForm: $2('.js-editAddress > form'),
            init: function () {
                ;($addAddressForm = this.addAddressForm),
                    ($editAddressForm = this.editAddressForm),
                    Site.addresses.validating()
            },
            validating: function () {
                $addAddressForm.add($editAddressForm).submit(function (e) {
                    var isEmpty = !0
                    if (
                        ($2(this)
                            .find('input')
                            .not('.optional')
                            .each(function () {
                                $2(this).val()
                                    ? $2(this)
                                          .next()
                                          .removeClass('validation--showup')
                                    : $2(this)
                                          .next()
                                          .addClass('validation--showup')
                            }),
                        $2(this)
                            .find('input')
                            .not('.optional')
                            .each(function () {
                                $2(this).val() || (isEmpty = !1)
                            }),
                        !isEmpty)
                    )
                        return !1
                })
            },
        },
        checkReviewsApp: function () {
            var showReviews = theme.settings.showReviews,
                showYotpo = theme.settings.enableYotpo,
                yotpoID = theme.settings.yotpoId
            if (!(!showReviews || !(showYotpo && yotpoID))) {
                var checkingApp = setInterval(function () {
                    var reviewsAppInstalled =
                        (typeof window.SPR == 'function' && showReviews) ||
                        (typeof yotpo == 'object' && showYotpo && yotpoID)
                    reviewsAppInstalled
                        ? ($2('body').removeAttr('data-app-reviews'),
                          clearInterval(checkingApp))
                        : $2('body').attr('data-app-reviews', 'not-installed')
                }, 1e3)
                setTimeout(function () {
                    clearInterval(checkingApp)
                }, 2e4)
            }
        },
        animations: {
            init: function () {
                this.animateAll(),
                    $2(document).on('ajaxify:updated', this.animateAll)
            },
            animateAll: function () {
                if (
                    (!theme.settings.enableTextAnimations &&
                        !theme.settings.enableGridItemsAnimations) ||
                    (window.MSInputMethodContext && document.documentMode)
                )
                    return
                var animatedElements =
                    document.querySelectorAll('.will-animate')
                if (typeof IntersectionObserver > 'u') {
                    animatedElements.forEach((element2) => {
                        element2.classList.remove('will-animate')
                    })
                    return
                }
                let observer = new IntersectionObserver(
                    (entries) => {
                        entries.forEach((entry) => {
                            if (entry.isIntersecting === !0) {
                                var animationClass = [
                                        'animated',
                                        entry.target.getAttribute(
                                            'data-animation'
                                        ),
                                    ],
                                    isGridItem =
                                        entry.target.getAttribute(
                                            'data-animation'
                                        ) == 'moFadeInUp'
                                if (
                                    (entry.target.classList.add(
                                        ...animationClass
                                    ),
                                    entry.target.classList.remove(
                                        'will-animate'
                                    ),
                                    isGridItem)
                                ) {
                                    var animationDelay =
                                            parseInt(
                                                entry.target.getAttribute(
                                                    'data-animation-delay'
                                                )
                                            ) || 0,
                                        timeout = 1e3 + animationDelay
                                    observer.unobserve(entry.target),
                                        setTimeout(() => {
                                            entry.target.classList.remove(
                                                ...animationClass
                                            )
                                        }, timeout)
                                }
                            }
                        })
                    },
                    { threshold: [0.1] }
                )
                animatedElements.forEach((element2) => {
                    observer.observe(element2)
                })
            },
        },
        initReviews: function () {
            var showReviews = theme.settings.showReviews,
                enableYotpo = theme.settings.enableYotpo,
                yotpoID = theme.settings.yotpoId
            enableYotpo && yotpoID != '' && typeof yotpo < 'u'
                ? yotpo.initialized && yotpo.refreshWidgets()
                : showReviews &&
                  typeof window.SPR == 'function' &&
                  (window.SPR.initDomEls(),
                  window.SPR.loadBadges(),
                  window.SPR.loadProducts())
        },
        removeAnimationClass: function (container) {
            $2('.will-animate', container).removeClass('will-animate')
        },
    }),
        Site.init(),
        Cart.init(),
        Collection.init(),
        Blog.init(),
        Site.animations.init(),
        $2(document).ready(function () {
            Gmap.init()
        }),
        Sections.init(),
        Popup.init(),
        Search.init(),
        $2('.template-product').length &&
            (Product.init(), RelatedProducts.init()),
        $2('.featured-product').length && Product.init(),
        $2('.template-password').length && Password.init(),
        $2('.template-customers-login').length && Login.init(),
        $2('.template-customers-addresses').length && Addresses.init(),
        $2('.template-search').length && SearchTemplate.init(),
        theme.settings.showQuickView && QuickView.init()
    var hash = window.location.hash,
        elementId = hash.substr(1, hash.length),
        element = document.getElementById(elementId)
    element !== null && slate.a11y.pageLinkFocus($2(window.location.hash)),
        $2('.in-page-link').on('click', function (evt) {
            slate.a11y.pageLinkFocus($2(evt.currentTarget.hash))
        }),
        tablesWrap(),
        $2(document).on('shopify:section:reorder', Site.header.init),
        $2(document).on('shopify:section:unload', Site.header.init),
        $2(document).on('shopify:section:load', Site.header.init)
}),
    (Cart = {
        popoverTimer: 0,
        classes: { buttonSubmitSuccess: 'productForm-submit--success' },
        init: function () {
            var $cart = $('#Cart'),
                $body = $('body'),
                $popover2 = $('#CartPopoverCont'),
                enableAjaxCart = theme.settings.enableAjaxCart,
                scrollLockTimeout = 0
            if (
                (this.counter(),
                this.initTermsAcceptance(),
                $(window).on(
                    'resize',
                    Reqs.throttle(Site.setCartClosePosition, 10)
                ),
                $cart.on('click', '.js-continueShopping', function (e) {
                    e.preventDefault()
                    var referrer = document.referrer,
                        origin = window.location.origin + '/',
                        isMobile = $(window).width() < 768
                    !isMobile && !(window.location.href.indexOf('/cart') > -1)
                        ? $('.js-cartToggle-close').eq(0).trigger('click')
                        : referrer === origin
                        ? (window.location.href = theme.routes.root_url)
                        : history.back(1)
                }),
                !enableAjaxCart)
            )
                return !1
            $(document).off('click', '.js-cartToggle'),
                $(document).on('click', '.js-cartToggle', function (e) {
                    var $this = $(this),
                        isCartTemplate = $('body').hasClass('template-cart'),
                        windowWidth =
                            window.innerWidth ||
                            document.documentElement.clientWidth ||
                            document.body.clientWidth,
                        scrollableElement = document.querySelector(
                            '.cart-drawer .scroll'
                        )
                    if (isCartTemplate) return !1
                    e.preventDefault(),
                        Site.setCartClosePosition(),
                        $body.toggleClass('cart--is-visible'),
                        $body.hasClass('cart--is-visible')
                            ? ($('.cartslide').animate({ left: '0' }, 300),
                              $cart.removeClass('close'),
                              $cart.addClass('open'),
                              $('#cartTotal').attr('aria-expanded', !0),
                              scrollLock.disablePageScroll(scrollableElement))
                            : ($('.cartslide').animate({ left: '200' }, 300),
                              $cart.removeClass('open'),
                              $cart.addClass('close'),
                              $('#cartTotal').attr('aria-expanded', !1),
                              Cart.popover.hide($popover2),
                              scrollLockTimeout &&
                                  clearTimeout(scrollLockTimeout),
                              (scrollLockTimeout = setTimeout(function () {
                                  scrollLock.enablePageScroll(scrollableElement)
                              }, 500))),
                        $('.js-continueShopping').attr('tabindex', '0')
                }),
                $('body').on('click', '[data-add-to-cart]', function (e) {
                    var $form = $(this).closest('form.productForm')
                    if (enableAjaxCart) {
                        if (
                            (e.preventDefault(),
                            $form.find('[type="file"]').length)
                        )
                            return
                        Cart.submit($(this))
                    }
                }),
                $(window).on('keyup', function (e) {
                    e.key === 'Escape' &&
                        ($body.removeClass('cart--is-visible'),
                        $cart.removeClass('open'),
                        $cart.addClass('close'),
                        $('#cartTotal').attr('aria-expanded', !1),
                        Cart.popover.hide($popover2))
                })
        },
        submit: function (el) {
            if (window.GlossyCart) {
                var glossyForm = el.closest('form.productForm')[0]
                return window.GlossyCart.addFromForm(glossyForm, {
                    trigger: el[0],
                    source: 'shop-js',
                }).catch(function () {})
            }
            var instance = this,
                $form = el.closest('form.productForm'),
                product_handle = el.attr('data-handle'),
                variant_id2 = $form.find('[name="id"]').val(),
                form_array = $form.serializeArray(),
                $addToCart = el,
                addToCartText = el.find('[data-add-to-cart-text]'),
                form_data = {}
            $.map(form_array, function (val, i) {
                form_data[val.name] = val.value
            }),
                $.ajax({
                    method: 'POST',
                    url: glossyCartRoute('cart/add.js'),
                    dataType: 'json',
                    data: form_data,
                    success: function (product) {
                        $addToCart
                            .attr('disabled', !0)
                            .addClass(instance.classes.buttonSubmitSuccess),
                            setTimeout(function () {
                                $addToCart
                                    .attr('disabled', !1)
                                    .removeClass(
                                        instance.classes.buttonSubmitSuccess
                                    )
                            }, 2e3),
                            Cart.getCart(Cart.buildCart),
                            $(window).width() >= 550 &&
                                Cart.popover.show(product, form_data.quantity)
                    },
                    error: function (data) {
                        $.ajax({
                            method: 'GET',
                            url: '/products/' + product_handle + '.js',
                            dataType: 'json',
                            success: function (product) {
                                var variants2 = product.variants,
                                    variant = $.each(
                                        variants2,
                                        function (i, val) {
                                            if (val.id == variant_id2)
                                                return (variant_quantity =
                                                    val.inventory_quantity)
                                        }
                                    ),
                                    $popover2 = $('#CartPopoverCont'),
                                    error_details =
                                        theme.translations
                                            .form_submit_error_details,
                                    tag = new RegExp('[[i]]'),
                                    error = error_details
                                tag.test(error_details) == !0 &&
                                    (error = error_details.replace(
                                        '[[i]]',
                                        variant_quantity
                                    )),
                                    addToCartText.html(
                                        theme.translations.form_submit_error
                                    ),
                                    setTimeout(function () {
                                        addToCartText.html(
                                            theme.translations.form_submit
                                        )
                                    }, 1e3),
                                    clearTimeout(instance.popoverTimer),
                                    $popover2
                                        .empty()
                                        .append(
                                            '<div class="popover-error">' +
                                                error +
                                                '</div>'
                                        )
                                        .addClass('is-visible')
                                        .css({ 'pointer-events': 'none' }),
                                    (instance.popoverTimer = setTimeout(
                                        function () {
                                            $popover2
                                                .removeClass('is-visible')
                                                .css({
                                                    'pointer-events': 'auto',
                                                })
                                        },
                                        5e3
                                    ))
                            },
                            error: function () {
                                console.log(
                                    "Error: product is out of stock. If you're seeing this, Cart.submit.error() must have failed."
                                )
                            },
                        })
                    },
                })
        },
        popover: {
            show: function (product, quantity) {
                var instance = this,
                    $popover2 = $('#CartPopoverCont'),
                    item = {},
                    source = $('#CartPopover').text(),
                    price = slate.Currency.formatMoney(
                        product.final_price,
                        window.moneyFormat
                    ),
                    unitPrice = '',
                    sellingPlanName = product.selling_plan_allocation
                        ? product.selling_plan_allocation.selling_plan.name
                        : null
                if (
                    (product.unit_price_measurement &&
                        ((unitPrice =
                            slate.Currency.formatMoney(
                                product.unit_price,
                                window.moneyFormat
                            ) + ' '),
                        product.unit_price_measurement.reference_value != 1 &&
                            (unitPrice +=
                                product.unit_price_measurement.reference_value),
                        (unitPrice +=
                            product.unit_price_measurement.reference_unit)),
                    product.image != null)
                )
                    var prodImg = bgset(
                        product.image
                            .replace(/(\.[^.]*)$/, '_1x1$1')
                            .replace('http:', ''),
                        product.featured_image.aspect_ratio
                    )
                else
                    var prodImg =
                        '//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif'
                item = {
                    item_count: quantity,
                    img: prodImg,
                    product_title: product.product_title,
                    variation: product.product_has_only_default_variant
                        ? !1
                        : product.variant_title,
                    selling_plan_name: sellingPlanName,
                    price: product.price,
                    price_formatted: price,
                    unit_price: unitPrice,
                    product_color: 'white',
                }
                var template = Sqrl.render(source, item)
                $popover2.empty().append(template),
                    $popover2.addClass('is-visible'),
                    clearTimeout(instance.popoverTimer),
                    (instance.popoverTimer = setTimeout(function () {
                        Cart.popover.hide($popover2)
                    }, 5e3))
            },
            hide: function (el) {
                el.removeClass('is-visible'),
                    setTimeout(function () {
                        el.empty()
                    }, 300)
            },
        },
        getCart: function (callback) {
            $.getJSON(glossyCartRoute('cart.js'), function (cart, textStatus) {
                typeof callback == 'function'
                    ? callback(cart)
                    : ShopifyAPI.onCartUpdate(cart)
            })
        },
        buildCart: function (cart) {
            var self2 = this,
                $cart = $('#Cart'),
                $body = $('body'),
                acceptanceChecked =
                    !!$cart.attr('data-acceptance-checked') || !1
            if (
                ($cart.empty(),
                $body.hasClass('template-cart') ||
                    $cart.append(
                        '<div class="js-cartToggle js-cartToggle-close cart-close"><i class="fa fa-arrow-left"></i></div>'
                    ),
                cart.item_count === 0)
            ) {
                $cart.append(
                    '<div class="cart-title cart-title--empty">              <h2>' +
                        theme.translations.cart_title +
                        '</h2>              <p>' +
                        theme.translations.cart_empty +
                        '</p>              <a tabindex="-1" class="js-continueShopping js-continueShopping--empty js-go-back button">' +
                        theme.translations.continue_shopping +
                        '</a>            </div>'
                ),
                    self2.updateCartTotal(),
                    Site.setCartClosePosition()
                return
            }
            var items = [],
                item = {},
                data = {},
                source = $('#CartTemplate').html()
            $.each(cart.items, function (index, cartItem) {
                var itemQty = cartItem.quantity,
                    itemVariantId = cartItem.variant_id,
                    discountsArray = cartItem.discounts,
                    discounts = '',
                    productPrice = '',
                    productTotalPrice = '',
                    unitPrice = '',
                    sellingPlanName = cartItem.selling_plan_allocation
                        ? cartItem.selling_plan_allocation.selling_plan.name
                        : !1
                if (
                    (cartItem.original_price > cartItem.final_price &&
                        (productPrice +=
                            '<s>' +
                            slate.Currency.formatMoney(
                                cartItem.original_price,
                                window.moneyFormat
                            ) +
                            '</s> '),
                    (productPrice +=
                        '<span>' +
                        slate.Currency.formatMoney(
                            cartItem.final_price,
                            window.moneyFormat
                        ) +
                        '</span>'),
                    cartItem.original_line_price > cartItem.final_line_price &&
                        (productTotalPrice +=
                            '<s>' +
                            slate.Currency.formatMoney(
                                cartItem.original_line_price,
                                window.moneyFormat
                            ) +
                            '</s> '),
                    (productTotalPrice += slate.Currency.formatMoney(
                        cartItem.final_line_price,
                        window.moneyFormat
                    )),
                    discountsArray.length)
                ) {
                    discounts += '<div class="cart-product__discounts">'
                    for (var j2 = 0; j2 < discountsArray.length; j2++)
                        discounts +=
                            '<p>' +
                            discountsArray[j2].title +
                            ' (-' +
                            slate.Currency.formatMoney(
                                discountsArray[j2].amount,
                                window.moneyFormat
                            ) +
                            ')</p>'
                    discounts += '</div>'
                }
                if (
                    (cartItem.unit_price_measurement &&
                        ((unitPrice =
                            slate.Currency.formatMoney(
                                cartItem.unit_price,
                                window.moneyFormat
                            ) + ' '),
                        (unitPrice +=
                            '<span aria-hidden="true">/</span><span class="visually-hidden">' +
                            theme.translations.unit_price_separator +
                            '</span>&nbsp;'),
                        cartItem.unit_price_measurement.reference_value != 1 &&
                            (unitPrice +=
                                cartItem.unit_price_measurement
                                    .reference_value),
                        (unitPrice +=
                            cartItem.unit_price_measurement.reference_unit)),
                    cartItem.image != null)
                )
                    var prodImg = cartItem.image
                        .replace(/(\.[^.]*)$/, '_300x$1')
                        .replace('http:', '')
                else
                    var prodImg =
                        '//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif'
                var prodName = cartItem.product_title,
                    prodVariation = cartItem.variant_title
                let varriant_title = '',
                    varriant_color = ''
                if (prodVariation == 'Default Title')
                    (prodVariation = !1), (varriant_title = !1)
                else if (prodVariation != null) {
                    let arr_variant = prodVariation.split('/')
                    ;(varriant_title = arr_variant[0]),
                        (varriant_color = arr_variant[1])
                }
                varriant_color == null && (varriant_color = ''),
                    (item = {
                        id: cartItem.variant_id,
                        url: cartItem.url,
                        img: prodImg,
                        name: prodName,
                        variation: varriant_title,
                        sellingPlanName,
                        itemQty,
                        itemVariantId,
                        properties: cartItem.properties,
                        price: cartItem.price,
                        priceFormatted: productPrice,
                        unitPrice,
                        linePriceFormatted: productTotalPrice,
                        discounts,
                        vendor: cartItem.vendor,
                        iconPlus: theme.icons.plus,
                        iconMinus: theme.icons.minus,
                        product_color: varriant_color,
                    }),
                    items.push(item)
            })
            var totalDiscounts = '',
                cartDiscounts = cart.cart_level_discount_applications
            if (cartDiscounts.length) {
                totalDiscounts += '<p class="cart-discounts">'
                for (var j = 0; j < cartDiscounts.length; j++)
                    (totalDiscounts +=
                        '<span class="cart-discounts__title">' +
                        cartDiscounts[j].title +
                        ':</span>'),
                        (totalDiscounts +=
                            '<span class="cart-discounts__price">-' +
                            slate.Currency.formatMoney(
                                cartDiscounts[j].total_allocated_amount,
                                window.moneyFormat
                            ) +
                            '</span>')
                totalDiscounts += '</p>'
            }
            data = {
                item_count: cart.item_count,
                items,
                note: cart.note,
                totalDiscounts,
                totalPrice: slate.Currency.formatMoney(
                    cart.total_price,
                    window.moneyFormat
                ),
                acceptanceChecked,
            }
            var template = Sqrl.render(source, data)
            $cart.append(template),
                Cart.updateCartTotal(),
                Cart.initTermsAcceptance(),
                Site.setCartClosePosition(),
                window.Shopify &&
                    Shopify.StorefrontExpressButtons &&
                    Shopify.StorefrontExpressButtons.initialize()
        },
        counter: function () {
            var self2 = this,
                $cart = $('#Cart'),
                namespace = '.cart'
            $cart
                .off(namespace)
                .on('change' + namespace, '.inputCounter', function () {
                    var el = $(this),
                        value = $(this).val()
                    self2.inputCounter(el, value)
                })
                .on(
                    'click' + namespace,
                    '.inputCounter__btn--down',
                    function (e) {
                        var el = $(this),
                            $input = el.siblings('.inputCounter'),
                            value = parseInt($input.val()) - 1
                        self2.inputCounter(el, value)
                    }
                )
                .on(
                    'click' + namespace,
                    '.inputCounter__btn--up',
                    function (e) {
                        var el = $(this),
                            $input = el.siblings('.inputCounter'),
                            value = parseInt($input.val()) + 1
                        self2.inputCounter(el, value)
                    }
                )
                .on('click' + namespace, '.cart-product__remove', function (e) {
                    var el = $(this)
                    theme.settings.enableAjaxCart &&
                        (self2.inputCounter(el, 0), e.preventDefault())
                })
        },
        inputCounter: function (el, value) {
            var glossyLine = el.closest('[data-cart-line-key]')
            if (window.GlossyCart && glossyLine.length) {
                var glossyArgs = {
                    key: glossyLine.attr('data-cart-line-key'),
                    quantity: Math.max(parseInt(value) || 0, 0),
                    trigger: el[0],
                }
                return (glossyArgs.quantity === 0
                    ? window.GlossyCart.remove(glossyArgs)
                    : window.GlossyCart.change(glossyArgs)).catch(function () {})
            }
            var self2 = this,
                $input = el.closest('.line-item').find('.inputCounter')
            if (!theme.settings.enableAjaxCart) $input.val(value)
            else {
                value == 0
                    ? $input.closest('.line-item').fadeOut(function () {
                          $(this).remove()
                      })
                    : value < 0 && (value = 0)
                var qty2 = value,
                    line = parseInt($input.closest('.line-item').index() + 1)
                $.ajax({
                    type: 'post',
                    url: glossyCartRoute('cart/change.js'),
                    dataType: 'json',
                    data: { quantity: qty2, line },
                    success: function (cart) {
                        Cart.buildCart(cart)
                    },
                }),
                    qty2 == 0 &&
                        $(this)
                            .closest('.line-item')
                            .fadeOut(function () {
                                $(this).remove(), self2.updateCartTotal()
                            })
            }
        },
        updateCartTotal: function () {
            $.getJSON(glossyCartRoute('cart.js'), function (cart) {
                var cartItemCount =
                    cart.item_count > 10 ? '9+' : cart.item_count
                $('#CartToggleItemCount').html(cartItemCount),
                    $(' #CartToggleItemCountTotal').val(cart.item_count),
                    cart.item_count
                        ? $('.js-cartToggle').removeClass('cartToggle--empty')
                        : $('.js-cartToggle').addClass('cartToggle--empty')
            })
        },
        initTermsAcceptance: function () {
            var namespace = '.cart',
                selectors = {
                    cartAcceptanceCheckbox: '[data-cart-acceptance-checkbox]',
                    cartAcceptanceLabel: '[data-cart-acceptance-label]',
                    cartButtons: '[data-cart-buttons]',
                    cartButtonsFieldset: '[data-cart-buttons-fieldset]',
                    cartContainer: '.cart-container',
                    cartFormError: '[data-cart-error]',
                }
            if ($(selectors.cartAcceptanceCheckbox).length) {
                var cartFormErrorElement =
                        '<div class="errors" data-cart-error>' +
                        theme.translations.cart_acceptance_error +
                        '</div>',
                    termsAccepted = $(selectors.cartAcceptanceCheckbox).is(
                        ':checked'
                    ),
                    formSubmitFunction = function (e) {
                        var termsAccepted2 = $(
                                selectors.cartAcceptanceCheckbox
                            ).is(':checked'),
                            updateCart = $(e.originalEvent.submitter).is(
                                '[name="update"]'
                            )
                        if (!updateCart)
                            if (termsAccepted2)
                                $(selectors.cartFormError)
                                    .stop()
                                    .slideUp('fast', function () {
                                        $(this).remove()
                                    }),
                                    $(selectors.cartButtonsFieldset).removeAttr(
                                        'disabled'
                                    ),
                                    $(selectors.cartContainer).attr(
                                        'data-acceptance-checked',
                                        'checked'
                                    )
                            else {
                                if (
                                    (e.preventDefault(),
                                    $(selectors.cartFormError).length)
                                )
                                    return
                                $(selectors.cartButtonsFieldset).attr(
                                    'disabled',
                                    !0
                                ),
                                    $(selectors.cartAcceptanceLabel).after(
                                        cartFormErrorElement
                                    ),
                                    $(selectors.cartFormError).slideDown(),
                                    $(selectors.cartContainer).removeAttr(
                                        'data-acceptance-checked'
                                    )
                            }
                    }
                termsAccepted ||
                    $(selectors.cartButtonsFieldset).attr('disabled', !0),
                    $(selectors.cartContainer)
                        .on(
                            'click' + namespace,
                            selectors.cartButtons,
                            formSubmitFunction
                        )
                        .on(
                            'submit' + namespace,
                            selectors.cartForm,
                            formSubmitFunction
                        )
                        .on(
                            'submit' + namespace,
                            selectors.cartFormDynamicCheckout,
                            formSubmitFunction
                        )
                        .on(
                            'change' + namespace,
                            selectors.cartAcceptance,
                            formSubmitFunction
                        )
            }
        },
    })
var Collection = {
        selectors: {
            body: 'body',
            collectionWrapper: '[data-collection-wrapper]',
            collectionProductsWrapper: '[data-collection-products-wrapper]',
            collectionProducts: '[data-collection-products]',
            collectionFilters: '[data-collection-filters]',
            collectionFiltersResetButton:
                '[data-collection-filters-reset-button]',
            collectionFilter: '[data-collection-filter]',
            collectionFilterTag: '[data-collection-filter-tag]',
            collectionFilterTagButton: '[data-collection-filter-tag-button]',
            collectionFilterTitle: '[data-collection-filter-title]',
            collectionFilterCount: '[data-collection-filter-count]',
            collectionPagination: '[data-pagination]',
            collectionSort: '[data-collection-sort]',
            collectionBlockImage: '.product-block__image',
            collectionFeaturedImage: '.featured-block',
            productsFoundLabel: '[data-products-found-label]',
            loadMoreButton: '[data-load-more]',
            loadMoreIcon: '[data-icon-load-more]',
            gridSpacer: '.gridSpacer',
        },
        classes: {
            loading: 'loading',
            isActive: 'is-active',
            isVisible: 'is-visible',
            isExpanded: 'is-expanded',
            isLoading: 'is-loading',
            ajaxSorting: 'ajax-sorting',
            hasTagsExpanded: 'has-tags-expanded',
            collectionFiltersTop: 'collection__filters--top',
            collectionFiltersHasTagsSelected:
                'collection__filters--has-tags-selected',
            collectionFiltersResetButtonFullwidth:
                'collection__filters-reset--fullwidth',
            collectionFilterAccordionExpanded:
                'collection__filter--accordion-expanded',
        },
        init: function () {
            var self2 = this,
                sectionId = 'collection-template'
            ;(this.filterProductsRequest = null),
                $(this.selectors.collectionSort).length &&
                    $(this.selectors.collectionSort).on('change', function () {
                        document.location.href =
                            '?sort_by=' + this.options[this.selectedIndex].value
                    }),
                $(this.selectors.collectionProducts).each(function () {
                    var $container = $(this),
                        sectionId2 = $(this).data('section-id')
                    if (theme.settings.imageBackgroundSize == 'contain') {
                        var $image = $(
                            self2.selectors.collectionBlockImage,
                            $container
                        )
                        Collection.setBadgePosition($image),
                            $(window).on(
                                'resize.' + sectionId2,
                                Reqs.debounce(
                                    self2.setBadgePosition.bind(self2, $image),
                                    50
                                )
                            )
                    }
                    self2.initFilters($container)
                }),
                Site.preventBannerContentOverflow(),
                $(window).on(
                    'resize.' + sectionId,
                    Reqs.debounce(Site.preventBannerContentOverflow, 50)
                ),
                ajaxify(),
                Product.qtyAdjust(),
                $(document).on('ajaxify:updated', function () {
                    Site.initReviews()
                })
        },
        ajaxSort: function (url) {
            var self2 = this,
                $loadMoreIcon = $(this.selectors.loadMoreIcon)
            $loadMoreIcon.show(),
                $(this.selectors.collectionProducts).hide().next('.row').hide(),
                $.ajax({
                    type: 'GET',
                    dataType: 'html',
                    url,
                    success: function (data) {
                        var products = $(data).find(
                                self2.selectors.collectionProducts
                            )[0].outerHTML,
                            nextPage = $(data)
                                .find(self2.selectors.collectionProducts)
                                .next('.row')[0]
                                ? $(data)
                                      .find(self2.selectors.collectionProducts)
                                      .next('.row')[0].outerHTML
                                : ''
                        $(self2.selectors.collectionProducts).replaceWith(
                            products
                        ),
                            $(self2.selectors.collectionProducts)
                                .next('.row')
                                .replaceWith(nextPage),
                            $loadMoreIcon.hide(),
                            $(self2.selectors.collectionSort).removeClass(
                                self2.classes.loading
                            ),
                            $(self2.selectors.body).removeClass(
                                self2.classes.ajaxSorting
                            )
                    },
                })
        },
        initLoadMore: function () {
            var self2 = this
            $(this.selectors.body).on(
                'click',
                self2.selectors.loadMoreButton,
                function (event) {
                    var isLoading = $(this).hasClass(self2.classes.isLoading)
                    if (!isLoading) {
                        QuickView.hide()
                        var $el = $(event.target),
                            url = $el.attr('href')
                        event.preventDefault(),
                            $el.addClass(self2.classes.loading),
                            self2.ajaxLoadMore(url)
                    }
                }
            )
        },
        ajaxLoadMore: function (url) {
            var self2 = this
            $.ajax({
                type: 'GET',
                dataType: 'html',
                url,
                success: function (data) {
                    var products = $(data)
                            .find(self2.selectors.collectionProducts)
                            .html(),
                        nextPage = $(data)
                            .find(self2.selectors.loadMoreButton)
                            .attr('href')
                    $(self2.selectors.collectionProducts)
                        .find(self2.selectors.gridSpacer)
                        .remove(),
                        $(products).appendTo(
                            self2.selectors.collectionProducts
                        ),
                        typeof nextPage < 'u'
                            ? $(self2.selectors.loadMoreButton)
                                  .attr('href', nextPage)
                                  .removeClass(self2.classes.loading)
                            : $(self2.selectors.loadMoreButton).remove(),
                        (collectionBlocks = $('.js-collection-block'))
                },
            })
        },
        setBadgePosition: function (image) {
            $(image).each(function () {
                var $image = $(this),
                    $saleBadge = $image.find('.product-status-flag')
                if ($saleBadge.length) {
                    var imageAspectRatio = $image.data('aspectratio'),
                        imageWidth = $image.outerWidth(),
                        imageHeight = $image.outerHeight(),
                        containerAspectRatio = imageWidth / imageHeight,
                        posTop = 0,
                        posLeft = 0
                    imageAspectRatio < containerAspectRatio
                        ? (posLeft =
                              (imageWidth - imageHeight * imageAspectRatio) / 2)
                        : (posTop =
                              (imageHeight - imageWidth / imageAspectRatio) /
                              2),
                        $saleBadge.css({ top: posTop, left: posLeft })
                }
            })
        },
        initFilters: function (container) {
            var self2 = this,
                $container = $(container),
                $collectionFilters = $(this.selectors.collectionFilters)
            if ($collectionFilters.length) {
                var sectionId = $(container).data('section-id'),
                    collection = $container.data('collection'),
                    sort = $container.data('sort')
                ;(this.tags = $container.data('tags')),
                    this.checkFiltersPosition(),
                    $(window).on(
                        'resize.' + sectionId,
                        Reqs.debounce(function () {
                            self2.checkFiltersPosition(self2)
                        }, 50)
                    ),
                    $collectionFilters.on(
                        'click',
                        this.selectors.collectionFilterTitle,
                        function () {
                            var windowWidth =
                                    window.innerWidth ||
                                    document.documentElement.clientWidth ||
                                    document.body.clientWidth,
                                isTopPosition =
                                    windowWidth < 1280 ||
                                    $('.collection__filters--top').length,
                                isAriaExpanded = !(
                                    $(this)
                                        .parent()
                                        .hasClass(self2.classes.isExpanded) ||
                                    $(this)
                                        .parent()
                                        .hasClass(
                                            self2.classes
                                                .collectionFilterAccordionExpanded
                                        )
                                )
                            isTopPosition
                                ? ($(this)
                                      .parent()
                                      .toggleClass(self2.classes.isExpanded)
                                      .attr('aria-expanded', isAriaExpanded)
                                      .siblings()
                                      .removeClass(self2.classes.isExpanded)
                                      .attr('aria-expanded', !1),
                                  $collectionFilters.find(
                                      '.collection__filter.is-expanded'
                                  ).length
                                      ? $collectionFilters.addClass(
                                            self2.classes.hasTagsExpanded
                                        )
                                      : $collectionFilters.removeClass(
                                            self2.classes.hasTagsExpanded
                                        ))
                                : $(this)
                                      .parent()
                                      .toggleClass(
                                          self2.classes
                                              .collectionFilterAccordionExpanded
                                      )
                                      .attr('aria-expanded', isAriaExpanded)
                                      .siblings()
                                      .removeClass(self2.classes.isExpanded)
                                      .attr('aria-expanded', !1)
                        }
                    ),
                    $(document).on('click', function (e) {
                        $(e.target).is('.collection__filters *') ||
                            $collectionFilters
                                .find(self2.selectors.collectionFilter)
                                .removeClass(self2.classes.isExpanded)
                                .attr('aria-expanded', !1)
                                .end()
                                .removeClass(self2.classes.hasTagsExpanded)
                    }),
                    $collectionFilters.on(
                        'click',
                        this.selectors.collectionFilterTagButton,
                        function (e) {
                            var $collectionFilterTag = $(this).parent(),
                                selectedTag = $(this).data('tag'),
                                isTagActive = $collectionFilterTag.hasClass(
                                    self2.classes.isActive
                                )
                            if (isTagActive) {
                                var tagIndex = self2.tags.indexOf(selectedTag)
                                $collectionFilterTag.removeClass(
                                    self2.classes.isActive
                                ),
                                    tagIndex > -1 &&
                                        self2.tags.splice(tagIndex, 1)
                            } else
                                $collectionFilterTag.addClass(
                                    self2.classes.isActive
                                ),
                                    self2.tags.push(selectedTag)
                            var groupFiltersCount = $(this)
                                .closest(self2.selectors.collectionFilter)
                                .find(self2.selectors.collectionFilterTag)
                                .filter('.' + self2.classes.isActive).length
                            $container.attr('data-tags', self2.tags),
                                $(this)
                                    .closest(self2.selectors.collectionFilter)
                                    .removeClass(self2.classes.isExpanded)
                                    .attr('aria-expanded', !1)
                                    .find(self2.selectors.collectionFilterCount)
                                    .attr('data-count', groupFiltersCount),
                                $collectionFilters.removeClass(
                                    self2.classes.hasTagsExpanded
                                )
                            var requestedURL =
                                collection +
                                '/' +
                                self2.tags.join('+') +
                                '?sort_by=' +
                                sort
                            self2.requestFilteredProducts(
                                self2,
                                container,
                                requestedURL
                            ),
                                e.preventDefault()
                        }
                    ),
                    this.bindResetButton(container)
            }
        },
        requestFilteredProducts: function (instance, container, requestedURL) {
            var self2 = instance,
                $container = $(container),
                sectionId = $(container).data('section-id'),
                productsTop = parseInt(
                    Math.ceil(
                        $(self2.selectors.collectionWrapper).offset().top
                    ) - 60
                ),
                action =
                    'scroll.endlessScroll--' +
                    sectionId +
                    ' resize.endlessScroll--' +
                    sectionId
            $(window).off(action),
                self2.filterProductsRequest != null &&
                    self2.filterProductsRequest.abort(),
                self2.tags.length ||
                    ($(self2.selectors.collectionFiltersResetButton)
                        .removeClass(self2.classes.isVisible)
                        .slideUp(300),
                    $(self2.selectors.collectionFilters).removeClass(
                        self2.classes.collectionFiltersHasTagsSelected
                    )),
                $(self2.selectors.collectionWrapper).addClass(
                    self2.classes.isLoading
                ),
                $('html, body')
                    .stop(!0)
                    .animate({ scrollTop: productsTop }, 300),
                history.replaceState &&
                    window.history.pushState(
                        { path: requestedURL },
                        '',
                        requestedURL
                    ),
                (self2.filterProductsRequest = $.ajax({
                    method: 'GET',
                    url: requestedURL,
                    dataType: 'html',
                })
                    .done(function (data) {
                        var collectionProducts = $(data)
                                .find(self2.selectors.collectionProducts)
                                .html(),
                            productsFoundLabel = $(data)
                                .find(self2.selectors.productsFoundLabel)
                                .html(),
                            $pagination = $(data).find(
                                self2.selectors.collectionPagination
                            )
                        if (
                            ($container.html(collectionProducts),
                            $(self2.selectors.productsFoundLabel).html(
                                productsFoundLabel
                            ),
                            $pagination.length
                                ? $(
                                      self2.selectors.collectionPagination,
                                      container
                                  ).html($pagination.html())
                                : $(
                                      self2.selectors.collectionPagination,
                                      container
                                  ).empty(),
                            self2.bindResetButton(container),
                            Site.animations.animateAll(),
                            Site.initReviews(),
                            ajaxify(),
                            theme.settings.imageBackgroundSize == 'contain')
                        ) {
                            var $image = $(
                                self2.selectors.collectionBlockImage,
                                container
                            )
                            self2.setBadgePosition($image),
                                $(window)
                                    .off('resize.products')
                                    .on(
                                        'resize.products',
                                        Reqs.debounce(
                                            Collection.setBadgePosition.bind(
                                                this,
                                                $image
                                            ),
                                            50
                                        )
                                    )
                        }
                        self2.tags.length &&
                            ($(self2.selectors.collectionFiltersResetButton)
                                .addClass(self2.classes.isVisible)
                                .slideDown(300),
                            $(self2.selectors.collectionFilters).addClass(
                                self2.classes.collectionFiltersHasTagsSelected
                            )),
                            setTimeout(function () {
                                $(
                                    self2.selectors.collectionWrapper
                                ).removeClass(self2.classes.isLoading)
                            }, 450)
                    })
                    .fail(function (jqXHR, textStatus, errorThrown) {
                        $(self2.selectors.collectionWrapper).removeClass(
                            self2.classes.isLoading
                        )
                    })
                    .always(function () {
                        setVars()
                    }))
        },
        checkFiltersPosition: function () {
            var isFiltersPositionTop = $(
                    this.selectors.collectionFilters
                ).hasClass(this.classes.collectionFiltersTop),
                windowWidth =
                    window.innerWidth || document.documentElement.clientWidth,
                containerWidth = $(this.selectors.collectionFilters)
                    .children()
                    .first()
                    .width(),
                $resetButton = $(this.selectors.collectionFiltersResetButton),
                $collectionFilter = $(this.selectors.collectionFilter),
                resetButtonWidth = $resetButton.outerWidth(!0),
                collectionFiltersWidth = 0,
                spaceBetween = 60,
                isOverlapping = !1
            ;(isFiltersPositionTop || windowWidth < 1280) &&
                ($collectionFilter.each(function () {
                    collectionFiltersWidth += $(this).outerWidth(!0)
                }),
                (isOverlapping =
                    containerWidth - collectionFiltersWidth - spaceBetween <
                    resetButtonWidth),
                isOverlapping
                    ? $resetButton
                          .parent()
                          .addClass(
                              this.classes.collectionFiltersResetButtonFullwidth
                          )
                    : $resetButton
                          .parent()
                          .removeClass(
                              this.classes.collectionFiltersResetButtonFullwidth
                          ))
        },
        bindResetButton: function (container) {
            var self2 = this,
                $collectionFilters = $(self2.selectors.collectionFilters),
                collection = $(container).data('collection'),
                sort = $(container).data('sort'),
                requestedURL = collection + '/?sort_by=' + sort
            $(this.selectors.collectionFiltersResetButton).on(
                'click',
                function (e) {
                    $(self2.selectors.collectionFilter).removeClass(
                        self2.classes.isExpanded
                    ),
                        $(self2.selectors.collectionFilterTag).removeClass(
                            self2.classes.isActive
                        ),
                        $(self2.selectors.collectionFilterCount).attr(
                            'data-count',
                            '0'
                        ),
                        $collectionFilters.removeClass(
                            self2.classes.hasTagsExpanded
                        ),
                        (self2.tags = []),
                        $(container).attr('data-tags', !1),
                        self2.requestFilteredProducts(
                            self2,
                            container,
                            requestedURL
                        ),
                        e.preventDefault()
                }
            )
        },
    },
    QuickView = {
        selectors: {
            addToCart: '[data-add-to-cart]',
            addToCartText: '[data-add-to-cart-text]',
            section: '[data-section-id]',
            quickViewButton: '.js-quickView-button',
            closeButton: '.js-quickView-close',
            collectionGrid: '.js-collection-grid',
            productMedia: '[data-product-single-media-group]',
            productMediaSlider: '[data-product-single-media-slider]',
            productMediaWrapper: '[data-product-single-media-wrapper]',
            productMediaThumbs: '[data-product-single-media-thumbs]',
            productMediaTypeVideo: '[data-product-media-type-video]',
            productMediaTypeModel: '[data-product-media-type-model]',
            productTitle: '[data-product-title]',
            productPrice: '[data-product-price]',
            comparePrice: '[data-compare-price]',
            unitPrice: '[data-unit-price]',
            unitBase: '[data-unit-base]',
            unitWrapper: '[data-unit-wrapper]',
            originalSelectorId: '[data-product-select]',
            singleOptionSelector: '[data-single-option-selector]',
            priceWrapper: '[data-price-wrapper]',
            productFormContainer: '[data-product-form-container]',
            productFormWrapper: '[data-product-form-wrapper]',
            productFormBlock: '.productForm-block',
            productFormSelectWrapper: '.selector-wrapper',
            productDescription: '[data-product-description]',
            productBlock: '[data-product-block]',
        },
        init: function () {
            var self2 = this,
                isQuickViewLoading = (this.isQuickViewLoading = !1)
            $(document).on(
                'click',
                this.selectors.quickViewButton,
                function (e) {
                    var $selector = $(this),
                        el = $(this).closest(self2.selectors.productBlock),
                        url = $(this).attr('href'),
                        sectionId = $selector
                            .closest(self2.selectors.section)
                            .data('section-id')
                    isQuickViewLoading ||
                        ((self2.isQuickViewLoading = !0),
                        el.addClass('quickView--is-loading'),
                        el.hasClass('is-loaded') &&
                        el.hasClass('quickView--is-visible')
                            ? self2.hide(self2)
                            : el.hasClass('is-loaded') &&
                              !el.hasClass('quickView--is-visible') &&
                              !$('.quickView--is-visible').length
                            ? self2.show(el)
                            : el.hasClass('is-loaded') &&
                              !el.hasClass('quickView--is-visible') &&
                              $('.quickView--is-visible').length
                            ? (self2.hide(self2),
                              setTimeout(function () {
                                  self2.show(el)
                              }, 200))
                            : $('.quickView--is-visible').length
                            ? (self2.hide(self2),
                              setTimeout(function () {
                                  self2.ajaxSearch(el, url, sectionId)
                              }, 200))
                            : self2.ajaxSearch(el, url, sectionId)),
                        e.preventDefault()
                }
            )
        },
        show: function (el) {
            var self2 = this,
                sub = ($(window).height() - 680) / 2,
                offset = el.children('.quickView').offset().top,
                headerHeight = 60,
                scrollPosition = offset - sub - headerHeight,
                isFocusActive = !$('body').hasClass('no-outline'),
                collectionFeaturedBlockHeight = getHeight(
                    '[data-collection-featured-block]'
                )
            document.documentElement.style.setProperty(
                '--collection-featured-block-height',
                `${collectionFeaturedBlockHeight}px`
            ),
                el.addClass('quickView--is-active'),
                el.removeClass('quickView--is-loading'),
                $('html, body')
                    .stop(!0, !0)
                    .animate({ scrollTop: scrollPosition }, 300, function () {
                        Site.initReviews(),
                            el.hasClass('is-loaded')
                                ? el.addClass('quickView--is-visible')
                                : el.addClass(
                                      'quickView--is-visible is-loaded'
                                  ),
                            (self2.isQuickViewLoading = !1)
                    }),
                $('html, body').trigger('quickView:show'),
                isFocusActive && el.find(this.selectors.closeButton).focus()
        },
        hide: function () {
            var $productBlock = $(this.selectors.productBlock),
                isQuickViewVisible = $productBlock.hasClass(
                    'quickView--is-visible'
                )
            isQuickViewVisible &&
                $productBlock.removeClass(
                    'quickView--is-visible quickView--is-active quickView--is-loading'
                ),
                $productBlock
                    .find('.product-image.is-selected')
                    .trigger('mediaHidden')
                    .addClass('media--hidden'),
                setTimeout(function () {
                    Site.animations.animateAll(),
                        document.documentElement.style.setProperty(
                            '--collection-featured-block-height',
                            'none'
                        )
                }, 300),
                $('html, body').trigger('quickView:hide')
        },
        ajaxSearch: function (el, url, sectionId) {
            var self2 = this,
                showProductDescription = theme.settings.showProductDescription
            el.addClass('quickView--is-loading'),
                $.ajax({ url, cache: !1, dataType: 'html' }).done(function (
                    data
                ) {
                    var productSectionId = 'product-template',
                        productJSON = $(data)
                            .find('#ProductJson--' + productSectionId)
                            .text(),
                        productMediaJson = $(data)
                            .find('#ModelJson-' + productSectionId)
                            .html(),
                        product = JSON.parse(productJSON),
                        productMediaSlider = self2.modifyProductMediaSettings(
                            $(data).find(self2.selectors.productMediaSlider),
                            self2.settings
                        ),
                        productMediaThumbs = $(data)
                            .find(self2.selectors.productMediaThumbs)
                            .html(),
                        productTitle = self2.addProductTitleLink(
                            $(data).find(self2.selectors.productTitle),
                            url
                        ),
                        productFormContainer = self2.modifyProductFormIds(
                            $(data).find(self2.selectors.productFormContainer),
                            product.id
                        ),
                        productDescription =
                            showProductDescription &&
                            $(data).find(self2.selectors.productDescription)
                                .length
                                ? $(data)
                                      .find(self2.selectors.productDescription)
                                      .html()
                                : !1,
                        isProductMediaSingle =
                            $(data).find('.js-productImgContainer > .js-slide')
                                .length == 1,
                        item = {},
                        source = $(
                            '#ProductQuickViewTemplate--' + sectionId
                        ).html()
                    item = {
                        productMediaSlider,
                        productMediaThumbs,
                        productTitle,
                        productFormContainer,
                        productDescription,
                        productMediaJson,
                        isProductMediaSingle,
                    }
                    var template = Sqrl.render(source, item)
                    el.append(template),
                        el.attr('data-section-id', productSectionId),
                        el.on(
                            'click',
                            self2.selectors.closeButton,
                            function (e) {
                                e.preventDefault(), self2.hide(self2)
                            }
                        ),
                        self2.initProductMediaSlider(el),
                        self2.initProductVideo(el),
                        self2.initMediaSwitch(el),
                        self2.initModelViewerLibraries(el),
                        self2.initShopifyXrLaunch(el),
                        self2.initVariants(el, product),
                        self2.initPaymentButton(el),
                        self2.show(el),
                        $('html, body').trigger('quickView:ajax')
                })
        },
        initProductMediaSlider: function (container) {
            var self2 = this,
                $productSection = $(container),
                $productImgSlider = $productSection.find(
                    '.js-productImgSlider'
                ),
                $productImgSliderNav = $productSection.find(
                    '.js-productImgSlider-nav'
                ),
                activeArrows = $productImgSlider.data('arrows'),
                activeDots = $productImgSlider.data('dots'),
                isDraggable = !(
                    $productImgSlider.find('.product-single__media--video')
                        .length ||
                    $productImgSlider.find('.product-single__media--model')
                        .length
                ),
                activeSlide = $productImgSlider
                    .find('.is-selected-product')
                    .index(),
                lastWindowWidth =
                    window.innerWidth || document.documentElement.clientWidth
            if (
                ((activeSlide = activeSlide == -1 ? 0 : activeSlide),
                $productImgSlider.find('.js-slide').length > 1)
            ) {
                let initSliderNav2 = function () {
                    var isInitialized = $productImgSliderNav.data('flickity'),
                        sliderNavArrows =
                            Site.sliders.checkThumbnailsOverflow(
                                $productImgSliderNav
                            )
                    isInitialized != null &&
                        $productImgSliderNav.flickity('destroy'),
                        $productImgSliderNav.flickity({
                            cellSelector: '.js-slide',
                            asNavFor: $productImgSlider[0],
                            initialIndex: activeSlide,
                            pageDots: !1,
                            prevNextButtons: sliderNavArrows,
                            arrowShape: theme.icons.arrowNavSlider,
                            contain: !0,
                        })
                }
                var initSliderNav = initSliderNav2
                $productImgSlider
                    .on('ready.flickity', function () {
                        $productImgSlider.attr('tabindex', '-1'),
                            $productImgSlider
                                .find('.js-slide')
                                .attr('tabindex', '-1')
                    })
                    .on('change.flickity', function (event, index) {
                        var $currentSlide = $productImgSlider
                                .find('.js-slide')
                                .eq(index),
                            $currentSlideImage = $currentSlide.find(
                                '.product-single__media--image'
                            )
                        $currentSlideImage.hasClass('lazyloaded') ||
                            $currentSlideImage.addClass('lazyload')
                    })
                    .on('settle.flickity', function (event, index) {
                        var $currentSlide = $productImgSlider
                                .find('.js-slide')
                                .eq(index),
                            mediaId = $currentSlide.data('media-id')
                        self2.switchMedia(container, mediaId)
                    }),
                    $productImgSlider.flickity({
                        cellSelector: '.js-slide',
                        prevNextButtons: activeArrows,
                        arrowShape: theme.icons.arrowNavSlider,
                        pageDots: activeDots,
                        initialIndex: activeSlide,
                        draggable: isDraggable,
                        adaptiveHeight: !0,
                        contain: !0,
                        wrapAround: !0,
                    }),
                    $productImgSliderNav.on('ready.flickity', function () {
                        $productImgSliderNav.attr('tabindex', '-1')
                    }),
                    initSliderNav2(),
                    $(window).on(
                        'resize.product',
                        Reqs.debounce(function () {
                            var windowWidth =
                                window.innerWidth ||
                                document.documentElement.clientWidth
                            lastWindowWidth != windowWidth && initSliderNav2(),
                                (lastWindowWidth = windowWidth)
                        }, 250)
                    )
            }
        },
        handleMediaFocus: function (e) {
            if (!(e.keyCode !== 13 && e.keyCode !== 9)) {
                var $container = $(e.currentTarget).closest(
                        this.selectors.productBlock
                    ),
                    mediaId = $(e.currentTarget).data('thumbnail-id'),
                    slideIndex = $(
                        this.selectors.productMediaWrapper +
                            '[data-media-id="' +
                            mediaId +
                            '"]',
                        $container
                    ).index(),
                    flick = $(
                        this.selectors.productMediaSlider,
                        $container
                    ).data('flickity'),
                    flickNav = $(
                        this.selectors.productMediaThumbs,
                        $container
                    ).data('flickity')
                flick &&
                    flick.isActive &&
                    slideIndex > -1 &&
                    e.keyCode === 13 &&
                    flick.select(slideIndex),
                    flickNav &&
                        flickNav.isActive &&
                        slideIndex > -1 &&
                        flickNav.select(slideIndex)
            }
        },
        switchMedia: function (container, mediaId) {
            var $container = $(container),
                $currentMedia = $(
                    this.selectors.productMediaWrapper + ':not(.media--hidden)',
                    $container
                ),
                $newMedia = $(
                    this.selectors.productMediaWrapper +
                        '[data-media-id="' +
                        mediaId +
                        '"]',
                    $container
                ),
                $otherMedia = $(
                    this.selectors.productMediaWrapper +
                        ':not([data-media-id="' +
                        mediaId +
                        '"])',
                    $container
                ),
                isFocusEnabled = !$('body').hasClass('no-outline')
            isFocusEnabled && $newMedia.focus(),
                $currentMedia.trigger('mediaHidden'),
                $newMedia.removeClass('media--hidden').trigger('mediaVisible'),
                $otherMedia.addClass('media--hidden')
        },
        initMediaSwitch: function (container) {
            var self2 = this,
                $container = $(container),
                $productThumbImages = $('[data-thumbnail-id]', $container)
            $productThumbImages.length &&
                $productThumbImages
                    .on('click', function (e) {
                        e.preventDefault()
                    })
                    .on('keyup', self2.handleMediaFocus.bind(self2))
        },
        initProductVideo: function (container) {
            var sectionId = $(container).data('section-id')
            $(this.selectors.productMediaTypeVideo, container).each(
                function () {
                    var $video = $(this)
                    ProductVideo.init($video, sectionId)
                }
            )
        },
        initModelViewerLibraries: function (container) {
            var sectionId = $(container).data('section-id'),
                $modelViewerElements = $(
                    this.selectors.productMediaTypeModel,
                    container
                )
            $modelViewerElements.length < 1 ||
                ProductModel.init($modelViewerElements, sectionId)
        },
        initShopifyXrLaunch: function (container) {
            var self2 = this
            $(document).on('shopify_xr_launch', function () {
                var $currentMedia = $(
                    self2.selectors.productMediaWrapper +
                        ':not(.media--hidden)',
                    container
                )
                $currentMedia.trigger('xrLaunch')
            })
        },
        initVariants: function (container, product) {
            var $container = $(container),
                sectionId = $(container).data('section-id'),
                namespace = '.product' + sectionId,
                enableHistoryState = !1,
                options = {
                    $container,
                    enableHistoryState,
                    singleOptionSelector: this.selectors.singleOptionSelector,
                    originalSelectorId: this.selectors.originalSelectorId,
                    product,
                }
            ;(this.$container = $(container)),
                (this.shopBarVariants = new slate.Variants(options)),
                $container.on(
                    'variantChange' + namespace,
                    this.updateAddToCartState.bind(this)
                ),
                $container.on(
                    'variantChange' + namespace,
                    this.updateColorName.bind(this)
                ),
                $container.on(
                    'variantPriceChange' + namespace,
                    this.updateProductPrices.bind(this)
                ),
                $container.on(
                    'variantUnitChange' + namespace,
                    this.updateProductUnits.bind(this)
                ),
                $container.on(
                    'variantImageChange' + namespace,
                    this.updateProductImage.bind(this)
                )
        },
        updateAddToCartState: function (evt) {
            var variant = evt.variant
            variant
                ? variant.available
                    ? ($(this.selectors.addToCart, this.$container).prop(
                          'disabled',
                          !1
                      ),
                      $(this.selectors.addToCartText, this.$container).html(
                          theme.translations.add_to_cart
                      ),
                      $(
                          this.selectors.notificationForm,
                          this.$container
                      ).addClass('visually-hidden'))
                    : ($(this.selectors.addToCart, this.$container).prop(
                          'disabled',
                          !0
                      ),
                      $(this.selectors.addToCartText, this.$container).html(
                          theme.translations.sold_out
                      ),
                      $(
                          this.selectors.notificationForm,
                          this.$container
                      ).removeClass('visually-hidden'))
                : ($(this.selectors.addToCart, this.$container).prop(
                      'disabled',
                      !0
                  ),
                  $(this.selectors.addToCartText, this.$container).html(
                      theme.translations.unavailable
                  ),
                  $(
                      this.selectors.notificationForm,
                      this.$container
                  ).removeClass('visually-hidden'))
        },
        updateColorName: function (evt) {
            var colorName = $(this.selectors.colorSwatch, this.$container)
                .filter(':checked')
                .val()
            console.log(colorName), $(this.selectors.colorLabel).text(colorName)
        },
        updateProductPrices: function (evt) {
            var variant = evt.variant,
                $comparePrice = $(this.selectors.comparePrice, this.$container),
                $productPrice = $(this.selectors.productPrice, this.$container)
            $productPrice.html(
                slate.Currency.formatMoney(variant.price, window.moneyFormat)
            ),
                variant.compare_at_price > variant.price
                    ? $comparePrice
                          .html(
                              slate.Currency.formatMoney(
                                  variant.compare_at_price,
                                  window.moneyFormat
                              )
                          )
                          .removeClass('visually-hidden')
                    : $comparePrice.html('').addClass('visually-hidden')
        },
        updateProductUnits: function (evt) {
            var variant = evt.variant
            if (typeof variant.unit_price < 'u') {
                var price = slate.Currency.formatMoney(
                        variant.unit_price,
                        window.moneyFormat
                    ),
                    base = this.getBaseUnit(variant)
                $(this.selectors.unitPrice, this.$container).html(price),
                    $(this.selectors.unitBase, this.$container).html(base),
                    $(this.selectors.unitWrapper, this.$container).show()
            } else $(this.selectors.unitWrapper, this.$container).hide()
        },
        getBaseUnit: function (variant) {
            return variant.unit_price_measurement.reference_value === 1
                ? variant.unit_price_measurement.reference_unit
                : variant.unit_price_measurement.reference_value +
                      variant.unit_price_measurement.reference_unit
        },
        updateProductImage: function (evt) {
            var variant = evt.variant,
                variantMediaId = variant.featured_media
                    ? variant.featured_media.id
                    : '',
                $imgSlider = $(
                    this.selectors.productMediaSlider,
                    this.$container
                ),
                flick = $imgSlider.data('flickity')
            if (flick && flick.isActive) {
                var $variantSlide = $imgSlider.find(
                    '[data-id="' + variantMediaId + '"]'
                )
                $variantSlide.index() != -1 &&
                    flick.select($variantSlide.index())
            }
        },
        initPaymentButton: function (container) {
            var enablePaymentButton = theme.settings.enablePaymentButton,
                enableAcceptTerms = theme.settings.enableAcceptTerms,
                $addToCartButton = $(this.selectors.addToCart, container)
            enablePaymentButton && !enableAcceptTerms
                ? ($addToCartButton.addClass('button--alt'),
                  Shopify.PaymentButton && Shopify.PaymentButton.init())
                : $addToCartButton.removeClass('button--alt')
        },
        modifyProductMediaSettings: function (productMediaSlider) {
            return (
                productMediaSlider.find('.product-image').each(function () {
                    $(this)
                        .attr(
                            'data-enable-video-looping',
                            theme.settings.enableVideoLooping
                        )
                        .attr('data-show_quantity', theme.settings.showQuantity)
                        .attr('tabindex', '-1')
                }),
                productMediaSlider.html()
            )
        },
        modifyProductFormIds: function (productForm, productId) {
            return (
                productForm.find('[id]').each(function () {
                    var currentId = $(this).attr('id'),
                        newId = currentId + '--' + productId + '-quickView'
                    $(this).attr('id', newId)
                }),
                productForm.find('[for]').each(function () {
                    var currentId = $(this).attr('for'),
                        newId = currentId + '--' + productId + '-quickView'
                    $(this).attr('for', newId)
                }),
                productForm.html()
            )
        },
        addProductTitleLink: function (productTitle, url) {
            var productTitleText = productTitle.find('.product-title').text()
            return (
                productTitle
                    .find('.product-title')
                    .html('<a href="' + url + '">' + productTitleText + '</a>'),
                productTitle.html()
            )
        },
    },
    Product = {
        selectors: {
            body: 'body',
            addToCart: '[data-add-to-cart]',
            addToCartText: '[data-add-to-cart-text]',
            productPrice: '[data-product-price]',
            comparePrice: '[data-compare-price]',
            unitPrice: '[data-unit-price]',
            unitBase: '[data-unit-base]',
            unitWrapper: '[data-unit-wrapper]',
            priceWrapper: '[data-price-wrapper]',
            notificationForm: '[data-notification-form]',
            originalSelectorId: '[data-product-select]',
            singleOptionSelector: '[data-single-option-selector]',
            productSection: '[data-section-type="product"]',
            productSectionContainer: '.js-product-template',
            productSliderContainer: '.js-productImgContainer',
            productSlider: '[data-product-single-media-slider]',
            productSliderNav: '.js-productImgSlider-nav',
            productSlide: '.js-slide',
            productScroller: '.js-productImgScroller',
            productScrollerNav: '.js-productImgScroller-nav',
            productSelected: '.is-selected-product',
            productMediaSlider: '[data-product-single-media-slider]',
            productMediaWrapper: '[data-product-single-media-wrapper]',
            productMediaTypeVideo: '[data-product-media-type-video]',
            productMediaTypeModel: '[data-product-media-type-model]',
            productMediaVideo: '.product-single__media--video',
            productMediaModel: '.product-single__media--model',
            productMediaImage: '.product-single__media--image',
            productMediaThumb: '.product-single__media-thumb',
            productThumbnail: '.js-product-single__thumbnail',
            productImageLightboxLink: '[data-lightbox-link]',
            productLayoutScrollable: '.product-layout--scrollable',
            productTabs: '.js-product-tabs',
            productTabsNav: '.product-tabs-nav',
            productTabsContents: '.product-tabs-contents',
            productTabTitle: '.product-tab-title',
            productTabContent: '.product-tab-content',
            productForm: '[data-product-form]',
            productFormBlock: '.productForm-block',
            productFormSelectWrapper: '.selector-wrapper',
            storeAvailabilityContainer: '[data-store-availability-container]',
            cartStatus: '[data-cart-status]',
            colorSwatch: '[data-color-swatch]',
            colorLabel: '[data-color-label]',
            shopBar: '.shop-bar',
            zoomContainer: '.zoom-container',
        },
        classes: { visibilityHidden: 'visibility-hidden' },
        switchMediaTimeout: 0,
        init: function (update, sectionId) {
            var self2 = this,
                update = typeof update < 'u' ? update : !1
            if (update) {
                var container = document.querySelector(
                    '[data-section-id="' + sectionId + '"]'
                )
                this.initSingleProduct(container, update)
            } else {
                var productSections = document.querySelectorAll(
                    this.selectors.productSection
                )
                productSections.forEach((container2) => {
                    self2.initSingleProduct(container2, update)
                })
            }
        },
        initSingleProduct: function (container, update) {
            var self2 = this,
                showShopBar = $(this.selectors.shopBar, container).length,
                isLayoutScrollable = $(
                    this.selectors.productLayoutScrollable,
                    container
                ).length,
                isOnboarding = $(container).hasClass('onboarding-product'),
                isProductTemplate = !$(container).hasClass('featured-product'),
                enableStoreAvailability = $(container).attr(
                    'data-store-availability'
                )
            isOnboarding
                ? (this.qtyAdjust(),
                  $(this.selectors.colorSwatch, container).on(
                      'change',
                      function () {
                          var colorName = $(
                              self2.selectors.colorSwatch,
                              container
                          )
                              .filter(':checked')
                              .val()
                          $(self2.selectors.colorLabel, container).text(
                              colorName
                          )
                      }
                  ))
                : (isProductTemplate
                      ? ((this.mfpOpen = !0),
                        enableStoreAvailability &&
                            ((this.storeAvailabilityContainer =
                                container.querySelector(
                                    this.selectors.storeAvailabilityContainer
                                )),
                            this.storeAvailabilityContainer &&
                                (this.storeAvailability =
                                    new theme.StoreAvailability(
                                        this.storeAvailabilityContainer
                                    ))),
                        this.initProductTabs(container),
                        this.initImageGallery(container),
                        this.qtyAdjust(),
                        isLayoutScrollable
                            ? this.initScroller(container, update)
                            : this.initProductMediaSlider(container),
                        showShopBar && this.initShopBar(container))
                      : this.initProductMediaSlider(container),
                  this.initProductVideo(container),
                  this.initMediaSwitch(container),
                  this.initModelViewerLibraries(container),
                  this.initShopifyXrLaunch(container),
                  this.initVariants(container),
                  Site.initReviews())
        },
        initVariants: function (container) {
            var $container = $(container),
                sectionId = $(container).data('section-id'),
                namespace = '.product' + sectionId,
                product = JSON.parse(
                    document.getElementById('ProductJson--' + sectionId)
                        .innerHTML
                ),
                isFeaturedProduct = $(container).hasClass('featured-product'),
                enableHistoryState = !isFeaturedProduct,
                options = {
                    $container,
                    enableHistoryState,
                    singleOptionSelector: this.selectors.singleOptionSelector,
                    originalSelectorId: this.selectors.originalSelectorId,
                    product,
                }
            ;(this.shopBarVariants = new slate.Variants(options)),
                (this.productSingleObject = product),
                this.storeAvailability &&
                    this.storeAvailability.updateContent(
                        this.shopBarVariants.currentVariant.id,
                        options.product.title
                    ),
                $container.on(
                    'variantChange' + namespace,
                    this.updateAddToCartState.bind(this)
                ),
                $container.on(
                    'variantChange' + namespace,
                    this.updateColorName.bind(this)
                ),
                $container.on(
                    'variantChange' + namespace,
                    this.updateAvailability.bind(this)
                ),
                $container.on(
                    'variantPriceChange' + namespace,
                    this.updateProductPrices.bind(this)
                ),
                $container.on(
                    'variantUnitChange' + namespace,
                    this.updateProductUnits.bind(this)
                ),
                $container.on(
                    'variantImageChange' + namespace,
                    this.updateProductImage.bind(this)
                )
        },
        updateAddToCartState: function (evt) {
            var container = evt.target,
                variant = evt.variant,
                $shopBar = $(this.selectors.shopBar)
            variant
                ? variant.available
                    ? ($(this.selectors.addToCart, container).prop(
                          'disabled',
                          !1
                      ),
                      $(this.selectors.addToCartText, container).html(
                          theme.translations.add_to_cart
                      ),
                      $(this.selectors.notificationForm, container).addClass(
                          'visually-hidden'
                      ))
                    : ($(this.selectors.addToCart, container).prop(
                          'disabled',
                          !0
                      ),
                      $(this.selectors.addToCartText, container).html(
                          theme.translations.sold_out
                      ),
                      $(this.selectors.notificationForm, container).removeClass(
                          'visually-hidden'
                      ))
                : ($(this.selectors.addToCart, container).prop('disabled', !0),
                  $(this.selectors.addToCartText, container).html(
                      theme.translations.unavailable
                  ),
                  $(this.selectors.notificationForm, container).removeClass(
                      'visually-hidden'
                  )),
                $shopBar.length &&
                    (variant
                        ? variant.available
                            ? ($(this.selectors.addToCart, $shopBar).prop(
                                  'disabled',
                                  !1
                              ),
                              $(this.selectors.addToCartText, $shopBar).html(
                                  theme.translations.add_to_cart
                              ))
                            : ($(this.selectors.addToCart, $shopBar).prop(
                                  'disabled',
                                  !0
                              ),
                              $(this.selectors.addToCartText, $shopBar).html(
                                  theme.translations.sold_out
                              ))
                        : ($(this.selectors.addToCart, $shopBar).prop(
                              'disabled',
                              !0
                          ),
                          $(this.selectors.addToCartText, $shopBar).html(
                              theme.translations.unavailable
                          )))
        },
        updateColorName: function (evt) {
            var container = evt.target,
                colorName = $(this.selectors.colorSwatch, container)
                    .filter(':checked')
                    .val()
            $(this.selectors.colorLabel, container).text(colorName)
        },
        updateProductPrices: function (evt) {
            var container = evt.target,
                variant = evt.variant,
                $comparePrice = $(this.selectors.comparePrice, container).add(
                    $(this.selectors.comparePrice, this.selectors.shopBar)
                ),
                $productPrice = $(this.selectors.productPrice, container).add(
                    $(this.selectors.productPrice, this.selectors.shopBar)
                )
            $productPrice.html(
                slate.Currency.formatMoney(variant.price, window.moneyFormat)
            ),
                variant.compare_at_price > variant.price
                    ? $comparePrice
                          .html(
                              slate.Currency.formatMoney(
                                  variant.compare_at_price,
                                  window.moneyFormat
                              )
                          )
                          .removeClass('visually-hidden')
                    : $comparePrice.html('').addClass('visually-hidden')
        },
        updateProductUnits: function (evt) {
            var container = evt.target,
                variant = evt.variant
            if (typeof variant.unit_price < 'u') {
                var price = slate.Currency.formatMoney(
                        variant.unit_price,
                        window.moneyFormat
                    ),
                    base = this.getBaseUnit(variant)
                $(this.selectors.unitPrice, container).html(price),
                    $(this.selectors.unitBase, container).html(base),
                    $(this.selectors.unitWrapper, container).show()
            } else $(this.selectors.unitWrapper, container).hide()
        },
        getBaseUnit: function (variant) {
            return variant.unit_price_measurement.reference_value === 1
                ? variant.unit_price_measurement.reference_unit
                : variant.unit_price_measurement.reference_value +
                      variant.unit_price_measurement.reference_unit
        },
        updateAvailability: function (evt) {
            this.updateStoreAvailabilityContent(evt)
        },
        updateStoreAvailabilityContent: function (evt) {
            if (this.storeAvailability) {
                var variant = evt.variant
                variant
                    ? this.storeAvailability.updateContent(
                          variant.id,
                          this.productSingleObject.title
                      )
                    : this.storeAvailability.clearContent()
            }
        },
        updateProductImage: function (evt) {
            var container = evt.target,
                variant = evt.variant,
                variantMediaId = variant.featured_media
                    ? variant.featured_media.id
                    : '',
                isLayoutScrollable = $(
                    this.selectors.productLayoutScrollable,
                    container
                ).length,
                $imgSlider = $(this.selectors.productSlider, container),
                flick = $imgSlider.data('flickity')
            if (flick && flick.isActive) {
                var $variantSlide = $imgSlider.find(
                    '[data-id="' + variantMediaId + '"]'
                )
                $variantSlide.index() != -1 &&
                    flick.select($variantSlide.index())
            }
            if (isLayoutScrollable) {
                var windowWidth =
                    window.innerWidth ||
                    document.documentElement.clientWidth ||
                    document.body.clientWidth
                if (windowWidth >= 768) {
                    var $selectedImage = $(
                            this.selectors.productMediaWrapper +
                                '[data-id="' +
                                variantMediaId +
                                '"]'
                        ),
                        headerHeight = 59,
                        additionalSpace = 40
                    if ($selectedImage.length) {
                        var mediaId = $selectedImage.data('media-id')
                        $('html, body')
                            .stop(!0, !0)
                            .animate({
                                scrollTop:
                                    $selectedImage.offset().top -
                                    headerHeight -
                                    additionalSpace,
                            }),
                            this.switchMediaTimeout &&
                                clearTimeout(this.switchMediaTimeout),
                            (this.switchMediaTimeout = setTimeout(function () {
                                Product.switchMedia(container, mediaId)
                            }, 500))
                    }
                }
            }
        },
        initProductMediaSlider: function (container) {
            var self2 = this,
                $productImgSlider = $(this.selectors.productSlider, container),
                $productImgSliderNav = $(
                    this.selectors.productSliderNav,
                    container
                ),
                activeArrows = $productImgSlider.data('arrows'),
                activeDots = $productImgSlider.data('dots'),
                isDraggable = !(
                    $(this.selectors.productMediaVideo, $productImgSlider)
                        .length ||
                    $(this.selectors.productMediaModel, $productImgSlider)
                        .length
                ),
                activeSlide = $(
                    this.selectors.productSelected,
                    $productImgSlider
                ).index(),
                hasSlides =
                    $(this.selectors.productSlide, $productImgSlider).length >
                    1,
                lastWindowWidth =
                    window.innerWidth || document.documentElement.clientWidth
            if (
                ((activeSlide = activeSlide == -1 ? 0 : activeSlide), hasSlides)
            ) {
                let initSliderNav2 = function () {
                    var isInitialized = $productImgSliderNav.data('flickity'),
                        sliderNavArrows =
                            Site.sliders.checkThumbnailsOverflow(
                                $productImgSliderNav
                            )
                    isInitialized != null &&
                        $productImgSliderNav.flickity('destroy'),
                        matchMedia('screen and (max-width: 769px)').matches
                            ? $productImgSliderNav.flickity({
                                  cellSelector: '.js-slide',
                                  asNavFor: $productImgSlider[0],
                                  initialIndex: activeSlide,
                                  pageDots: !1,
                                  prevNextButtons: sliderNavArrows,
                                  arrowShape: theme.icons.arrowNavSlider,
                                  contain: !0,
                                  wrapAround: !0,
                                  fullscreen: !0,
                                  groupCells: 1,
                              })
                            : $productImgSliderNav.flickity({
                                  cellSelector: '.js-slide',
                                  asNavFor: $productImgSlider[0],
                                  initialIndex: activeSlide,
                                  pageDots: !1,
                                  prevNextButtons: sliderNavArrows,
                                  arrowShape: theme.icons.arrowNavSlider,
                                  contain: !0,
                                  groupCells: 2,
                              })
                }
                var initSliderNav = initSliderNav2
                $productImgSlider
                    .on('ready.flickity', function () {
                        $productImgSlider.attr('tabindex', '-1'),
                            $(
                                self2.selectors.productSlide,
                                $productImgSlider
                            ).attr('tabindex', '-1')
                    })
                    .on('change.flickity', function (event, index) {
                        var $currentSlide = $(
                                self2.selectors.productSlide,
                                $productImgSlider
                            ).eq(index),
                            $currentSlideImage = $(
                                self2.selectors.productMediaImage,
                                $currentSlide
                            )
                        $currentSlideImage.hasClass('lazyloaded') ||
                            $currentSlideImage.addClass('lazyload'),
                            setTimeout(function () {
                                self2.mfpOpen = !0
                            }, 10)
                    })
                    .on('dragStart.flickity', function (event, index) {
                        self2.mfpOpen = !1
                    })
                    .on('settle.flickity', function (event, index) {
                        var $currentSlide = $(
                                self2.selectors.productSlide,
                                $productImgSlider
                            ).eq(index),
                            mediaId = $currentSlide.data('media-id')
                        self2.switchMedia(container, mediaId)
                    }),
                    matchMedia('screen and (max-width: 769px)').matches
                        ? $productImgSlider.flickity({
                              cellSelector: self2.selectors.productSlide,
                              prevNextButtons: activeArrows,
                              arrowShape: theme.icons.arrowNavSlider,
                              pageDots: activeDots,
                              initialIndex: activeSlide,
                              draggable: isDraggable,
                              adaptiveHeight: !0,
                              contain: !0,
                              wrapAround: !0,
                              fullscreen: !0,
                              groupCells: 1,
                          })
                        : $productImgSlider.flickity({
                              cellSelector: self2.selectors.productSlide,
                              prevNextButtons: activeArrows,
                              arrowShape: theme.icons.arrowNavSlider,
                              pageDots: activeDots,
                              initialIndex: activeSlide,
                              draggable: isDraggable,
                              adaptiveHeight: !0,
                              contain: !0,
                              wrapAround: !0,
                              fullscreen: !0,
                              groupCells: 2,
                          }),
                    $productImgSliderNav.on('ready.flickity', function () {
                        $productImgSliderNav.attr('tabindex', '-1')
                    }),
                    initSliderNav2(),
                    $(window).on(
                        'resize.product',
                        Reqs.debounce(function () {
                            var windowWidth =
                                window.innerWidth ||
                                document.documentElement.clientWidth
                            lastWindowWidth != windowWidth && initSliderNav2(),
                                (lastWindowWidth = windowWidth)
                        }, 250)
                    )
            }
        },
        initImageGallery: function (container) {
            var self2 = this,
                $productImgContainer = $(
                    self2.selectors.productSliderContainer,
                    container
                ),
                lightbox = $productImgContainer.data('lightbox')
            lightbox &&
                (Reqs.lightbox(),
                Reqs.zoom(),
                $(
                    self2.selectors.productImageLightboxLink,
                    $productImgContainer
                ).magnificPopup({
                    mainClass: 'mfp-fade-in-up',
                    type: 'image',
                    removalDelay: 300,
                    fixedContentPos: !0,
                    closeOnContentClick: !1,
                    closeOnBgClick: !1,
                    closeBtnInside: !0,
                    gallery: {
                        enabled: !0,
                        preload: 0,
                        tCounter:
                            '<div class="mfp-counter-text">%curr% / %total%</div>',
                        arrowMarkup:
                            '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%">' +
                            theme.icons.arrowSlider +
                            '</button>',
                    },
                    tLoading: '<span class="icon-loader"></span>',
                    closeMarkup:
                        '<button title="%title%" type="button" class="mfp-close">' +
                        theme.icons.close +
                        '</button>',
                    disableOn: function () {
                        return self2.mfpOpen
                    },
                    callbacks: {
                        open: function () {
                            var imgSrc = $(this.currItem.el).attr('href'),
                                $contentContainer = $(this.contentContainer)
                            self2.initZoom(imgSrc, $contentContainer)
                        },
                        change: function () {
                            var imgSrc = $(this.currItem.el).attr('href'),
                                $contentContainer = $(this.contentContainer)
                            self2.initZoom(imgSrc, $contentContainer)
                        },
                    },
                }))
        },
        initZoom: function (imgSrc, $contentContainer) {
            $(this.selectors.zoomContainer, $contentContainer).length ||
                $contentContainer.append(
                    '<span class="zoom-container"></span>'
                ),
                $contentContainer
                    .find(this.selectors.zoomContainer)
                    .removeClass('zoom-container--loaded is-zoomed')
                    .trigger('zoom.destroy')
                    .empty()
                    .zoom({
                        on: 'click',
                        url: imgSrc,
                        magnify: 1.5,
                        duration: 500,
                        callback: function () {
                            $(this)
                                .parent()
                                .removeClass('is-zoomed')
                                .addClass('zoom-container--loaded')
                        },
                        onZoomIn: function () {
                            $(this).parent().addClass('is-zoomed')
                        },
                        onZoomOut: function () {
                            $(this).parent().removeClass('is-zoomed')
                        },
                    })
        },
        initProductTabs: function (container) {
            var self2 = this,
                $productTabs = $(this.selectors.productTabs, container)
            enquire.register('screen and (min-width: 768px)', function () {
                var tabsTitles = $(
                        self2.selectors.productTabsNav,
                        $productTabs
                    ),
                    tabsContents = $(
                        self2.selectors.productTabsContents,
                        $productTabs
                    )
                $(self2.selectors.productTabTitle, $productTabs)
                    .remove()
                    .appendTo(tabsTitles),
                    $(self2.selectors.productTabContent, $productTabs)
                        .remove()
                        .appendTo(tabsContents)
            }),
                enquire.register('screen and (max-width: 767px)', function () {
                    for (
                        var tabsTitles = $(
                                self2.selectors.productTabTitle,
                                $productTabs
                            ),
                            tabsContents = $(
                                self2.selectors.productTabContent,
                                $productTabs
                            ),
                            i = 0;
                        i < tabsTitles.length;
                        i++
                    )
                        tabsTitles.eq(i).remove().appendTo($productTabs),
                            tabsContents.eq(i).remove().appendTo($productTabs)
                }),
                $productTabs.on(
                    'click',
                    self2.selectors.productTabTitle,
                    function () {
                        var tabIndex = $(this).index(),
                            isActive = $(this).hasClass('is-active'),
                            tabsCount =
                                $(this).siblings(
                                    self2.selectors.productTabTitle
                                ).length + 1,
                            windowWidth =
                                window.innerWidth ||
                                document.documentElement.clientWidth ||
                                document.body.clientWidth
                        ;(tabsCount == 1 && windowWidth >= 768) ||
                            ($productTabs
                                .find(self2.selectors.productTabTitle)
                                .removeClass('is-active'),
                            $productTabs
                                .find(self2.selectors.productTabContent)
                                .removeClass('is-active'),
                            isActive
                                ? (tabIndex++,
                                  $productTabs
                                      .find(self2.selectors.productTabTitle)
                                      .eq(tabIndex).length || (tabIndex = 0),
                                  windowWidth >= 768
                                      ? ($productTabs
                                            .find(
                                                self2.selectors.productTabTitle
                                            )
                                            .eq(tabIndex)
                                            .addClass('is-active')
                                            .siblings()
                                            .removeClass('is-active'),
                                        $productTabs
                                            .find(
                                                self2.selectors
                                                    .productTabContent
                                            )
                                            .eq(tabIndex)
                                            .addClass('is-active')
                                            .siblings()
                                            .removeClass('is-active'))
                                      : $(this)
                                            .next()
                                            .next(
                                                self2.selectors.productTabTitle
                                            ).length
                                      ? $(this)
                                            .next()
                                            .next(
                                                self2.selectors.productTabTitle
                                            )
                                            .addClass('is-active')
                                            .next(
                                                self2.selectors
                                                    .productTabContent
                                            )
                                            .addClass('is-active')
                                      : tabsCount == 1
                                      ? $(this)
                                            .removeClass('is-active')
                                            .next(
                                                self2.selectors
                                                    .productTabContent
                                            )
                                            .removeClass('is-active')
                                      : $(this)
                                            .parent()
                                            .find(
                                                self2.selectors.productTabTitle
                                            )
                                            .eq(0)
                                            .addClass('is-active')
                                            .next(
                                                self2.selectors
                                                    .productTabContent
                                            )
                                            .addClass('is-active'))
                                : windowWidth >= 768
                                ? ($productTabs
                                      .find(self2.selectors.productTabTitle)
                                      .eq(tabIndex)
                                      .addClass('is-active')
                                      .siblings()
                                      .removeClass('is-active'),
                                  $productTabs
                                      .find(self2.selectors.productTabContent)
                                      .eq(tabIndex)
                                      .addClass('is-active')
                                      .siblings()
                                      .removeClass('is-active'))
                                : $(this)
                                      .addClass('is-active')
                                      .next(self2.selectors.productTabContent)
                                      .addClass('is-active'),
                            windowWidth < 768 &&
                                $productTabs.find(
                                    self2.selectors.productTabTitle +
                                        '.is-active'
                                ).length &&
                                setTimeout(function () {
                                    var activeTabPosition =
                                        $productTabs
                                            .find(
                                                self2.selectors
                                                    .productTabTitle +
                                                    '.is-active'
                                            )
                                            .offset().top - 61
                                    $('html, body')
                                        .stop(!0, !0)
                                        .animate({
                                            scrollTop: activeTabPosition,
                                        })
                                }, 300))
                    }
                )
        },
        initScroller: function (container, update) {
            var self2 = this,
                productImages = $(
                    this.selectors.productMediaWrapper,
                    container
                ).length
            if (productImages > 1) {
                let toggleMobileSlider2 = function () {
                        var windowWidth =
                                window.innerWidth ||
                                document.documentElement.clientWidth ||
                                document.body.clientWidth,
                            hasSlides =
                                $(
                                    self2.selectors.productSlide,
                                    $productLayoutScrollable
                                ).length > 1
                        windowWidth < 768 && hasSlides
                            ? initMobileSlider()
                            : destroyMobileSlider()
                    },
                    stickyThumbnails2 = function () {
                        var windowWidth =
                            window.innerWidth ||
                            document.documentElement.clientWidth ||
                            document.body.clientWidth
                        if (windowWidth >= 768)
                            for (
                                var scrolled = window.scrollY,
                                    productOffset =
                                        $productLayoutScrollable.offset().top -
                                        100,
                                    i = $productImg.length - 1;
                                i >= 0;
                                i--
                            ) {
                                var $currentProduct = $(
                                        self2.selectors.productMediaWrapper
                                    ).eq(i),
                                    id = $currentProduct.data('id'),
                                    productOffset = parseInt(
                                        $currentProduct.offset().top - 100
                                    )
                                if (scrolled >= productOffset) {
                                    $productImgNav
                                        .find(
                                            self2.selectors.productMediaThumb +
                                                '[data-id="' +
                                                id +
                                                '"]'
                                        )
                                        .addClass('active')
                                        .siblings()
                                        .removeClass('active')
                                    break
                                }
                            }
                    }
                var toggleMobileSlider = toggleMobileSlider2,
                    stickyThumbnails = stickyThumbnails2,
                    isPageLoaded = !1,
                    $productLayoutScrollable = $(
                        this.selectors.productLayoutScrollable,
                        container
                    ),
                    $productImg = $(
                        this.selectors.productMediaWrapper,
                        container
                    ),
                    $productImgNav = $(
                        this.selectors.productScrollerNav,
                        container
                    )
                update && stickyThumbnails2(),
                    $(window)
                        .on(
                            'scroll.product',
                            Reqs.throttle(stickyThumbnails2, 10)
                        )
                        .on('load', function () {
                            isPageLoaded = !0
                        }),
                    $productImgNav.on(
                        'click',
                        this.selectors.productThumbnail,
                        function (e) {
                            e.preventDefault()
                            var windowWidth =
                                window.innerWidth ||
                                document.documentElement.clientWidth ||
                                document.body.clientWidth
                            if (windowWidth >= 768) {
                                var id = $(this).parent().data('id'),
                                    $selectedImage = $(
                                        self2.selectors.productMediaWrapper +
                                            '[data-id="' +
                                            id +
                                            '"]'
                                    ),
                                    headerHeight = 59,
                                    additionalSpace = 40
                                if ($selectedImage.length) {
                                    var mediaId =
                                        $selectedImage.data('media-id')
                                    ;(isPageLoaded || update) &&
                                        $('html, body')
                                            .stop(!0, !0)
                                            .animate(
                                                {
                                                    scrollTop:
                                                        $selectedImage.offset()
                                                            .top -
                                                        headerHeight -
                                                        additionalSpace,
                                                },
                                                300,
                                                function () {
                                                    Product.switchMedia(
                                                        container,
                                                        mediaId
                                                    )
                                                }
                                            )
                                }
                            }
                        }
                    ),
                    $(window).on(
                        'resize.product',
                        Reqs.throttle(toggleMobileSlider2, 250)
                    ),
                    toggleMobileSlider2()
            }
            function initMobileSlider() {
                var $productImgSlider = $(
                        self2.selectors.productScroller,
                        container
                    ),
                    $productImgSliderNav = $(
                        self2.selectors.productScrollerNav,
                        container
                    ),
                    hasSlides =
                        $(self2.selectors.productSlide, container).length > 1,
                    activeArrows = $productImgSlider.data('arrows'),
                    activeDots = $productImgSlider.data('dots'),
                    sliderNavArrows =
                        Site.sliders.checkThumbnailsOverflow(
                            $productImgSliderNav
                        ),
                    isDraggable = !(
                        $(self2.selectors.productMediaVideo, $productImgSlider)
                            .length ||
                        $(self2.selectors.productMediaModel, $productImgSlider)
                            .length
                    ),
                    activeSlide = $(
                        self2.selectors.productSelected,
                        $productImgSlider
                    ).index()
                activeSlide = activeSlide == -1 ? 0 : activeSlide
                var flickity = $productImgSlider.data('flickity'),
                    flickityNav = $productImgSliderNav.data('flickity')
                hasSlides &&
                    (flickity == null &&
                        ($productImgSlider
                            .on('change.flickity', function (event, index) {
                                var $currentSlide = $(
                                    self2.selectors.productSlide,
                                    $productImgSlider
                                ).eq(index)
                                $currentSlide.hasClass('lazyloaded') ||
                                    $currentSlide.addClass('lazyload'),
                                    setTimeout(function () {
                                        self2.mfpOpen = !0
                                    }, 10)
                            })
                            .on('dragStart.flickity', function (event, index) {
                                self2.mfpOpen = !1
                            }),
                        $productImgSlider.flickity({
                            cellSelector: '.js-slide',
                            prevNextButtons: activeArrows,
                            arrowShape: theme.icons.arrowNavSlider,
                            pageDots: activeDots,
                            initialIndex: activeSlide,
                            draggable: isDraggable,
                            selectedAttraction: 0.08,
                            friction: 0.8,
                            adaptiveHeight: !0,
                            contain: !0,
                            wrapAround: !0,
                            fullscreen: !0,
                            groupCells: 1,
                        })),
                    flickityNav == null &&
                        $productImgSliderNav.flickity({
                            cellSelector: '.js-slide',
                            asNavFor: $productImgSlider[0],
                            initialIndex: activeSlide,
                            pageDots: !1,
                            prevNextButtons: sliderNavArrows,
                            arrowShape: theme.icons.arrowNavSlider,
                            contain: !0,
                            wrapAround: !0,
                            fullscreen: !0,
                            groupCells: 1,
                        }))
            }
            function destroyMobileSlider() {
                var $productImgSlider = $(
                        self2.selectors.productScroller,
                        container
                    ),
                    $productImgSliderNav = $(
                        self2.selectors.productScrollerNav,
                        container
                    ),
                    flickity = $productImgSlider.data('flickity'),
                    flickityNav = $productImgSliderNav.data('flickity')
                flickity &&
                    flickity.isActive &&
                    $productImgSlider.flickity('destroy'),
                    flickityNav &&
                        flickityNav.isActive &&
                        $productImgSliderNav.flickity('destroy')
            }
        },
        handleMediaFocus: function (e, container) {
            if (!(e.keyCode !== 13 && e.keyCode !== 9)) {
                var mediaId = $(e.currentTarget).data('thumbnail-id'),
                    slideIndex = $(
                        this.selectors.productSlide +
                            '[data-media-id="' +
                            mediaId +
                            '"]',
                        container
                    ).index(),
                    flick = $(
                        this.selectors.productSliderContainer,
                        container
                    ).data('flickity'),
                    flickNav = $(
                        this.selectors.productSliderNav,
                        container
                    ).data('flickity')
                flick &&
                    flick.isActive &&
                    slideIndex > -1 &&
                    e.keyCode === 13 &&
                    flick.select(slideIndex),
                    flickNav &&
                        flickNav.isActive &&
                        slideIndex > -1 &&
                        flickNav.select(slideIndex)
            }
        },
        switchMedia: function (container, mediaId) {
            var $currentMedia = $(
                    this.selectors.productMediaWrapper + ':not(.media--hidden)',
                    container
                ),
                $newMedia = $(
                    this.selectors.productMediaWrapper +
                        '[data-media-id="' +
                        mediaId +
                        '"]',
                    container
                ),
                $otherMedia = $(
                    this.selectors.productMediaWrapper +
                        ':not([data-media-id="' +
                        mediaId +
                        '"])',
                    container
                ),
                isFocusEnabled = !$(this.selectors.body).hasClass('no-outline')
            isFocusEnabled && $newMedia.focus(),
                $currentMedia.trigger('mediaHidden'),
                $newMedia.removeClass('media--hidden').trigger('mediaVisible'),
                $otherMedia.addClass('media--hidden')
        },
        pauseOtherMedia: function (mediaId, container) {
            var $currentMedia = $(
                    this.selectors.productMediaWrapper +
                        '[data-media-id="' +
                        mediaId +
                        '"]'
                ),
                $otherMedia = $(
                    this.selectors.productMediaWrapper +
                        ':not([data-media-id="' +
                        mediaId +
                        '"])'
                )
            $currentMedia.removeClass('media--hidden'),
                $otherMedia.trigger('mediaHidden').addClass('media--hidden')
        },
        initMediaSwitch: function (container) {
            var $productThumbImages = $(
                this.selectors.productThumbnail,
                container
            )
            $productThumbImages.length &&
                $productThumbImages
                    .on('click', function (e) {
                        e.preventDefault()
                    })
                    .on('keyup', this.handleMediaFocus.bind(this))
        },
        initProductVideo: function (container) {
            var sectionId = $(container).data('section-id')
            $(this.selectors.productMediaTypeVideo, container).each(
                function () {
                    var $video = $(this)
                    ProductVideo.init($video, sectionId)
                }
            )
        },
        initModelViewerLibraries: function (container) {
            var sectionId = $(container).data('section-id'),
                $modelViewerElements = $(
                    this.selectors.productMediaTypeModel,
                    container
                )
            $modelViewerElements.length < 1 ||
                ProductModel.init($modelViewerElements, sectionId)
        },
        initShopifyXrLaunch: function (container) {
            var self2 = this
            $(document).on('shopify_xr_launch', function () {
                var $currentMedia = $(
                    self2.selectors.productMediaWrapper +
                        ':not(.media--hidden)',
                    container
                )
                $currentMedia.trigger('xrLaunch')
            })
        },
        initShopBar: function (container) {
            var sectionId = $(container).data('section-id'),
                namespace = '.product' + sectionId,
                product = JSON.parse(
                    document.getElementById('ProductJson--' + sectionId)
                        .innerHTML
                ),
                $body = $(this.selectors.body),
                $siteFooter = $(this.selectors.footer),
                $shopBar = $(this.selectors.shopBar),
                $shopBarProductSelect = $shopBar.find(
                    this.selectors.originalSelectorId
                ),
                $productContainer = $(
                    this.selectors.productSectionContainer,
                    container
                ),
                $productForm = $(this.selectors.productForm, container),
                $productSelect = $productForm.find(
                    this.selectors.originalSelectorId
                ),
                $singleOptionSelector = $productForm.find(
                    this.selectors.singleOptionSelector
                ),
                enableHistoryState = !1
            $shopBar = $shopBar.remove().appendTo($body)
            var options = {
                $container: $shopBar,
                enableHistoryState,
                singleOptionSelector: this.selectors.singleOptionSelector,
                originalSelectorId: this.selectors.originalSelectorId,
                product,
            }
            ;(this.shopBarVariants = new slate.Variants(options)),
                $shopBar.on(
                    'variantChange' + namespace,
                    this.updateAddToCartState.bind(this)
                ),
                $shopBar.on(
                    'variantChange' + namespace,
                    this.updateColorName.bind(this)
                ),
                $shopBar.on(
                    'variantPriceChange' + namespace,
                    this.updateProductPrices.bind(this)
                ),
                $shopBar.on(
                    'variantUnitChange' + namespace,
                    this.updateProductUnits.bind(this)
                ),
                $shopBar.on(
                    'variantImageChange' + namespace,
                    this.updateProductImage.bind(this)
                ),
                $shopBar.on(
                    'change',
                    this.selectors.singleOptionSelector,
                    function (e) {
                        var optionSelected = $(this).val(),
                            optionIndex = $(this).data('index'),
                            $formElement = $singleOptionSelector.filter(
                                '[data-index="' + optionIndex + '"]'
                            )
                        $formElement.is('select')
                            ? $formElement
                                  .val(optionSelected)
                                  .triggerHandler('change')
                            : $formElement
                                  .filter('[value="' + optionSelected + '"]')
                                  .prop('checked', !0)
                                  .triggerHandler('change')
                    }
                ),
                $singleOptionSelector.on('change', function (e) {
                    var optionIndex = $(this).data('index'),
                        optionSelected = $(this).val()
                    $shopBar
                        .find('[data-index="' + optionIndex + '"]')
                        .val(optionSelected)
                        .triggerHandler('change')
                }),
                $(window)
                    .on(
                        'scroll.product',
                        Reqs.throttle(function () {
                            var scrolled = window.scrollY
                            if ($productContainer.length && $shopBar.length) {
                                var productContainerOffset =
                                    $productContainer.offset().top
                                scrolled > productContainerOffset
                                    ? ($shopBar.addClass(
                                          'shop-bar--is-visible'
                                      ),
                                      $siteFooter.addClass('site-footer--push'))
                                    : scrolled < productContainerOffset - 60 &&
                                      ($shopBar.removeClass(
                                          'shop-bar--is-visible'
                                      ),
                                      $siteFooter.removeClass(
                                          'site-footer--push'
                                      ))
                            }
                        }, 100)
                    )
                    .trigger('scroll.product')
        },
        showVariantImage: function (variant, container) {
            var variantMediaId = variant.featured_media
                    ? variant.featured_media.id
                    : '',
                $productImage = container.find('.product-image'),
                $imgSlider = container.find('.js-productImgContainer'),
                $imgScrollerNav = container.find('.productImgScroller-nav'),
                flick = $imgSlider.data('flickity')
            if (flick && flick.isActive) {
                var $variantSlide = $imgSlider.find(
                    '[data-id="' + variantMediaId + '"]'
                )
                $variantSlide.index() != -1 &&
                    flick.select($variantSlide.index()),
                    $productImage.removeClass('is-selected-product'),
                    $variantSlide.addClass('is-selected-product')
            } else {
                var $variantThumb = $imgScrollerNav.find(
                    '[data-id="' +
                        variantMediaId +
                        '"] .js-product-single__thumbnail'
                )
                $variantThumb.length && $variantThumb.trigger('click')
            }
        },
        qtyAdjust: function () {
            var $body = $('body')
            $body.off('click', '.js-qty__adjust-btn'),
                $body.on('click', '.js-qty__adjust-btn', function (e) {
                    e.preventDefault()
                    var $adjustBtn = $(this),
                        $qtySelector = $(this).siblings('.qty__adjust-input')
                    ;(qty = validateQty(
                        parseInt($qtySelector.val().replace(/\D/g, ''))
                    )),
                        $adjustBtn.hasClass('increase')
                            ? (qty += 1)
                            : ((qty -= 1), qty < 1 && (qty = 1)),
                        $qtySelector.val(qty)
                }),
                $body.off('focusout', '.qty__adjust > input'),
                $body.on('focusout', '.qty__adjust > input', function (e) {
                    var currentValue = $(this).val()
                    currentValue || $(this).prop('value', 1)
                }),
                $body.off('keydown', '.qty__adjust > input'),
                $body.on('keydown', '.qty__adjust > input', function (e) {
                    var currentValue = $(this).val()
                    e.keyCode === 13 &&
                        !currentValue &&
                        $(this).prop('value', 1)
                })
            function validateQty(qty2) {
                return (
                    (parseFloat(qty2) != parseInt(qty2) || isNaN(qty2)) &&
                        (qty2 = 1),
                    qty2
                )
            }
        },
    }
window.isYoutubeAPILoaded = !1
function onYouTubeIframeAPIReady() {
    ProductVideo.loadVideos(ProductVideo.hosts.youtube),
        (window.isYoutubeAPILoaded = !0)
}
var ProductVideo = (function () {
        var videos = {},
            hosts = { html5: 'html5', youtube: 'youtube' },
            selectors = {
                productMediaWrapper: '[data-product-single-media-wrapper]',
            },
            attributes = {
                enableVideoLooping: 'enable-video-looping',
                videoId: 'video-id',
                mediaId: 'media-id',
            }
        function init(videoContainer, sectionId) {
            if (videoContainer.length) {
                var videoElement = videoContainer.find('iframe, video')[0],
                    mediaId = videoContainer.data('mediaId')
                if (videoElement) {
                    videos[mediaId] = {
                        mediaId,
                        sectionId,
                        host: hostFromVideoElement(videoElement),
                        container: videoContainer,
                        element: videoElement,
                        ready: function () {
                            createPlayer(this)
                        },
                    }
                    var video = videos[mediaId]
                    switch (video.host) {
                        case hosts.html5:
                            window.Shopify.loadFeatures([
                                {
                                    name: 'video-ui',
                                    version: '1.0',
                                    onLoad: setupPlyrVideos,
                                },
                            ]),
                                LibraryLoader.load('plyrShopifyStyles')
                            break
                        case hosts.youtube:
                            window.isYoutubeAPILoaded
                                ? ProductVideo.loadVideos(
                                      ProductVideo.hosts.youtube
                                  )
                                : LibraryLoader.load('youtubeSdk')
                            break
                    }
                }
            }
        }
        function setupPlyrVideos(errors) {
            if (errors) {
                fallbackToNativeVideo()
                return
            }
            loadVideos(hosts.html5)
        }
        function createPlayer(video) {
            if (!video.player) {
                var productMediaWrapper = video.container,
                    enableLooping = productMediaWrapper.data(
                        attributes.enableVideoLooping
                    ),
                    mediaId = productMediaWrapper.data(attributes.mediaId)
                switch (video.host) {
                    case hosts.html5:
                        ;(video.player = new Shopify.Plyr(video.element, {
                            loop: { active: enableLooping },
                            focusOnPlay: !0,
                        })),
                            video.player.on('play', function () {
                                Product.pauseOtherMedia(mediaId)
                            })
                        break
                    case hosts.youtube:
                        var videoId = productMediaWrapper.data(
                            attributes.videoId
                        )
                        video.player = new YT.Player(video.element, {
                            videoId,
                            events: {
                                onStateChange: function (event) {
                                    event.data === 0 &&
                                        enableLooping &&
                                        event.target.seekTo(0),
                                        event.data === 1 &&
                                            Product.pauseOtherMedia(mediaId)
                                },
                            },
                        })
                        break
                }
                productMediaWrapper.on('mediaHidden xrLaunch', function (e) {
                    video.player &&
                        (video.host === hosts.html5 && video.player.pause(),
                        video.host === hosts.youtube &&
                            video.player.pauseVideo &&
                            video.player.pauseVideo())
                }),
                    productMediaWrapper.on('mediaVisible', function (e) {
                        window.isTouch ||
                            (video.player &&
                                (video.host === hosts.html5 &&
                                    video.player.play(),
                                video.host === hosts.youtube &&
                                    video.player.playVideo &&
                                    video.player.playVideo()))
                    })
            }
        }
        function hostFromVideoElement(video) {
            return video.tagName === 'VIDEO'
                ? hosts.html5
                : video.tagName === 'IFRAME' &&
                  /^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(
                      video.src
                  )
                ? hosts.youtube
                : null
        }
        function loadVideos(host) {
            for (var key in videos)
                if (videos.hasOwnProperty(key)) {
                    var video = videos[key]
                    video.host === host && video.ready()
                }
        }
        function fallbackToNativeVideo() {
            for (var key in videos)
                if (videos.hasOwnProperty(key)) {
                    var video = videos[key]
                    if (video.nativeVideo) continue
                    video.host === hosts.html5 &&
                        (video.element.setAttribute('controls', 'controls'),
                        (video.nativeVideo = !0))
                }
        }
        function removeSectionVideos(sectionId) {
            for (var key in videos)
                if (videos.hasOwnProperty(key)) {
                    var video = videos[key]
                    video.sectionId === sectionId &&
                        (video.player && video.player.destroy(),
                        delete videos[key])
                }
        }
        return { init, hosts, loadVideos, removeSectionVideos }
    })(),
    ProductModel = (function () {
        var modelJsonSections = {},
            models = {},
            xrButtons = {},
            selectors = {
                mediaGroup: '[data-product-single-media-group]',
                xrButton: '[data-shopify-xr]',
            }
        function init(modelViewerContainers, sectionId) {
            ;(modelJsonSections[sectionId] = { loaded: !1 }),
                modelViewerContainers.each(function (index) {
                    var $modelViewerContainer = $(this),
                        mediaId = $modelViewerContainer.data('media-id'),
                        $modelViewerElement = $(
                            $modelViewerContainer.find('model-viewer')[0]
                        ),
                        modelId = $modelViewerElement.data('model-id')
                    if (index === 0) {
                        var $xrButton = $modelViewerContainer
                            .closest(selectors.mediaGroup)
                            .find(selectors.xrButton)
                        xrButtons[sectionId] = {
                            $element: $xrButton,
                            defaultId: modelId,
                        }
                    }
                    models[mediaId] = {
                        modelId,
                        mediaId,
                        sectionId,
                        $container: $modelViewerContainer,
                        $element: $modelViewerElement,
                    }
                }),
                window.Shopify.loadFeatures([
                    {
                        name: 'shopify-xr',
                        version: '1.0',
                        onLoad: setupShopifyXr,
                    },
                    {
                        name: 'model-viewer-ui',
                        version: '1.0',
                        onLoad: setupModelViewerUi,
                    },
                ]),
                LibraryLoader.load('modelViewerUiStyles')
        }
        function setupShopifyXr(errors) {
            if (!errors) {
                if (!window.ShopifyXR) {
                    document.addEventListener(
                        'shopify_xr_initialized',
                        function () {
                            setupShopifyXr()
                        }
                    )
                    return
                }
                for (var sectionId in modelJsonSections)
                    if (modelJsonSections.hasOwnProperty(sectionId)) {
                        var modelSection = modelJsonSections[sectionId]
                        if (modelSection.loaded) continue
                        var $modelJson = $('#ModelJson-' + sectionId)
                        window.ShopifyXR.addModels(
                            JSON.parse($modelJson.html())
                        ),
                            (modelSection.loaded = !0)
                    }
                window.ShopifyXR.setupXRElements()
            }
        }
        function setupModelViewerUi(errors) {
            if (!errors) {
                for (var key in models)
                    if (models.hasOwnProperty(key)) {
                        var model = models[key]
                        model.modelViewerUi ||
                            (model.modelViewerUi = new Shopify.ModelViewerUI(
                                model.$element
                            )),
                            setupModelViewerListeners(model)
                    }
            }
        }
        function setupModelViewerListeners(model) {
            var xrButton = xrButtons[model.sectionId]
            model.$container.on('mediaVisible', function () {
                xrButton.$element.attr(
                    'data-shopify-model3d-id',
                    model.modelId
                ),
                    Product.pauseOtherMedia(model.mediaId),
                    !window.isTouch && model.modelViewerUi.play()
            }),
                model.$container
                    .on('mediaHidden', function () {
                        xrButton.$element.attr(
                            'data-shopify-model3d-id',
                            xrButton.defaultId
                        ),
                            model.modelViewerUi.pause()
                    })
                    .on('xrLaunch', function () {
                        model.modelViewerUi.pause()
                    }),
                model.$element.on(
                    'shopify_model_viewer_ui_toggle_play',
                    function () {
                        Product.pauseOtherMedia(model.mediaId)
                    }
                )
        }
        function removeSectionModels(sectionId) {
            for (var key in models)
                if (models.hasOwnProperty(key)) {
                    var model = models[key]
                    model.sectionId === sectionId &&
                        (models[key].modelViewerUi.destroy(),
                        delete models[key])
                }
            delete modelJsonSections[sectionId]
        }
        return { init, removeSectionModels }
    })(),
    RelatedProducts = {
        init: function () {
            var $container = $('[data-section-type="related-products"]'),
                enableSection = $container.data('enable-section'),
                sectionId = $container.attr('data-section-id'),
                productId = $container.data('product-id'),
                limit = $container.data('limit'),
                requestUrl =
                    theme.routes.product_recommendations_url +
                    '?section_id=' +
                    sectionId +
                    '&limit=' +
                    limit +
                    '&product_id=' +
                    productId
            enableSection &&
                $.get(requestUrl).done(function (data) {
                    var products = $(data)
                        .find('[data-section-type="related-products"]')
                        .html()
                    $container.hide().html(products).slideDown('slow')
                    var $image = $container.find('.product-block__image')
                    Site.animations.animateAll(),
                        Site.initReviews(),
                        theme.settings.imageBackgroundSize == 'contain' &&
                            (Collection.setBadgePosition($image),
                            $(window)
                                .off('resize.products')
                                .on(
                                    'resize.products',
                                    Reqs.debounce(
                                        Collection.setBadgePosition.bind(
                                            this,
                                            $image
                                        ),
                                        50
                                    )
                                ))
                })
        },
    },
    Blog = {
        selectors: {
            blogContainer: '[data-blog-container]',
            blogPosts: '[data-blog-posts]',
            blogPost: '[data-blog-post]',
            blogPostContent: '[data-post-title], [data-post-excerpt]',
        },
        classes: { blogPostHasImage: 'blogModule-posts__post--has-image' },
        init: function () {
            var self2 = this,
                namespace = '.blog'
            this.removeAnimations(),
                $(window)
                    .off(namespace)
                    .on(
                        'resize' + namespace,
                        Reqs.debounce(self2.removeAnimations.bind(self2), 250)
                    )
        },
        removeAnimations: function () {
            var windowWidth =
                window.innerWidth || document.decumentElement.clientWidth
            windowWidth < 768 &&
                $(this.selectors.blogContainer).each(function () {
                    Site.removeAnimationClass($(this))
                })
        },
    },
    Reqs = {
        throttle: function (fn, threshhold, scope) {
            threshhold || (threshhold = 250)
            var last, deferTimer
            return function () {
                var context = scope || this,
                    now = +new Date(),
                    args = arguments
                last && now < last + threshhold
                    ? (clearTimeout(deferTimer),
                      (deferTimer = setTimeout(function () {
                          ;(last = now), fn.apply(context, args)
                      }, threshhold)))
                    : ((last = now), fn.apply(context, args))
            }
        },
        debounce: function (fn, wait, immediate) {
            var timeout
            return function () {
                var context = this,
                    args = arguments,
                    later = function () {
                        ;(timeout = null), immediate || fn.apply(context, args)
                    },
                    callNow = immediate && !timeout
                clearTimeout(timeout),
                    (timeout = setTimeout(later, wait)),
                    callNow && fn.apply(context, args)
            }
        },
        lightbox: function () {
            /*! Magnific Popup - v1.1.0 - 2016-02-20
             * http://dimsemenov.com/plugins/magnific-popup/
             * Copyright (c) 2016 Dmitry Semenov; */ ;(function (a) {
                typeof define == 'function' && define.amd
                    ? define(['jquery'], a)
                    : a(
                          typeof exports == 'object'
                              ? require('jquery')
                              : window.jQuery || window.Zepto
                      )
            })(function (a) {
                var b,
                    c,
                    d,
                    e,
                    f,
                    g,
                    h = 'Close',
                    i = 'BeforeClose',
                    j = 'AfterClose',
                    k = 'BeforeAppend',
                    l = 'MarkupParse',
                    m = 'Open',
                    n = 'Change',
                    o = 'mfp',
                    p = '.' + o,
                    q = 'mfp-ready',
                    r = 'mfp-removing',
                    s = 'mfp-prevent-close',
                    t = function () {},
                    u = !!window.jQuery,
                    v = a(window),
                    w = function (a2, c2) {
                        b.ev.on(o + a2 + p, c2)
                    },
                    x = function (b2, c2, d2, e2) {
                        var f2 = document.createElement('div')
                        return (
                            (f2.className = 'mfp-' + b2),
                            d2 && (f2.innerHTML = d2),
                            e2
                                ? c2 && c2.appendChild(f2)
                                : ((f2 = a(f2)), c2 && f2.appendTo(c2)),
                            f2
                        )
                    },
                    y = function (c2, d2) {
                        b.ev.triggerHandler(o + c2, d2),
                            b.st.callbacks &&
                                ((c2 =
                                    c2.charAt(0).toLowerCase() + c2.slice(1)),
                                b.st.callbacks[c2] &&
                                    b.st.callbacks[c2].apply(
                                        b,
                                        a.isArray(d2) ? d2 : [d2]
                                    ))
                    },
                    z = function (c2) {
                        return (
                            (c2 === g && b.currTemplate.closeBtn) ||
                                ((b.currTemplate.closeBtn = a(
                                    b.st.closeMarkup.replace(
                                        '%title%',
                                        b.st.tClose
                                    )
                                )),
                                (g = c2)),
                            b.currTemplate.closeBtn
                        )
                    },
                    A = function () {
                        a.magnificPopup.instance ||
                            ((b = new t()),
                            b.init(),
                            (a.magnificPopup.instance = b))
                    },
                    B = function () {
                        var a2 = document.createElement('p').style,
                            b2 = ['ms', 'O', 'Moz', 'Webkit']
                        if (a2.transition !== void 0) return !0
                        for (; b2.length; )
                            if (b2.pop() + 'Transition' in a2) return !0
                        return !1
                    }
                ;(t.prototype = {
                    constructor: t,
                    init: function () {
                        var c2 = navigator.appVersion
                        ;(b.isLowIE = b.isIE8 =
                            document.all && !document.addEventListener),
                            (b.isAndroid = /android/gi.test(c2)),
                            (b.isIOS = /iphone|ipad|ipod/gi.test(c2)),
                            (b.supportsTransition = B()),
                            (b.probablyMobile =
                                b.isAndroid ||
                                b.isIOS ||
                                /(Opera Mini)|Kindle|webOS|BlackBerry|(Opera Mobi)|(Windows Phone)|IEMobile/i.test(
                                    navigator.userAgent
                                )),
                            (d = a(document)),
                            (b.popupsCache = {})
                    },
                    open: function (c2) {
                        var e2
                        if (c2.isObj === !1) {
                            ;(b.items = c2.items.toArray()), (b.index = 0)
                            var g2,
                                h2 = c2.items
                            for (e2 = 0; e2 < h2.length; e2++)
                                if (
                                    ((g2 = h2[e2]),
                                    g2.parsed && (g2 = g2.el[0]),
                                    g2 === c2.el[0])
                                ) {
                                    b.index = e2
                                    break
                                }
                        } else
                            (b.items = a.isArray(c2.items)
                                ? c2.items
                                : [c2.items]),
                                (b.index = c2.index || 0)
                        if (b.isOpen) return void b.updateItemHTML()
                        ;(b.types = []),
                            (f = ''),
                            c2.mainEl && c2.mainEl.length
                                ? (b.ev = c2.mainEl.eq(0))
                                : (b.ev = d),
                            c2.key
                                ? (b.popupsCache[c2.key] ||
                                      (b.popupsCache[c2.key] = {}),
                                  (b.currTemplate = b.popupsCache[c2.key]))
                                : (b.currTemplate = {}),
                            (b.st = a.extend(
                                !0,
                                {},
                                a.magnificPopup.defaults,
                                c2
                            )),
                            (b.fixedContentPos =
                                b.st.fixedContentPos === 'auto'
                                    ? !b.probablyMobile
                                    : b.st.fixedContentPos),
                            b.st.modal &&
                                ((b.st.closeOnContentClick = !1),
                                (b.st.closeOnBgClick = !1),
                                (b.st.showCloseBtn = !1),
                                (b.st.enableEscapeKey = !1)),
                            b.bgOverlay ||
                                ((b.bgOverlay = x('bg').on(
                                    'click' + p,
                                    function () {
                                        b.close()
                                    }
                                )),
                                (b.wrap = x('wrap')
                                    .attr('tabindex', -1)
                                    .on('click' + p, function (a2) {
                                        b._checkIfClose(a2.target) && b.close()
                                    })),
                                (b.container = x('container', b.wrap))),
                            (b.contentContainer = x('content')),
                            b.st.preloader &&
                                (b.preloader = x(
                                    'preloader',
                                    b.container,
                                    b.st.tLoading
                                ))
                        var i2 = a.magnificPopup.modules
                        for (e2 = 0; e2 < i2.length; e2++) {
                            var j2 = i2[e2]
                            ;(j2 = j2.charAt(0).toUpperCase() + j2.slice(1)),
                                b['init' + j2].call(b)
                        }
                        y('BeforeOpen'),
                            b.st.showCloseBtn &&
                                (b.st.closeBtnInside
                                    ? (w(l, function (a2, b2, c3, d2) {
                                          c3.close_replaceWith = z(d2.type)
                                      }),
                                      (f += ' mfp-close-btn-in'))
                                    : b.wrap.append(z())),
                            b.st.alignTop && (f += ' mfp-align-top'),
                            b.fixedContentPos
                                ? b.wrap.css({
                                      overflow: b.st.overflowY,
                                      overflowX: 'hidden',
                                      overflowY: b.st.overflowY,
                                  })
                                : b.wrap.css({
                                      top: v.scrollTop(),
                                      position: 'absolute',
                                  }),
                            (b.st.fixedBgPos === !1 ||
                                (b.st.fixedBgPos === 'auto' &&
                                    !b.fixedContentPos)) &&
                                b.bgOverlay.css({
                                    height: d.height(),
                                    position: 'absolute',
                                }),
                            b.st.enableEscapeKey &&
                                d.on('keyup' + p, function (a2) {
                                    a2.keyCode === 27 && b.close()
                                }),
                            v.on('resize' + p, function () {
                                b.updateSize()
                            }),
                            b.st.closeOnContentClick ||
                                (f += ' mfp-auto-cursor'),
                            f && b.wrap.addClass(f)
                        var k2 = (b.wH = v.height()),
                            n2 = {}
                        if (b.fixedContentPos && b._hasScrollBar(k2)) {
                            var o2 = b._getScrollbarSize()
                            o2 && (n2.marginRight = o2)
                        }
                        b.fixedContentPos &&
                            (b.isIE7
                                ? a('body, html').css('overflow', 'hidden')
                                : (n2.overflow = 'hidden'))
                        var r2 = b.st.mainClass
                        return (
                            b.isIE7 && (r2 += ' mfp-ie7'),
                            r2 && b._addClassToMFP(r2),
                            b.updateItemHTML(),
                            y('BuildControls'),
                            a('html').css(n2),
                            b.bgOverlay
                                .add(b.wrap)
                                .prependTo(b.st.prependTo || a(document.body)),
                            (b._lastFocusedEl = document.activeElement),
                            setTimeout(function () {
                                b.content
                                    ? (b._addClassToMFP(q), b._setFocus())
                                    : b.bgOverlay.addClass(q),
                                    d.on('focusin' + p, b._onFocusIn)
                            }, 16),
                            (b.isOpen = !0),
                            b.updateSize(k2),
                            y(m),
                            c2
                        )
                    },
                    close: function () {
                        b.isOpen &&
                            (y(i),
                            (b.isOpen = !1),
                            b.st.removalDelay &&
                            !b.isLowIE &&
                            b.supportsTransition
                                ? (b._addClassToMFP(r),
                                  setTimeout(function () {
                                      b._close()
                                  }, b.st.removalDelay))
                                : b._close())
                    },
                    _close: function () {
                        y(h)
                        var c2 = r + ' ' + q + ' '
                        if (
                            (b.bgOverlay.detach(),
                            b.wrap.detach(),
                            b.container.empty(),
                            b.st.mainClass && (c2 += b.st.mainClass + ' '),
                            b._removeClassFromMFP(c2),
                            b.fixedContentPos)
                        ) {
                            var e2 = { marginRight: '' }
                            b.isIE7
                                ? a('body, html').css('overflow', '')
                                : (e2.overflow = ''),
                                a('html').css(e2)
                        }
                        d.off('keyup' + p + ' focusin' + p),
                            b.ev.off(p),
                            b.wrap
                                .attr('class', 'mfp-wrap')
                                .removeAttr('style'),
                            b.bgOverlay.attr('class', 'mfp-bg'),
                            b.container.attr('class', 'mfp-container'),
                            !b.st.showCloseBtn ||
                                (b.st.closeBtnInside &&
                                    b.currTemplate[b.currItem.type] !== !0) ||
                                (b.currTemplate.closeBtn &&
                                    b.currTemplate.closeBtn.detach()),
                            b.st.autoFocusLast &&
                                b._lastFocusedEl &&
                                a(b._lastFocusedEl).focus(),
                            (b.currItem = null),
                            (b.content = null),
                            (b.currTemplate = null),
                            (b.prevHeight = 0),
                            y(j)
                    },
                    updateSize: function (a2) {
                        if (b.isIOS) {
                            var c2 =
                                    document.documentElement.clientWidth /
                                    window.innerWidth,
                                d2 = window.innerHeight * c2
                            b.wrap.css('height', d2), (b.wH = d2)
                        } else b.wH = a2 || v.height()
                        b.fixedContentPos || b.wrap.css('height', b.wH),
                            y('Resize')
                    },
                    updateItemHTML: function () {
                        var c2 = b.items[b.index]
                        b.contentContainer.detach(),
                            b.content && b.content.detach(),
                            c2.parsed || (c2 = b.parseEl(b.index))
                        var d2 = c2.type
                        if (
                            (y('BeforeChange', [
                                b.currItem ? b.currItem.type : '',
                                d2,
                            ]),
                            (b.currItem = c2),
                            !b.currTemplate[d2])
                        ) {
                            var f2 = b.st[d2] ? b.st[d2].markup : !1
                            y('FirstMarkupParse', f2),
                                f2
                                    ? (b.currTemplate[d2] = a(f2))
                                    : (b.currTemplate[d2] = !0)
                        }
                        e &&
                            e !== c2.type &&
                            b.container.removeClass('mfp-' + e + '-holder')
                        var g2 = b[
                            'get' + d2.charAt(0).toUpperCase() + d2.slice(1)
                        ](c2, b.currTemplate[d2])
                        b.appendContent(g2, d2),
                            (c2.preloaded = !0),
                            y(n, c2),
                            (e = c2.type),
                            b.container.prepend(b.contentContainer),
                            y('AfterChange')
                    },
                    appendContent: function (a2, c2) {
                        ;(b.content = a2),
                            a2
                                ? b.st.showCloseBtn &&
                                  b.st.closeBtnInside &&
                                  b.currTemplate[c2] === !0
                                    ? b.content.find('.mfp-close').length ||
                                      b.content.append(z())
                                    : (b.content = a2)
                                : (b.content = ''),
                            y(k),
                            b.container.addClass('mfp-' + c2 + '-holder'),
                            b.contentContainer.append(b.content)
                    },
                    parseEl: function (c2) {
                        var d2,
                            e2 = b.items[c2]
                        if (
                            (e2.tagName
                                ? (e2 = { el: a(e2) })
                                : ((d2 = e2.type),
                                  (e2 = { data: e2, src: e2.src })),
                            e2.el)
                        ) {
                            for (var f2 = b.types, g2 = 0; g2 < f2.length; g2++)
                                if (e2.el.hasClass('mfp-' + f2[g2])) {
                                    d2 = f2[g2]
                                    break
                                }
                            ;(e2.src = e2.el.attr('data-mfp-src')),
                                e2.src || (e2.src = e2.el.attr('href'))
                        }
                        return (
                            (e2.type = d2 || b.st.type || 'inline'),
                            (e2.index = c2),
                            (e2.parsed = !0),
                            (b.items[c2] = e2),
                            y('ElementParse', e2),
                            b.items[c2]
                        )
                    },
                    addGroup: function (a2, c2) {
                        var d2 = function (d3) {
                            ;(d3.mfpEl = this), b._openClick(d3, a2, c2)
                        }
                        c2 || (c2 = {})
                        var e2 = 'click.magnificPopup'
                        ;(c2.mainEl = a2),
                            c2.items
                                ? ((c2.isObj = !0), a2.off(e2).on(e2, d2))
                                : ((c2.isObj = !1),
                                  c2.delegate
                                      ? a2.off(e2).on(e2, c2.delegate, d2)
                                      : ((c2.items = a2),
                                        a2.off(e2).on(e2, d2)))
                    },
                    _openClick: function (c2, d2, e2) {
                        var f2 =
                            e2.midClick !== void 0
                                ? e2.midClick
                                : a.magnificPopup.defaults.midClick
                        if (
                            f2 ||
                            !(
                                c2.which === 2 ||
                                c2.ctrlKey ||
                                c2.metaKey ||
                                c2.altKey ||
                                c2.shiftKey
                            )
                        ) {
                            var g2 =
                                e2.disableOn !== void 0
                                    ? e2.disableOn
                                    : a.magnificPopup.defaults.disableOn
                            if (g2) {
                                if (a.isFunction(g2)) {
                                    if (!g2.call(b)) return !0
                                } else if (v.width() < g2) return !0
                            }
                            c2.type &&
                                (c2.preventDefault(),
                                b.isOpen && c2.stopPropagation()),
                                (e2.el = a(c2.mfpEl)),
                                e2.delegate &&
                                    (e2.items = d2.find(e2.delegate)),
                                b.open(e2)
                        }
                    },
                    updateStatus: function (a2, d2) {
                        if (b.preloader) {
                            c !== a2 && b.container.removeClass('mfp-s-' + c),
                                d2 || a2 !== 'loading' || (d2 = b.st.tLoading)
                            var e2 = { status: a2, text: d2 }
                            y('UpdateStatus', e2),
                                (a2 = e2.status),
                                (d2 = e2.text),
                                b.preloader.html(d2),
                                b.preloader
                                    .find('a')
                                    .on('click', function (a3) {
                                        a3.stopImmediatePropagation()
                                    }),
                                b.container.addClass('mfp-s-' + a2),
                                (c = a2)
                        }
                    },
                    _checkIfClose: function (c2) {
                        if (!a(c2).hasClass(s)) {
                            var d2 = b.st.closeOnContentClick,
                                e2 = b.st.closeOnBgClick
                            if (
                                (d2 && e2) ||
                                !b.content ||
                                a(c2).hasClass('mfp-close') ||
                                (b.preloader && c2 === b.preloader[0])
                            )
                                return !0
                            if (
                                c2 === b.content[0] ||
                                a.contains(b.content[0], c2)
                            ) {
                                if (d2) return !0
                            } else if (e2 && a.contains(document, c2)) return !0
                            return !1
                        }
                    },
                    _addClassToMFP: function (a2) {
                        b.bgOverlay.addClass(a2), b.wrap.addClass(a2)
                    },
                    _removeClassFromMFP: function (a2) {
                        this.bgOverlay.removeClass(a2), b.wrap.removeClass(a2)
                    },
                    _hasScrollBar: function (a2) {
                        return (
                            (b.isIE7
                                ? d.height()
                                : document.body.scrollHeight) >
                            (a2 || v.height())
                        )
                    },
                    _setFocus: function () {
                        ;(b.st.focus
                            ? b.content.find(b.st.focus).eq(0)
                            : b.wrap
                        ).focus()
                    },
                    _onFocusIn: function (c2) {
                        return c2.target === b.wrap[0] ||
                            a.contains(b.wrap[0], c2.target)
                            ? void 0
                            : (b._setFocus(), !1)
                    },
                    _parseMarkup: function (b2, c2, d2) {
                        var e2
                        d2.data && (c2 = a.extend(d2.data, c2)),
                            y(l, [b2, c2, d2]),
                            a.each(c2, function (c3, d3) {
                                if (d3 === void 0 || d3 === !1) return !0
                                if (((e2 = c3.split('_')), e2.length > 1)) {
                                    var f2 = b2.find(p + '-' + e2[0])
                                    if (f2.length > 0) {
                                        var g2 = e2[1]
                                        g2 === 'replaceWith'
                                            ? f2[0] !== d3[0] &&
                                              f2.replaceWith(d3)
                                            : g2 === 'img'
                                            ? f2.is('img')
                                                ? f2.attr('src', d3)
                                                : f2.replaceWith(
                                                      a('<img>')
                                                          .attr('src', d3)
                                                          .attr(
                                                              'class',
                                                              f2.attr('class')
                                                          )
                                                  )
                                            : f2.attr(e2[1], d3)
                                    }
                                } else b2.find(p + '-' + c3).html(d3)
                            })
                    },
                    _getScrollbarSize: function () {
                        if (b.scrollbarSize === void 0) {
                            var a2 = document.createElement('div')
                            ;(a2.style.cssText =
                                'width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;'),
                                document.body.appendChild(a2),
                                (b.scrollbarSize =
                                    a2.offsetWidth - a2.clientWidth),
                                document.body.removeChild(a2)
                        }
                        return b.scrollbarSize
                    },
                }),
                    (a.magnificPopup = {
                        instance: null,
                        proto: t.prototype,
                        modules: [],
                        open: function (b2, c2) {
                            return (
                                A(),
                                (b2 = b2 ? a.extend(!0, {}, b2) : {}),
                                (b2.isObj = !0),
                                (b2.index = c2 || 0),
                                this.instance.open(b2)
                            )
                        },
                        close: function () {
                            return (
                                a.magnificPopup.instance &&
                                a.magnificPopup.instance.close()
                            )
                        },
                        registerModule: function (b2, c2) {
                            c2.options &&
                                (a.magnificPopup.defaults[b2] = c2.options),
                                a.extend(this.proto, c2.proto),
                                this.modules.push(b2)
                        },
                        defaults: {
                            disableOn: 0,
                            key: null,
                            midClick: !1,
                            mainClass: '',
                            preloader: !0,
                            focus: '',
                            closeOnContentClick: !1,
                            closeOnBgClick: !0,
                            closeBtnInside: !0,
                            showCloseBtn: !0,
                            enableEscapeKey: !0,
                            modal: !1,
                            alignTop: !1,
                            removalDelay: 0,
                            prependTo: null,
                            fixedContentPos: 'auto',
                            fixedBgPos: 'auto',
                            overflowY: 'auto',
                            closeMarkup:
                                '<button title="%title%" type="button" class="mfp-close">&#215;</button>',
                            tClose: 'Close (Esc)',
                            tLoading: 'Loading...',
                            autoFocusLast: !0,
                        },
                    }),
                    (a.fn.magnificPopup = function (c2) {
                        A()
                        var d2 = a(this)
                        if (typeof c2 == 'string')
                            if (c2 === 'open') {
                                var e2,
                                    f2 = u
                                        ? d2.data('magnificPopup')
                                        : d2[0].magnificPopup,
                                    g2 = parseInt(arguments[1], 10) || 0
                                f2.items
                                    ? (e2 = f2.items[g2])
                                    : ((e2 = d2),
                                      f2.delegate &&
                                          (e2 = e2.find(f2.delegate)),
                                      (e2 = e2.eq(g2))),
                                    b._openClick({ mfpEl: e2 }, d2, f2)
                            } else
                                b.isOpen &&
                                    b[c2].apply(
                                        b,
                                        Array.prototype.slice.call(arguments, 1)
                                    )
                        else
                            (c2 = a.extend(!0, {}, c2)),
                                u
                                    ? d2.data('magnificPopup', c2)
                                    : (d2[0].magnificPopup = c2),
                                b.addGroup(d2, c2)
                        return d2
                    })
                var C,
                    D,
                    E,
                    F = 'inline',
                    G = function () {
                        E && (D.after(E.addClass(C)).detach(), (E = null))
                    }
                a.magnificPopup.registerModule(F, {
                    options: {
                        hiddenClass: 'hide',
                        markup: '',
                        tNotFound: 'Content not found',
                    },
                    proto: {
                        initInline: function () {
                            b.types.push(F),
                                w(h + '.' + F, function () {
                                    G()
                                })
                        },
                        getInline: function (c2, d2) {
                            if ((G(), c2.src)) {
                                var e2 = b.st.inline,
                                    f2 = a(c2.src)
                                if (f2.length) {
                                    var g2 = f2[0].parentNode
                                    g2 &&
                                        g2.tagName &&
                                        (D ||
                                            ((C = e2.hiddenClass),
                                            (D = x(C)),
                                            (C = 'mfp-' + C)),
                                        (E = f2
                                            .after(D)
                                            .detach()
                                            .removeClass(C))),
                                        b.updateStatus('ready')
                                } else
                                    b.updateStatus('error', e2.tNotFound),
                                        (f2 = a('<div>'))
                                return (c2.inlineElement = f2), f2
                            }
                            return (
                                b.updateStatus('ready'),
                                b._parseMarkup(d2, {}, c2),
                                d2
                            )
                        },
                    },
                })
                var H,
                    I = 'ajax',
                    J = function () {
                        H && a(document.body).removeClass(H)
                    },
                    K = function () {
                        J(), b.req && b.req.abort()
                    }
                a.magnificPopup.registerModule(I, {
                    options: {
                        settings: null,
                        cursor: 'mfp-ajax-cur',
                        tError: '<a href="%url%">The content</a> could not be loaded.',
                    },
                    proto: {
                        initAjax: function () {
                            b.types.push(I),
                                (H = b.st.ajax.cursor),
                                w(h + '.' + I, K),
                                w('BeforeChange.' + I, K)
                        },
                        getAjax: function (c2) {
                            H && a(document.body).addClass(H),
                                b.updateStatus('loading')
                            var d2 = a.extend(
                                {
                                    url: c2.src,
                                    success: function (d3, e2, f2) {
                                        var g2 = { data: d3, xhr: f2 }
                                        y('ParseAjax', g2),
                                            b.appendContent(a(g2.data), I),
                                            (c2.finished = !0),
                                            J(),
                                            b._setFocus(),
                                            setTimeout(function () {
                                                b.wrap.addClass(q)
                                            }, 16),
                                            b.updateStatus('ready'),
                                            y('AjaxContentAdded')
                                    },
                                    error: function () {
                                        J(),
                                            (c2.finished = c2.loadError = !0),
                                            b.updateStatus(
                                                'error',
                                                b.st.ajax.tError.replace(
                                                    '%url%',
                                                    c2.src
                                                )
                                            )
                                    },
                                },
                                b.st.ajax.settings
                            )
                            return (b.req = a.ajax(d2)), ''
                        },
                    },
                })
                var L,
                    M = function (c2) {
                        if (c2.data && c2.data.title !== void 0)
                            return c2.data.title
                        var d2 = b.st.image.titleSrc
                        if (d2) {
                            if (a.isFunction(d2)) return d2.call(b, c2)
                            if (c2.el) return c2.el.attr(d2) || ''
                        }
                        return ''
                    }
                a.magnificPopup.registerModule('image', {
                    options: {
                        markup: '<div class="mfp-figure"><div class="mfp-close"></div><figure><div class="mfp-img"></div><figcaption><div class="mfp-bottom-bar"><div class="mfp-title"></div><div class="mfp-counter"></div></div></figcaption></figure></div>',
                        cursor: 'mfp-zoom-out-cur',
                        titleSrc: 'title',
                        verticalFit: !0,
                        tError: '<a href="%url%">The image</a> could not be loaded.',
                    },
                    proto: {
                        initImage: function () {
                            var c2 = b.st.image,
                                d2 = '.image'
                            b.types.push('image'),
                                w(m + d2, function () {
                                    b.currItem.type === 'image' &&
                                        c2.cursor &&
                                        a(document.body).addClass(c2.cursor)
                                }),
                                w(h + d2, function () {
                                    c2.cursor &&
                                        a(document.body).removeClass(c2.cursor),
                                        v.off('resize' + p)
                                }),
                                w('Resize' + d2, b.resizeImage),
                                b.isLowIE && w('AfterChange', b.resizeImage)
                        },
                        resizeImage: function () {
                            var a2 = b.currItem
                            if (a2 && a2.img && b.st.image.verticalFit) {
                                var c2 = 0
                                b.isLowIE &&
                                    (c2 =
                                        parseInt(
                                            a2.img.css('padding-top'),
                                            10
                                        ) +
                                        parseInt(
                                            a2.img.css('padding-bottom'),
                                            10
                                        )),
                                    a2.img.css('max-height', b.wH - c2)
                            }
                        },
                        _onImageHasSize: function (a2) {
                            a2.img &&
                                ((a2.hasSize = !0),
                                L && clearInterval(L),
                                (a2.isCheckingImgSize = !1),
                                y('ImageHasSize', a2),
                                a2.imgHidden &&
                                    (b.content &&
                                        b.content.removeClass('mfp-loading'),
                                    (a2.imgHidden = !1)))
                        },
                        findImageSize: function (a2) {
                            var c2 = 0,
                                d2 = a2.img[0],
                                e2 = function (f2) {
                                    L && clearInterval(L),
                                        (L = setInterval(function () {
                                            return d2.naturalWidth > 0
                                                ? void b._onImageHasSize(a2)
                                                : (c2 > 200 && clearInterval(L),
                                                  c2++,
                                                  void (c2 === 3
                                                      ? e2(10)
                                                      : c2 === 40
                                                      ? e2(50)
                                                      : c2 === 100 && e2(500)))
                                        }, f2))
                                }
                            e2(1)
                        },
                        getImage: function (c2, d2) {
                            var e2 = 0,
                                f2 = function () {
                                    c2 &&
                                        (c2.img[0].complete
                                            ? (c2.img.off('.mfploader'),
                                              c2 === b.currItem &&
                                                  (b._onImageHasSize(c2),
                                                  b.updateStatus('ready')),
                                              (c2.hasSize = !0),
                                              (c2.loaded = !0),
                                              y('ImageLoadComplete'))
                                            : (e2++,
                                              200 > e2
                                                  ? setTimeout(f2, 100)
                                                  : g2()))
                                },
                                g2 = function () {
                                    c2 &&
                                        (c2.img.off('.mfploader'),
                                        c2 === b.currItem &&
                                            (b._onImageHasSize(c2),
                                            b.updateStatus(
                                                'error',
                                                h2.tError.replace(
                                                    '%url%',
                                                    c2.src
                                                )
                                            )),
                                        (c2.hasSize = !0),
                                        (c2.loaded = !0),
                                        (c2.loadError = !0))
                                },
                                h2 = b.st.image,
                                i2 = d2.find('.mfp-img')
                            if (i2.length) {
                                var j2 = document.createElement('img')
                                ;(j2.className = 'mfp-img'),
                                    c2.el &&
                                        c2.el.find('img').length &&
                                        (j2.alt = c2.el
                                            .find('img')
                                            .attr('alt')),
                                    (c2.img = a(j2)
                                        .on('load.mfploader', f2)
                                        .on('error.mfploader', g2)),
                                    (j2.src = c2.src),
                                    i2.is('img') && (c2.img = c2.img.clone()),
                                    (j2 = c2.img[0]),
                                    j2.naturalWidth > 0
                                        ? (c2.hasSize = !0)
                                        : j2.width || (c2.hasSize = !1)
                            }
                            return (
                                b._parseMarkup(
                                    d2,
                                    { title: M(c2), img_replaceWith: c2.img },
                                    c2
                                ),
                                b.resizeImage(),
                                c2.hasSize
                                    ? (L && clearInterval(L),
                                      c2.loadError
                                          ? (d2.addClass('mfp-loading'),
                                            b.updateStatus(
                                                'error',
                                                h2.tError.replace(
                                                    '%url%',
                                                    c2.src
                                                )
                                            ))
                                          : (d2.removeClass('mfp-loading'),
                                            b.updateStatus('ready')),
                                      d2)
                                    : (b.updateStatus('loading'),
                                      (c2.loading = !0),
                                      c2.hasSize ||
                                          ((c2.imgHidden = !0),
                                          d2.addClass('mfp-loading'),
                                          b.findImageSize(c2)),
                                      d2)
                            )
                        },
                    },
                })
                var N,
                    O = function () {
                        return (
                            N === void 0 &&
                                (N =
                                    document.createElement('p').style
                                        .MozTransform !== void 0),
                            N
                        )
                    }
                a.magnificPopup.registerModule('zoom', {
                    options: {
                        enabled: !1,
                        easing: 'ease-in-out',
                        duration: 300,
                        opener: function (a2) {
                            return a2.is('img') ? a2 : a2.find('img')
                        },
                    },
                    proto: {
                        initZoom: function () {
                            var a2,
                                c2 = b.st.zoom,
                                d2 = '.zoom'
                            if (c2.enabled && b.supportsTransition) {
                                var e2,
                                    f2,
                                    g2 = c2.duration,
                                    j2 = function (a3) {
                                        var b2 = a3
                                                .clone()
                                                .removeAttr('style')
                                                .removeAttr('class')
                                                .addClass('mfp-animated-image'),
                                            d3 =
                                                'all ' +
                                                c2.duration / 1e3 +
                                                's ' +
                                                c2.easing,
                                            e3 = {
                                                position: 'fixed',
                                                zIndex: 9999,
                                                left: 0,
                                                top: 0,
                                                '-webkit-backface-visibility':
                                                    'hidden',
                                            },
                                            f3 = 'transition'
                                        return (
                                            (e3['-webkit-' + f3] =
                                                e3['-moz-' + f3] =
                                                e3['-o-' + f3] =
                                                e3[f3] =
                                                    d3),
                                            b2.css(e3),
                                            b2
                                        )
                                    },
                                    k2 = function () {
                                        b.content.css('visibility', 'visible')
                                    }
                                w('BuildControls' + d2, function () {
                                    if (b._allowZoom()) {
                                        if (
                                            (clearTimeout(e2),
                                            b.content.css(
                                                'visibility',
                                                'hidden'
                                            ),
                                            (a2 = b._getItemToZoom()),
                                            !a2)
                                        )
                                            return void k2()
                                        ;(f2 = j2(a2)),
                                            f2.css(b._getOffset()),
                                            b.wrap.append(f2),
                                            (e2 = setTimeout(function () {
                                                f2.css(b._getOffset(!0)),
                                                    (e2 = setTimeout(
                                                        function () {
                                                            k2(),
                                                                setTimeout(
                                                                    function () {
                                                                        f2.remove(),
                                                                            (a2 =
                                                                                f2 =
                                                                                    null),
                                                                            y(
                                                                                'ZoomAnimationEnded'
                                                                            )
                                                                    },
                                                                    16
                                                                )
                                                        },
                                                        g2
                                                    ))
                                            }, 16))
                                    }
                                }),
                                    w(i + d2, function () {
                                        if (b._allowZoom()) {
                                            if (
                                                (clearTimeout(e2),
                                                (b.st.removalDelay = g2),
                                                !a2)
                                            ) {
                                                if (
                                                    ((a2 = b._getItemToZoom()),
                                                    !a2)
                                                )
                                                    return
                                                f2 = j2(a2)
                                            }
                                            f2.css(b._getOffset(!0)),
                                                b.wrap.append(f2),
                                                b.content.css(
                                                    'visibility',
                                                    'hidden'
                                                ),
                                                setTimeout(function () {
                                                    f2.css(b._getOffset())
                                                }, 16)
                                        }
                                    }),
                                    w(h + d2, function () {
                                        b._allowZoom() &&
                                            (k2(),
                                            f2 && f2.remove(),
                                            (a2 = null))
                                    })
                            }
                        },
                        _allowZoom: function () {
                            return b.currItem.type === 'image'
                        },
                        _getItemToZoom: function () {
                            return b.currItem.hasSize ? b.currItem.img : !1
                        },
                        _getOffset: function (c2) {
                            var d2
                            d2 = c2
                                ? b.currItem.img
                                : b.st.zoom.opener(b.currItem.el || b.currItem)
                            var e2 = d2.offset(),
                                f2 = parseInt(d2.css('padding-top'), 10),
                                g2 = parseInt(d2.css('padding-bottom'), 10)
                            e2.top -= a(window).scrollTop() - f2
                            var h2 = {
                                width: d2.width(),
                                height:
                                    (u
                                        ? d2.innerHeight()
                                        : d2[0].offsetHeight) -
                                    g2 -
                                    f2,
                            }
                            return (
                                O()
                                    ? (h2['-moz-transform'] = h2.transform =
                                          'translate(' +
                                          e2.left +
                                          'px,' +
                                          e2.top +
                                          'px)')
                                    : ((h2.left = e2.left), (h2.top = e2.top)),
                                h2
                            )
                        },
                    },
                })
                var P = 'iframe',
                    Q = '//about:blank',
                    R = function (a2) {
                        if (b.currTemplate[P]) {
                            var c2 = b.currTemplate[P].find('iframe')
                            c2.length &&
                                (a2 || (c2[0].src = Q),
                                b.isIE8 &&
                                    c2.css('display', a2 ? 'block' : 'none'))
                        }
                    }
                a.magnificPopup.registerModule(P, {
                    options: {
                        markup: '<div class="mfp-iframe-scaler"><div class="mfp-close"></div><iframe class="mfp-iframe" src="//about:blank" frameborder="0" allowfullscreen></iframe></div>',
                        srcAction: 'iframe_src',
                        patterns: {
                            youtube: {
                                index: 'youtube.com',
                                id: 'v=',
                                src: '//www.youtube.com/embed/%id%?autoplay=1',
                            },
                            vimeo: {
                                index: 'vimeo.com/',
                                id: '/',
                                src: '//player.vimeo.com/video/%id%?autoplay=1',
                            },
                            gmaps: {
                                index: '//maps.google.',
                                src: '%id%&output=embed',
                            },
                        },
                    },
                    proto: {
                        initIframe: function () {
                            b.types.push(P),
                                w('BeforeChange', function (a2, b2, c2) {
                                    b2 !== c2 &&
                                        (b2 === P ? R() : c2 === P && R(!0))
                                }),
                                w(h + '.' + P, function () {
                                    R()
                                })
                        },
                        getIframe: function (c2, d2) {
                            var e2 = c2.src,
                                f2 = b.st.iframe
                            a.each(f2.patterns, function () {
                                return e2.indexOf(this.index) > -1
                                    ? (this.id &&
                                          (e2 =
                                              typeof this.id == 'string'
                                                  ? e2.substr(
                                                        e2.lastIndexOf(
                                                            this.id
                                                        ) + this.id.length,
                                                        e2.length
                                                    )
                                                  : this.id.call(this, e2)),
                                      (e2 = this.src.replace('%id%', e2)),
                                      !1)
                                    : void 0
                            })
                            var g2 = {}
                            return (
                                f2.srcAction && (g2[f2.srcAction] = e2),
                                b._parseMarkup(d2, g2, c2),
                                b.updateStatus('ready'),
                                d2
                            )
                        },
                    },
                })
                var S = function (a2) {
                        var c2 = b.items.length
                        return a2 > c2 - 1 ? a2 - c2 : 0 > a2 ? c2 + a2 : a2
                    },
                    T = function (a2, b2, c2) {
                        return a2
                            .replace(/%curr%/gi, b2 + 1)
                            .replace(/%total%/gi, c2)
                    }
                a.magnificPopup.registerModule('gallery', {
                    options: {
                        enabled: !1,
                        arrowMarkup:
                            '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>',
                        preload: [0, 2],
                        navigateByImgClick: !0,
                        arrows: !0,
                        tPrev: 'Previous (Left arrow key)',
                        tNext: 'Next (Right arrow key)',
                        tCounter: '%curr% of %total%',
                    },
                    proto: {
                        initGallery: function () {
                            var c2 = b.st.gallery,
                                e2 = '.mfp-gallery'
                            return (
                                (b.direction = !0),
                                c2 && c2.enabled
                                    ? ((f += ' mfp-gallery'),
                                      w(m + e2, function () {
                                          c2.navigateByImgClick &&
                                              b.wrap.on(
                                                  'click' + e2,
                                                  '.mfp-img',
                                                  function () {
                                                      return b.items.length > 1
                                                          ? (b.next(), !1)
                                                          : void 0
                                                  }
                                              ),
                                              d.on(
                                                  'keydown' + e2,
                                                  function (a2) {
                                                      a2.keyCode === 37
                                                          ? b.prev()
                                                          : a2.keyCode === 39 &&
                                                            b.next()
                                                  }
                                              )
                                      }),
                                      w('UpdateStatus' + e2, function (a2, c3) {
                                          c3.text &&
                                              (c3.text = T(
                                                  c3.text,
                                                  b.currItem.index,
                                                  b.items.length
                                              ))
                                      }),
                                      w(l + e2, function (a2, d2, e3, f2) {
                                          var g2 = b.items.length
                                          e3.counter =
                                              g2 > 1
                                                  ? T(c2.tCounter, f2.index, g2)
                                                  : ''
                                      }),
                                      w('BuildControls' + e2, function () {
                                          if (
                                              b.items.length > 1 &&
                                              c2.arrows &&
                                              !b.arrowLeft
                                          ) {
                                              var d2 = c2.arrowMarkup,
                                                  e3 = (b.arrowLeft = a(
                                                      d2
                                                          .replace(
                                                              /%title%/gi,
                                                              c2.tPrev
                                                          )
                                                          .replace(
                                                              /%dir%/gi,
                                                              'left'
                                                          )
                                                  ).addClass(s)),
                                                  f2 = (b.arrowRight = a(
                                                      d2
                                                          .replace(
                                                              /%title%/gi,
                                                              c2.tNext
                                                          )
                                                          .replace(
                                                              /%dir%/gi,
                                                              'right'
                                                          )
                                                  ).addClass(s))
                                              e3.click(function () {
                                                  b.prev()
                                              }),
                                                  f2.click(function () {
                                                      b.next()
                                                  }),
                                                  b.container.append(e3.add(f2))
                                          }
                                      }),
                                      w(n + e2, function () {
                                          b._preloadTimeout &&
                                              clearTimeout(b._preloadTimeout),
                                              (b._preloadTimeout = setTimeout(
                                                  function () {
                                                      b.preloadNearbyImages(),
                                                          (b._preloadTimeout =
                                                              null)
                                                  },
                                                  16
                                              ))
                                      }),
                                      void w(h + e2, function () {
                                          d.off(e2),
                                              b.wrap.off('click' + e2),
                                              (b.arrowRight = b.arrowLeft =
                                                  null)
                                      }))
                                    : !1
                            )
                        },
                        next: function () {
                            ;(b.direction = !0),
                                (b.index = S(b.index + 1)),
                                b.updateItemHTML()
                        },
                        prev: function () {
                            ;(b.direction = !1),
                                (b.index = S(b.index - 1)),
                                b.updateItemHTML()
                        },
                        goTo: function (a2) {
                            ;(b.direction = a2 >= b.index),
                                (b.index = a2),
                                b.updateItemHTML()
                        },
                        preloadNearbyImages: function () {
                            var a2,
                                c2 = b.st.gallery.preload,
                                d2 = Math.min(c2[0], b.items.length),
                                e2 = Math.min(c2[1], b.items.length)
                            for (a2 = 1; a2 <= (b.direction ? e2 : d2); a2++)
                                b._preloadItem(b.index + a2)
                            for (a2 = 1; a2 <= (b.direction ? d2 : e2); a2++)
                                b._preloadItem(b.index - a2)
                        },
                        _preloadItem: function (c2) {
                            if (((c2 = S(c2)), !b.items[c2].preloaded)) {
                                var d2 = b.items[c2]
                                d2.parsed || (d2 = b.parseEl(c2)),
                                    y('LazyLoad', d2),
                                    d2.type === 'image' &&
                                        (d2.img = a('<img class="mfp-img" />')
                                            .on('load.mfploader', function () {
                                                d2.hasSize = !0
                                            })
                                            .on('error.mfploader', function () {
                                                ;(d2.hasSize = !0),
                                                    (d2.loadError = !0),
                                                    y('LazyLoadError', d2)
                                            })
                                            .attr('src', d2.src)),
                                    (d2.preloaded = !0)
                            }
                        },
                    },
                })
                var U = 'retina'
                a.magnificPopup.registerModule(U, {
                    options: {
                        replaceSrc: function (a2) {
                            return a2.src.replace(/\.\w+$/, function (a3) {
                                return '@2x' + a3
                            })
                        },
                        ratio: 1,
                    },
                    proto: {
                        initRetina: function () {
                            if (window.devicePixelRatio > 1) {
                                var a2 = b.st.retina,
                                    c2 = a2.ratio
                                ;(c2 = isNaN(c2) ? c2() : c2),
                                    c2 > 1 &&
                                        (w(
                                            'ImageHasSize.' + U,
                                            function (a3, b2) {
                                                b2.img.css({
                                                    'max-width':
                                                        b2.img[0].naturalWidth /
                                                        c2,
                                                    width: '100%',
                                                })
                                            }
                                        ),
                                        w(
                                            'ElementParse.' + U,
                                            function (b2, d2) {
                                                d2.src = a2.replaceSrc(d2, c2)
                                            }
                                        ))
                            }
                        },
                    },
                }),
                    A()
            })
        },
        zoom: function () {
            /*!
  Zoom 1.7.21
  license: MIT
  http://www.jacklmoore.com/zoom
*/ ;(function (o) {
                var t = {
                    url: !1,
                    callback: !1,
                    target: !1,
                    duration: 120,
                    on: 'mouseover',
                    touch: !0,
                    onZoomIn: !1,
                    onZoomOut: !1,
                    magnify: 1,
                }
                ;(o.zoom = function (t2, n, e, i) {
                    var u,
                        c,
                        a,
                        r,
                        m,
                        l,
                        s,
                        f = o(t2),
                        h = f.css('position'),
                        d = o(n)
                    return (
                        (t2.style.position = /(absolute|fixed)/.test(h)
                            ? h
                            : 'relative'),
                        (t2.style.overflow = 'hidden'),
                        (e.style.width = e.style.height = ''),
                        o(e)
                            .addClass('zoomImg')
                            .css({
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                opacity: 0,
                                width: e.width * i,
                                height: e.height * i,
                                border: 'none',
                                maxWidth: 'none',
                                maxHeight: 'none',
                            })
                            .appendTo(t2),
                        {
                            init: function () {
                                ;(c = f.outerWidth()),
                                    (u = f.outerHeight()),
                                    n === t2
                                        ? ((r = c), (a = u))
                                        : ((r = d.outerWidth()),
                                          (a = d.outerHeight())),
                                    (m = (e.width - c) / r),
                                    (l = (e.height - u) / a),
                                    (s = d.offset())
                            },
                            move: function (o2) {
                                var t3 = o2.pageX - s.left,
                                    n2 = o2.pageY - s.top
                                ;(n2 = Math.max(Math.min(n2, a), 0)),
                                    (t3 = Math.max(Math.min(t3, r), 0)),
                                    (e.style.left = t3 * -m + 'px'),
                                    (e.style.top = n2 * -l + 'px')
                            },
                        }
                    )
                }),
                    (o.fn.zoom = function (n) {
                        return this.each(function () {
                            var e = o.extend({}, t, n || {}),
                                i = (e.target && o(e.target)[0]) || this,
                                u = this,
                                c = o(u),
                                a = document.createElement('img'),
                                r = o(a),
                                m = 'mousemove.zoom',
                                l = !1,
                                s = !1
                            if (!e.url) {
                                var f = u.querySelector('img')
                                if (
                                    (f &&
                                        (e.url =
                                            f.getAttribute('data-src') ||
                                            f.currentSrc ||
                                            f.src),
                                    !e.url)
                                )
                                    return
                            }
                            c.one(
                                'zoom.destroy',
                                function (o2, t2) {
                                    c.off('.zoom'),
                                        (i.style.position = o2),
                                        (i.style.overflow = t2),
                                        (a.onload = null),
                                        r.remove()
                                }.bind(this, i.style.position, i.style.overflow)
                            ),
                                (a.onload = function () {
                                    function t2(t3) {
                                        f2.init(),
                                            f2.move(t3),
                                            r
                                                .stop()
                                                .fadeTo(
                                                    o.support.opacity
                                                        ? e.duration
                                                        : 0,
                                                    1,
                                                    o.isFunction(e.onZoomIn)
                                                        ? e.onZoomIn.call(a)
                                                        : !1
                                                )
                                    }
                                    function n2() {
                                        r.stop().fadeTo(
                                            e.duration,
                                            0,
                                            o.isFunction(e.onZoomOut)
                                                ? e.onZoomOut.call(a)
                                                : !1
                                        )
                                    }
                                    var f2 = o.zoom(i, u, a, e.magnify)
                                    e.on === 'grab'
                                        ? c.on('mousedown.zoom', function (e2) {
                                              e2.which === 1 &&
                                                  (o(document).one(
                                                      'mouseup.zoom',
                                                      function () {
                                                          n2(),
                                                              o(document).off(
                                                                  m,
                                                                  f2.move
                                                              )
                                                      }
                                                  ),
                                                  t2(e2),
                                                  o(document).on(m, f2.move),
                                                  e2.preventDefault())
                                          })
                                        : e.on === 'click'
                                        ? c.on('click.zoom', function (e2) {
                                              return l
                                                  ? void 0
                                                  : ((l = !0),
                                                    t2(e2),
                                                    o(document).on(m, f2.move),
                                                    o(document).one(
                                                        'click.zoom',
                                                        function () {
                                                            n2(),
                                                                (l = !1),
                                                                o(document).off(
                                                                    m,
                                                                    f2.move
                                                                )
                                                        }
                                                    ),
                                                    !1)
                                          })
                                        : e.on === 'toggle'
                                        ? c.on('click.zoom', function (o2) {
                                              l ? n2() : t2(o2), (l = !l)
                                          })
                                        : e.on === 'mouseover' &&
                                          (f2.init(),
                                          c
                                              .on('mouseenter.zoom', t2)
                                              .on('mouseleave.zoom', n2)
                                              .on(m, f2.move)),
                                        e.touch &&
                                            c
                                                .on(
                                                    'touchstart.zoom',
                                                    function (o2) {
                                                        o2.preventDefault(),
                                                            s
                                                                ? ((s = !1),
                                                                  n2())
                                                                : ((s = !0),
                                                                  t2(
                                                                      o2
                                                                          .originalEvent
                                                                          .touches[0] ||
                                                                          o2
                                                                              .originalEvent
                                                                              .changedTouches[0]
                                                                  ))
                                                    }
                                                )
                                                .on(
                                                    'touchmove.zoom',
                                                    function (o2) {
                                                        o2.preventDefault(),
                                                            f2.move(
                                                                o2.originalEvent
                                                                    .touches[0] ||
                                                                    o2
                                                                        .originalEvent
                                                                        .changedTouches[0]
                                                            )
                                                    }
                                                )
                                                .on(
                                                    'touchend.zoom',
                                                    function (o2) {
                                                        o2.preventDefault(),
                                                            s &&
                                                                ((s = !1), n2())
                                                    }
                                                ),
                                        o.isFunction(e.callback) &&
                                            e.callback.call(a)
                                }),
                                a.setAttribute('role', 'presentation'),
                                (a.alt = ''),
                                (a.src = e.url)
                        })
                    }),
                    (o.fn.zoom.defaults = t)
            })(window.jQuery)
        },
        cookie: function () {
            /*!
             * JavaScript Cookie v2.1.0
             * https://github.com/js-cookie/js-cookie
             *
             * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
             * Released under the MIT license
             */ ;(function (e) {
                if (typeof define == 'function' && define.amd) define(e)
                else if (typeof exports == 'object') module.exports = e()
                else {
                    var n = window.Cookies,
                        t = (window.Cookies = e())
                    t.noConflict = function () {
                        return (window.Cookies = n), t
                    }
                }
            })(function () {
                function e() {
                    for (var e2 = 0, n2 = {}; e2 < arguments.length; e2++) {
                        var t = arguments[e2]
                        for (var o in t) n2[o] = t[o]
                    }
                    return n2
                }
                function n(t) {
                    function o(n2, r, i) {
                        var c
                        if (arguments.length > 1) {
                            if (
                                ((i = e({ path: '/' }, o.defaults, i)),
                                typeof i.expires == 'number')
                            ) {
                                var s = new Date()
                                s.setMilliseconds(
                                    s.getMilliseconds() + 864e5 * i.expires
                                ),
                                    (i.expires = s)
                            }
                            try {
                                ;(c = JSON.stringify(r)),
                                    /^[\{\[]/.test(c) && (r = c)
                            } catch {}
                            return (
                                (r = t.write
                                    ? t.write(r, n2)
                                    : encodeURIComponent(String(r)).replace(
                                          /%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g,
                                          decodeURIComponent
                                      )),
                                (n2 = encodeURIComponent(String(n2))),
                                (n2 = n2.replace(
                                    /%(23|24|26|2B|5E|60|7C)/g,
                                    decodeURIComponent
                                )),
                                (n2 = n2.replace(/[\(\)]/g, escape)),
                                (document.cookie = [
                                    n2,
                                    '=',
                                    r,
                                    i.expires &&
                                        '; expires=' + i.expires.toUTCString(),
                                    i.path && '; path=' + i.path,
                                    i.domain && '; domain=' + i.domain,
                                    i.secure ? '; secure' : '',
                                ].join(''))
                            )
                        }
                        n2 || (c = {})
                        for (
                            var p = document.cookie
                                    ? document.cookie.split('; ')
                                    : [],
                                d = /(%[0-9A-Z]{2})+/g,
                                u = 0;
                            u < p.length;
                            u++
                        ) {
                            var f = p[u].split('='),
                                l = f[0].replace(d, decodeURIComponent),
                                m = f.slice(1).join('=')
                            m.charAt(0) === '"' && (m = m.slice(1, -1))
                            try {
                                if (
                                    ((m = t.read
                                        ? t.read(m, l)
                                        : t(m, l) ||
                                          m.replace(d, decodeURIComponent)),
                                    this.json)
                                )
                                    try {
                                        m = JSON.parse(m)
                                    } catch {}
                                if (n2 === l) {
                                    c = m
                                    break
                                }
                                n2 || (c[l] = m)
                            } catch {}
                        }
                        return c
                    }
                    return (
                        (o.get = o.set = o),
                        (o.getJSON = function () {
                            return o.apply(
                                { json: !0 },
                                [].slice.call(arguments)
                            )
                        }),
                        (o.defaults = {}),
                        (o.remove = function (n2, t2) {
                            o(n2, '', e(t2, { expires: -1 }))
                        }),
                        (o.withConverter = n),
                        o
                    )
                }
                return n(function () {})
            })
        },
    },
    apiStatus = null,
    Gmap = {
        selectors: { map: '[data-section-type="map"]' },
        init: function () {
            var instance = this,
                mapsToLoad = []
            $(this.selectors.map).each(function () {
                var container = this,
                    key = $(container).data('api-key')
                if (!(typeof key != 'string' || key === ''))
                    if (apiStatus === 'loaded') {
                        var $script = $('script[src*="' + key + '&"]')
                        $script.length === 0
                            ? $.getScript(
                                  'https://maps.googleapis.com/maps/api/js?key=' +
                                      key
                              ).then(function () {
                                  ;(apiStatus = 'loaded'),
                                      instance.createMap(container)
                              })
                            : instance.createMap(container)
                    } else
                        mapsToLoad.push(this),
                            apiStatus !== 'loading' &&
                                ((apiStatus = 'loading'),
                                typeof window.google > 'u' &&
                                    $.getScript(
                                        'https://maps.googleapis.com/maps/api/js?key=' +
                                            key
                                    ).then(function () {
                                        ;(apiStatus = 'loaded'), initAllMaps()
                                    }))
            })
            function initAllMaps() {
                $.each(mapsToLoad, function (index, container) {
                    instance.createMap(container)
                })
            }
        },
        geolocate: function ($map) {
            var deferred = $.Deferred(),
                geocoder = new google.maps.Geocoder(),
                defaultAddress = '37.4439064, -122.1639733',
                address =
                    $map.closest(this.selectors.map).data('address') ||
                    defaultAddress
            return (
                geocoder.geocode({ address }, function (results, status) {
                    status !== google.maps.GeocoderStatus.OK &&
                        deferred.reject(status),
                        deferred.resolve(results)
                }),
                deferred
            )
        },
        createMap: function (container) {
            var instance = this,
                style = $(container).data('style'),
                zoom = $(container).data('zoom'),
                id = $(container).data('section-id'),
                $map = $('.map--' + id),
                standard = [],
                silver = [
                    {
                        elementType: 'geometry',
                        stylers: [{ color: '#f5f5f5' }],
                    },
                    {
                        elementType: 'labels.icon',
                        stylers: [{ visibility: 'off' }],
                    },
                    {
                        elementType: 'labels.text.fill',
                        stylers: [{ color: '#616161' }],
                    },
                    {
                        elementType: 'labels.text.stroke',
                        stylers: [{ color: '#f5f5f5' }],
                    },
                    {
                        featureType: 'administrative.land_parcel',
                        elementType: 'labels.text.fill',
                        stylers: [{ color: '#bdbdbd' }],
                    },
                    {
                        featureType: 'poi',
                        elementType: 'geometry',
                        stylers: [{ color: '#eeeeee' }],
                    },
                    {
                        featureType: 'poi',
                        elementType: 'labels.text.fill',
                        stylers: [{ color: '#757575' }],
                    },
                    {
                        featureType: 'poi.park',
                        elementType: 'geometry',
                        stylers: [{ color: '#e5e5e5' }],
                    },
                    {
                        featureType: 'poi.park',
                        elementType: 'labels.text.fill',
                        stylers: [{ color: '#9e9e9e' }],
                    },
                    {
                        featureType: 'road',
                        elementType: 'geometry',
                        stylers: [{ color: '#ffffff' }],
                    },
                    {
                        featureType: 'road.arterial',
                        elementType: 'labels.text.fill',
                        stylers: [{ color: '#757575' }],
                    },
                    {
                        featureType: 'road.highway',
                        elementType: 'geometry',
                        stylers: [{ color: '#dadada' }],
                    },
                    {
                        featureType: 'road.highway',
                        elementType: 'labels.text.fill',
                        stylers: [{ color: '#616161' }],
                    },
                    {
                        featureType: 'road.local',
                        elementType: 'labels.text.fill',
                        stylers: [{ color: '#9e9e9e' }],
                    },
                    {
                        featureType: 'transit.line',
                        elementType: 'geometry',
                        stylers: [{ color: '#e5e5e5' }],
                    },
                    {
                        featureType: 'transit.station',
                        elementType: 'geometry',
                        stylers: [{ color: '#eeeeee' }],
                    },
                    {
                        featureType: 'water',
                        elementType: 'geometry',
                        stylers: [{ color: '#c9c9c9' }],
                    },
                    {
                        featureType: 'water',
                        elementType: 'labels.text.fill',
                        stylers: [{ color: '#9e9e9e' }],
                    },
                ],
                retro = [
                    {
                        elementType: 'geometry',
                        stylers: [{ color: '#ebe3cd' }],
                    },
                    {
                        elementType: 'labels.text.fill',
                        stylers: [{ color: '#523735' }],
                    },
                    {
                        elementType: 'labels.text.stroke',
                        stylers: [{ color: '#f5f1e6' }],
                    },
                    {
                        featureType: 'administrative',
                        elementType: 'geometry.stroke',
                        stylers: [{ color: '#c9b2a6' }],
                    },
                    {
                        featureType: 'administrative.land_parcel',
                        elementType: 'geometry.stroke',
                        stylers: [{ color: '#dcd2be' }],
                    },
                    {
                        featureType: 'administrative.land_parcel',
                        elementType: 'labels.text.fill',
                        stylers: [{ color: '#ae9e90' }],
                    },
                    {
                        featureType: 'landscape.natural',
                        elementType: 'geometry',
                        stylers: [{ color: '#dfd2ae' }],
                    },
                    {
                        featureType: 'poi',
                        elementType: 'geometry',
                        stylers: [{ color: '#dfd2ae' }],
                    },
                    {
                        featureType: 'poi',
                        elementType: 'labels.text.fill',
                        stylers: [{ color: '#93817c' }],
                    },
                    {
                        featureType: 'poi.park',
                        elementType: 'geometry.fill',
                        stylers: [{ color: '#a5b076' }],
                    },
                    {
                        featureType: 'poi.park',
                        elementType: 'labels.text.fill',
                        stylers: [{ color: '#447530' }],
                    },
                    {
                        featureType: 'road',
                        elementType: 'geometry',
                        stylers: [{ color: '#f5f1e6' }],
                    },
                    {
                        featureType: 'road.arterial',
                        elementType: 'geometry',
                        stylers: [{ color: '#fdfcf8' }],
                    },
                    {
                        featureType: 'road.highway',
                        elementType: 'geometry',
                        stylers: [{ color: '#f8c967' }],
                    },
                    {
                        featureType: 'road.highway',
                        elementType: 'geometry.stroke',
                        stylers: [{ color: '#e9bc62' }],
                    },
                    {
                        featureType: 'road.highway.controlled_access',
                        elementType: 'geometry',
                        stylers: [{ color: '#e98d58' }],
                    },
                    {
                        featureType: 'road.highway.controlled_access',
                        elementType: 'geometry.stroke',
                        stylers: [{ color: '#db8555' }],
                    },
                    {
                        featureType: 'road.local',
                        elementType: 'labels.text.fill',
                        stylers: [{ color: '#806b63' }],
                    },
                    {
                        featureType: 'transit.line',
                        elementType: 'geometry',
                        stylers: [{ color: '#dfd2ae' }],
                    },
                    {
                        featureType: 'transit.line',
                        elementType: 'labels.text.fill',
                        stylers: [{ color: '#8f7d77' }],
                    },
                    {
                        featureType: 'transit.line',
                        elementType: 'labels.text.stroke',
                        stylers: [{ color: '#ebe3cd' }],
                    },
                    {
                        featureType: 'transit.station',
                        elementType: 'geometry',
                        stylers: [{ color: '#dfd2ae' }],
                    },
                    {
                        featureType: 'water',
                        elementType: 'geometry.fill',
                        stylers: [{ color: '#b9d3c2' }],
                    },
                    {
                        featureType: 'water',
                        elementType: 'labels.text.fill',
                        stylers: [{ color: '#92998d' }],
                    },
                ],
                dark = [
                    {
                        elementType: 'geometry',
                        stylers: [{ color: '#212121' }],
                    },
                    {
                        elementType: 'labels.icon',
                        stylers: [{ visibility: 'off' }],
                    },
                    {
                        elementType: 'labels.text.fill',
                        stylers: [{ color: '#757575' }],
                    },
                    {
                        elementType: 'labels.text.stroke',
                        stylers: [{ color: '#212121' }],
                    },
                    {
                        featureType: 'administrative',
                        elementType: 'geometry',
                        stylers: [{ color: '#757575' }],
                    },
                    {
                        featureType: 'administrative.country',
                        elementType: 'labels.text.fill',
                        stylers: [{ color: '#9e9e9e' }],
                    },
                    {
                        featureType: 'administrative.land_parcel',
                        stylers: [{ visibility: 'off' }],
                    },
                    {
                        featureType: 'administrative.locality',
                        elementType: 'labels.text.fill',
                        stylers: [{ color: '#bdbdbd' }],
                    },
                    {
                        featureType: 'poi',
                        elementType: 'labels.text.fill',
                        stylers: [{ color: '#757575' }],
                    },
                    {
                        featureType: 'poi.park',
                        elementType: 'geometry',
                        stylers: [{ color: '#181818' }],
                    },
                    {
                        featureType: 'poi.park',
                        elementType: 'labels.text.fill',
                        stylers: [{ color: '#616161' }],
                    },
                    {
                        featureType: 'poi.park',
                        elementType: 'labels.text.stroke',
                        stylers: [{ color: '#1b1b1b' }],
                    },
                    {
                        featureType: 'road',
                        elementType: 'geometry.fill',
                        stylers: [{ color: '#2c2c2c' }],
                    },
                    {
                        featureType: 'road',
                        elementType: 'labels.text.fill',
                        stylers: [{ color: '#8a8a8a' }],
                    },
                    {
                        featureType: 'road.arterial',
                        elementType: 'geometry',
                        stylers: [{ color: '#373737' }],
                    },
                    {
                        featureType: 'road.highway',
                        elementType: 'geometry',
                        stylers: [{ color: '#3c3c3c' }],
                    },
                    {
                        featureType: 'road.highway.controlled_access',
                        elementType: 'geometry',
                        stylers: [{ color: '#4e4e4e' }],
                    },
                    {
                        featureType: 'road.local',
                        elementType: 'labels.text.fill',
                        stylers: [{ color: '#616161' }],
                    },
                    {
                        featureType: 'transit',
                        elementType: 'labels.text.fill',
                        stylers: [{ color: '#757575' }],
                    },
                    {
                        featureType: 'water',
                        elementType: 'geometry',
                        stylers: [{ color: '#000000' }],
                    },
                    {
                        featureType: 'water',
                        elementType: 'labels.text.fill',
                        stylers: [{ color: '#3d3d3d' }],
                    },
                ],
                night = [
                    {
                        elementType: 'geometry',
                        stylers: [{ color: '#242f3e' }],
                    },
                    {
                        elementType: 'labels.text.fill',
                        stylers: [{ color: '#746855' }],
                    },
                    {
                        elementType: 'labels.text.stroke',
                        stylers: [{ color: '#242f3e' }],
                    },
                    {
                        featureType: 'administrative.locality',
                        elementType: 'labels.text.fill',
                        stylers: [{ color: '#d59563' }],
                    },
                    {
                        featureType: 'poi',
                        elementType: 'labels.text.fill',
                        stylers: [{ color: '#d59563' }],
                    },
                    {
                        featureType: 'poi.park',
                        elementType: 'geometry',
                        stylers: [{ color: '#263c3f' }],
                    },
                    {
                        featureType: 'poi.park',
                        elementType: 'labels.text.fill',
                        stylers: [{ color: '#6b9a76' }],
                    },
                    {
                        featureType: 'road',
                        elementType: 'geometry',
                        stylers: [{ color: '#38414e' }],
                    },
                    {
                        featureType: 'road',
                        elementType: 'geometry.stroke',
                        stylers: [{ color: '#212a37' }],
                    },
                    {
                        featureType: 'road',
                        elementType: 'labels.text.fill',
                        stylers: [{ color: '#9ca5b3' }],
                    },
                    {
                        featureType: 'road.highway',
                        elementType: 'geometry',
                        stylers: [{ color: '#746855' }],
                    },
                    {
                        featureType: 'road.highway',
                        elementType: 'geometry.stroke',
                        stylers: [{ color: '#1f2835' }],
                    },
                    {
                        featureType: 'road.highway',
                        elementType: 'labels.text.fill',
                        stylers: [{ color: '#f3d19c' }],
                    },
                    {
                        featureType: 'transit',
                        elementType: 'geometry',
                        stylers: [{ color: '#2f3948' }],
                    },
                    {
                        featureType: 'transit.station',
                        elementType: 'labels.text.fill',
                        stylers: [{ color: '#d59563' }],
                    },
                    {
                        featureType: 'water',
                        elementType: 'geometry',
                        stylers: [{ color: '#17263c' }],
                    },
                    {
                        featureType: 'water',
                        elementType: 'labels.text.fill',
                        stylers: [{ color: '#515c6d' }],
                    },
                    {
                        featureType: 'water',
                        elementType: 'labels.text.stroke',
                        stylers: [{ color: '#17263c' }],
                    },
                ],
                aubergine = [
                    {
                        elementType: 'geometry',
                        stylers: [{ color: '#1d2c4d' }],
                    },
                    {
                        elementType: 'labels.text.fill',
                        stylers: [{ color: '#8ec3b9' }],
                    },
                    {
                        elementType: 'labels.text.stroke',
                        stylers: [{ color: '#1a3646' }],
                    },
                    {
                        featureType: 'administrative.country',
                        elementType: 'geometry.stroke',
                        stylers: [{ color: '#4b6878' }],
                    },
                    {
                        featureType: 'administrative.land_parcel',
                        elementType: 'labels.text.fill',
                        stylers: [{ color: '#64779e' }],
                    },
                    {
                        featureType: 'administrative.province',
                        elementType: 'geometry.stroke',
                        stylers: [{ color: '#4b6878' }],
                    },
                    {
                        featureType: 'landscape.man_made',
                        elementType: 'geometry.stroke',
                        stylers: [{ color: '#334e87' }],
                    },
                    {
                        featureType: 'landscape.natural',
                        elementType: 'geometry',
                        stylers: [{ color: '#023e58' }],
                    },
                    {
                        featureType: 'poi',
                        elementType: 'geometry',
                        stylers: [{ color: '#283d6a' }],
                    },
                    {
                        featureType: 'poi',
                        elementType: 'labels.text.fill',
                        stylers: [{ color: '#6f9ba5' }],
                    },
                    {
                        featureType: 'poi',
                        elementType: 'labels.text.stroke',
                        stylers: [{ color: '#1d2c4d' }],
                    },
                    {
                        featureType: 'poi.park',
                        elementType: 'geometry.fill',
                        stylers: [{ color: '#023e58' }],
                    },
                    {
                        featureType: 'poi.park',
                        elementType: 'labels.text.fill',
                        stylers: [{ color: '#3C7680' }],
                    },
                    {
                        featureType: 'road',
                        elementType: 'geometry',
                        stylers: [{ color: '#304a7d' }],
                    },
                    {
                        featureType: 'road',
                        elementType: 'labels.text.fill',
                        stylers: [{ color: '#98a5be' }],
                    },
                    {
                        featureType: 'road',
                        elementType: 'labels.text.stroke',
                        stylers: [{ color: '#1d2c4d' }],
                    },
                    {
                        featureType: 'road.highway',
                        elementType: 'geometry',
                        stylers: [{ color: '#2c6675' }],
                    },
                    {
                        featureType: 'road.highway',
                        elementType: 'geometry.stroke',
                        stylers: [{ color: '#255763' }],
                    },
                    {
                        featureType: 'road.highway',
                        elementType: 'labels.text.fill',
                        stylers: [{ color: '#b0d5ce' }],
                    },
                    {
                        featureType: 'road.highway',
                        elementType: 'labels.text.stroke',
                        stylers: [{ color: '#023e58' }],
                    },
                    {
                        featureType: 'transit',
                        elementType: 'labels.text.fill',
                        stylers: [{ color: '#98a5be' }],
                    },
                    {
                        featureType: 'transit',
                        elementType: 'labels.text.stroke',
                        stylers: [{ color: '#1d2c4d' }],
                    },
                    {
                        featureType: 'transit.line',
                        elementType: 'geometry.fill',
                        stylers: [{ color: '#283d6a' }],
                    },
                    {
                        featureType: 'transit.station',
                        elementType: 'geometry',
                        stylers: [{ color: '#3a4762' }],
                    },
                    {
                        featureType: 'water',
                        elementType: 'geometry',
                        stylers: [{ color: '#0e1626' }],
                    },
                    {
                        featureType: 'water',
                        elementType: 'labels.text.fill',
                        stylers: [{ color: '#4e6d70' }],
                    },
                ],
                styles = ''
            return (
                style == 'standard'
                    ? (styles = standard)
                    : style == 'silver'
                    ? (styles = silver)
                    : style == 'retro'
                    ? (styles = retro)
                    : style == 'dark'
                    ? (styles = dark)
                    : style == 'night'
                    ? (styles = night)
                    : (styles = aubergine),
                instance.geolocate($map).then(
                    function (results) {
                        var mapOptions = {
                                styles,
                                center: results[0].geometry.location,
                                clickableIcons: !1,
                                scrollwheel: !1,
                                zoomControl: !0,
                                disableDefaultUI: !0,
                                navigationControl: !1,
                                mapTypeControl: !1,
                                scaleControl: !1,
                                draggable: !1,
                                zoom,
                            },
                            map = new google.maps.Map($map[0], mapOptions),
                            center = map.getCenter(),
                            marker = new google.maps.Marker({
                                map,
                                position: center,
                            })
                        google.maps.event.addDomListener(
                            window,
                            'resize',
                            function () {
                                google.maps.event.trigger(map, 'resize'),
                                    map.setCenter(center)
                            }
                        )
                    }.bind(this)
                )
            )
        },
    },
    Popup = {
        init: function () {
            var self2 = this,
                $popup = (this.$popup = $('#popup')),
                $popupClose = $popup.find('.popup__close'),
                popupEnabled = $popup.data('enabled'),
                popupTimeout = (this.popupTimeout = 0)
            if (popupEnabled) {
                var testMode = $popup.data('testmode'),
                    modalDelay = parseInt($popup.data('delay')) * 1e3,
                    reappearTime = parseInt($popup.data('reappear_time')) * 1e3
                enquire.register('screen and (min-width:768px)', function () {
                    Reqs.cookie(),
                        testMode
                            ? self2.show($popup, modalDelay, testMode)
                            : (Cookies.get('newsletter_delay') === void 0 ||
                                  reappearTime == 0) &&
                              (self2.show($popup, modalDelay, testMode),
                              self2.createCookie(reappearTime))
                }),
                    $(window).on(
                        'resize',
                        Reqs.debounce(function () {
                            var windowWidth =
                                    window.innerWidth ||
                                    document.documentElement.clientWidth,
                                hasPopup = $popup.hasClass('popup--visible')
                            windowWidth < 768 && hasPopup && self2.hide()
                        }, 100)
                    ),
                    $popupClose.on('click', function () {
                        $popup.removeClass('popup--visible')
                    })
            }
        },
        show: function ($popup, modalDelay, testMode) {
            if (sessionStorage.name != 'shown') {
                if (
                    ((this.popupTimeout = setTimeout(function () {
                        $popup.addClass('popup--visible'),
                            $popup.find('.popup__close').focus()
                    }, modalDelay)),
                    typeof localStorage == 'object')
                )
                    try {
                        localStorage.setItem('localStorage', 1),
                            localStorage.removeItem('localStorage'),
                            (sessionStorage.name = 'shown')
                    } catch {
                        ;(Storage.prototype._setItem =
                            Storage.prototype.setItem),
                            (Storage.prototype.setItem = function () {})
                    }
            } else
                testMode &&
                    (this.popupTimeout = setTimeout(function () {
                        $popup.addClass('popup--visible'),
                            $popup.find('.popup__close').focus()
                    }, modalDelay))
        },
        hide: function () {
            clearTimeout(this.popupTimeout),
                this.$popup.removeClass('popup--visible')
        },
        createCookie: function (reappearTime) {
            reappearTime != 0 &&
                Cookies.set('newsletter_delay', 'value', {
                    expires: reappearTime,
                })
        },
    },
    Popup = {
        init: function () {
            var self2 = this,
                $popup = (this.$popup = $('#popup')),
                $popupClose = $popup.find('.popup__close'),
                popupEnabled = $popup.data('enabled'),
                popupTimeout = (this.popupTimeout = 0)
            if (popupEnabled) {
                var testMode = $popup.data('testmode'),
                    modalDelay = parseInt($popup.data('delay')) * 1e3,
                    reappearTime = parseInt($popup.data('reappear_time')) * 1e3
                enquire.register('screen and (min-width:768px)', function () {
                    Reqs.cookie(),
                        testMode
                            ? self2.show($popup, modalDelay, testMode)
                            : (Cookies.get('newsletter_delay') === void 0 ||
                                  reappearTime == 0) &&
                              (self2.show($popup, modalDelay, testMode),
                              self2.createCookie(reappearTime))
                }),
                    $(window).on(
                        'resize',
                        Reqs.debounce(function () {
                            var windowWidth =
                                    window.innerWidth ||
                                    document.documentElement.clientWidth,
                                hasPopup = $popup.hasClass('popup--visible')
                            windowWidth < 768 && hasPopup && self2.hide()
                        }, 100)
                    ),
                    $popupClose.on('click', function () {
                        $popup.removeClass('popup--visible')
                    })
            }
        },
        show: function ($popup, modalDelay, testMode) {
            if (sessionStorage.name != 'shown') {
                if (
                    ((this.popupTimeout = setTimeout(function () {
                        $popup.addClass('popup--visible'),
                            $popup.find('.popup__close').focus()
                    }, modalDelay)),
                    typeof localStorage == 'object')
                )
                    try {
                        localStorage.setItem('localStorage', 1),
                            localStorage.removeItem('localStorage'),
                            (sessionStorage.name = 'shown')
                    } catch {
                        ;(Storage.prototype._setItem =
                            Storage.prototype.setItem),
                            (Storage.prototype.setItem = function () {})
                    }
            } else
                testMode &&
                    (this.popupTimeout = setTimeout(function () {
                        $popup.addClass('popup--visible'),
                            $popup.find('.popup__close').focus()
                    }, modalDelay))
        },
        hide: function () {
            clearTimeout(this.popupTimeout),
                this.$popup.removeClass('popup--visible')
        },
        createCookie: function (reappearTime) {
            reappearTime != 0 &&
                Cookies.set('newsletter_delay', 'value', {
                    expires: reappearTime,
                })
        },
    },
    SearchTemplate = {
        init: function () {
            var $image = $('.product-block__image')
            theme.settings.imageBackgroundSize == 'contain' &&
                (Collection.setBadgePosition($image),
                $(window).on(
                    'resize.search',
                    Reqs.debounce(
                        Collection.setBadgePosition.bind(this, $image),
                        50
                    )
                ))
        },
    },
    Search = {
        init: function () {
            var self2 = this,
                enableSearch = theme.settings.enableSearch
            enableSearch &&
                ((this.searchForm = $('.nav-search .search-form')),
                (this.searchContainer = $('.nav-search-container')),
                (this.searchScroller = $('.nav-search-scroller')),
                (this.searchResultsContainer = $('#search-results')),
                (this.searchType = theme.settings.searchType),
                (this.searchOptionsPrefix = this.searchForm
                    .find('input[name="options[prefix]"]')
                    .val()),
                (this.searchRequest = null),
                this.searchForm.on('keyup', '.nav-search-input', function (e) {
                    e.keyCode === slate.utils.keyboardKeys.ESCAPE &&
                        (self2.close(), Site.nav.search.close()),
                        e.keyCode === slate.utils.keyboardKeys.ENTER &&
                            e.preventDefault()
                    var query = $(this).val()
                    query.length ? self2.request(query) : self2.close()
                }))
        },
        close: function () {
            this.searchResultsContainer.empty(),
                this.searchContainer.removeClass('is-searching')
        },
        request: function (query) {
            var self2 = this
            this.searchRequest != null && this.searchRequest.abort(),
                this.searchResultsContainer.empty(),
                this.searchContainer.addClass('is-searching'),
                (this.searchRequest = $.ajax({
                    method: 'GET',
                    url: theme.routes.search_url + '?view=json',
                    dataType: 'json',
                    data: {
                        q: query,
                        type: self2.searchType,
                        options: { prefix: self2.searchOptionsPrefix },
                    },
                })
                    .done(function (data) {
                        self2.displaySearchResults(data)
                    })
                    .fail(function (data, jqXHR, textStatus, errorThrown) {
                        self2.displaySearchResults(data)
                    }))
        },
        displaySearchResults: function (data) {
            var searchResultsContent = this.getResultsContent(data)
            this.searchResultsContainer.html(searchResultsContent),
                this.searchContainer.removeClass('is-searching')
            var $image = $('.result__image', this.searchResultsContainer)
            theme.settings.imageBackgroundSize == 'contain' &&
                (Collection.setBadgePosition($image),
                $(window).on(
                    'resize.search',
                    Reqs.debounce(
                        Collection.setBadgePosition.bind(this, $image),
                        50
                    )
                ))
        },
        getResultsContent: function (data) {
            var searchResults = '',
                searchResultsProducts = '',
                searchResultsPages = '',
                searchResultsArticles = '',
                limitProducts = 4,
                limitPages = 10,
                limitArticles = 10,
                countProducts = 0,
                countPages = 0,
                countArticles = 0,
                viewAllProducts = '',
                searchQuery = $('.nav-search-input').val(),
                searchOptionsPrefix = $('.nav-search-options').val(),
                searchType = theme.settings.searchType
            if (data.results)
                for (var i = 0; i < data.results.length; i++) {
                    var title = data.results[i].title,
                        url = data.results[i].url,
                        price = slate.Currency.formatMoney(
                            data.results[i].price,
                            window.moneyFormat
                        ),
                        image = data.results[i].featured_image,
                        imageWidths =
                            '295,394,590,700,800,1000,1200,1500,1800,2000,2400',
                        imageAspectRatio =
                            data.results[i].image_aspectratio || 1,
                        imageBlank = theme.icons.blank,
                        object_type = data.results[i].object_type,
                        sold_out = !data.results[i].available,
                        on_sale = data.results[i].on_sale,
                        badge = '',
                        badgeText = '',
                        badgeClass =
                            ' product-status-flag--' +
                            theme.settings.productBadgeStyle,
                        badgeStyle = theme.settings.productBadgeStyle,
                        itemClass = 'result__item'
                    theme.settings.productTitlePosition == 'center' &&
                        (itemClass += ' result__item--center'),
                        object_type == 'product'
                            ? ((on_sale || sold_out) &&
                                  ((badgeClass += on_sale ? ' is-sale' : ''),
                                  (badgeClass += sold_out
                                      ? ' is-sold-out'
                                      : ''),
                                  (badge =
                                      '<span class="product-status-flag' +
                                      badgeClass +
                                      '">'),
                                  sold_out
                                      ? (badgeText =
                                            theme.translations.sold_out)
                                      : on_sale
                                      ? (badgeText = theme.translations.on_sale)
                                      : on_sale &&
                                        sold_out &&
                                        (badgeText =
                                            theme.translations.sold_out),
                                  badgeStyle == 'circle' &&
                                      (badgeText = badgeText.replace(
                                          ' ',
                                          '<br>'
                                      )),
                                  (badge += badgeText),
                                  (badge += '</span>')),
                              countProducts < limitProducts &&
                                  (searchResultsProducts +=
                                      '<li class="' +
                                      itemClass +
                                      '"><div class="result__image" data-aspectratio="' +
                                      imageAspectRatio +
                                      '"><a href="' +
                                      url +
                                      '"><img class="lazyload" alt="' +
                                      title +
                                      '"src="' +
                                      imageBlank +
                                      '"data-src="' +
                                      image.replace('_1x1.', '_{width}x.') +
                                      '"data-widths="[' +
                                      imageWidths +
                                      ']"data-aspectratio="' +
                                      imageAspectRatio +
                                      '"data-sizes="auto" />' +
                                      badge +
                                      '</a></div><h3 class="result__title"><a href="' +
                                      url +
                                      '">' +
                                      title +
                                      '</a></h3><p class="result__price">' +
                                      price +
                                      '</p></li>'),
                              countProducts++)
                            : object_type == 'page'
                            ? (countPages < limitPages &&
                                  (searchResultsPages +=
                                      '<li class="result__item"><h3 class="result__title"><a href="' +
                                      url +
                                      '">' +
                                      title +
                                      '</a></h3></li>'),
                              countPages++)
                            : object_type == 'article' &&
                              (countArticles < limitArticles &&
                                  (searchResultsArticles +=
                                      '<li class="result__item"><h3 class="result__title"><a href="' +
                                      url +
                                      '">' +
                                      title +
                                      '</a></h3></li>'),
                              countArticles++)
                }
            return (
                (searchResultsProducts = countProducts
                    ? searchResultsProducts
                    : '<li class="result__item"><p class="result__title">' +
                      theme.translations.no_results +
                      '</p></li>'),
                (searchResultsPages = countPages
                    ? searchResultsPages
                    : '<li class="result__item"><p class="result__title">' +
                      theme.translations.no_results +
                      '</p></li>'),
                (searchResultsArticles = countArticles
                    ? searchResultsArticles
                    : '<li class="result__item"><p class="result__title">' +
                      theme.translations.no_results +
                      '</p></li>'),
                (viewAllProducts = countProducts
                    ? '<a href="/collections/all/?type=product&q=' +
                      searchQuery +
                      '&options[prefix]=' +
                      searchOptionsPrefix +
                      '" class="view-all" title="' +
                      theme.translations.view_all +
                      '">' +
                      theme.icons.arrowLong +
                      '</a>'
                    : ''),
                (searchResults +=
                    '<div class="results__column results__column--products"><div class="results__heading"><span>' +
                    theme.translations.results_products +
                    ' (' +
                    countProducts +
                    ')</span>' +
                    viewAllProducts +
                    '</div><ul class="results__list">' +
                    searchResultsProducts +
                    '</ul></div>'),
                searchType.indexOf('page') > -1 &&
                    (searchResults +=
                        '<div class="results__column results__column--pages"><div class="results__heading"><span>' +
                        theme.translations.results_pages +
                        ' (' +
                        countPages +
                        ')</span></div><ul class="results__list">' +
                        searchResultsPages +
                        '</ul></div>'),
                searchType.indexOf('article') > -1 &&
                    (searchResults +=
                        '<div class="results__column results__column--articles"><div class="results__heading"><span>' +
                        theme.translations.results_articles +
                        ' (' +
                        countArticles +
                        ')</span></div><ul class="results__list">' +
                        searchResultsArticles +
                        '</ul></div>'),
                searchResults
            )
        },
    },
    Password = {
        init: function () {
            var $targets = $('.password-signup, .password-login')
            $targets.each(function () {
                var $el = $(this)
                $el.find('div.errors').length &&
                    $el.find('input.password, input.email').select()
            })
        },
    },
    Login = {
        init: function () {
            this.bind(),
                window.location.hash == '#recover'
                    ? this.recover.show()
                    : this.recover.hide()
        },
        bind: function () {
            $('.js-recoverToggle').on('click', Login.recover.show),
                $('.js-recoverCancel').on('click', Login.recover.hide)
        },
        recover: {
            show: function (e) {
                return (
                    $('.js-loginForm').hide(),
                    $('.js-recoverForm').show(),
                    (window.location.hash = '#recover'),
                    !1
                )
            },
            hide: function (e) {
                return (
                    $('.js-loginForm').show(),
                    $('.js-recoverForm').hide(),
                    (window.location.hash = ''),
                    !1
                )
            },
        },
    },
    Addresses = {
        init: function () {
            Shopify.CountryProvinceSelector &&
                new Shopify.CountryProvinceSelector(
                    'AddressCountryNew',
                    'AddressProvinceNew',
                    { hideElement: 'AddressProvinceContainerNew' }
                ),
                $('.address-country-option').each(function () {
                    var formId = $(this).data('form-id'),
                        countrySelector = 'AddressCountry_' + formId,
                        provinceSelector = 'AddressProvince_' + formId,
                        containerSelector = 'AddressProvinceContainer_' + formId
                    new Shopify.CountryProvinceSelector(
                        countrySelector,
                        provinceSelector,
                        { hideElement: containerSelector }
                    )
                }),
                (Shopify.CustomerAddress = {
                    toggleForm: function (id) {
                        var editEl = document.getElementById(
                            'EditAddress_' + id
                        )
                        return (
                            (editEl.style.display =
                                editEl.style.display == 'none' ? '' : 'none'),
                            !1
                        )
                    },
                    toggleNewForm: function () {
                        var el = document.getElementById('AddAddress'),
                            toggle = document.getElementById('js-addAddress')
                        return (
                            (el.style.display =
                                el.style.display == 'none' ? '' : 'none'),
                            (toggle.style.display =
                                toggle.style.display == 'inline-block'
                                    ? 'none'
                                    : 'inline-block'),
                            !1
                        )
                    },
                    destroy: function (id, confirm_msg) {
                        confirm(
                            confirm_msg ||
                                'Are you sure you wish to delete this address?'
                        ) &&
                            Shopify.postLink('/account/addresses/' + id, {
                                parameters: { _method: 'delete' },
                            })
                    },
                })
        },
    }
;(slate.utils = {
    getParameterByName: function (name, url) {
        url || (url = window.location.href),
            (name = name.replace(/[[\]]/g, '\\$&'))
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url)
        return results
            ? results[2]
                ? decodeURIComponent(results[2].replace(/\+/g, ' '))
                : ''
            : null
    },
    findInstance: function (array, key, value) {
        for (var i = 0; i < array.length; i++)
            if (array[i][key] === value) return array[i]
    },
    removeInstance: function (array, key, value) {
        for (var i = array.length; i--; )
            if (array[i][key] === value) {
                array.splice(i, 1)
                break
            }
        return array
    },
    compact: function (array) {
        for (
            var index = -1,
                length = array == null ? 0 : array.length,
                resIndex = 0,
                result = [];
            ++index < length;

        ) {
            var value = array[index]
            value && (result[resIndex++] = value)
        }
        return result
    },
    defaultTo: function (value, defaultValue) {
        return value == null || value !== value ? defaultValue : value
    },
    keyboardKeys: {
        TAB: 9,
        ENTER: 13,
        ESCAPE: 27,
        LEFTARROW: 37,
        RIGHTARROW: 39,
    },
}),
    (slate.a11y = {
        pageLinkFocus: function ($element) {
            var focusClass = 'js-focus-hidden'
            $element
                .first()
                .attr('tabIndex', '-1')
                .focus()
                .addClass(focusClass)
                .one('blur', callback)
            function callback() {
                $element.first().removeClass(focusClass).removeAttr('tabindex')
            }
        },
        focusHash: function () {
            var hash = window.location.hash
            hash &&
                document.getElementById(hash.slice(1)) &&
                this.pageLinkFocus($(hash))
        },
        bindInPageLinks: function () {
            $('a[href*=#]').on(
                'click',
                function (evt) {
                    this.pageLinkFocus($(evt.currentTarget.hash))
                }.bind(this)
            )
        },
        trapFocus: function (options) {
            var eventsName = {
                    focusin: options.namespace
                        ? 'focusin.' + options.namespace
                        : 'focusin',
                    focusout: options.namespace
                        ? 'focusout.' + options.namespace
                        : 'focusout',
                    keydown: options.namespace
                        ? 'keydown.' + options.namespace
                        : 'keydown.handleFocus',
                },
                $focusableElements = options.$container.find(
                    $(
                        'button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])'
                    ).filter(':visible')
                ),
                firstFocusable = $focusableElements[0],
                lastFocusable =
                    $focusableElements[$focusableElements.length - 1]
            options.$elementToFocus ||
                (options.$elementToFocus = options.$container)
            function _manageFocus(evt) {
                evt.keyCode === slate.utils.keyboardKeys.TAB &&
                    (evt.target === lastFocusable &&
                        !evt.shiftKey &&
                        (evt.preventDefault(), firstFocusable.focus()),
                    evt.target === firstFocusable &&
                        evt.shiftKey &&
                        (evt.preventDefault(), lastFocusable.focus()))
            }
            options.$container.attr('tabindex', '-1'),
                options.$elementToFocus.focus(),
                $(document).off('focusin'),
                $(document).on(eventsName.focusout, function () {
                    $(document).off(eventsName.keydown)
                }),
                $(document).on(eventsName.focusin, function (evt) {
                    ;(evt.target !== lastFocusable &&
                        evt.target !== firstFocusable) ||
                        $(document).on(eventsName.keydown, function (evt2) {
                            _manageFocus(evt2)
                        })
                })
        },
        removeTrapFocus: function (options) {
            var eventName = options.namespace
                ? 'focusin.' + options.namespace
                : 'focusin'
            options.$container &&
                options.$container.length &&
                options.$container.removeAttr('tabindex'),
                $(document).off(eventName)
        },
        accessibleLinks: function (options) {
            var body = document.querySelector('body'),
                idSelectors = {
                    newWindow: 'a11y-new-window-message',
                    external: 'a11y-external-message',
                    newWindowExternal: 'a11y-new-window-external-message',
                }
            ;(options.$links === void 0 || !options.$links.jquery) &&
                (options.$links = $('a[href]:not([aria-describedby])'))
            function generateHTML(customMessages) {
                typeof customMessages != 'object' && (customMessages = {})
                var messages = $.extend(
                        {
                            newWindow: 'Opens in a new window.',
                            external: 'Opens external website.',
                            newWindowExternal:
                                'Opens external website in a new window.',
                        },
                        customMessages
                    ),
                    container = document.createElement('ul'),
                    htmlMessages = ''
                for (var message in messages)
                    htmlMessages +=
                        '<li id=' +
                        idSelectors[message] +
                        '>' +
                        messages[message] +
                        '</li>'
                container.setAttribute('hidden', !0),
                    (container.innerHTML = htmlMessages),
                    body.appendChild(container)
            }
            function _externalSite($link) {
                var hostname = window.location.hostname
                return $link[0].hostname !== hostname
            }
            $.each(options.$links, function () {
                var $link = $(this),
                    target = $link.attr('target'),
                    rel = $link.attr('rel'),
                    isExternal = _externalSite($link),
                    isTargetBlank = target === '_blank'
                isExternal &&
                    $link.attr('aria-describedby', idSelectors.external),
                    isTargetBlank &&
                        ((rel === void 0 || rel.indexOf('noopener') === -1) &&
                            $link.attr('rel', function (i, val) {
                                var relValue = val === void 0 ? '' : val + ' '
                                return relValue + 'noopener'
                            }),
                        $link.attr('aria-describedby', idSelectors.newWindow)),
                    isExternal &&
                        isTargetBlank &&
                        $link.attr(
                            'aria-describedby',
                            idSelectors.newWindowExternal
                        )
            }),
                generateHTML(options.messages)
        },
    }),
    (slate.Variants = (function () {
        function Variants(options) {
            ;(this.$container = options.$container),
                (this.product = options.product),
                (this.singleOptionSelector = options.singleOptionSelector),
                (this.originalSelectorId = options.originalSelectorId),
                (this.enableHistoryState = options.enableHistoryState),
                (this.currentVariant = this._getVariantFromOptions()),
                $(this.singleOptionSelector, this.$container).on(
                    'change',
                    this._onSelectChange.bind(this)
                )
        }
        return (
            (Variants.prototype = $.extend({}, Variants.prototype, {
                _getCurrentOptions: function () {
                    var currentOptions = $.map(
                        $(this.singleOptionSelector, this.$container),
                        function (element) {
                            var $element = $(element),
                                type = $element.attr('type'),
                                currentOption = {}
                            return type === 'radio' || type === 'checkbox'
                                ? $element[0].checked
                                    ? ((currentOption.value = $element.val()),
                                      (currentOption.index =
                                          $element.data('index')),
                                      currentOption)
                                    : !1
                                : ((currentOption.value = $element.val()),
                                  (currentOption.index =
                                      $element.data('index')),
                                  currentOption)
                        }
                    )
                    return (
                        (currentOptions = slate.utils.compact(currentOptions)),
                        currentOptions
                    )
                },
                _getVariantFromOptions: function () {
                    var selectedValues = this._getCurrentOptions(),
                        variants2 = this.product.variants,
                        found = !1
                    return (
                        variants2.forEach(function (variant) {
                            var satisfied = !0
                            selectedValues.forEach(function (option) {
                                satisfied &&
                                    (satisfied =
                                        option.value === variant[option.index])
                            }),
                                satisfied && (found = variant)
                        }),
                        found || null
                    )
                },
                _onSelectChange: function () {
                    var variant = this._getVariantFromOptions()
                    this.$container.trigger({ type: 'variantChange', variant }),
                        variant &&
                            (this._updateMasterSelect(variant),
                            this._updateImages(variant),
                            this._updatePrice(variant),
                            this._updateUnits(variant),
                            (this.currentVariant = variant),
                            this.enableHistoryState &&
                                this._updateHistoryState(variant))
                },
                _updateImages: function (variant) {
                    var variantImage = variant.featured_image || {},
                        currentVariantImage =
                            this.currentVariant.featured_image || {}
                    !variant.featured_image ||
                        variantImage.src === currentVariantImage.src ||
                        this.$container.trigger({
                            type: 'variantImageChange',
                            variant,
                        })
                },
                _updatePrice: function (variant) {
                    ;(variant.price === this.currentVariant.price &&
                        variant.compare_at_price ===
                            this.currentVariant.compare_at_price) ||
                        this.$container.trigger({
                            type: 'variantPriceChange',
                            variant,
                        })
                },
                _updateUnits: function (variant) {
                    this.$container.trigger({
                        type: 'variantUnitChange',
                        variant,
                    })
                },
                _updateHistoryState: function (variant) {
                    if (!(!history.replaceState || !variant)) {
                        var newurl =
                            window.location.protocol +
                            '//' +
                            window.location.host +
                            window.location.pathname +
                            '?variant=' +
                            variant.id
                        window.history.replaceState(
                            { path: newurl },
                            '',
                            newurl
                        )
                    }
                },
                _updateMasterSelect: function (variant) {
                    $(this.originalSelectorId, this.$container)[0].value =
                        variant.id
                },
            })),
            Variants
        )
    })()),
    (slate.Currency = (function () {
        var moneyFormat = '${{amount}}'
        function formatMoney(cents, format) {
            typeof cents == 'string' && (cents = cents.replace('.', ''))
            var value = '',
                placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
                formatString = format || moneyFormat
            function formatWithDelimiters(
                number,
                precision,
                thousands,
                decimal
            ) {
                if (
                    ((thousands = thousands || ','),
                    (decimal = decimal || '.'),
                    isNaN(number) || number === null)
                )
                    return 0
                number = (number / 100).toFixed(precision)
                var parts = number.split('.'),
                    dollarsAmount = parts[0].replace(
                        /(\d)(?=(\d\d\d)+(?!\d))/g,
                        '$1' + thousands
                    ),
                    centsAmount = parts[1] ? decimal + parts[1] : ''
                return dollarsAmount + centsAmount
            }
            switch (formatString.match(placeholderRegex)[1]) {
                case 'amount':
                    value = formatWithDelimiters(cents, 2)
                    break
                case 'amount_no_decimals':
                    value = formatWithDelimiters(cents, 0)
                    break
                case 'amount_with_comma_separator':
                    value = formatWithDelimiters(cents, 2, '.', ',')
                    break
                case 'amount_no_decimals_with_comma_separator':
                    value = formatWithDelimiters(cents, 0, '.', ',')
                    break
                case 'amount_no_decimals_with_space_separator':
                    value = formatWithDelimiters(cents, 0, ' ')
                    break
                case 'amount_with_apostrophe_separator':
                    value = formatWithDelimiters(cents, 2, "'")
                    break
            }
            return formatString.replace(placeholderRegex, value)
        }
        return { formatMoney }
    })())
var Disclosure = (function () {
    var selectors = {
            disclosureList: '[data-disclosure-list]',
            disclosureToggle: '[data-disclosure-toggle]',
            disclosureInput: '[data-disclosure-input]',
            disclosureOptions: '[data-disclosure-option]',
        },
        classes = { listVisible: 'disclosure-list--visible' }
    function Disclosure2($disclosure) {
        ;(this.$container = $disclosure),
            (this.cache = {}),
            this._cacheSelectors(),
            this._connectOptions(),
            this._connectToggle(),
            this._onFocusOut()
    }
    return (
        (Disclosure2.prototype = $.extend({}, Disclosure2.prototype, {
            _cacheSelectors: function () {
                this.cache = {
                    $disclosureList: this.$container.find(
                        selectors.disclosureList
                    ),
                    $disclosureToggle: this.$container.find(
                        selectors.disclosureToggle
                    ),
                    $disclosureInput: this.$container.find(
                        selectors.disclosureInput
                    ),
                    $disclosureOptions: this.$container.find(
                        selectors.disclosureOptions
                    ),
                }
            },
            _connectToggle: function () {
                this.cache.$disclosureToggle.on(
                    'click',
                    function (evt) {
                        var ariaExpanded =
                            $(evt.currentTarget).attr('aria-expanded') ===
                            'true'
                        $(evt.currentTarget).attr(
                            'aria-expanded',
                            !ariaExpanded
                        ),
                            this.cache.$disclosureList.toggleClass(
                                classes.listVisible
                            ),
                            evt.preventDefault()
                    }.bind(this)
                )
            },
            _connectOptions: function () {
                this.cache.$disclosureOptions.on(
                    'click',
                    function (evt) {
                        this._submitForm($(evt.currentTarget).data('value')),
                            evt.preventDefault()
                    }.bind(this)
                )
            },
            _onFocusOut: function () {
                this.cache.$disclosureToggle.on(
                    'focusout',
                    function (evt) {
                        var disclosureLostFocus =
                            this.$container.has(evt.relatedTarget).length === 0
                        disclosureLostFocus && this._hideList()
                    }.bind(this)
                ),
                    this.cache.$disclosureList.on(
                        'focusout',
                        function (evt) {
                            var childInFocus =
                                    $(evt.currentTarget).has(evt.relatedTarget)
                                        .length > 0,
                                isVisible = this.cache.$disclosureList.hasClass(
                                    classes.listVisible
                                )
                            isVisible && !childInFocus && this._hideList()
                        }.bind(this)
                    ),
                    this.$container.on(
                        'keyup',
                        function (evt) {
                            evt.which === slate.utils.keyboardKeys.ESCAPE &&
                                (this._hideList(),
                                this.cache.$disclosureToggle.focus())
                        }.bind(this)
                    ),
                    (this.bodyOnClick = function (evt) {
                        var isOption =
                                this.$container.has(evt.target).length > 0,
                            isVisible = this.cache.$disclosureList.hasClass(
                                classes.listVisible
                            )
                        isVisible && !isOption && this._hideList()
                    }.bind(this)),
                    $('body').on('click', this.bodyOnClick)
            },
            _submitForm: function (value) {
                this.cache.$disclosureInput.val(value),
                    this.$container.parents('form').submit()
            },
            _hideList: function () {
                this.cache.$disclosureList.removeClass(classes.listVisible),
                    this.cache.$disclosureToggle.attr('aria-expanded', !1)
            },
            unload: function () {
                $('body').off('click', this.bodyOnClick),
                    this.cache.$disclosureOptions.off(),
                    this.cache.$disclosureToggle.off(),
                    this.cache.$disclosureList.off(),
                    this.$container.off()
            },
        })),
        Disclosure2
    )
})()
;(theme.StoreAvailability = (function () {
    var selectors = {
            body: 'body',
            storeAvailabilityModal: '[data-store-availability-modal]',
            storeAvailabilityModalOpen: '[data-store-availability-modal-open]',
            storeAvailabilityModalProductTitle:
                '[data-store-availability-modal-product-title]',
        },
        classes = { hidden: 'visually-hidden' }
    function StoreAvailability(container) {
        this.container = container
    }
    return (
        (StoreAvailability.prototype = Object.assign(
            {},
            StoreAvailability.prototype,
            {
                updateContent: function (variantId, productTitle) {
                    this._fetchStoreAvailabilities(variantId, productTitle)
                },
                clearContent: function () {
                    this.container.innerHTML = ''
                },
                _initModal: function () {
                    return new theme.Modals(
                        'StoreAvailabilityModal',
                        'store-availability-modal',
                        {
                            close: '.js-modal-close-store-availability-modal',
                            closeModalOnClick: !0,
                            openClass: 'store-availabilities-modal--active',
                            scrollIntoView: !0,
                        }
                    )
                },
                _fetchStoreAvailabilities: function (variantId, productTitle) {
                    var variantSectionUrl =
                        '/variants/' +
                        variantId +
                        '/?section_id=store-availability'
                    this.clearContent()
                    var self2 = this
                    fetch(variantSectionUrl)
                        .then(function (response) {
                            return response.text()
                        })
                        .then(function (storeAvailabilityHTML) {
                            if (storeAvailabilityHTML.trim() !== '') {
                                var body = document.querySelector(
                                        selectors.body
                                    ),
                                    storeAvailabilityModal = body.querySelector(
                                        selectors.storeAvailabilityModal
                                    )
                                storeAvailabilityModal &&
                                    storeAvailabilityModal.remove(),
                                    (self2.container.innerHTML =
                                        storeAvailabilityHTML),
                                    (self2.container.innerHTML =
                                        self2.container.firstElementChild.innerHTML)
                                var storeAvailabilityModalOpen =
                                    self2.container.querySelector(
                                        selectors.storeAvailabilityModalOpen
                                    )
                                if (storeAvailabilityModalOpen) {
                                    ;(self2.modal = self2._initModal()),
                                        self2._updateProductTitle(productTitle)
                                    var storeAvailabilityModal =
                                        self2.container.querySelector(
                                            selectors.storeAvailabilityModal
                                        )
                                    storeAvailabilityModal &&
                                        body.appendChild(storeAvailabilityModal)
                                }
                            }
                        })
                },
                _updateProductTitle: function (productTitle) {
                    var storeAvailabilityModalProductTitle =
                        this.container.querySelector(
                            selectors.storeAvailabilityModalProductTitle
                        )
                    storeAvailabilityModalProductTitle.textContent =
                        productTitle
                },
            }
        )),
        StoreAvailability
    )
})()),
    (theme.Modals = (function () {
        function Modal(id, name, options) {
            var defaults = {
                close: '.js-modal-close',
                open: '.js-modal-open-' + name,
                openClass: 'modal--is-active',
                openBodyClass: 'modal--is-visible',
                closeModalOnClick: !1,
                scrollIntoView: !1,
            }
            if (((this.modal = document.getElementById(id)), !this.modal))
                return !1
            ;(this.nodes = {
                parents: [document.querySelector('html'), document.body],
            }),
                (this.config = Object.assign(defaults, options)),
                (this.modalIsOpen = !1),
                (this.focusOnOpen = this.config.focusOnOpen
                    ? document.getElementById(this.config.focusOnOpen)
                    : this.modal),
                (this.openElement = document.querySelector(this.config.open)),
                this.init()
        }
        return (
            (Modal.prototype.init = function () {
                this.openElement.addEventListener(
                    'click',
                    this.open.bind(this)
                ),
                    this.modal
                        .querySelector(this.config.close)
                        .addEventListener('click', this.closeModal.bind(this))
            }),
            (Modal.prototype.open = function (evt) {
                var self2 = this,
                    externalCall = !1
                if (!this.modalIsOpen) {
                    evt ? evt.preventDefault() : (externalCall = !0),
                        evt && evt.stopPropagation && evt.stopPropagation(),
                        this.modalIsOpen && !externalCall && this.closeModal(),
                        this.modal.classList.add(this.config.openClass),
                        this.nodes.parents.forEach(function (node) {
                            node.classList.add(self2.config.openBodyClass)
                        }),
                        (this.modalIsOpen = !0)
                    var scrollableElement = document.querySelector(
                        '.store-availabilities-list'
                    )
                    scrollLock.disablePageScroll(scrollableElement),
                        slate.a11y.trapFocus({
                            $container: $(this.modal),
                            $elementToFocus: $(this.focusOnOpen),
                        }),
                        this.config.scrollIntoView && this.scrollIntoView(),
                        this.bindEvents()
                }
            }),
            (Modal.prototype.closeModal = function () {
                if (this.modalIsOpen) {
                    document.activeElement.blur(),
                        this.modal.classList.remove(this.config.openClass)
                    var self2 = this,
                        scrollableElement = document.querySelector(
                            '.store-availabilities-list'
                        )
                    scrollLock.enablePageScroll(scrollableElement),
                        this.nodes.parents.forEach(function (node) {
                            node.classList.remove(self2.config.openBodyClass)
                        }),
                        (this.modalIsOpen = !1),
                        slate.a11y.removeTrapFocus({
                            $container: $(this.modal),
                        }),
                        this.openElement.focus(),
                        this.unbindEvents()
                }
            }),
            (Modal.prototype.bindEvents = function () {
                ;(this.keyupHandler = this.keyupHandler.bind(this)),
                    (this.clickHandler = this.clickHandler.bind(this)),
                    document.body.addEventListener('keyup', this.keyupHandler),
                    document.body.addEventListener('click', this.clickHandler)
            }),
            (Modal.prototype.unbindEvents = function () {
                document.body.removeEventListener('keyup', this.keyupHandler),
                    document.body.removeEventListener(
                        'click',
                        this.clickHandler
                    )
            }),
            (Modal.prototype.keyupHandler = function (event) {
                event.keyCode === 27 && this.closeModal()
            }),
            (Modal.prototype.clickHandler = function (event) {
                this.config.closeModalOnClick &&
                    !this.modal.contains(event.target) &&
                    this.closeModal()
            }),
            (Modal.prototype.scrollIntoView = function () {
                this.focusOnOpen.scrollIntoView({ behavior: 'smooth' })
            }),
            Modal
        )
    })()),
    (theme.Helpers = (function () {
        function cookiesEnabled() {
            var cookieEnabled = navigator.cookieEnabled
            return (
                cookieEnabled ||
                    ((document.cookie = 'testcookie'),
                    (cookieEnabled =
                        document.cookie.indexOf('testcookie') !== -1)),
                cookieEnabled
            )
        }
        function setCookie(name, value, days) {
            var expires = ''
            if (days) {
                var date = new Date()
                date.setTime(date.getTime() + days * 24 * 60 * 60 * 1e3),
                    (expires = '; expires=' + date.toUTCString())
            }
            document.cookie = name + '=' + (value || '') + expires + '; path=/'
        }
        function getCookie(name) {
            var cookie = document.cookie.split('; ').find(function (row) {
                return row.startsWith(name)
            })
            return cookie ? cookie.split('=')[1] : null
        }
        return { cookiesEnabled, setCookie, getCookie }
    })())
function tablesWrap() {
    var tableSelectors = '.rte table',
        $tables = $(tableSelectors)
    $tables.each(function () {
        $(this).wrap('<div class="rte__table-wrapper" />')
    })
}
function bgset(image, imageAspectRatio) {
    var bgset2 = ''
    return image.indexOf('blank.gif') != -1
        ? image
        : ((bgset2 +=
              image.replace('_1x1.', '_180x.') +
              ' 180w ' +
              Math.round(180 / imageAspectRatio) +
              'h,'),
          (bgset2 +=
              image.replace('_1x1.', '_240x.') +
              ' 240w ' +
              Math.round(240 / imageAspectRatio) +
              'h,'),
          (bgset2 +=
              image.replace('_1x1.', '_360x.') +
              ' 360w ' +
              Math.round(360 / imageAspectRatio) +
              'h,'),
          (bgset2 +=
              image.replace('_1x1.', '_540x.') +
              ' 540w ' +
              Math.round(540 / imageAspectRatio) +
              'h,'),
          (bgset2 +=
              image.replace('_1x1.', '_720x.') +
              ' 720w ' +
              Math.round(720 / imageAspectRatio) +
              'h,'),
          (bgset2 +=
              image.replace('_1x1.', '_900x.') +
              ' 900w ' +
              Math.round(900 / imageAspectRatio) +
              'h,'),
          (bgset2 +=
              image.replace('_1x1.', '_1080x.') +
              ' 1080w ' +
              Math.round(1080 / imageAspectRatio) +
              'h,'),
          (bgset2 +=
              image.replace('_1x1.', '_1296x.') +
              ' 1296w ' +
              Math.round(1296 / imageAspectRatio) +
              'h,'),
          (bgset2 +=
              image.replace('_1x1.', '_1512x.') +
              ' 1512w ' +
              Math.round(1512 / imageAspectRatio) +
              'h,'),
          (bgset2 +=
              image.replace('_1x1.', '_1728x.') +
              ' 1728w ' +
              Math.round(1728 / imageAspectRatio) +
              'h,'),
          (bgset2 +=
              image.replace('_1x1.', '_1950x.') +
              ' 1950w ' +
              Math.round(1950 / imageAspectRatio) +
              'h,'),
          (bgset2 +=
              image + ' 2048w ' + Math.round(2048 / imageAspectRatio) + 'h'),
          bgset2)
}
function readHeights() {
    const h = {}
    return (
        (h.windowHeight = window.innerHeight),
        (h.announcementHeight = getHeight(
            '[data-section-type*="announcement"]'
        )),
        (h.footerHeight = getHeight('[data-section-type*="footer"]')),
        (h.headerHeight = getHeight('[data-header-height]')),
        (h.headerInitialHeight = getHeight(
            '[data-header-height]:not(.header--has-scrolled)'
        )),
        h
    )
}
function setVarsOnResize() {
    document.addEventListener('theme:resize', resizeVars), setVars()
}
function setVars() {
    const {
        windowHeight,
        announcementHeight,
        headerHeight,
        headerInitialHeight,
        footerHeight,
    } = readHeights()
    document.documentElement.style.setProperty(
        '--header-height',
        `${headerHeight}px`
    ),
        document.documentElement.style.setProperty(
            '--header-initial-height',
            `${headerInitialHeight}px`
        ),
        document.documentElement.style.setProperty(
            '--announcement-height',
            `${announcementHeight}px`
        ),
        document.documentElement.style.setProperty(
            '--footer-height',
            `${footerHeight}px`
        ),
        document.documentElement.style.setProperty(
            '--content-full',
            `${windowHeight - headerHeight}px`
        ),
        document.documentElement.style.setProperty(
            '--content-min',
            `${windowHeight - headerHeight - footerHeight}px`
        )
}
function resizeVars() {
    const { windowHeight, announcementHeight, headerHeight, footerHeight } =
        readHeights()
    document.documentElement.style.setProperty(
        '--header-height',
        `${headerHeight}px`
    ),
        document.documentElement.style.setProperty(
            '--announcement-height',
            `${announcementHeight}px`
        ),
        document.documentElement.style.setProperty(
            '--footer-height',
            `${footerHeight}px`
        ),
        document.documentElement.style.setProperty(
            '--content-full',
            `${windowHeight - headerHeight}px`
        ),
        document.documentElement.style.setProperty(
            '--content-min',
            `${windowHeight - headerHeight - footerHeight}px`
        )
}
function getHeight(selector) {
    const el = document.querySelector(selector)
    return el ? el.clientHeight : 0
}
function dispatch() {
    document.dispatchEvent(new CustomEvent('theme:resize', { bubbles: !0 }))
}
function resizeListener() {
    window.addEventListener(
        'resize',
        Reqs.debounce(function () {
            dispatch()
        }, 50)
    )
}
window.addEventListener('load', () => {
    setVarsOnResize()
}),
    resizeListener()
function uf_swatchColor(e) {
    product_url = e.getAttribute('data-url');
    main_product_id = e.getAttribute('data-main-product-id');
    console.log('Load Product: ' + product_url + '-' + main_product_id);
    
    jQuery.getJSON('/products/' + product_url + '.js', function (product) {
        if (product.featured_image) {
            $('.product_' + main_product_id).css(
                'background-image',
                'url(' + product.featured_image + ')'
            );
        }
        
        $('.product_link_' + main_product_id).attr('href', product.url);
        $('.product_title_' + main_product_id).html(product.title);
        
        // FIX: Changed from '../products/' to '/products/'
        $('.product_sub_handle_' + main_product_id).attr(
            'href',
            '/products/' + product.handle
        );
        
        let default_variant_id = '';
        let size_option = '';
        
        for (let i = 0; i < product.variants.length; i++) {
            var arr_title = product.variants[i].title.split('/');
            
            if (product.variants[i].available) {
                if (product.variants[i].title == 'Default Title') {
                    default_variant_id = product.variants[i].id;
                }
                size_option +=
                    '<span class="in_stock" data-variant-id="' +
                    product.variants[i].id +
                    '" data-variant-price="' +
                    product.variants[i].price +
                    '" data-variant-title="' +
                    arr_title[0] +
                    '" onClick="uf_addCart(' +
                    product.variants[i].id +
                    ')">' +
                    arr_title[0] +
                    '</span>';
            } else {
                size_option +=
                    '<span class="out_of_stock" title="Out Of Stock">' +
                    arr_title[0] +
                    '</span>';
            }
        }
        
        if (size_option != '') {
            $('.product_size_' + main_product_id).html(
                '<div class="product_size_header">Select a size:</div>' + size_option
            );
        }
        
        $('#mp_id').val(main_product_id);
        $('#mp_default_variant' + main_product_id).val(default_variant_id);
        $('#mp_title' + main_product_id).val(product.title);
        $('#mp_image' + main_product_id).val(product.featured_image);
        $('#mp_price' + main_product_id).val(product.maxprice);
        $('#mp_size' + main_product_id).val(JSON.stringify(product.variants));
    });
}
function uf_swatchColorProductPage(e) {
    ;(color_description = [
        ["Cashmere Rose", "#ce879f"],
        ["Deep Blue", "#3e4071"],
        ["Jester Red", "#751921"],
        ["Dark Earth", "#4d2e19"],
        ["Turkish Coffee", "#706f48"],
        ["Rio Red", "#751922"],
        ["Peppercorn", "#bfbdbb"],
        ["Jet Black", "#383e4e"],
        ["Stone Grey", "#939597"],
        ["White Cloud", "#edede6"],
        ["Leafy Khaki", "#706f48"],
        ["Sea Sage Green", "#96a480"],
        ["Natural Taupe", "#af9483"],
        ["Sunset Red", "#d1332c"],
        ["Cherry Red", "#d1332c"],
        ["Violet Blue", "#464f75"],
        ["Ocean Pale Blue", "#9cc3dc"],
        ["Pastel Lavendar", "#b9b3d1"],
        ["Pastel Pink", "#f7c8c2"],
        ["Steel Blue", "#999fbf"],
        ["Wheat", "#cdbfba"],
        ["Slate Green", "#81988e"],
        ["Pink", "#fbd8db"],
        ["Lavender", "#b7a0bb"],
        ["White", "#ffffff"],
        ["Navy", "#293a65"],
        ["Powder Blue", "#d8eff5"],
        ["Muted Blue", "#e8edf0"],
        ["Warm Beige", "#ede3d4"],
        ["Nectar", "#ecdacc"],
        ["Brown", "#6a493c"],
        ["Stone", "#baafa4"],
        ["Offwhite", "#f2ede4"],
        ["Ivory", "#fff9e6"],
        ["Light Pink", "#f0d5d2"],
        ["Sky Blue", "#b9cfe3"],
        ["Olive", "#7e9055"],
        ["Green", "#777c63"],
        ["Mustard Yellow", "#dccc50"],
        ["Red", "#e00030"],
        ["Butter Yellow", "#fff3bc"],
        ["Blush Pink", "#f0d5d2"],
        ["Rust Brown", "#81553d"],
        ["Taupe", "#967e6c"],
        ["Charcoal Grey", "#636364"],
        ["Feminine Pink", "#C599C7"],
        ["Black", "#000000"],
        ["Pale Lavender", "#B9B3D1"],
        ["Grey", "#939597"],
        ["Beige", "#EDE3D4"],
        ["Pale Blue", "#9CC3DC"],
        ["Warm Taupe", "#BB9C8A"],
        ["Cafe", "#6A493C"],
        // Two-toned colors
        ["Sky Blue / Ivory", "#b9cfe3,#fff9e6"],
        ["White / Navy", "#ffffff,#293a65"],
        ["Brown / Offwhite", "#bd9f83,#f2ede4"],
        ["Ivory / Brown", "#fff9e6,#6a493c"],
        ["Light Pink / Ivory", "#f0d5d2,#fff9e6"],
        ["Brown / Stone", "#6a493c,#baafa4"],
        ["Ivory / Green", "#fff9e6,#777c63"],
        ["Olive / Mustard Yellow", "#7e9055,#dccc50"]
    ]),
        (product_url = e.getAttribute('data-url')),
        (main_product_id = e.getAttribute('data-main-product-id')),
        console.log('Load Product: ' + product_url + '-' + main_product_id),
        jQuery.getJSON('/products/' + product_url + '.js', function (product) {
            typeof product.featured_image < 'u' &&
                $('.product_sub_' + main_product_id).css(
                    'background-image',
                    'url(' + product.featured_image + ')'
                ),
                $('.product_sub_title_' + main_product_id).html(product.title),
                $('.product_sub_handle_' + main_product_id).attr(
                    'href',
                    product.handle
                ),
                (base_color = '')
            for (var x = 0; x < product.options.length; x++)
                product.options[x].name == 'Colour' &&
                    (base_color = product.options[x].values)
            $('.base_color_' + main_product_id).html(base_color),
                product.price > 0
                    ? ((pprice = product.price / 100),
                      $('.product_sub_price_' + main_product_id).html(
                          'AED' + pprice
                      ))
                    : $('.product_sub_price_' + main_product_id).html(
                          product.price
                      )
            let size_option = '',
                size_option_ddl = ''
            for (let i = 0; i < product.variants.length; i++)
                (arrSizeTitle = product.variants[i].title.split('/')),
                    product.variants[i].available
                        ? i == 0
                            ? ((size_option +=
                                  '<div class="ctl_size"><input id="size_' +
                                  i +
                                  '" class="ctl_size_radio" type="radio" name="radio_size_' +
                                  main_product_id +
                                  '" value="' +
                                  product.variants[i].id +
                                  '" checked="checked"><label class="ctl_size_label" for="size_' +
                                  i +
                                  '">' +
                                  arrSizeTitle[0] +
                                  '</label></div>'),
                              (size_option_ddl +=
                                  '<option value="' +
                                  product.variants[i].id +
                                  '">' +
                                  arrSizeTitle[0] +
                                  '</option>'))
                            : ((size_option +=
                                  '<div class="ctl_size"><input id="size_' +
                                  i +
                                  '" class="ctl_size_radio" type="radio" name="radio_size_' +
                                  main_product_id +
                                  '" value="' +
                                  product.variants[i].id +
                                  '"><label class="ctl_size_label" for="size_' +
                                  i +
                                  '">' +
                                  arrSizeTitle[0] +
                                  '</label></div>'),
                              (size_option_ddl +=
                                  '<option value="' +
                                  product.variants[i].id +
                                  '">' +
                                  arrSizeTitle[0] +
                                  '</option>'))
                        : (size_option +=
                              '<div class="ctl_size ctl-oos-bg"><div class="ctl-oos-line"></div><label class="ctl_size_label">' +
                              arrSizeTitle[0] +
                              '</label></div>')
            size_option != '' &&
                ($('.size_form_' + main_product_id).html(size_option),
                $('.' + main_product_id + '_ddlsize').html(size_option_ddl))
        })
}
function glossyCartRoute(path) {
    var routeRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/'
    if (routeRoot.charAt(routeRoot.length - 1) !== '/') routeRoot += '/'
    return routeRoot + String(path || '').replace(/^\//, '')
}
function uf_addCartProductPageDesktop(product_identifier) {
    ;(variant_id = $(
        'input[name=radio_size_' + product_identifier + ']:checked'
    ).val()),
        variant_id != null &&
            $.ajax({
                method: 'POST',
                url: glossyCartRoute('cart/add.js'),
                dataType: 'json',
                data: { id: variant_id, quantity: 1 },
                success: function (product) {
                    Cart.getCart(Cart.buildCart),
                        $(window).width() >= 550 &&
                            Cart.popover.show(product, 1)
                },
                error: function (data) {},
            })
}
function uf_addCartProductPageMobile(product_identifier) {
    ;(variant_id = $('.' + product_identifier + '_ddlsize').val()),
        variant_id != null &&
            $.ajax({
                method: 'POST',
                url: glossyCartRoute('cart/add.js'),
                dataType: 'json',
                data: { id: variant_id, quantity: 1 },
                success: function (product) {
                    Cart.getCart(Cart.buildCart),
                        $('body').toggleClass('cart--is-visible'),
                        $('body').hasClass('cart--is-visible')
                            ? ($('.cartslide').animate({ left: '0' }, 300),
                              $('#Cart').removeClass('close'),
                              $('#Cart').addClass('open'),
                              $('#cartTotal').attr('aria-expanded', !0))
                            : ($('.cartslide').animate({ left: '200' }, 300),
                              $('#Cart').removeClass('open'),
                              $('#Cart').addClass('close'),
                              $('#cartTotal').attr('aria-expanded', !1),
                              $('#Cart').popover.hide($popover))
                },
                error: function (data) {},
            })
}
function uf_addCart(variant_id2) {
    $.ajax({
        method: 'POST',
        url: glossyCartRoute('cart/add.js'),
        dataType: 'json',
        data: { id: variant_id2, quantity: 1 },
        success: function (product) {
            Cart.getCart(Cart.buildCart),
                $('body').toggleClass('cart--is-visible'),
                $('body').hasClass('cart--is-visible')
                    ? ($('.cartslide').animate({ left: '0' }, 300),
                      $('#Cart').removeClass('close'),
                      $('#Cart').addClass('open'),
                      $('#cartTotal').attr('aria-expanded', !0))
                    : ($('.cartslide').animate({ left: '200' }, 300),
                      $('#Cart').removeClass('open'),
                      $('#Cart').addClass('close'),
                      $('#cartTotal').attr('aria-expanded', !1),
                      $('#Cart').popover.hide($popover))
        },
        error: function (data) {},
    })
}
function uf_addCartMobile() {
    var variant_id2 = $('#mp_variant_id_selected').val()
    console.log(variant_id2),
        variant_id2 != '' &&
            $.ajax({
                method: 'POST',
                url: glossyCartRoute('cart/add.js'),
                dataType: 'json',
                data: { id: variant_id2, quantity: 1 },
                success: function (product) {
                    Cart.getCart(Cart.buildCart)
                    var scrollableElement = document.querySelector(
                        '.store-availabilities-list'
                    )
                    $('body').toggleClass('cart--is-visible'),
                        $('body').hasClass('cart--is-visible')
                            ? ($('.cartslide').animate({ left: '0' }, 300),
                              $('#Cart').removeClass('close'),
                              $('#Cart').addClass('open'),
                              $('#cartTotal').attr('aria-expanded', !0))
                            : ($('.cartslide').animate({ left: '200' }, 300),
                              $('#Cart').removeClass('open'),
                              $('#Cart').addClass('close'),
                              $('#cartTotal').attr('aria-expanded', !1),
                              $('#Cart').popover.hide($popover))
                },
                error: function (data) {},
            })
}
function uf_addCartSlideGiftCard() {
    ;(variant_id = $('#giftcardselection').val()),
        $.ajax({
            method: 'POST',
            url: glossyCartRoute('cart/add.js'),
            dataType: 'json',
            data: { id: variant_id, quantity: 1 },
            success: function (e) {
                Cart.getCart(Cart.buildCart)
                var scrollableElement = document.querySelector(
                    '.store-availabilities-list'
                )
                scrollLock.disablePageScroll(scrollableElement),
                    $('body').toggleClass('cart--is-visible'),
                    $('body').hasClass('cart--is-visible')
                        ? ($('.cartslide').animate({ left: '0' }, 300),
                          $('#Cart').removeClass('close'),
                          $('#Cart').addClass('open'),
                          $('#cartTotal').attr('aria-expanded', !0))
                        : ($('.cartslide').animate({ left: '200' }, 300),
                          $('#Cart').removeClass('open'),
                          $('#Cart').addClass('close'),
                          $('#cartTotal').attr('aria-expanded', !1),
                          $('#Cart').popover.hide($popover))
            },
            error: function (data) {},
        })
}
function uf_addCartSlide(quantity = 1) {
    var variant_id = $('input[data-variant-id]:checked').attr('data-variant-id');

    var data = {
        id: variant_id,
        quantity: quantity
    };

    $.ajax({
        method: 'POST',
        url: glossyCartRoute('cart/add.js'),
        dataType: 'json',
        data: data,
        success: function (e) {
            Cart.getCart(Cart.buildCart);
            var scrollableElement = document.querySelector('.store-availabilities-list');
            $('body').toggleClass('cart--is-visible');
            if ($('body').hasClass('cart--is-visible')) {
                $('.cartslide').animate({ left: '0' }, 300);
                $('#Cart').removeClass('close');
                $('#Cart').addClass('open');
                $('#cartTotal').attr('aria-expanded', true);
            } else {
                $('.cartslide').animate({ left: '200' }, 300);
                $('#Cart').removeClass('open');
                $('#Cart').addClass('close');
                $('#cartTotal').attr('aria-expanded', false);
                $('#Cart').popover.hide($popover);
            }
        },
        error: function (data) {},
    });
}
$(document).ready(function () {
    $(this).on('click', '.accordion-productss', function (e) {
        $(this).next('.panels').toggle(),
            $(this).addClass('open'),
            $(this).next('.panels').css('display') == 'none'
                ? ($(this).find('.arrowss').addClass('down'),
                  $(this).find('.arrowss').removeClass('up'))
                : ($(this).find('.arrowss').addClass('up'),
                  $(this).find('.arrowss').removeClass('down'))
    })
})
if (
    typeof Swiper !== 'undefined' &&
    document.querySelector('.swiper-product')
) {
    var swiperthumb = new Swiper('.swiper-thumb', {
        spaceBetween: 10,
        slidesPerView: 4,
        freeMode: !0,
        watchSlidesProgress: !0,
    })
    const swiper = new Swiper('.swiper-product', {
        slidesPerView: 1,
        spaceBetween: 0,
        breakpoints: {
            992: { slidesPerView: 2, spaceBetween: 16, allowTouchMove: !0 },
        },
        pagination: { el: '.swiper-pagination' },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        scrollbar: { el: '.swiper-scrollbar' },
        thumbs: { swiper: swiperthumb },
    })
}
var cart_items = []
function uf_dengage() {}
//# sourceMappingURL=/s/files/1/0469/1152/0920/t/44/assets/shop.js.map?v=1734530889
